namespace CosmoApps.Designer {
    type AnyDoc = any;

    interface DesignerTreeNode {
        id: string;
        text: string;
        kind: "document" | "collection" | "group";
        icon?: string;
        doc?: AnyDoc;
        ownerDoc?: AnyDoc;
        containerDoc?: AnyDoc;
        collection?: AnyDoc;
        property?: AnyDoc;
        items?: DesignerTreeNode[];
        expanded?: boolean;
    }

    interface PropertyGridRow {
        id: string;
        category: string;
        name: string;
        value: any;
        meta?: AnyDoc;
        description?: string;
    }

    export async function showModelDesigner(e?: any): Promise<void> {
        const runtime: any = (window as any).app || (window as any).cosmoApp || e?.app;
        const designerPageMode = e?.pageMode === true;
        const designerAutoSaveOnOpen = e?.autoSaveOnOpen === true;
        const designerBackUrl = String(e?.backUrl || "Default.aspx");
        const designerPageHostSelector = String(e?.pageHostSelector || "body");

        if (!runtime || typeof runtime.query !== "function") {
            DevExpress.ui.dialog.alert("Не найден app.query / cosmoApp.query", "CosmoApps Designer");
            return;
        }

        function getCurrentSavedAppId(): string {
            try {
                const params = new URLSearchParams(window.location.search);
                return String(params.get("appId") || "").trim();
            } catch {
                return "";
            }
        }

        function runCurrentApplication(): void {
            const appId = getCurrentSavedAppId();

            if (!appId) {
                DevExpress.ui.notify("Сначала сохраните проект.", "warning", 2200);
                return;
            }

            window.open(
                "https://app.easydev.pro/Run?appId=" + encodeURIComponent(appId),
                "_blank"
            );
        }

        function getReferenceModuleName(projectId: string): string {
            if (!projectId || projectId === runtime.id) return "";

            const refs = runtime.References || runtime.ModuleReferences || [];

            const ref = refs.find((r: any) =>
                r.Id === projectId ||
                r.id === projectId ||
                r.ProjectId === projectId ||
                r.projectId === projectId
            );

            if (!ref) return " !!! Ref Error";

            return ` (${ref.Module || ref.Name || ref.Project || projectId})`;
        }

        function getTypeLookupData(): AnyDoc[] {
            const res: AnyDoc[] = [];

            const source = Array.isArray(runtime.objects)
                ? runtime.objects
                : runtimeObjects;

            source.forEach((cur: any) => {
                if (!cur || !cur.id || !cur.Name) return;

                res.push({
                    id: cur.id,
                    Name: cur.Name + getReferenceModuleName(cur.projectId || cur._partitionId),
                    source: cur
                });
            });

            return res.sort((a, b) => String(a.Name).localeCompare(String(b.Name)));
        }

        function getBaseTypes(current?: AnyDoc): AnyDoc[] {
            const items = getTypeLookupData();

            return [{ id: "object", Name: "object" }]
                .concat(current?.id ? items.filter(o => o.id !== current.id) : items);
        }

        function getEnumLookupData(): AnyDoc[] {
            return getRuntimeEnumDocs()
                .filter((item: AnyDoc) => item && item.id && item.Name)
                .map((item: AnyDoc) => ({
                    id: item.id,
                    Name:
                        item.Name +
                        getReferenceModuleName(
                            item.projectId ||
                            item._partitionId
                        ) +
                        " [enum]",
                    source: item,
                    kind: "enum"
                }))
                .sort((a: AnyDoc, b: AnyDoc) =>
                    String(a.Name).localeCompare(String(b.Name))
                );
        }

        function getPropertyTypes(): AnyDoc[] {
            const scalarTypes = [
                { id: "string", Name: "string" },
                { id: "int", Name: "int" },
                { id: "float", Name: "float" },
                { id: "boolean", Name: "boolean" },
                { id: "date", Name: "date" },
                { id: "dateTime", Name: "dateTime" },
                { id: "time", Name: "time" },
                { id: "color", Name: "color" },
                { id: "email", Name: "email" },
                { id: "url", Name: "url" },
                { id: "money", Name: "money" }
            ];

            const systemTypes = [
                { id: "caRole", Name: "caRole" },
                { id: "caDataType", Name: "caDataType" },
                { id: "caType", Name: "caType" },
                { id: "caProperty", Name: "caProperty" }
            ];

            return scalarTypes
                .concat(systemTypes)
                .concat(getEnumLookupData())
                .concat(getTypeLookupData());
        }

        function displayTypeName(value: any, forBaseType = false): string {
            if (value === undefined || value === null || value === "") return "";

            const items = forBaseType
                ? getBaseTypes()
                : getPropertyTypes();

            const found = items.find(x => x.id === value);

            return found ? found.Name : String(value);
        }
        const POPUP_ID = "ca-model-designer-popup";
        const STYLE_ID = "ca-model-designer-style";

        const safeGetType = (ctor: any, fallback: string): string => {
            try {
                if (ctor && typeof ctor.getType === "function") return ctor.getType();
            } catch {
                // ignore
            }
            return fallback;
        };

        const safeGetDerivedTypes = (ctor: any, fallback: string[]): string[] => {
            try {
                if (ctor && typeof ctor.getDerivedTypes === "function") {
                    const values = ctor.getDerivedTypes();
                    if (Array.isArray(values) && values.length) return values;
                }
            } catch {
                // ignore
            }
            return fallback;
        };

        const APPLICATION_TYPE = safeGetType(CosmoApps.Application, "d6cad845-b11c-4662-a02e-611f25d87176");
        const META_ENTITY_TYPE = safeGetType(CosmoApps.MetaEntity, "c7a8796b-5dd4-5b93-a81b-5be412f4c21c");
        const PROPERTY_TYPE = safeGetType(CosmoApps.Property, "966fec76-9ea9-1216-2296-89615aa795bd");
        const COLLECTION_TYPE = safeGetType(CosmoApps.MetaCollection, "b225482a-aceb-3912-f95c-6ceed25b13a0");
        const CATEGORY_TYPE = safeGetType(CosmoApps.MetaPropertyCategory, "2c2c3916-125e-d775-84cd-7eea6ae525d1");
        const ICON_TYPE = safeGetType(CosmoApps.Icon, "a603a69b-9e58-619d-e665-1cc3e8a3ba94");
        const PROPERTY_VALUE_TYPE = safeGetType(CosmoApps.MetaPropertyValue, "b2742b97-852e-aba2-b49c-d8cc3cca3928");
        const META_ENTITY_DERIVED_TYPES = safeGetDerivedTypes(CosmoApps.MetaEntity, [META_ENTITY_TYPE]);

        let docs: AnyDoc[] = [];
        let applicationDoc: AnyDoc | null = null;
        let runtimeEnums: AnyDoc[] = [];
        let runtimeNavigationItems: AnyDoc[] = [];
        let runtimeObjects: AnyDoc[] = [];
        let treeItems: DesignerTreeNode[] = [];
        let selectedNode: DesignerTreeNode | null = null;
        let selectedPropertyRow: PropertyGridRow | null = null;

        let popup: any = null;
        let tree: any = null;
        let grid: any = null;
        let propertySearchBox: any = null;
        let propertySearchText = "";

        interface DesignerAIMessage {
            Role: "user" | "assistant";
            Content: string;
            Plan?: any;
            InternalPlan?: any;
            Error?: boolean;
            ErrorReport?: AnyDoc;
        }

        let aiPromptBox: any = null;
        let aiSendButton: any = null;
        let aiApplyButton: any = null;
        let aiPromptExpanded = false;
        let designerLeftWidth = 360;
        let designerRightWidth = 360;
        let designerAIComposerHeight = 156;
        let aiThinkingModeBox: any = null;

        const COSMOAPPS_METAMODEL_APPLICATION_ID =
            "3cd81511-4554-462f-b294-7787db89f2d9";

        const aiThinkingModeStorageKey =
            "cosmoapps.designer.ai.thinkingMode";

        function loadAIThinkingMode():
            "strict" | "creative" {
            try {
                return localStorage.getItem(
                    aiThinkingModeStorageKey
                ) === "creative"
                    ? "creative"
                    : "strict";
            } catch {
                return "strict";
            }
        }

        function saveAIThinkingMode(
            value: "strict" | "creative"
        ): void {
            try {
                localStorage.setItem(
                    aiThinkingModeStorageKey,
                    value
                );
            } catch {
                // Continue normally when browser storage is unavailable.
            }
        }

        let aiThinkingMode:
            "strict" | "creative" =
            loadAIThinkingMode();

        let aiProjectBrief: string | null = null;
        // Concise business title proposed by the BusinessAnalysis pass for a new project.
        // It is only used while the project still has a generic/default Name.
        let aiSuggestedApplicationName: string | null = null;
        let aiMessages: DesignerAIMessage[] = [];
        let aiRequestInProgress = false;
        let aiTaskId = new DevExpress.data.Guid().toString();
        let initialDesignerPromptConsumed = false;

        const DESIGNER_CLIENT_BUILD =
            "2026-10-29-pipeline-trace-v28";

        let lastDesignerAITrace: AnyDoc | null = null;

        let designerAIPipelineRequestSequence = 0;
        let designerAIPipelineServiceSequence = 0;
        let designerAIPipelineTrace: AnyDoc[] = [];

        function summarizeDesignerAIOperation(operation: AnyDoc): string {
            const kind = String(operation?.Type || "Unknown");
            const owner = String(
                operation?.EntityRef?.TemporaryId || operation?.EntityId ||
                operation?.OwnerRef?.TemporaryId || operation?.OwnerId || ""
            );
            const name = String(
                operation?.Entity?.Name || operation?.Enum?.Name ||
                operation?.Property?.Name || operation?.Collection?.Name ||
                operation?.Action?.Name || operation?.Rule?.Name ||
                operation?.Event?.Name || operation?.NavigationItem?.Name ||
                operation?.NavigationItem?.Caption || operation?.TemporaryId || ""
            );
            const target = owner && name ? `${owner}.${name}` : (name || owner);
            return target ? `${kind}:${target}` : kind;
        }

        function summarizeDesignerAIOperations(planOrOperations: AnyDoc): AnyDoc {
            const operations: AnyDoc[] = Array.isArray(planOrOperations)
                ? planOrOperations
                : (Array.isArray(planOrOperations?.Operations) ? planOrOperations.Operations : []);
            const byType: Record<string, number> = {};
            operations.forEach((operation: AnyDoc) => {
                const kind = String(operation?.Type || "Unknown");
                byType[kind] = (byType[kind] || 0) + 1;
            });
            return {
                Count: operations.length,
                ByType: byType,
                Items: operations.slice(0,40).map(summarizeDesignerAIOperation),
                Truncated: operations.length > 40
            };
        }

        function traceDesignerAIPipeline(stage: string, data?: AnyDoc): void {
            const entry = {
                At: new Date().toISOString(),
                TaskId: aiTaskId,
                Request: designerAIPipelineRequestSequence,
                Stage: stage,
                Data: data || {}
            };
            designerAIPipelineTrace.push(entry);
            if (designerAIPipelineTrace.length > 250) {
                designerAIPipelineTrace = designerAIPipelineTrace.slice(-250);
            }
            (window as any).cosmoDesignerAITrace = cloneData(designerAIPipelineTrace);
            console.info(`[DesignerAI Trace ${aiTaskId} #${designerAIPipelineRequestSequence}] ${stage}`, data || {});
        }

        function classifyDesignerAIServiceCall(prompt: string, phase: string, networkRetry: boolean): string {
            const text = String(prompt || "");
            if (networkRetry) return `${phase}:NetworkRetry`;
            if (phase === "BusinessAnalysis") return /compact|retry/i.test(text) ? "BusinessAnalysis:Retry" : "BusinessAnalysis";
            if (/Review the generated CosmoApps plan as a senior application designer/i.test(text)) return "SemanticReview";
            if (/continue the same CosmoApps ModelGeneration/i.test(text)) return "ModelGeneration:Continuation";
            if (/reserved Cosmos DB SQL keyword/i.test(text)) return "ReservedIdentifierRepair";
            if (/MISSING_TYPES/i.test(text)) return "NavigationCompiler";
            if (/navigation reorganization/i.test(text)) return "NavigationReorganization";
            if (/Apply one simple structural modification/i.test(text)) return "SimpleStructuralEdit";
            return phase === "ModelGeneration" ? "ModelGeneration" : phase;
        }

        function truncateDesignerAIReportText(
            value: any,
            maxLength: number
        ): string | null {
            if (
                value === undefined ||
                value === null
            ) {
                return null;
            }

            const text =
                typeof value === "string"
                    ? value
                    : (() => {
                        try {
                            return JSON.stringify(
                                value
                            );
                        } catch {
                            return String(value);
                        }
                    })();

            if (
                text.length <= maxLength
            ) {
                return text;
            }

            return (
                text.substring(
                    0,
                    maxLength
                ) +
                `\\n...[truncated ${text.length - maxLength} chars]`
            );
        }

        function designerAIErrorReportUrl(): string {
            return String(
                (window as any)
                    .COSMOAPPS_DESIGNER_AI_ERROR_REPORT_URL ||
                "DesignerAIErrorReport.ashx"
            ).trim();
        }

        function buildDesignerAIModelSnapshot(): AnyDoc {
            const navigation =
                getAIApplicationNavigationItems();

            return {
                Types:
                    getAIApplicationTypeDocs()
                        .map(
                            (typeDoc: AnyDoc) => ({
                                id:
                                    typeDoc?.id ||
                                    null,
                                Name:
                                    typeDoc?.Name ||
                                    null,
                                Caption:
                                    typeDoc?.Caption ||
                                    null
                            })
                        ),
                Enums:
                    getAIApplicationEnumDocs()
                        .map(
                            (enumDoc: AnyDoc) => ({
                                id:
                                    enumDoc?.id ||
                                    null,
                                Name:
                                    enumDoc?.Name ||
                                    null
                            })
                        ),
                Navigation:
                    navigation.map(
                        (item: AnyDoc) => ({
                            id:
                                item?.id ||
                                null,
                            Caption:
                                item?.Caption ||
                                null,
                            Type:
                                item?.Type ||
                                null,
                            ParentId:
                                item?.ParentId ||
                                null,
                            Path:
                                item?.Path ||
                                null,
                            IsGroup:
                                item?.IsGroup === true
                        })
                    ),
                Counts: {
                    Types:
                        getAIApplicationTypeDocs()
                            .length,
                    Enums:
                        getAIApplicationEnumDocs()
                            .length,
                    NavigationItems:
                        navigation.length
                }
            };
        }

        function buildDesignerAIErrorReport(
            error: any,
            userPrompt: string
        ): AnyDoc {
            const attached =
                error?.DesignerAIReport &&
                typeof error.DesignerAIReport ===
                    "object"
                    ? error.DesignerAIReport
                    : null;

            const trace =
                attached ||
                lastDesignerAITrace ||
                {};

            const reportId =
                String(
                    trace?.ReportId ||
                    new DevExpress.data.Guid()
                        .toString()
                );

            const userEmail =
                String(
                    (window as any)
                        .cosmoDesignerUserEmail ||
                    ""
                ).trim();

            return {
                ReportId:
                    reportId,
                CreatedAtUtc:
                    new Date()
                        .toISOString(),
                ClientBuild:
                    DESIGNER_CLIENT_BUILD,
                TaskId:
                    aiTaskId,
                Phase:
                    trace?.Phase ||
                    null,
                Error: {
                    Name:
                        error?.name ||
                        "Error",
                    Message:
                        error?.message ||
                        String(error),
                    Stack:
                        truncateDesignerAIReportText(
                            error?.stack,
                            30000
                        )
                },
                Project: {
                    AppId:
                        runtime?.id ||
                        null,
                    Name:
                        runtime?.Name ||
                        runtime?.ModuleName ||
                        applicationDoc?.Name ||
                        null,
                    Owner:
                        runtime?._owner ||
                        null,
                    CurrentUser:
                        userEmail ||
                        null,
                    Page:
                        window.location
                            .pathname +
                        window.location
                            .search
                },
                Environment: {
                    UserAgent:
                        navigator.userAgent,
                    Language:
                        navigator.language,
                    TimeZone:
                        (() => {
                            try {
                                return Intl
                                    .DateTimeFormat()
                                    .resolvedOptions()
                                    .timeZone;
                            } catch {
                                return null;
                            }
                        })(),
                    ThinkingMode:
                        aiThinkingMode
                },
                UserPrompt:
                    truncateDesignerAIReportText(
                        userPrompt,
                        20000
                    ),
                Service: {
                    Url:
                        trace?.Url ||
                        "DesignerAI.ashx",
                    Phase:
                        trace?.Phase ||
                        null,
                    StartedAtUtc:
                        trace?.StartedAtUtc ||
                        null,
                    CompletedAtUtc:
                        trace?.CompletedAtUtc ||
                        null,
                    DurationMs:
                        trace?.DurationMs ??
                        null,
                    HttpStatus:
                        trace?.HttpStatus ??
                        null,
                    HttpStatusText:
                        trace?.HttpStatusText ||
                        null,
                    Request:
                        truncateDesignerAIReportText(
                            trace?.Request,
                            250000
                        ),
                    Response:
                        truncateDesignerAIReportText(
                            trace?.Response,
                            250000
                        ),
                    ParsedResponse:
                        trace?.ParsedResponse
                            ? truncateDesignerAIReportText(
                                trace.ParsedResponse,
                                120000
                            )
                            : null
                },
                Conversation:
                    aiMessages
                        .slice(-8)
                        .map(
                            (message: DesignerAIMessage) => ({
                                Role:
                                    message.Role,
                                Content:
                                    truncateDesignerAIReportText(
                                        message.Content,
                                        12000
                                    ),
                                Error:
                                    message.Error === true
                            })
                        ),
                ModelSnapshot:
                    buildDesignerAIModelSnapshot()
            };
        }

        function stringifyDesignerAIErrorReport(
            report: AnyDoc
        ): string {
            try {
                return JSON.stringify(
                    report,
                    null,
                    2
                );
            } catch {
                return String(report);
            }
        }

        async function copyDesignerAIErrorReport(
            report: AnyDoc
        ): Promise<void> {
            const text =
                stringifyDesignerAIErrorReport(
                    report
                );

            if (
                navigator.clipboard &&
                navigator.clipboard.writeText
            ) {
                await navigator.clipboard
                    .writeText(text);
                return;
            }

            const $textarea =
                $("<textarea>")
                    .val(text)
                    .css({
                        position:
                            "fixed",
                        left:
                            "-10000px",
                        top:
                            "-10000px"
                    })
                    .appendTo(
                        document.body
                    );

            const element =
                $textarea[0] as
                    HTMLTextAreaElement;

            element.select();
            document.execCommand(
                "copy"
            );
            $textarea.remove();
        }

        async function sendDesignerAIErrorReport(
            report: AnyDoc
        ): Promise<AnyDoc> {
            const response =
                await fetch(
                    designerAIErrorReportUrl(),
                    {
                        method:
                            "POST",
                        credentials:
                            "same-origin",
                        cache:
                            "no-store",
                        headers: {
                            "Accept":
                                "application/json",
                            "Content-Type":
                                "application/json"
                        },
                        body:
                            JSON.stringify(
                                report
                            )
                    }
                );

            const text =
                await response.text();

            let result: AnyDoc = null;

            try {
                result =
                    text
                        ? JSON.parse(text)
                        : null;
            } catch {
                result = null;
            }

            if (
                !response.ok ||
                !result?.Success
            ) {
                throw new Error(
                    result?.Error ||
                    `HTTP ${response.status}`
                );
            }

            return result;
        }

        function openDesignerAIErrorReport(
            report: AnyDoc
        ): void {
            const $popup =
                $("<div>")
                    .appendTo(
                        document.body
                    );

            const reportText =
                stringifyDesignerAIErrorReport(
                    report
                );

            let popup: any = null;

            ($popup as any)
                .dxPopup({
                    title:
                        `Отчёт об ошибке · ${report?.ReportId || ""}`,
                    width: () =>
                        Math.min(
                            window.innerWidth -
                            80,
                            1000
                        ),
                    height: () =>
                        Math.min(
                            window.innerHeight -
                            80,
                            760
                        ),
                    showCloseButton:
                        true,
                    dragEnabled:
                        true,
                    resizeEnabled:
                        true,
                    contentTemplate:
                        (contentElement: any) => {
                            const $content =
                                $(contentElement)
                                    .css({
                                        height:
                                            "100%",
                                        display:
                                            "flex",
                                        flexDirection:
                                            "column",
                                        gap:
                                            "8px"
                                    });

                            $("<div>")
                                .text(
                                    "Технический отчёт содержит запрос к ИИ, ответ сервера, сведения о проекте и внутреннюю ошибку. Его можно скопировать или отправить разработчикам."
                                )
                                .css({
                                    opacity:
                                        .8
                                })
                                .appendTo(
                                    $content
                                );

                            $("<textarea>")
                                .val(
                                    reportText
                                )
                                .attr(
                                    "readonly",
                                    "readonly"
                                )
                                .css({
                                    width:
                                        "100%",
                                    flex:
                                        "1 1 auto",
                                    minHeight:
                                        "280px",
                                    boxSizing:
                                        "border-box",
                                    fontFamily:
                                        "Consolas, monospace",
                                    fontSize:
                                        "12px",
                                    resize:
                                        "none"
                                })
                                .appendTo(
                                    $content
                                );
                        },
                    toolbarItems: [
                        {
                            toolbar:
                                "bottom",
                            location:
                                "before",
                            widget:
                                "dxButton",
                            options: {
                                text:
                                    "Скопировать",
                                icon:
                                    "copy",
                                onClick:
                                    async () => {
                                        try {
                                            await copyDesignerAIErrorReport(
                                                report
                                            );
                                            DevExpress
                                                .ui
                                                .notify(
                                                    "Отчёт скопирован",
                                                    "success",
                                                    1800
                                                );
                                        } catch (
                                            copyError: any
                                        ) {
                                            DevExpress
                                                .ui
                                                .notify(
                                                    copyError?.message ||
                                                    String(
                                                        copyError
                                                    ),
                                                    "error",
                                                    2600
                                                );
                                        }
                                    }
                            }
                        },
                        {
                            toolbar:
                                "bottom",
                            location:
                                "after",
                            widget:
                                "dxButton",
                            options: {
                                text:
                                    "Отправить на сервер",
                                icon:
                                    "upload",
                                type:
                                    "default",
                                onClick:
                                    async () => {
                                        try {
                                            const result =
                                                await sendDesignerAIErrorReport(
                                                    report
                                                );

                                            DevExpress
                                                .ui
                                                .notify(
                                                    `Отчёт сохранён: ${result?.ReportId || report.ReportId}`,
                                                    "success",
                                                    3200
                                                );
                                        } catch (
                                            sendError: any
                                        ) {
                                            DevExpress
                                                .ui
                                                .notify(
                                                    "Не удалось отправить отчёт: " +
                                                    (
                                                        sendError?.message ||
                                                        String(
                                                            sendError
                                                        )
                                                    ),
                                                    "error",
                                                    3600
                                                );
                                        }
                                    }
                            }
                        }
                    ],
                    onHidden:
                        () =>
                            $popup.remove()
                } as any);

            popup =
                ($popup as any)
                    .dxPopup(
                        "instance"
                    );

            popup.show();
        }

        const initialDesignerPromptStorageKey =
            "cosmoapps.designer.initialPrompt";

        interface AIInMemoryApplyState {
            Applied: boolean;
            OperationCount: number;
            AppliedAt: Date | null;
            Message: string;
            AppliedPlanJson: string | null;
        }

        let aiInMemoryApplyState: AIInMemoryApplyState = {
            Applied: false,
            OperationCount: 0,
            AppliedAt: null,
            Message: "",
            AppliedPlanJson: null
        };

        const legacyKindNames: Record<number, string> = {
            [-1]: "Application",
            0: "Type",
            1: "Property",
            2: "Enum",
            3: "Formula",
            4: "Rule",
            5: "Action",
            6: "Event",
            7: "View",
            8: "ViewGroup",
            9: "ViewItem",
            11: "EnumValue",
            12: "SecurityRole",
            13: "SecurityPermission",
            14: "Script",
            15: "UserDesignerAccess",
            16: "ModuleReferences",
            17: "Theme",
            18: "Menu"
        };

        const enumMaps: Record<string, { value: any; name: string }[]> = {
            ValueType: [
                { value: -2, name: "Enum" },
                { value: -1, name: "EntityRef" },
                { value: 0, name: "string" },
                { value: 2, name: "int" },
                { value: 3, name: "float" },
                { value: 4, name: "boolean" },
                { value: 5, name: "date" },
                { value: 6, name: "dateTime" },
                { value: 7, name: "time" },
                { value: 8, name: "color" },
                { value: 9, name: "email" },
                { value: 10, name: "url" },
                { value: 12, name: "SecurityRole" },
                { value: 13, name: "SecurityPermission" },
                { value: 14, name: "anyDataType" }
            ],
            ValueKind: [
                { value: 0, name: "scalar" },
                { value: 1, name: "entityRef" },
                { value: 2, name: "enum" },
                { value: 3, name: "expression" },
                { value: 4, name: "json" },
                { value: 5, name: "script" }
            ],
            StorageKind: [
                { value: 0, name: "Structured" },
                { value: 1, name: "SemiStructured" },
                { value: 2, name: "OpaqueJson" }
            ],
            Aggregation: [
                { value: 0, name: "Value" },
                { value: 1, name: "Aggregated" },
                { value: 2, name: "Hybrid" },
                { value: 3, name: "Deferred" }
            ],
            DesignerRoles: [
                { value: 0, name: "Developer" },
                { value: 1, name: "BA" }
            ],
            Roles: [
                { value: 0, name: "Developer" },
                { value: 1, name: "BA" }
            ]
        };

        function attachDesignerVerticalSplitter(
            $splitter: JQuery,
            side: "left" | "right",
            $root: JQuery,
            $left: JQuery,
            $right: JQuery
        ): void {
            let dragging = false;
            let startX = 0;
            let startWidth = 0;

            const applyWidth = (width: number): void => {
                const rootWidth = Math.max(
                    1,
                    Number($root.innerWidth()) || 1
                );
                const oppositeWidth =
                    side === "left"
                        ? Number($right.outerWidth()) || designerRightWidth
                        : Number($left.outerWidth()) || designerLeftWidth;
                const minCenterWidth = 420;
                const splitterSpace = 14;
                const minWidth = side === "left" ? 240 : 300;
                const maxWidth = Math.max(
                    minWidth,
                    rootWidth -
                    oppositeWidth -
                    minCenterWidth -
                    splitterSpace
                );
                const nextWidth = Math.max(
                    minWidth,
                    Math.min(maxWidth, width)
                );

                if (side === "left") {
                    designerLeftWidth = nextWidth;
                    $left.css({
                        width: `${nextWidth}px`,
                        minWidth: `${minWidth}px`,
                        flex: `0 0 ${nextWidth}px`
                    });
                } else {
                    designerRightWidth = nextWidth;
                    $right.css({
                        width: `${nextWidth}px`,
                        minWidth: `${minWidth}px`,
                        flex: `0 0 ${nextWidth}px`
                    });
                }

                try { grid?.updateDimensions?.(); } catch { /* ignore */ }
            };

            const onMove = (event: any): void => {
                if (!dragging) return;

                const currentX = Number(event.clientX || 0);
                const delta =
                    side === "left"
                        ? currentX - startX
                        : startX - currentX;

                applyWidth(startWidth + delta);
                event.preventDefault?.();
            };

            const stopDragging = (): void => {
                if (!dragging) return;

                dragging = false;
                $("body").removeClass("ca-md-resizing");

                $(document)
                    .off("mousemove.caModelDesignerSplitter", onMove)
                    .off("mouseup.caModelDesignerSplitter", stopDragging);

                try { grid?.updateDimensions?.(); } catch { /* ignore */ }
            };

            $splitter.on("mousedown", (event: any) => {
                dragging = true;
                startX = Number(event.clientX || 0);
                startWidth =
                    side === "left"
                        ? Number($left.outerWidth()) || designerLeftWidth
                        : Number($right.outerWidth()) || designerRightWidth;

                $("body").addClass("ca-md-resizing");

                $(document)
                    .on("mousemove.caModelDesignerSplitter", onMove)
                    .on("mouseup.caModelDesignerSplitter", stopDragging);

                event.preventDefault?.();
                event.stopPropagation?.();
            });
        }

        function attachDesignerAIHorizontalSplitter(
            $splitter: JQuery,
            $right: JQuery,
            $body: JQuery,
            $composer: JQuery
        ): void {
            let dragging = false;
            let startY = 0;
            let startHeight = 0;

            const applyHeight = (height: number): void => {
                const panelHeight = Math.max(
                    1,
                    Number($right.innerHeight()) || 1
                );
                const reservedTop = Math.max(
                    0,
                    panelHeight -
                    (Number($body.outerHeight()) || 0) -
                    (Number($composer.outerHeight()) || 0)
                );
                const splitterHeight = 10;
                const minBodyHeight = 180;
                const minComposerHeight = 118;
                const maxComposerHeight = Math.max(
                    minComposerHeight,
                    panelHeight -
                    reservedTop -
                    splitterHeight -
                    minBodyHeight
                );
                const nextHeight = Math.max(
                    minComposerHeight,
                    Math.min(maxComposerHeight, height)
                );

                designerAIComposerHeight = nextHeight;

                $composer.css({
                    height: `${nextHeight}px`,
                    minHeight: `${minComposerHeight}px`,
                    flex: `0 0 ${nextHeight}px`
                });

                $body.css({
                    flex: "1 1 auto",
                    minHeight: `${minBodyHeight}px`
                });

                try { aiPromptBox?.repaint?.(); } catch { /* ignore */ }
            };

            const onMove = (event: any): void => {
                if (!dragging) return;

                const currentY = Number(event.clientY || 0);
                const delta = startY - currentY;

                applyHeight(startHeight + delta);
                event.preventDefault?.();
            };

            const stopDragging = (): void => {
                if (!dragging) return;

                dragging = false;
                $("body").removeClass("ca-md-resizing-horizontal");

                $(document)
                    .off("mousemove.caModelDesignerAISplitter", onMove)
                    .off("mouseup.caModelDesignerAISplitter", stopDragging);
            };

            $splitter.on("mousedown", (event: any) => {
                dragging = true;
                startY = Number(event.clientY || 0);
                startHeight =
                    Number($composer.outerHeight()) ||
                    designerAIComposerHeight;

                $("body").addClass("ca-md-resizing-horizontal");

                $(document)
                    .on("mousemove.caModelDesignerAISplitter", onMove)
                    .on("mouseup.caModelDesignerAISplitter", stopDragging);

                event.preventDefault?.();
                event.stopPropagation?.();
            });
        }

        function ensureStyle(): void {
            if (document.getElementById(STYLE_ID)) return;

            $("<style>")
                .attr("id", STYLE_ID)
                .text(`
                    .ca-md-root { height: 100%; display: flex; overflow: hidden; }
                    .ca-md-left { width: 360px; min-width: 240px; flex: 0 0 360px; display: flex; flex-direction: column; }
                    .ca-md-center { flex: 1 1 auto; min-width: 420px; display: flex; flex-direction: column; }
                    .ca-md-right { width: 360px; min-width: 300px; flex: 0 0 360px; display: flex; flex-direction: column; }
                    .ca-md-v-splitter { flex: 0 0 7px; width: 7px; cursor: col-resize; position: relative; background: rgba(128,128,128,.08); border-left: 1px solid rgba(128,128,128,.22); border-right: 1px solid rgba(128,128,128,.22); }
                    .ca-md-v-splitter:hover, .ca-md-resizing .ca-md-v-splitter { background: rgba(37,99,235,.20); }
                    .ca-md-v-splitter::after { content: ""; position: absolute; top: 50%; left: 2px; width: 2px; height: 42px; transform: translateY(-50%); border-left: 1px solid rgba(128,128,128,.7); border-right: 1px solid rgba(128,128,128,.7); }
                    .ca-md-resizing { cursor: col-resize !important; user-select: none !important; }
                    .ca-md-toolbar { min-height: 42px; display: flex; align-items: center; gap: 8px; padding: 6px 8px; border-bottom: 1px solid rgba(128,128,128,.35); }
                    .ca-md-title { font-weight: 700; font-size: 15px; padding: 0 4px; white-space: nowrap; }
                    .ca-md-toolbar-spacer { flex: 1 1 auto; min-width: 12px; }
                    .ca-md-property-search { flex: 0 1 320px; min-width: 180px; max-width: 360px; }
                    .ca-md-property-search .dx-texteditor { width: 100%; }
                    .ca-md-tree-wrap { flex: 1; min-height: 0; overflow: auto; padding: 6px; }
                    .ca-md-grid-wrap { flex: 1; min-height: 0; padding: 8px; }
                    .ca-md-info { min-height: 96px; max-height: 160px; overflow: auto; padding: 10px; border-top: 1px solid rgba(128,128,128,.35); }
                    .ca-md-info-title { font-weight: 700; margin-bottom: 4px; }
                    .ca-md-ai-header { min-height: 42px; display: flex; align-items: center; padding: 0 12px; border-bottom: 1px solid rgba(128,128,128,.35); font-weight: 700; font-size: 15px; }
                    .ca-md-ai-body { flex: 1 1 auto; min-height: 180px; overflow: auto; padding: 12px; }
                    .ca-md-ai-msg { border: 1px solid rgba(128,128,128,.25); border-radius: 10px; padding: 10px 12px; margin-bottom: 10px; line-height: 1.4; white-space: pre-wrap; overflow-wrap: anywhere; }
                    .ca-md-ai-msg-user { margin-left: 24px; background: rgba(37,99,235,.10); }
                    .ca-md-ai-msg-assistant { margin-right: 24px; background: rgba(128,128,128,.08); }
                    .ca-md-ai-msg-error { border-color: rgba(220,38,38,.55); background: rgba(220,38,38,.08); }
                    .ca-md-ai-plan { margin-top: 8px; padding-top: 8px; border-top: 1px solid rgba(128,128,128,.25); font-family: Consolas, Monaco, 'Courier New', monospace; font-size: 12px; white-space: pre-wrap; }
                    .ca-md-ai-apply-preview { height: 100%; box-sizing: border-box; overflow-y: auto; padding: 4px 8px 12px 2px; }
                    .ca-md-ai-apply-summary { margin-bottom: 12px; opacity: .82; }
                    .ca-md-ai-operation { padding: 10px 12px; margin: 0 0 8px; border: 1px solid rgba(128,128,128,.24); border-radius: 6px; }
                    .ca-md-ai-operation-title { font-weight: 600; margin-bottom: 3px; }
                    .ca-md-ai-operation-detail { opacity: .8; font-size: 12px; }
                    .ca-md-ai-context { margin: 0 12px 8px 12px; padding: 8px 10px; border: 1px solid rgba(128,128,128,.20); border-radius: 8px; font-size: 12px; opacity: .82; }
                    .ca-md-ai-apply-state { margin: 0 12px 8px 12px; padding: 8px 10px; border: 1px solid rgba(22,163,74,.45); border-radius: 8px; font-size: 12px; background: rgba(22,163,74,.10); display: none; }
                    .ca-md-ai-apply-state-visible { display: block; }
                    .ca-md-ai-apply-state-title { font-weight: 700; margin-bottom: 2px; }
                    .ca-md-ai-apply-state-detail { opacity: .82; }
                    .ca-md-ai-context-toolbar { margin: 8px 12px 6px 12px; display: flex; gap: 6px; align-items: flex-end; }
                    .ca-md-ai-context-mode { flex: 1 1 auto; min-width: 0; }
                    .ca-md-ai-project-brief-button { flex: 0 0 auto; }
                    .ca-md-ai-project-brief-state { margin: 0 12px 6px 12px; font-size: 11px; opacity: .72; }
                    .ca-md-ai-intent { display: inline-block; margin-bottom: 6px; padding: 2px 7px; border-radius: 999px; background: rgba(37,99,235,.16); font-size: 11px; font-weight: 600; }
                    .ca-md-ai-section { margin-top: 8px; padding-top: 7px; border-top: 1px solid rgba(128,128,128,.20); }
                    .ca-md-ai-section-title { font-weight: 600; margin-bottom: 4px; }
                    .ca-md-ai-section-item { margin: 3px 0 3px 14px; }
                    .ca-md-ai-horizontal-splitter { flex: 0 0 10px; height: 10px; min-height: 10px; cursor: row-resize; position: relative; background: rgba(128,128,128,.10); border-top: 1px solid rgba(128,128,128,.24); border-bottom: 1px solid rgba(128,128,128,.24); box-sizing: border-box; }
                    .ca-md-ai-horizontal-splitter:hover, .ca-md-resizing-horizontal .ca-md-ai-horizontal-splitter { background: rgba(37,99,235,.20); }
                    .ca-md-ai-horizontal-splitter::after { content: ""; position: absolute; left: 50%; top: 3px; width: 42px; height: 2px; transform: translateX(-50%); border-top: 1px solid rgba(160,160,160,.85); border-bottom: 1px solid rgba(160,160,160,.85); }
                    .ca-md-ai-composer { flex: 0 0 156px; height: 156px; min-height: 118px; padding: 10px 12px 12px 12px; box-sizing: border-box; overflow: hidden; }
                    .ca-md-ai-composer-row { height: 100%; display: flex; flex-direction: column; align-items: stretch; gap: 8px; }
                    .ca-md-ai-prompt { flex: 1 1 auto; min-width: 0; width: 100%; min-height: 0; }
                    .ca-md-ai-prompt .dx-textarea, .ca-md-ai-prompt .dx-texteditor-container { height: 100% !important; width: 100% !important; }
                    .ca-md-ai-composer-actions { flex: 0 0 auto; display: flex; justify-content: flex-end; align-items: center; gap: 8px; width: 100%; }
                    body.ca-md-resizing-horizontal { cursor: row-resize !important; user-select: none !important; }
                    .ca-md-ai-msg-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 9px; padding-top: 8px; border-top: 1px solid rgba(128,128,128,.20); }
                    .ca-md-ai-send { flex: 0 0 auto; }
                    .ca-md-ai-apply { flex: 0 0 auto; }
                    .ca-md-ai-thinking { display: flex; align-items: center; gap: 8px; opacity: .82; }
                    .ca-md-ai-thinking-dot { width: 8px; height: 8px; border-radius: 50%; background: currentColor; animation: ca-md-ai-pulse 1.1s ease-in-out infinite; }
                    .ca-md-ai-thinking-dot:nth-child(2) { animation-delay: .15s; }
                    .ca-md-ai-thinking-dot:nth-child(3) { animation-delay: .30s; }
                    @keyframes ca-md-ai-pulse { 0%, 80%, 100% { opacity: .25; transform: scale(.82); } 40% { opacity: 1; transform: scale(1); } }
                     .ca-md-node-icon {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 30px;
                        min-width: 30px;
                        height: 24px;
                        border-radius: 7px;
                        font-size: 18px;
                        line-height: 1;
                        font-weight: 700;
                        opacity: .98;
                        background: rgba(128,128,128,.12);
                        color: inherit;
                        box-sizing: border-box;
                    }
                    .ca-md-icon-app { background: rgba(37,99,235,.14); color: #2563eb; }
                    .ca-md-icon-type { background: rgba(37,99,235,.13); color: #1d4ed8; }
                    .ca-md-icon-property { background: rgba(100,116,139,.16); color: #475569; }
                    .ca-md-icon-collection { background: rgba(8,145,178,.15); color: #0891b2; }
                    .ca-md-icon-view { background: rgba(22,163,74,.14); color: #15803d; }
                    .ca-md-icon-rule { background: rgba(220,38,38,.13); color: #dc2626; }
                    .ca-md-icon-action { background: rgba(124,58,237,.13); color: #7c3aed; }
                    .ca-md-icon-event { background: rgba(2,132,199,.14); color: #0284c7; }
                    .ca-md-icon-enum { background: rgba(147,51,234,.13); color: #9333ea; }
                    .ca-md-icon-security { background: rgba(15,118,110,.14); color: #0f766e; }
                    .ca-md-icon-script { background: rgba(79,70,229,.13); color: #4f46e5; }
                    .ca-md-icon-navigation { background: rgba(217,119,6,.14); color: #b45309; }
                    .ca-md-icon-theme { background: rgba(219,39,119,.13); color: #db2777; }
                    .ca-md-icon-data { background: rgba(5,150,105,.14); color: #059669; }
                    .ca-md-icon-doc { background: rgba(75,85,99,.13); color: #4b5563; }
                    .ca-md-icon-value { background: rgba(202,138,4,.14); color: #a16207; }
                    .ca-md-icon-link { background: rgba(14,165,233,.14); color: #0369a1; }
                    .ca-md-icon-code { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-size: 13px; }
                    .ca-md-property-grid .dx-datagrid-headers { display: none; }
                    .ca-md-property-grid .dx-row > td { padding-top: 2px; padding-bottom: 2px; }
                    .ca-md-property-grid .dx-group-row td { font-weight: 700; }
                    .ca-md-prop-name { font-weight: 500; }
                    .ca-md-required { margin-left: 4px; font-weight: 700; color: #d9822b; }
                    .ca-md-tree-row {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        width: 100%;
                        min-height: 26px;
                    }

                    .ca-md-tree-text {
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: 24px;
                    }

                    .ca-md-tree-add {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 24px;
                        min-width: 26px;
                    }

                    .ca-md-tree-add .dx-button {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .ca-md-tree-add .dx-button-content {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 0;
                        padding-bottom: 0;
                    }
                    .ca-md-popup .dx-popup-title {
                        padding: 0 10px;
                        min-height: 48px;
                        height: 48px;
                        box-sizing: border-box;
                    }

                    .ca-md-popup .dx-popup-title .dx-toolbar {
                        height: 48px;
                        min-height: 48px;
                    }

                    .ca-md-popup .dx-popup-title .dx-toolbar-items-container {
                        height: 48px;
                        min-height: 48px;
                    }

                    .ca-md-popup .dx-popup-title .dx-toolbar-before,
                    .ca-md-popup .dx-popup-title .dx-toolbar-after {
                        display: flex;
                        align-items: center;
                        height: 48px;
                    }

                    .ca-md-popup .dx-popup-title .dx-toolbar-item,
                    .ca-md-popup .dx-popup-title .dx-toolbar-item-content {
                        display: flex;
                        align-items: center;
                        height: 48px;
                        overflow: hidden;
                    }

                    .ca-md-popup-toolbar-title {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        height: 48px;
                        overflow: hidden;
                        box-sizing: border-box;
                    }

                    .ca-md-popup-toolbar-logo {
                        display: block;
                        height: 34px;
                        max-height: 34px;
                        max-width: 140px;
                        width: auto;
                        object-fit: contain;
                        flex: 0 0 auto;
                    }

                    .ca-md-popup-toolbar-title-text {
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 20px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .ca-md-popup-toolbar-title {
                        transform: translateY(-5px);
                    }

                    .ca-md-code-textarea textarea {
                        font-family: Consolas, Monaco, 'Courier New', monospace;
                        font-size: 13px;
                        line-height: 1.45;
                    }

                    .ca-md-code-editor-host {
                        background: var(--dx-base-bg, transparent);
                    }
                    .ca-md-page-popup .dx-overlay-content { border-radius: 0 !important; box-shadow: none !important; }
                    .ca-md-page-popup .dx-popup-content { padding: 0 !important; }

                `)
                .appendTo(document.head);
        }

        function cloneData<T>(src: T, map = new WeakMap<object, any>()): T {
            if (src === null || src === undefined) return src;

            const srcType = typeof src;
            if (srcType === "function") return undefined as T;
            if (srcType !== "object") return src;

            const obj: any = src as any;
            if (obj instanceof Date) return new Date(obj.getTime()) as any;
            if (map.has(obj)) return map.get(obj);

            if (Array.isArray(obj)) {
                const arr: any[] = [];
                map.set(obj, arr);
                for (const item of obj) {
                    const cloned = cloneData(item, map);
                    if (cloned !== undefined) arr.push(cloned);
                }
                return arr as any;
            }

            const result: any = {};
            map.set(obj, result);

            Object.keys(obj).forEach(key => {
                if (key.startsWith("__")) return;
                const val = obj[key];
                if (typeof val === "function") return;
                const cloned = cloneData(val, map);
                if (cloned !== undefined) result[key] = cloned;
            });

            return result;
        }

        function normalizeQueryResult(result: any): AnyDoc[] {
            if (Array.isArray(result)) return result;
            if (Array.isArray(result?.data)) return result.data;
            if (Array.isArray(result?.items)) return result.items;
            if (Array.isArray(result?.result)) return result.result;
            if (Array.isArray(result?.documents)) return result.documents;
            return [];
        }

        async function loadDesignerMetamodel(): Promise<AnyDoc[]> {
            const response = await fetch("services/cosmoAppModel.ashx", {
                method: "GET",
                credentials: "same-origin",
                cache: "no-store",
                headers: {
                    "Accept": "application/json"
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(
                    `Failed to load CosmoApps metamodel: ${response.status} ${response.statusText}` +
                    (errorText ? `\n${errorText}` : "")
                );
            }

            const result = await response.json();
            return normalizeQueryResult(result);
        }

        function isTrashDoc(doc: AnyDoc): boolean {
            return !!doc && !!doc.ttl && !!doc.DropDate;
        }

        function nameOf(obj: AnyDoc): string {
            if (!obj) return "(no name)";

            // Navigation items have a technical Name and a user-facing Caption.
            // The model tree should display the same caption the runtime menu shows,
            // while keeping Name intact for serialization and technical references.
            const explicitEntityName =
                String(
                    obj?.__typeEntity?.Name ||
                    ""
                ).trim();

            if (
                explicitEntityName === "Menu" &&
                obj?.Caption
            ) {
                return String(obj.Caption);
            }

            return obj?.Name || obj?.Caption || obj?.TypeName || obj?.id || "(no name)";
        }

        function readRuntimeArray(name: string): AnyDoc[] {
            const value = runtime ? runtime[name] : null;
            return Array.isArray(value) ? cloneData(value) : [];
        }

        function isMetaEntityDoc(doc: AnyDoc): boolean {
            return !!doc && META_ENTITY_DERIVED_TYPES.indexOf(doc._type) >= 0 && Array.isArray(doc.Properties);
        }

        function isEnumDoc(doc: AnyDoc): boolean {
            return !!doc && !isTrashDoc(doc) && Array.isArray(doc.Values) && !!doc.Name && doc._type !== PROPERTY_TYPE;
        }

        function getRuntimeObjectsArray(createIfMissing = false): AnyDoc[] {
            if (Array.isArray(runtime.objects)) return runtime.objects;
            if (createIfMissing) { runtime.objects = []; return runtime.objects; }
            return [];
        }

        function getRuntimeEnumsArray(createIfMissing = false): AnyDoc[] {
            if (Array.isArray(runtime.enums)) return runtime.enums;
            if (createIfMissing) { runtime.enums = []; return runtime.enums; }
            return [];
        }

        function getRuntimeNavigationItemsArray(createIfMissing = false): AnyDoc[] {
            if (Array.isArray(runtime.navigationItems)) return runtime.navigationItems;
            if (createIfMissing) { runtime.navigationItems = []; return runtime.navigationItems; }
            return [];
        }

        function getRuntimeAllowedUsersArray(createIfMissing = false): AnyDoc[] {
            if (Array.isArray(runtime.AllowedUsers)) return runtime.AllowedUsers;
            if (createIfMissing) { runtime.AllowedUsers = []; return runtime.AllowedUsers; }
            return [];
        }

        function getRuntimeModuleReferencesArray(createIfMissing = false): AnyDoc[] {
            if (Array.isArray(runtime.References)) return runtime.References;
            if (createIfMissing) { runtime.References = []; return runtime.References; }
            return [];
        }

        function getAllDocs(): AnyDoc[] {
            const all: AnyDoc[] = [];
            if (applicationDoc) all.push(applicationDoc);
            all.push(...docs);
            all.push(...runtimeObjects);
            all.push(...runtimeEnums);

            const seen: Record<string, boolean> = {};
            return all.filter(d => {
                if (!d) return false;
                const key = d.id || `${d._type || ""}_${d.Name || ""}`;
                if (seen[key]) return false;
                seen[key] = true;
                return true;
            });
        }

        function getModelTypes(): AnyDoc[] {
            return getAllDocs()
                .filter(isMetaEntityDoc)
                .sort((a, b) => {
                    const ia = Number(a.Index ?? 999999);
                    const ib = Number(b.Index ?? 999999);
                    if (ia !== ib) return ia - ib;
                    return String(a.Name || "").localeCompare(String(b.Name || ""));
                });
        }

        function getModelEnums(): AnyDoc[] {
            const candidates: AnyDoc[] = [];

            if (Array.isArray(applicationDoc?.Enums)) candidates.push(...applicationDoc.Enums);
            candidates.push(...runtimeEnums);
            candidates.push(...docs.filter(isEnumDoc));

            const seen: Record<string, boolean> = {};

            return candidates
                .filter(x => !!x && !isTrashDoc(x))
                .filter(x => {
                    const key = x.id || x.Name;
                    if (!key || seen[key]) return false;
                    seen[key] = true;
                    return true;
                })
                .sort((a, b) => nameOf(a).localeCompare(nameOf(b)));
        }

        function getCategories(): AnyDoc[] {
            return getAllDocs()
                .filter(d => d._type === CATEGORY_TYPE)
                .sort((a, b) => nameOf(a).localeCompare(nameOf(b)));
        }

        function getIcons(): AnyDoc[] {
            return getAllDocs()
                .filter(d => d._type === ICON_TYPE)
                .sort((a, b) => nameOf(a).localeCompare(nameOf(b)));
        }

        function getIconByRef(ref: any): AnyDoc | null {
            if (!ref) return null;

            if (typeof ref === "object") {
                if (ref.Content) return ref;

                const refId = String(ref.id || "");
                const refName = String(ref.Name || "");

                return getIcons().find(icon =>
                    (!!refId && icon.id === refId) ||
                    (!!refName && icon.Name === refName)
                ) || null;
            }

            const text = String(ref);
            if (!text) return null;

            return getIcons().find(icon => icon.id === text || icon.Name === text) || null;
        }

        function getIconContent(ref: any): string | null {
            if (!ref) return null;

            const icon = getIconByRef(ref);
            const content = icon?.Content || ref?.Content || null;
            if (content) return String(content);

            if (typeof ref === "string") {
                const text = ref.trim();
                if (text && Array.from(text).length <= 4 && !/^[A-Za-z0-9_-]+$/.test(text)) {
                    return text;
                }
            }

            return null;
        }

        const designedEntityIcons: Record<string, string> = {
            Application: "◆",
            MetaEntity: "T",
            MetaType: "T",
            Type: "T",
            Entity: "T",
            MetaProperty: "P",
            Property: "P",
            ViewProperty: "P",
            MetaCollection: "C",
            Collection: "C",
            DataType: "D",
            Icon: "✦",
            MetaPropertyCategory: "G",
            Category: "G",
            MetaPropertyValue: "#",
            EnumValue: "#",
            Enum: "E",
            Formula: "ƒ",
            Rule: "!",
            Action: "▶",
            Event: "⚡",
            View: "V",
            ViewGroup: "▦",
            ViewItem: "◇",
            SecurityRole: "S",
            SecurityPermission: "🔒",
            UserDesignerAccess: "ID",
            Script: "{}",
            Code: "</>",
            CodeExpression: "ƒx",
            ModuleReferences: "↔",
            ModuleReferense: "↔",
            Theme: "◐",
            Menu: "☰",
            NavigationItem: "↗",
            Language: "🌐",
            Documentation: "📄",
            Doc: "📄"
        };

        const designedCollectionIcons: Record<string, string> = {
            Types: "T",
            Entities: "T",
            Properties: "P",
            Collections: "C",
            Enums: "E",
            Values: "#",
            Rules: "!",
            Actions: "▶",
            Events: "⚡",
            Views: "V",
            ViewGroups: "▦",
            ViewItems: "◇",
            Navigation: "↗",
            NavigationItems: "↗",
            ModuleReferences: "↔",
            ManageAccess: "S",
            SecurityRoles: "S",
            SecurityPermissions: "🔒",
            Scripts: "{}",
            Themes: "◐",
            Languages: "🌐",
            Icons: "✦",
            Categories: "G"
        };

        const designedIconKinds: Record<string, string> = {
            Application: "app",
            MetaEntity: "type",
            MetaType: "type",
            Type: "type",
            Entity: "type",
            MetaProperty: "property",
            Property: "property",
            ViewProperty: "property",
            MetaCollection: "collection",
            Collection: "collection",
            DataType: "data",
            Icon: "theme",
            MetaPropertyCategory: "property",
            Category: "property",
            MetaPropertyValue: "value",
            EnumValue: "value",
            Enum: "enum",
            Formula: "code",
            Rule: "rule",
            Action: "action",
            Event: "event",
            View: "view",
            ViewGroup: "view",
            ViewItem: "view",
            SecurityRole: "security",
            SecurityPermission: "security",
            UserDesignerAccess: "security",
            Script: "script",
            Code: "script",
            CodeExpression: "code",
            ModuleReferences: "link",
            ModuleReferense: "link",
            Theme: "theme",
            Menu: "navigation",
            NavigationItem: "navigation",
            Language: "data",
            Documentation: "doc",
            Doc: "doc"
        };

        const designedCollectionIconKinds: Record<string, string> = {
            Types: "type",
            Entities: "type",
            Properties: "property",
            Collections: "collection",
            Enums: "enum",
            Values: "value",
            Rules: "rule",
            Actions: "action",
            Events: "event",
            Views: "view",
            ViewGroups: "view",
            ViewItems: "view",
            Navigation: "navigation",
            NavigationItems: "navigation",
            ModuleReferences: "link",
            ManageAccess: "security",
            SecurityRoles: "security",
            SecurityPermissions: "security",
            Scripts: "script",
            Themes: "theme",
            Languages: "data",
            Icons: "theme",
            Categories: "property"
        };

        function normalizeIconKey(value: any): string {
            return String(value || "").trim().replace(/\s+/g, "");
        }

        function getDesignedIconByName(name: any, fallback: string | null = null): string | null {
            const key = normalizeIconKey(name);
            if (!key) return fallback;
            return designedEntityIcons[key] || fallback;
        }

        function getDesignedIconKindByName(name: any, fallback: string | null = null): string | null {
            const key = normalizeIconKey(name);
            if (!key) return fallback;
            return designedIconKinds[key] || fallback;
        }

        function getMetaEntityIconKind(entity: AnyDoc | null | undefined): string | null {
            if (!entity) return null;
            return getDesignedIconKindByName(entity.Name);
        }

        function getMetaEntityIconKindByRef(ref: any): string | null {
            return getMetaEntityIconKind(resolveMetaEntityRef(ref));
        }

        function getDataKindIconKind(valueType: any, valueKind?: any): string | null {
            const kind = String(valueKind ?? "").toLowerCase();
            const type = String(valueType ?? "").toLowerCase();

            if (kind === "1" || kind === "entityref" || type === "-1" || type === "entityref" || type === "type") return "link";
            if (kind === "2" || kind === "enum" || type === "-2" || type === "enum") return "enum";
            if (kind === "3" || kind === "expression") return "code";
            if (kind === "4" || kind === "json") return "script";
            if (kind === "5" || kind === "script") return "script";
            if (type === "2" || type === "3" || type === "int" || type === "float" || type === "number" || type === "money") return "value";
            if (type === "4" || type === "boolean") return "value";
            if (type === "8" || type === "color") return "theme";
            if (type === "9" || type === "email" || type === "10" || type === "url") return "link";

            return "property";
        }

        function getPropertyDesignIconKind(prop: AnyDoc | null | undefined, fallback = "property"): string {
            if (!prop) return fallback;

            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (typeEntity) return getMetaEntityIconKind(typeEntity) || fallback;

            return getDataKindIconKind(prop.ValueType, prop.ValueKind) || fallback;
        }

        function getCollectionIconKind(collection: AnyDoc | null | undefined): string {
            if (!collection) return "collection";

            const collectionName = normalizeIconKey(collection.Name || collection.OldName);
            const byCollectionName = designedCollectionIconKinds[collectionName];
            if (byCollectionName) return byCollectionName;

            if (collection.__sourceProperty) return getPropertyDesignIconKind(collection.__sourceProperty, "collection");

            return getMetaEntityIconKindByRef(collection.ItemEntity) ||
                getMetaEntityIconKindByRef(collection.__sourceProperty?.TypeEntity) ||
                "collection";
        }

        function getNodeIconKind(node: DesignerTreeNode): string {
            if (!node) return "doc";
            if (node.kind === "collection") return getCollectionIconKind(node.collection);
            if (node.property) return getPropertyDesignIconKind(node.property, "property");
            if (node.doc) {
                const schema = getSchemaForObject(node.doc, node.collection);
                if (schema) return getMetaEntityIconKind(schema) || "doc";
                if (node.doc._type === APPLICATION_TYPE) return "app";
                if (node.doc._type === PROPERTY_TYPE) return "property";
                if (node.doc._type === COLLECTION_TYPE) return "collection";
            }
            return "doc";
        }

        function getMetaEntityIcon(entity: AnyDoc | null | undefined): string | null {
            if (!entity) return null;
            return getDesignedIconByName(entity.Name);
        }

        function getMetaEntityIconByRef(ref: any): string | null {
            return getMetaEntityIcon(resolveMetaEntityRef(ref));
        }

        function getMetaEntityIconByName(name: string): string | null {
            return getDesignedIconByName(name) || getMetaEntityIcon(getMetaEntityByName(name));
        }

        function getTypeIconBySchemaName(name: string, fallback = "·"): string {
            if (!name) return fallback;
            return getMetaEntityIconByName(name) || fallback;
        }

        function getDataKindIcon(valueType: any, valueKind?: any): string | null {
            const kind = String(valueKind ?? "").toLowerCase();
            const type = String(valueType ?? "").toLowerCase();

            if (kind === "1" || kind === "entityref" || type === "-1" || type === "entityref" || type === "type") return "↗";
            if (kind === "2" || kind === "enum" || type === "-2" || type === "enum") return "E";
            if (kind === "3" || kind === "expression") return "ƒ";
            if (kind === "4" || kind === "json") return "{}";
            if (kind === "5" || kind === "script") return "</>";

            if (type === "4" || type === "boolean") return "✓";
            if (type === "1" || type === "string") return "Aa";
            if (type === "0" || type === "text" || type === "html") return "¶";
            if (type === "2" || type === "3" || type === "int" || type === "float" || type === "number" || type === "money") return "#";
            if (type === "5" || type === "6" || type === "date" || type === "datetime") return "◷";
            if (type === "7" || type === "time") return "◷";
            if (type === "8" || type === "color") return "◐";
            if (type === "9" || type === "email") return "@";
            if (type === "10" || type === "url") return "↗";

            return null;
        }

        function getPropertyDesignIcon(prop: AnyDoc | null | undefined, fallback = "P"): string {
            if (!prop) return fallback;

            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (typeEntity) return getMetaEntityIcon(typeEntity) || fallback;

            const dataIcon = getDataKindIcon(prop.ValueType, prop.ValueKind);
            if (dataIcon) return dataIcon;

            if (prop.Many) return "M";
            return fallback;
        }

        function getCollectionIcon(collection: AnyDoc): string {
            if (!collection) return getTypeIconBySchemaName("MetaCollection", "C");

            const collectionName = normalizeIconKey(collection.Name || collection.OldName);
            const byCollectionName = designedCollectionIcons[collectionName];
            if (byCollectionName) return byCollectionName;

            const sourcePropIcon = getPropertyDesignIcon(collection.__sourceProperty, "");
            if (sourcePropIcon) return sourcePropIcon;

            return getMetaEntityIconByRef(collection.ItemEntity) ||
                getMetaEntityIconByRef(collection.__sourceProperty?.TypeEntity) ||
                getTypeIconBySchemaName("MetaCollection", "C");
        }

        function getTypedPropertyIcon(prop: AnyDoc): string {
            return getPropertyDesignIcon(prop, "◇");
        }

        function getMetaEntityById(id: string): AnyDoc | null {
            if (!id) return null;
            return getModelTypes().find(d => d.id === id) || null;
        }

        function getMetaEntityByName(name: string): AnyDoc | null {
            if (!name) return null;
            return getModelTypes().find(d => d.Name === name) || null;
        }

        function getLegacyNameByKind(kind: number): string | null {
            const allEnums = getModelEnums();
            const systemEnum = allEnums.find(en => en.Name === "SystemEntityEnum");
            const item = systemEnum?.Values?.find((v: any) => Number(v.Value) === Number(kind));
            return item?.Name || legacyKindNames[kind] || null;
        }

        function getMetaEntityByLegacyKind(kind: number): AnyDoc | null {
            const name = getLegacyNameByKind(kind);
            if (!name) return null;

            // В данных есть опечатка ModuleReferense, а тип называется ModuleReferences.
            if (name === "ModuleReferense") return getMetaEntityByName("ModuleReferences");
            if (name === "NavigationItem") return getMetaEntityByName("Menu");

            return getMetaEntityByName(name);
        }

        function resolveMetaEntityRef(ref: any): AnyDoc | null {
            if (ref === undefined || ref === null || ref === "") return null;

            if (typeof ref === "object") {
                if (ref.id) return getMetaEntityById(ref.id) || getMetaEntityByName(ref.Name);
                if (ref.Name) return getMetaEntityByName(ref.Name);
                return null;
            }

            if (typeof ref === "string") {
                return getMetaEntityById(ref) || getMetaEntityByName(ref);
            }

            if (typeof ref === "number") {
                return getMetaEntityByLegacyKind(ref);
            }

            return null;
        }

        function findApplicationDoc(): AnyDoc | null {
            const applicationSchema = docs.find(d =>
                d &&
                d._type === APPLICATION_TYPE &&
                Array.isArray(d.Properties) &&
                Array.isArray(d.Collections)
            );

            if (!applicationSchema) {
                return {
                    ...cloneData(runtime),
                    _type: APPLICATION_TYPE,
                    Properties: [],
                    Collections: []
                };
            }

            const result = cloneData(applicationSchema);

            Object.keys(runtime || {}).forEach(key => {
                if (key === "objects") return;
                if (key === "enums") return;
                if (key === "navigationItems") return;
                if (key === "AllowedUsers") return;
                if (key === "References") return;
                if (key === "views") return;

                const value = runtime[key];

                if (typeof value !== "function") {
                    result[key] = cloneData(value);
                }
            });

            result.id = runtime.id;
            result.Name = runtime.Name || runtime.ModuleName || runtime.id;
            result.ModuleName = runtime.ModuleName || runtime.Name;
            result._type = APPLICATION_TYPE;

            return result;
        }

        function getSchemaForObject(obj: AnyDoc, collection?: AnyDoc): AnyDoc | null {
            if (!obj) return null;

            if (collection?.ItemEntity !== undefined && collection?.ItemEntity !== null && obj !== collection) {
                const byCollection = resolveMetaEntityRef(collection.ItemEntity);
                if (byCollection) return byCollection;
            }

            if (obj.__typeEntity) {
                const byTypedProperty = resolveMetaEntityRef(obj.__typeEntity);
                if (byTypedProperty) return byTypedProperty;
            }

            if (applicationDoc && obj === applicationDoc) return applicationDoc;

            if (obj._type === "_Type") {
                return getMetaEntityByName("Type") || getMetaEntityByName("MetaEntity");
            }

            if (isMetaEntityDoc(obj)) {
                return getMetaEntityByName("Type") || getMetaEntityByName("MetaEntity");
            }

            if (obj._type) {
                if (obj._type === PROPERTY_TYPE) return getMetaEntityByName("Property");
                if (obj._type === COLLECTION_TYPE) return getMetaEntityByName("MetaCollection");
                if (obj._type === CATEGORY_TYPE) return getMetaEntityByName("MetaPropertyCategory") || getMetaEntityByName("Category");
                if (obj._type === ICON_TYPE) return getMetaEntityByName("Icon");
                if (obj._type === PROPERTY_VALUE_TYPE) return getMetaEntityByName("EnumValue") || getMetaEntityByName("MetaPropertyValue");

                const byType = getMetaEntityById(obj._type);
                if (byType) return byType;
            }

            return null;
        }

        function lowerFirst(name: string): string {
            if (!name) return name;
            return name.charAt(0).toLowerCase() + name.slice(1);
        }

        function upperFirst(name: string): string {
            if (!name) return name;
            return name.charAt(0).toUpperCase() + name.slice(1);
        }

        function addNameCandidate(list: string[], name: any): void {
            if (!name || typeof name !== "string") return;
            if (list.indexOf(name) < 0) list.push(name);
        }

        function getPropertyStorageNames(prop: AnyDoc): string[] {
            const result: string[] = [];

            addNameCandidate(result, prop?.Name);
            addNameCandidate(result, prop?.OldName);

            if (prop?.Name) {
                addNameCandidate(result, lowerFirst(prop.Name));
                addNameCandidate(result, upperFirst(prop.Name));
            }

            if (prop?.OldName) {
                addNameCandidate(result, lowerFirst(prop.OldName));
                addNameCandidate(result, upperFirst(prop.OldName));
            }

            // Старые/особые имена, которые уже встречаются в модели/runtime.
            const map: Record<string, string[]> = {
                ProjectUrl: ["projectUrl"],
                ServiceUrl: ["serviceUrl"],
                RefUrl: ["refUrl"],
                RegisterMethod: ["registerMethod"],
                AuthMethod: ["authMethod"],
                SelectMethod: ["selectMethod"],
                ByKeyMethod: ["byKeyMethod"],
                UpsertMethod: ["upsertMethod"],
                DeleteMethod: ["deleteMethod", "deleteMethos"],
                NavigationItems: ["navigationItems"],
                Items: ["items"],
                Views: ["views"],
                Types: ["objects"],
                Entities: ["objects"],
                Enums: ["enums"],
                ManageAccess: ["AllowedUsers"],
                ModuleReferences: ["References"],
                Script: ["js"],
                ActionType: ["Type"],
                AppearanceRules: ["ApperanceRules"],
                Properties: ["Properies"]
            };

            const extra = map[prop?.Name] || [];

            extra.forEach(x => addNameCandidate(result, x));

            return result;
        }

        function readOwnValue(obj: AnyDoc, names: string[]): { found: boolean; value: any; name?: string } {
            if (!obj) return { found: false, value: undefined };

            for (const name of names) {
                if (Object.prototype.hasOwnProperty.call(obj, name)) {
                    return {
                        found: true,
                        value: obj[name],
                        name
                    };
                }
            }

            return {
                found: false,
                value: undefined
            };
        }

        function getDefaultValueForDisplay(obj: AnyDoc, prop: AnyDoc): any {
            if (!prop) return undefined;

            // null — это явное отсутствие default, а "0"/"false"/'""' — валидные defaults.
            if (prop.DefaultValue === undefined || prop.DefaultValue === null || prop.DefaultValue === "") {
                return undefined;
            }

            try {
                return parseDefaultValue(prop.DefaultValue, prop, obj, obj?.__parent || obj);
            } catch {
                return prop.DefaultValue;
            }
        }

        function normalizeImageSource(value: any): string | null {
            if (value === undefined || value === null) return null;

            const raw = String(value).trim();

            if (!raw) return null;

            // Уже готовый URL или data-url.
            if (
                raw.startsWith("http://") ||
                raw.startsWith("https://") ||
                raw.startsWith("/") ||
                raw.startsWith("./") ||
                raw.startsWith("../") ||
                raw.startsWith("data:image/")
            ) {
                return raw;
            }

            // SVG base64 часто начинается с PHN2Zy...
            if (raw.startsWith("PHN2Zy") || raw.startsWith("PD94bW")) {
                return `data:image/svg+xml;base64,${raw}`;
            }

            // PNG
            if (raw.startsWith("iVBORw0KGgo")) {
                return `data:image/png;base64,${raw}`;
            }

            // JPEG
            if (raw.startsWith("/9j/")) {
                return `data:image/jpeg;base64,${raw}`;
            }

            // WEBP
            if (raw.startsWith("UklGR")) {
                return `data:image/webp;base64,${raw}`;
            }

            // Fallback: считаем, что это base64-картинка, но тип неизвестен.
            // Большинство браузеров нормально покажет image/png, если данные реально PNG.
            if (/^[A-Za-z0-9+/=\s]+$/.test(raw) && raw.length > 80) {
                return `data:image/png;base64,${raw.replace(/\s/g, "")}`;
            }

            return raw;
        }

        function getApplicationLogoSource(): string | null {
            if (!applicationDoc) return null;

            const logoProp = Array.isArray(applicationDoc.Properties)
                ? applicationDoc.Properties.find((p: AnyDoc) =>
                    p?.Name === "LogoUrl" ||
                    p?.Name === "Logo" ||
                    p?.OldName === "Logo"
                )
                : null;

            const value =
                logoProp
                    ? getObjectValue(applicationDoc, logoProp)
                    : (
                        applicationDoc.LogoUrl ??
                        applicationDoc.Logo ??
                        runtime?.LogoUrl ??
                        runtime?.Logo
                    );

            return normalizeImageSource(value);
        }

        function getObjectValue(obj: AnyDoc, prop: AnyDoc | null): any {
            if (!obj || !prop) return undefined;

            const names = getPropertyStorageNames(prop);

            const own = readOwnValue(obj, names);
            if (own.found) {
                return own.value;
            }

            // Корневой Application-документ является метаданными приложения,
            // но реальные значения части свойств ещё могут жить в runtime app.
            if (obj === applicationDoc && runtime) {
                const runtimeValue = readOwnValue(runtime, names);
                if (runtimeValue.found) {
                    return cloneData(runtimeValue.value);
                }
            }

            return getDefaultValueForDisplay(obj, prop);
        }

        function setObjectValue(obj: AnyDoc, prop: AnyDoc | null, value: any): void {
            if (!obj || !prop) return;

            const names =
                getPropertyStorageNames(
                    prop
                );

            // Preserve the storage shape of an existing legacy runtime object.
            // Example: metamodel ActionType is stored as runtime Action.Type.
            for (
                let index = 0;
                index < names.length;
                index++
            ) {
                const storageName =
                    names[index];

                if (
                    Object.prototype.hasOwnProperty.call(
                        obj,
                        storageName
                    )
                ) {
                    obj[storageName] =
                        value;
                    return;
                }
            }

            const name =
                prop.Name;

            if (
                prop.OldName &&
                Object.prototype.hasOwnProperty.call(
                    obj,
                    prop.OldName
                )
            ) {
                obj[prop.OldName] =
                    value;
                return;
            }

            obj[name] =
                value;
        }

        function getMetaEntityName(ref: any): string {
            const entity = resolveMetaEntityRef(ref);
            return String(entity?.Name || ref?.Name || "").trim();
        }

        function isCodeEntityName(name: string): boolean {
            return name === "Code" || name === "CodeExpression";
        }

        function isCodeProperty(prop: AnyDoc | null | undefined): boolean {
            if (!prop?.TypeEntity) return false;
            return isCodeEntityName(getMetaEntityName(prop.TypeEntity));
        }

        function normalizeCodeLanguage(value: any): string {
            const raw = String(value || "").trim();

            if (!raw) return "JS";

            if (raw.toUpperCase() === "JS") return "JS";
            if (raw.toUpperCase() === "TS") return "TS";
            if (raw.toUpperCase() === "SQL") return "SQL";

            return raw;
        }

        function getDefaultCodeLanguage(typeEntityName: string): string {
            if (typeEntityName === "CodeExpression") return "JS";
            return "JS";
        }

        function makeCodeValue(typeEntity: AnyDoc, oldValue?: any): AnyDoc {
            const typeName = String(typeEntity?.Name || "");

            // Старое поле было строковым: переносим его в .Code.
            const oldText =
                oldValue === undefined || oldValue === null
                    ? ""
                    : typeof oldValue === "string"
                        ? oldValue
                        : typeof oldValue === "object"
                            ? String(oldValue.Code ?? "")
                            : String(oldValue);

            const result: AnyDoc = {
                __typeEntity: makeHybridMetaEntityRef(typeEntity),
                Code: oldText
            };

            if (typeName === "Code") {
                result.Language = getDefaultCodeLanguage(typeName);
            }

            if (typeName === "CodeExpression") {
                result.WithContext = "None";
            }

            return result;
        }

        function ensureCodeValue(owner: AnyDoc, prop: AnyDoc): AnyDoc {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (!typeEntity) return { Code: "" };

            const currentValue = getObjectValue(owner, prop);

            if (currentValue && typeof currentValue === "object" && !Array.isArray(currentValue)) {
                if (!currentValue.__typeEntity) {
                    currentValue.__typeEntity = makeHybridMetaEntityRef(typeEntity);
                }

                if (currentValue.Code === undefined || currentValue.Code === null) {
                    currentValue.Code = "";
                }

                if (typeEntity.Name === "Code" && !currentValue.Language) {
                    currentValue.Language = getDefaultCodeLanguage(typeEntity.Name);
                }

                if (typeEntity.Name === "CodeExpression" && !currentValue.WithContext) {
                    currentValue.WithContext = "None";
                }

                return currentValue;
            }

            const newValue = makeCodeValue(typeEntity, currentValue);
            setObjectValue(owner, prop, newValue);
            return newValue;
        }

        function getCodeEditorMode(codeValue: AnyDoc, typeName: string): string {
            if (typeName === "CodeExpression") return "typescript";

            const lang = normalizeCodeLanguage(codeValue.Language);

            if (lang === "TS") return "typescript";
            if (lang === "SQL") return "sql";

            return "javascript";
        }

        function getCodeDisplayText(value: any): string {
            if (value === undefined || value === null) return "";

            if (typeof value === "string") {
                return value.length > 120 ? value.substring(0, 120) + "..." : value;
            }

            if (typeof value === "object") {
                const code = String(value.Code || "");
                const lang = value.Language ? `[${value.Language}] ` : "";
                const ctx = value.WithContext ? `[${value.WithContext}] ` : "";

                if (!code) return `${lang}${ctx}`.trim();

                return `${lang}${ctx}${code.length > 120 ? code.substring(0, 120) + "..." : code}`;
            }

            return String(value);
        }


        function displayValue(propName: string, value: any): string {
            if (propName === "BaseType") {
                return displayTypeName(value, true);
            }

            if (propName === "Type") {
                return displayTypeName(value, false);
            }

            if (value === undefined || value === null) return "";

            if (Array.isArray(value)) {
                if (propName === "DesignerRoles" || propName === "Roles") {
                    return value.map(x => enumMaps.DesignerRoles.find(r => r.value === x)?.name || String(x)).join(", ");
                }
                return `[${value.length}]`;
            }

            if (enumMaps[propName]) {
                const item = enumMaps[propName].find(x => x.value === value);
                return item ? item.name : String(value);
            }

            if (propName === "ItemEntity" || propName === "TypeEntity") {
                const entity = resolveMetaEntityRef(value);
                return entity?.Name || (typeof value === "object" ? value.Name || value.id : String(value));
            }

            if (value && typeof value === "object" && !Array.isArray(value)) {
                const typeName = getMetaEntityName(value.__typeEntity || value.TypeEntity || value._type);

                if (isCodeEntityName(typeName) || Object.prototype.hasOwnProperty.call(value, "Code")) {
                    return getCodeDisplayText(value);
                }
            }

            if (typeof value === "object") return value.Name || value.Caption || value.id || JSON.stringify(value);
            return String(value);
        }

        function getFallbackRows(obj: AnyDoc): PropertyGridRow[] {
            const skip: Record<string, boolean> = {
                _rid: true,
                _self: true,
                _etag: true,
                _attachments: true,
                _ts: true,
                __parent: true,
                __typeEntity: true
            };

            return Object.keys(obj || {})
                .filter(k => !skip[k])
                .filter(k => !k.startsWith("__"))
                .filter(k => !Array.isArray(obj[k]))
                .map((k, index) => ({
                    id: `${k}_${index}`,
                    category: "General",
                    name: k,
                    value: obj[k]
                }));
        }

        function buildPropertyRows(node: DesignerTreeNode): PropertyGridRow[] {
            if (!node.doc) return [];

            const schema = getSchemaForObject(node.doc, node.collection);
            const props: AnyDoc[] = Array.isArray(schema?.Properties) ? schema.Properties : [];

            if (!props.length) return getFallbackRows(node.doc);

            return props.map((p, index) => ({
                id: `${p.Name}_${index}`,
                category: p.Category?.Name || "General",
                name: p.Name,
                value: getObjectValue(node.doc, p),
                meta: p,
                description: p.Description || p.Note || ""
            }));
        }

        function iconForDocument(doc: AnyDoc, collection?: AnyDoc): string {
            if (!doc) return "·";

            if (doc._type === ICON_TYPE) return "✨";
            if (doc._type === PROPERTY_TYPE || META_ENTITY_DERIVED_TYPES.indexOf(doc._type) >= 0 && (doc.Name === "Property" || doc.Name === "ViewProperty")) {
                return getPropertyDesignIcon(doc, "🔧");
            }

            const schema = getSchemaForObject(doc, collection);
            const schemaIcon = getMetaEntityIcon(schema);
            if (schemaIcon) return schemaIcon;

            if (doc._type === APPLICATION_TYPE) return getTypeIconBySchemaName("Application", "◆");
            if (doc._type === PROPERTY_TYPE) return getPropertyDesignIcon(doc, "🔧");
            if (doc._type === COLLECTION_TYPE) return getCollectionIcon(doc);
            if (doc._type === CATEGORY_TYPE) return getTypeIconBySchemaName("MetaPropertyCategory", "T");
            if (doc._type === PROPERTY_VALUE_TYPE) return getTypeIconBySchemaName("EnumValue", "#");

            return getTypeIconBySchemaName(String(schema?.Name || doc.Name || ""), "·");
        }

        function getCollectionArray(owner: AnyDoc, collection: AnyDoc, createIfMissing = false): AnyDoc[] {
            if (!owner || !collection?.Name) return [];

            const name = collection.Name;

            if (collection.__sourceProperty) {
                const propItems = getSpecialApplicationPropertyItems(owner, collection.__sourceProperty, createIfMissing);
                if (propItems.length || createIfMissing) return propItems;
            }

            if (owner === applicationDoc) {
                if (name === "Types" || name === "Entities") return getRuntimeObjectsArray(createIfMissing);
                if (name === "Enums") return getRuntimeEnumsArray(createIfMissing);
                if (name === "NavigationItems" || name === "Navigation") return getRuntimeNavigationItemsArray(createIfMissing);
                if (name === "ManageAccess") return getRuntimeAllowedUsersArray(createIfMissing);
                if (name === "ModuleReferences") return getRuntimeModuleReferencesArray(createIfMissing);
                if (name === "Views") {
                    if (Array.isArray(runtime.views)) return runtime.views;
                    if (createIfMissing) { runtime.views = []; return runtime.views; }
                }
            }

            const direct = owner[name];
            if (Array.isArray(direct)) return direct;

            // Legacy runtime navigation stores Menu.Items in lowercase `items`.
            // The metamodel collection is named `Items`, so the designer must
            // read/write the old runtime field instead of displaying Items (0).
            if (
                name === "Items" &&
                Array.isArray(owner.items)
            ) {
                return owner.items;
            }

            if (collection.OldName && Array.isArray(owner[collection.OldName])) return owner[collection.OldName];

            if (createIfMissing) {
                if (name === "Items") {
                    owner.items = [];
                    return owner.items;
                }

                owner[name] = [];
                return owner[name];
            }

            return [];
        }

        function getCollectionItems(owner: AnyDoc, collection: AnyDoc): AnyDoc[] {
            return getCollectionArray(owner, collection, false);
        }

        function makeHybridMetaEntityRef(entity: AnyDoc): AnyDoc {
            return entity ? { id: entity.id, Name: entity.Name, _type: entity._type } : null;
        }

        function getSyntheticCollectionsForObject(obj: AnyDoc, existingNames: Record<string, boolean>): AnyDoc[] {
            const result: AnyDoc[] = [];

            if (Array.isArray(obj?.Values) && !existingNames.Values) {
                const enumValueEntity = getMetaEntityByName("EnumValue") || getMetaEntityByName("MetaPropertyValue");

                result.push({
                    id: `${obj.id || obj.Name || "object"}_ValuesDef`,
                    _type: COLLECTION_TYPE,
                    Name: "Values",
                    ItemEntity: enumValueEntity ? makeHybridMetaEntityRef(enumValueEntity) : 11,
                    Aggregation: 1,
                    StorageKind: 0
                });
            }

            return result;
        }

        function makeDocumentNode(
            doc: AnyDoc,
            ownerDoc: AnyDoc,
            path: string[],
            collection?: AnyDoc,
            visited?: WeakSet<object>
        ): DesignerTreeNode {
            const schema =
                getSchemaForObject(
                    doc,
                    collection
                );
            const isMenu =
                String(
                    schema?.Name || ""
                ) === "Menu";

            return {
                id: path.join("/"),
                text: nameOf(doc),
                kind: "document",
                icon: iconForDocument(doc, collection),
                doc,
                ownerDoc,
                collection,
                items: buildObjectChildren(doc, ownerDoc, path, visited),

                // Runtime navigation is normally inspected as a hierarchy.
                // Keep menu/group nodes open so their child navigation items
                // are visible immediately after reload.
                expanded: isMenu
            };
        }



        function makeCollectionNode(
            owner: AnyDoc,
            ownerDoc: AnyDoc,
            collection: AnyDoc,
            path: string[],
            visited?: WeakSet<object>
        ): DesignerTreeNode {
            const items = getCollectionItems(owner, collection);
            const count = items.length;
            const itemEntity = resolveMetaEntityRef(collection.ItemEntity);

            const ownerSchema =
                getSchemaForObject(owner);
            const expandNavigationItems =
                String(
                    ownerSchema?.Name || ""
                ) === "Menu" &&
                String(
                    collection?.Name || ""
                ) === "Items";

            return {
                id: path.join("/"),
                text: `${collection.Name} (${count})`,
                kind: "collection",
                icon: getCollectionIcon(collection),
                doc: collection,
                ownerDoc,
                containerDoc: owner,
                collection,
                property: collection.__sourceProperty,

                // In the old runtime format Menu.Items contains the actual
                // visible navigation entries. Expand it by default.
                expanded: expandNavigationItems,
                items: items.map((item, index) => {
                    if (item && itemEntity && !item.__typeEntity && !item._type) {
                        item.__typeEntity = makeHybridMetaEntityRef(itemEntity);
                    }

                    const itemId = item?.id || `${index}`;
                    return makeDocumentNode(item, item, path.concat([String(itemId)]), collection, visited);
                })
            };
        }

        function makeTypedPropertyNode(
            owner: AnyDoc,
            ownerDoc: AnyDoc,
            prop: AnyDoc,
            path: string[],
            visited?: WeakSet<object>
        ): DesignerTreeNode | null {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (!typeEntity) return null;

            if (isCodeEntityName(typeEntity.Name)) {
                return null;
            }

            const value = getObjectValue(owner, prop);

            // ВАЖНО:
            // Не создаём виртуальный пустой объект {} для отсутствующего значения.
            // Иначе Code/CodeExpression и другие typed-property могут уйти в бесконечную рекурсию.
            if (!value || typeof value !== "object" || Array.isArray(value)) {
                return null;
            }

            const doc = value;

            if (!doc.__typeEntity) {
                doc.__typeEntity = makeHybridMetaEntityRef(typeEntity);
            }

            return {
                id: path.concat([prop.Name]).join("/"),
                text: prop.Name,
                kind: "document",
                icon: getTypedPropertyIcon(prop),
                doc,
                ownerDoc,
                containerDoc: owner,
                property: prop,
                items: buildObjectChildren(doc, ownerDoc, path.concat([prop.Name]), visited),
                expanded: false
            };
        }


        let monacoLoadPromise: Promise<any> | null = null;
        let monacoContextDisposables: any[] = [];
        let projectDeclarationBundlePromise: Promise<string> | null = null;

        function getProjectNamespaceName(): string {
            debugger;
            const name = safeTsName(
                applicationDoc?.Name ||
                applicationDoc?.id ||
                runtime?.ModuleName ||
                runtime?.Name || app.ModuleName ||
                "CosmoApps"
            );
            return name;
        }

        function getAIApplicationTypeDocs(): AnyDoc[] {
            // IMPORTANT: AI reuse must be based on the application being edited,
            // not on designer/metamodel/runtime objects that may coexist in memory.
            // An explicitly present empty objects array means the project has no types.
            const explicitObjects =
                applicationDoc &&
                    Array.isArray((applicationDoc as AnyDoc).objects)
                    ? (applicationDoc as AnyDoc).objects
                    : null;

            const source: AnyDoc[] = explicitObjects !== null
                ? explicitObjects
                : (
                    applicationDoc &&
                        Array.isArray((applicationDoc as AnyDoc).Objects)
                        ? (applicationDoc as AnyDoc).Objects
                        : (
                            Array.isArray(runtime?.objects)
                                ? runtime.objects
                                : runtimeObjects
                        )
                );

            const seen: Record<string, boolean> = {};

            return (Array.isArray(source) ? source : [])
                .filter((x: AnyDoc) => x && x.Name)
                .filter((x: AnyDoc) => !x._type || x._type === "_Type")
                .filter((x: AnyDoc) => {
                    const key = String(x.id || x.Name || "");
                    if (!key || seen[key]) return false;
                    seen[key] = true;
                    return true;
                })
                .sort((a: AnyDoc, b: AnyDoc) =>
                    String(a.Name).localeCompare(String(b.Name))
                );
        }

        function getAIApplicationEnumDocs(): AnyDoc[] {
            // Same rule as for types: an explicit empty project enum array is authoritative.
            const lowerEnums =
                applicationDoc &&
                    Array.isArray((applicationDoc as AnyDoc).enums)
                    ? (applicationDoc as AnyDoc).enums
                    : null;
            const upperEnums =
                applicationDoc &&
                    Array.isArray((applicationDoc as AnyDoc).Enums)
                    ? (applicationDoc as AnyDoc).Enums
                    : null;

            const source: AnyDoc[] =
                lowerEnums !== null
                    ? lowerEnums
                    : (
                        upperEnums !== null
                            ? upperEnums
                            : (
                                Array.isArray(runtime?.enums)
                                    ? runtime.enums
                                    : runtimeEnums
                            )
                    );

            const seen: Record<string, boolean> = {};

            return (Array.isArray(source) ? source : [])
                .filter((x: AnyDoc) => x && x.Name)
                .filter((x: AnyDoc) => {
                    const key = String(x.id || x.Name || "");
                    if (!key || seen[key]) return false;
                    seen[key] = true;
                    return true;
                })
                .sort((a: AnyDoc, b: AnyDoc) =>
                    String(a.Name).localeCompare(String(b.Name))
                );
        }

        function getAIApplicationNavigationItems(): AnyDoc[] {
            // Runtime navigation is the authoritative current application menu.
            // applicationDoc is a detached metamodel/application projection and
            // may contain stale or schema-level navigation data.
            const source =
                cloneData(
                    getRuntimeNavigationItemsArray(false)
                ) || [];

            const result: AnyDoc[] = [];

            const visit = (
                item: AnyDoc,
                inheritedParentId: string | null,
                parentPath: string,
                depth: number
            ): void => {
                if (!item) return;

                const id = String(item?.id || "").trim();
                const caption = String(
                    item?.Caption ||
                    item?.Name ||
                    id ||
                    "NavigationItem"
                ).trim();
                const explicitParentId =
                    item?.ParentId ||
                    item?.parentId ||
                    null;
                const parentId = explicitParentId
                    ? String(explicitParentId)
                    : inheritedParentId;
                const path = parentPath
                    ? `${parentPath} / ${caption}`
                    : caption;
                const children = Array.isArray(item?.items)
                    ? item.items
                    : [];

                result.push({
                    id: id || null,
                    Name: item?.Name || null,
                    Caption: caption,
                    Type: item?.Type ?? null,
                    js:
                        item?.Type === "<js>"
                            ? String(item?.js || "")
                            : null,
                    EntityId: item?.EntityId ?? null,
                    TargetType: item?.TargetType ?? null,
                    ParentId: parentId || null,
                    IsGroup:
                        item?.IsGroup === true ||
                        (
                            !item?.Type &&
                            !item?.EntityId &&
                            !item?.TargetType &&
                            (
                                children.length > 0 ||
                                depth === 0
                            )
                        ),
                    Depth: depth,
                    Path: path,
                    ChildCount: children.length
                });

                children.forEach((child: AnyDoc) =>
                    visit(
                        child,
                        id || null,
                        path,
                        depth + 1
                    )
                );
            };

            source.forEach((item: AnyDoc) =>
                visit(item, null, "", 0)
            );

            return result;
        }

        function getRuntimeTypeDocs(): AnyDoc[] {
            const source = Array.isArray(runtime?.objects)
                ? runtime.objects
                : runtimeObjects;

            const seen: Record<string, boolean> = {};

            return source
                .filter((x: AnyDoc) => x && x.Name)
                .filter((x: AnyDoc) => !x._type || x._type === "_Type")
                .filter((x: AnyDoc) => {
                    const key = x.id || x.Name;
                    if (seen[key]) return false;
                    seen[key] = true;
                    return true;
                })
                .sort((a: AnyDoc, b: AnyDoc) =>
                    String(a.Name).localeCompare(String(b.Name))
                );
        }

        function getRuntimeTypeById(id: any): AnyDoc | null {
            if (!id) return null;

            return getRuntimeTypeDocs().find((t: AnyDoc) =>
                t.id === id ||
                t.Type === id ||
                t._type === id
            ) || null;
        }

        function getRuntimeTypeByName(name: any): AnyDoc | null {
            if (!name) return null;

            const text = typeof name === "object"
                ? name.Name
                : String(name);

            if (!text) return null;

            return getRuntimeTypeDocs().find((t: AnyDoc) =>
                t.Name === text ||
                t.TypeName === text ||
                String(t.TypeName || "").endsWith("." + text)
            ) || null;
        }

        function getEnumTypeById(id: any): AnyDoc | null {
            if (!id) return null;

            const source = Array.isArray(runtime?.enums)
                ? runtime.enums
                : runtimeEnums;

            return source.find((e: AnyDoc) =>
                e &&
                e.id === id &&
                e.Name
            ) || null;
        }

        function getTypeDocById(id: any): AnyDoc | null {
            if (!id) return null;

            const source = Array.isArray(runtime?.objects)
                ? runtime.objects
                : runtimeObjects;

            return source.find((t: AnyDoc) =>
                t &&
                t.id === id &&
                t.Name
            ) || null;
        }

        function getRuntimePropertyTsType(prop: AnyDoc): string {
            if (!prop) return "any";

            const rawType = prop.Type ?? prop.ValueType;
            let resultType = "any";

            // 1. Scalars.
            if (
                rawType === "string" ||
                rawType === "text" ||
                rawType === "color" ||
                rawType === "email" ||
                rawType === "url" ||
                rawType === "html"
            ) {
                resultType = "string";
            }
            else if (
                rawType === "int" ||
                rawType === "float" ||
                rawType === "number" ||
                rawType === "money"
            ) {
                resultType = "number";
            }
            else if (
                rawType === "boolean" ||
                rawType === "bool"
            ) {
                resultType = "boolean";
            }
            else if (
                rawType === "date" ||
                rawType === "dateTime" ||
                rawType === "time"
            ) {
                resultType = "Date | string";
            }
            else {
                // 2. Enum values are stored as the enum scalar Value.
                const enumDoc = getEnumTypeById(rawType);
                if (enumDoc?.Name) {
                    resultType = safeTsName(enumDoc.Name);
                } else {
                    // 3. Entity references depend on Aggregation/storage semantics.
                    const typeDoc = getTypeDocById(rawType);
                    if (typeDoc?.Name) {
                        const targetType = safeTsName(typeDoc.Name);
                        const aggregation = String(prop.Aggregation || "");

                        if (aggregation === "Value") {
                            resultType = "string";
                        } else if (aggregation === "Hybrid") {
                            resultType = `CosmoHybridRef<${targetType}>`;
                        } else {
                            // Aggregated and Deferred expose typed objects.
                            resultType = targetType;
                        }
                    } else {
                        resultType = "any";
                    }
                }
            }

            if (prop.Many === true) {
                return `${resultType}[]`;
            }

            return resultType;
        }

        function buildRuntimeTypeInterface(typeDoc: AnyDoc): string {
            const name = safeTsName(typeDoc.Name || "Entity");
            const baseName = getBaseClassName(typeDoc);

            const props = Array.isArray(typeDoc.Properties) ? typeDoc.Properties : [];
            const collections = Array.isArray(typeDoc.Collections) ? typeDoc.Collections : [];

            const lines: string[] = [];

            lines.push(`export class ${name} extends ${baseName} {`);
            lines.push(`    constructor(parent?: any, calcDefaults?: boolean, calcFormulas?: boolean);`);
            lines.push(`    static getType(): string;`);
            lines.push(`    static getDerivedTypes(): string[];`);

            // дальше props/collections

            // дальше твой текущий код props/collections без изменений

            props
                .filter((p: AnyDoc) => p && p.Name)
                .sort((a: AnyDoc, b: AnyDoc) => {
                    const ai = Number(a.Index ?? 999999);
                    const bi = Number(b.Index ?? 999999);
                    if (ai !== bi) return ai - bi;
                    return String(a.Name || "").localeCompare(String(b.Name || ""));
                })
                .forEach((p: AnyDoc) => {
                    const propName = quotePropName(p.Name);
                    const optional = p.Required ? "" : "?";
                    const type = getRuntimePropertyTsType(p);

                    const commentParts: string[] = [];
                    if (p.Description) {
                        commentParts.push(String(p.Description).replace(/\*\//g, "* /"));
                    }

                    const referencedEnum = getEnumTypeById(p.Type ?? p.ValueType);
                    const referencedType = getTypeDocById(p.Type ?? p.ValueType);

                    if (referencedEnum?.Name) {
                        commentParts.push(`@enum ${safeTsName(referencedEnum.Name)}`);
                        commentParts.push("@stores scalar-value");
                        commentParts.push("@caption-not-storage");
                    } else if (referencedType?.Name) {
                        const aggregation = String(p.Aggregation || "Value");
                        commentParts.push(`@relation ${aggregation}`);
                        commentParts.push(`@target ${safeTsName(referencedType.Name)}`);
                        if (aggregation === "Value") {
                            commentParts.push("@storage id");
                        } else if (aggregation === "Hybrid") {
                            commentParts.push("@storage embedded-reference");
                            commentParts.push("@fields id, Name, _type plus configured subset only");
                        } else if (aggregation === "Aggregated") {
                            commentParts.push("@storage embedded-owned");
                        } else if (aggregation === "Deferred") {
                            commentParts.push("@storage query-backed");
                        }
                    }

                    if (p.Formula) {
                        commentParts.push("@formula derived-value");
                    }

                    if (commentParts.length) {
                        lines.push("    /**");
                        commentParts.forEach(part => lines.push(`     * ${part}`));
                        lines.push("     */");
                    }

                    lines.push(`    ${propName}${optional}: ${type};`);
                });

            collections
                .filter((c: AnyDoc) => c && c.Name)
                .sort((a: AnyDoc, b: AnyDoc) => {
                    const ai = Number(a.Index ?? 999999);
                    const bi = Number(b.Index ?? 999999);
                    if (ai !== bi) return ai - bi;
                    return String(a.Name || "").localeCompare(String(b.Name || ""));
                })
                .forEach((c: AnyDoc) => {
                    const itemTypeDoc =
                        getTypeDocById(c.ItemEntity) ||
                        getTypeDocById(c.Type) ||
                        getRuntimeTypeByName(c.ItemEntity?.Name || c.Type?.Name || c.ItemEntity || c.Type);

                    const itemType = itemTypeDoc?.Name
                        ? safeTsName(itemTypeDoc.Name)
                        : "any";

                    if (c.Description) {
                        lines.push(`    /** ${String(c.Description).replace(/\*\//g, "* /")} */`);
                    }

                    lines.push(`    ${quotePropName(c.Name)}: ${itemType}[];`);
                });

            lines.push("}");

            return lines.join("\n");
        }

        function buildRuntimeEnumDeclaration(enumDoc: AnyDoc): string {
            const name = safeTsName(enumDoc.Name || "Enum");
            const values = Array.isArray(enumDoc.Values) ? enumDoc.Values : [];

            const lines: string[] = [];

            lines.push(`export enum ${name} {`);

            values.forEach((v: AnyDoc) => {
                const itemName = safeTsName(v.Name || v.Caption || `Value${v.Value}`);
                const value = Number(v.Value);
                const caption = String(v.Caption || "").trim();
                const description = String(v.Description || "").trim();
                const note = [caption, description].filter(Boolean).join(" — ");

                if (note) {
                    lines.push(`    /** ${note.replace(/\*\//g, "* /")} */`);
                }

                if (Number.isFinite(value)) {
                    lines.push(`    ${itemName} = ${value},`);
                } else {
                    lines.push(`    ${itemName} = ${JSON.stringify(String(v.Value ?? v.Name ?? ""))},`);
                }
            });

            lines.push(`}`);

            return lines.join("\n");
        }

        function getRuntimeEnumDocs(): AnyDoc[] {
            const source = Array.isArray(runtime?.enums)
                ? runtime.enums
                : runtimeEnums;

            return source
                .filter((x: AnyDoc) => x && x.Name && Array.isArray(x.Values))
                .sort((a: AnyDoc, b: AnyDoc) =>
                    String(a.Name).localeCompare(String(b.Name))
                );
        }

        function buildRuntimeDeclaration(): string {
            const ns = getProjectNamespaceName();

            return `
interface CosmoAppRuntime {
    id: string;
    ModuleName?: string;
    Name?: string;

    /**
     * Legacy runtime query. Synchronous. Uses native Cosmos/runtime SQL,
     * e.g. SELECT * FROM {s} WHERE s._type = '...' .
     * Semantic DataAPI syntax such as FROM Client or FROM Module.Type is NOT available here.
     */
    query<T = any>(sql: string): T[];
    upsertDocument?<T = any>(doc: T, asunc?: boolean): T;
    deleteDocument?(doc: any): any;
    getType?(type: string): any;
    getLookupObject?(obj: any): any;
    createDocument?(type: any, parent?: any): any;
    calc?(expr: string, data?: any, parent?: any, type?: string | object): any;
}

interface CosmoActionEvent<TData = any, TParent = any, TParams = any> {
    data: TData;
    parent?: TParent;
    params?: TParams;
    view?: any;
    app?: CosmoAppRuntime;
    currentData?: TData;
    [key: string]: any;
}

declare const app: CosmoAppRuntime;
declare const cosmoApp: CosmoAppRuntime;

declare namespace DevExpress {
    namespace ui {
        function notify(message: string, type?: string, displayTime?: number): void;

        namespace dialog {
            function alert(message: string, title?: string): Promise<any>;
            function confirm(message: string, title?: string): Promise<boolean>;
        }

        interface dxDataGrid {
            getSelectedRowsData(): any[];
            getSelectedRowKeys?(): any[];
            refresh(): void;
            saveEditData?(): Promise<any>;
            option(name: string): any;
            option(name: string, value: any): void;
        }
    }

    namespace data {
        class Guid {
            constructor();
            toString(): string;
        }
    }
}

/**
 * Default project namespace.
 */
declare const ProjectNamespaceName: "${ns}";
`;
        }

        function getExternalScriptRefs(): AnyDoc[] {
            const candidates: AnyDoc[] = [];

            const sources = [
                runtime?.Scripts,
                runtime?.ExternalScripts,
                runtime?.ScriptFiles,
                runtime?.UserScripts,
                runtime?.RegisteredScripts,
                applicationDoc?.Scripts,
                applicationDoc?.ExternalScripts,
                applicationDoc?.ScriptFiles,
                applicationDoc?.UserScripts,
                applicationDoc?.RegisteredScripts
            ];

            sources.forEach(src => {
                if (Array.isArray(src)) {
                    candidates.push(...src);
                }
            });

            const seen: Record<string, boolean> = {};

            return candidates.filter(x => {
                if (!x) return false;

                const key =
                    x.id ||
                    x.Name ||
                    x.Url ||
                    x.DeclarationUrl ||
                    JSON.stringify(x);

                if (seen[key]) return false;
                seen[key] = true;

                return true;
            });
        }

        async function loadTextFile(url: string): Promise<string> {
            const response = await fetch(url, {
                method: "GET",
                credentials: "same-origin"
            });

            if (!response.ok) {
                throw new Error(`Failed to load ${url}: ${response.status} ${response.statusText}`);
            }

            return await response.text();
        }

        async function loadExternalScriptDeclarations(): Promise<string> {
            const refs = getExternalScriptRefs();

            const parts: string[] = [];

            for (const ref of refs) {
                if (ref.Declaration) {
                    parts.push(`\n/* ${ref.Name || ref.id || "external declaration"} */\n${ref.Declaration}`);
                    continue;
                }

                if (ref.AmbientDeclaration) {
                    parts.push(`\n/* ${ref.Name || ref.id || "external ambient declaration"} */\n${ref.AmbientDeclaration}`);
                    continue;
                }

                if (ref.DeclarationUrl) {
                    try {
                        const text = await loadTextFile(ref.DeclarationUrl);
                        parts.push(`\n/* ${ref.Name || ref.DeclarationUrl} */\n${text}`);
                    } catch (err) {
                        console.warn("Failed to load script declaration", ref, err);
                    }
                }
            }

            return parts.join("\n\n");
        }
        function buildProjectModelDeclaration(): string {
            const ns = getProjectNamespaceName();
            const types = getRuntimeTypeDocs();
            const enums = getRuntimeEnumDocs();

            const enumDeclarations = enums
                .map(e => buildRuntimeEnumDeclaration(e))
                .join("\n\n");

            const classDeclarations = types
                .map(t => buildRuntimeTypeInterface(t))
                .join("\n\n");

            const dts = `
declare namespace ${ns} {

    /**
     * Partial embedded reference used by Hybrid relations.
     * Only id/Name/_type are guaranteed here; additional fields depend on the
     * relation configuration. Resolve the full target explicitly before using
     * undeclared target fields.
     */
    export interface CosmoHybridRef<TTarget = unknown> {
        id: string;
        Name?: string;
        _type?: string;
    }

    export class caBase {
        id: string;
        _type: string;
        _partitionId: string;
        _defer?: boolean;
        _ts?: number;
        __parent?: any;
        __clone?: boolean;
        __new?: boolean;

        constructor(parent?: any, calcDefaults?: boolean, calcFormulas?: boolean);

        CalculateDfaults(parent?: any): void;
        CalculateFormulas(parent?: any): void;
        Save(async?: boolean): void;
        Clone(): any;
        Load(id: string): this;
    }

${enumDeclarations
                    .split("\n")
                    .map(line => line ? "    " + line : "")
                    .join("\n")}

${classDeclarations
                    .split("\n")
                    .map(line => line ? "    " + line : "")
                    .join("\n")}
}
`;

            console.log("Project model DTS:", {
                namespace: ns,
                typeCount: types.length,
                enumCount: enums.length,
                typeNames: types.slice(0, 30).map((t: AnyDoc) => t.Name),
                enumNames: enums.slice(0, 30).map((e: AnyDoc) => e.Name),
                preview: dts.substring(0, 2000)
            });

            return dts;
        }

        function getBaseClassName(typeDoc: AnyDoc): string {
            if (!typeDoc?.BaseType || typeDoc.BaseType === "object") {
                return "caBase";
            }

            const baseType = getTypeDocById(typeDoc.BaseType);
            return baseType?.Name ? safeTsName(baseType.Name) : "caBase";
        }

        async function loadProjectDeclarationBundle(): Promise<string> {
            if (projectDeclarationBundlePromise) {
                return projectDeclarationBundlePromise;
            }

            projectDeclarationBundlePromise = Promise.all([
                Promise.resolve(buildRuntimeDeclaration()),
                Promise.resolve(buildProjectModelDeclaration()),
                loadExternalScriptDeclarations()
            ]).then(parts => {
                return parts
                    .filter(x => !!x && !!String(x).trim())
                    .join("\n\n");
            });

            return projectDeclarationBundlePromise;
        }

        function getPropName(prop: AnyDoc): string {
            return String(prop?.Name || "").trim();
        }

        function getCompletionKindForProperty(monaco: any, prop: AnyDoc): any {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);

            if (typeEntity) {
                return monaco.languages.CompletionItemKind.Field;
            }

            const valueType = prop.ValueType ?? prop.Type;

            switch (valueType) {
                case 2:
                case 3:
                    return monaco.languages.CompletionItemKind.Value;

                case 4:
                    return monaco.languages.CompletionItemKind.Value;

                default:
                    return monaco.languages.CompletionItemKind.Field;
            }
        }

        function getPropertyDetail(prop: AnyDoc): string {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);

            if (typeEntity?.Name) {
                return String(typeEntity.Name);
            }

            if (prop.Values && Array.isArray(prop.Values) && prop.Values.length) {
                return "enum";
            }

            const valueType = prop.ValueType ?? prop.Type;

            switch (valueType) {
                case 2:
                case 3:
                    return "number";

                case 4:
                    return "boolean";

                case 5:
                case 6:
                case 7:
                    return "date";

                case 0:
                default:
                    return "string";
            }
        }

        function getSchemaByPropertyPath(rootSchema: AnyDoc | null, path: string[]): AnyDoc | null {
            let schema = rootSchema;

            for (const segment of path) {
                if (!schema || !Array.isArray(schema.Properties)) return null;

                const prop = schema.Properties.find((p: AnyDoc) => p?.Name === segment);
                if (!prop) return null;

                const nextSchema = resolveMetaEntityRef(prop.TypeEntity);
                if (!nextSchema) return null;

                schema = nextSchema;
            }

            return schema;
        }

        function getSchemaCompletionItems(monaco: any, schema: AnyDoc | null): any[] {
            const props = getSchemaPropertiesForDeclaration(schema);

            return props
                .filter((p: AnyDoc) => p?.Name)
                .map((p: AnyDoc) => ({
                    label: getPropName(p),
                    kind: getCompletionKindForProperty(monaco, p),
                    insertText: getPropName(p),
                    detail: getPropertyDetail(p),
                    documentation: p.Description || ""
                }));
        }
        function safeTsName(name: any, fallback = "Field"): string {
            const raw = String(name || fallback).trim();
            const fixed = raw.replace(/[^\w$]/g, "_");

            if (!fixed) return fallback;
            if (/^\d/.test(fixed)) return "_" + fixed;

            return fixed;
        }

        function quotePropName(name: string): string {
            return /^[A-Za-z_$][\w$]*$/.test(name)
                ? name
                : JSON.stringify(name);
        }

        function getPropertyTsType(prop: AnyDoc, depth = 0): string {
            if (!prop) return "any";

            if (prop.Many === true) {
                const one = getPropertyTsType({ ...prop, Many: false }, depth);
                return `${one}[]`;
            }

            if (prop.Values && Array.isArray(prop.Values) && prop.Values.length) {
                return prop.Values
                    .map((v: AnyDoc) => JSON.stringify(String(v.Name || v.Value || "")))
                    .join(" | ") || "string";
            }

            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);

            if (typeEntity) {
                const typeName = String(typeEntity.Name || "");

                if (typeName === "Code") {
                    return "CosmoCode";
                }

                if (typeName === "CodeExpression") {
                    return "CosmoCodeExpression";
                }

                return safeTsName(typeName);
            }

            const valueType = prop.ValueType ?? prop.Type;

            // Совместимость со старым ValueType.
            // 0 string, 2 int, 3 float, 4 boolean, 5 date, 6 dateTime и т.п.
            switch (valueType) {
                case 2:
                case 3:
                    return "number";

                case 4:
                    return "boolean";

                case 5:
                case 6:
                case 7:
                    return "Date | string";

                case 0:
                default:
                    return "string";
            }
        }

        function getSchemaPropertiesForDeclaration(schema: AnyDoc | null): AnyDoc[] {
            if (!schema || !Array.isArray(schema.Properties)) return [];

            return schema.Properties
                .filter((p: AnyDoc) => p && p.Name)
                .sort((a: AnyDoc, b: AnyDoc) => {
                    const ai = Number(a.Index ?? 999999);
                    const bi = Number(b.Index ?? 999999);
                    if (ai !== bi) return ai - bi;
                    return String(a.Name || "").localeCompare(String(b.Name || ""));
                });
        }
        function registerCurrentDataCompletionProvider(
            monaco: any,
            currentSchema: AnyDoc | null,
            withCurrentDataContext: boolean
        ): any {
            const languages = ["javascript", "typescript"];

            const providers = languages.map(language =>
                monaco.languages.registerCompletionItemProvider(language, {
                    triggerCharacters: ["."],

                    provideCompletionItems: (model: any, position: any) => {
                        const word = model.getWordUntilPosition(position);

                        const range = {
                            startLineNumber: position.lineNumber,
                            endLineNumber: position.lineNumber,
                            startColumn: word.startColumn,
                            endColumn: word.endColumn
                        };

                        const linePrefix = model.getValueInRange({
                            startLineNumber: position.lineNumber,
                            startColumn: 1,
                            endLineNumber: position.lineNumber,
                            endColumn: position.column
                        });

                        const rootProps = getSchemaPropertiesForDeclaration(currentSchema);

                        const objectPathMatch = linePrefix.match(
                            /(?:currentData|CurrentData|data|e\.data|e\.currentData)((?:\.[A-Za-z_$][\w$]*)*)\.$/
                        );

                        if (objectPathMatch) {
                            if (!currentSchema || !rootProps.length) {
                                return {
                                    suggestions: [
                                        {
                                            label: "__NO_CURRENT_SCHEMA__",
                                            kind: monaco.languages.CompletionItemKind.Text,
                                            insertText: "",
                                            detail: "Designer could not resolve currentData schema",
                                            documentation: `owner schema is empty; linePrefix: ${linePrefix}`,
                                            range
                                        }
                                    ]
                                };
                            }

                            const pathText = objectPathMatch[1] || "";
                            const path = pathText
                                .split(".")
                                .map((x: string) => x.trim())
                                .filter(Boolean);

                            const schema = getSchemaByPropertyPath(currentSchema, path) || currentSchema;
                            const items = getSchemaCompletionItems(monaco, schema);

                            return {
                                suggestions: items.map(item => ({
                                    ...item,
                                    range
                                }))
                            };
                        }

                        const rootSuggestions: any[] = [
                            {
                                label: "currentData",
                                kind: monaco.languages.CompletionItemKind.Variable,
                                insertText: "currentData",
                                detail: currentSchema?.Name || "current data",
                                documentation: "Данные текущего объекта",
                                range
                            },
                            {
                                label: "data",
                                kind: monaco.languages.CompletionItemKind.Variable,
                                insertText: "data",
                                detail: currentSchema?.Name || "current data",
                                documentation: "Короткий alias для currentData",
                                range
                            },
                            {
                                label: "e",
                                kind: monaco.languages.CompletionItemKind.Variable,
                                insertText: "e",
                                detail: "event/context",
                                documentation: "Контекст выполнения",
                                range
                            }
                        ];

                        const directFields = withCurrentDataContext
                            ? getSchemaCompletionItems(monaco, currentSchema).map(item => ({
                                ...item,
                                range
                            }))
                            : [];

                        return {
                            suggestions: rootSuggestions.concat(directFields)
                        };
                    }
                })
            );

            return {
                dispose: () => {
                    providers.forEach(p => p?.dispose?.());
                }
            };
        }
        function buildInterfaceDeclaration(
            schema: AnyDoc,
            emitted: Record<string, boolean>
        ): string {
            const name = safeTsName(schema.Name || "CurrentData");

            if (emitted[name]) return "";
            emitted[name] = true;

            let nested = "";
            let body = "";

            const props = getSchemaPropertiesForDeclaration(schema);

            props.forEach((prop: AnyDoc) => {
                const typeEntity = resolveMetaEntityRef(prop.TypeEntity);

                if (typeEntity && !isCodeEntityName(String(typeEntity.Name || ""))) {
                    nested += buildInterfaceDeclaration(typeEntity, emitted);
                }

                const propName = quotePropName(prop.Name);
                const optional = prop.Required ? "" : "?";
                const tsType = getPropertyTsType(prop);

                const comment = prop.Description
                    ? `    /** ${String(prop.Description).replace(/\*\//g, "* /")} */\n`
                    : "";

                body += `${comment}    ${propName}${optional}: ${tsType};\n`;
            });

            return `
${nested}
interface ${name} {
${body || "    [key: string]: any;\n"}
}
`;
        }
        function isCurrentDataContextEnabled(typeName: string, codeValue: AnyDoc): boolean {
            if (typeName !== "CodeExpression") return false;

            return String(codeValue.WithContext || "None").trim() === "CurrentData";
        }
        function buildCurrentDataDeclaration(
            currentSchema: AnyDoc | null,
            withCurrentDataContext: boolean
        ): string {
            const emitted: Record<string, boolean> = {};

            const schemaName = currentSchema?.Name
                ? safeTsName(currentSchema.Name)
                : "CurrentData";

            const interfaces = currentSchema
                ? buildInterfaceDeclaration(currentSchema, emitted)
                : `
interface CurrentData {
    [key: string]: any;
}
`;

            const props = getSchemaPropertiesForDeclaration(currentSchema);

            const directWithFields = withCurrentDataContext
                ? props.map((prop: AnyDoc) => {
                    const propName = safeTsName(prop.Name);
                    const type = getPropertyTsType(prop);

                    const comment = prop.Description
                        ? `/** ${String(prop.Description).replace(/\*\//g, "* /")} */\n`
                        : "";

                    return `${comment}declare const ${propName}: ${type};`;
                }).join("\n")
                : "";

            return `
interface CosmoCode {
    Language?: "JS" | "TS" | "SQL" | string;
    Code: string;
}

interface CosmoCodeExpression {
    WithContext?: "None" | "CurrentData" | string;
    Code: string;
}

${interfaces}

declare const currentData: ${schemaName};
declare const CurrentData: ${schemaName};
declare const data: ${schemaName};
declare const e: {
    data?: ${schemaName};
    currentData?: ${schemaName};
    [key: string]: any;
};

/**
 * Fields available directly only inside CodeExpression WithContext = CurrentData.
 */
${directWithFields}
`;
        }

        function configureMonacoForCurrentData(
            monaco: any,
            currentSchema: AnyDoc | null,
            withCurrentDataContext: boolean,
            projectDts?: string
        ): void {
            monacoContextDisposables.forEach(d => {
                try {
                    d?.dispose?.();
                } catch {
                    // ignore
                }
            });

            monacoContextDisposables = [];

            const dts = buildCurrentDataDeclaration(currentSchema, withCurrentDataContext);
            const uri = "inmemory://cosmoapps/current-data-context.d.ts";

            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSyntaxValidation: false,
                noSemanticValidation: false,
                noSuggestionDiagnostics: false
            });

            monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
                noSyntaxValidation: false,
                noSemanticValidation: false,
                noSuggestionDiagnostics: false
            });

            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                allowNonTsExtensions: true,
                checkJs: true,
                allowJs: true,
                noImplicitAny: true,
                strictNullChecks: false,
                noImplicitThis: false,
                alwaysStrict: false,
                target: monaco.languages.typescript.ScriptTarget.ES2020,
                module: monaco.languages.typescript.ModuleKind.None,
                moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs
            });

            monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
                allowNonTsExtensions: true,
                noImplicitAny: true,
                strictNullChecks: false,
                noImplicitThis: false,
                alwaysStrict: false,
                target: monaco.languages.typescript.ScriptTarget.ES2020,
                module: monaco.languages.typescript.ModuleKind.None,
                moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs
            });

            monacoContextDisposables.push(
                monaco.languages.typescript.javascriptDefaults.addExtraLib(dts, uri)
            );

            monacoContextDisposables.push(
                monaco.languages.typescript.typescriptDefaults.addExtraLib(dts, uri)
            );

            if (projectDts && projectDts.trim()) {
                monacoContextDisposables.push(
                    monaco.languages.typescript.javascriptDefaults.addExtraLib(
                        projectDts,
                        "inmemory://cosmoapps/project-bundle-js.d.ts"
                    )
                );

                monacoContextDisposables.push(
                    monaco.languages.typescript.typescriptDefaults.addExtraLib(
                        projectDts,
                        "inmemory://cosmoapps/project-bundle.d.ts"
                    )
                );
            }

            monacoContextDisposables.push(
                registerCurrentDataCompletionProvider(
                    monaco,
                    currentSchema,
                    withCurrentDataContext
                )
            );
        }

        function ensureMonacoLoaded(): Promise<any> {
            const w = window as any;

            if (w.monaco?.editor) {
                return Promise.resolve(w.monaco);
            }

            if (monacoLoadPromise) {
                return monacoLoadPromise;
            }

            monacoLoadPromise = new Promise((resolve, reject) => {
                const existingLoader = document.querySelector(
                    'script[data-ca-monaco-loader="true"]'
                ) as HTMLScriptElement | null;

                function configureAndLoad() {
                    const ww = window as any;

                    ww.require.config({
                        paths: {
                            vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs"
                        }
                    });

                    ww.require(
                        ["vs/editor/editor.main"],
                        () => {
                            if (ww.monaco?.editor) resolve(ww.monaco);
                            else reject(new Error("Monaco loaded, but window.monaco.editor is missing"));
                        },
                        reject
                    );
                }

                if ((window as any).require?.config) {
                    configureAndLoad();
                    return;
                }

                if (existingLoader) {
                    existingLoader.addEventListener("load", configureAndLoad);
                    existingLoader.addEventListener("error", () => reject(new Error("Monaco loader failed")));
                    return;
                }

                const script = document.createElement("script");
                script.src = "https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs/loader.js";
                script.async = true;
                script.dataset.caMonacoLoader = "true";

                script.onload = configureAndLoad;
                script.onerror = () => reject(new Error("Monaco loader failed"));

                document.head.appendChild(script);
            });

            return monacoLoadPromise;
        }

        function registerSqlCompletionProvider(monaco: any, currentSchema: AnyDoc | null): any {
            const props = getSchemaPropertiesForDeclaration(currentSchema);

            return monaco.languages.registerCompletionItemProvider("sql", {
                provideCompletionItems: () => {
                    const suggestions = props.map((p: AnyDoc) => ({
                        label: p.Name,
                        kind: monaco.languages.CompletionItemKind.Field,
                        insertText: p.Name,
                        detail: getPropertyTsType(p),
                        documentation: p.Description || ""
                    }));

                    return { suggestions };
                }
            });
        }

        function getSpecialApplicationPropertyItems(owner: AnyDoc, prop: AnyDoc, createIfMissing = false): AnyDoc[] {
            if (owner !== applicationDoc || !prop?.Name) return [];

            if (prop.Name === "Types" || prop.Name === "Entities") return getRuntimeObjectsArray(createIfMissing);
            if (prop.Name === "Enums") return getRuntimeEnumsArray(createIfMissing);
            if (prop.Name === "NavigationItems" || prop.Name === "Navigation") return getRuntimeNavigationItemsArray(createIfMissing);
            if (prop.Name === "ManageAccess") return getRuntimeAllowedUsersArray(createIfMissing);
            if (prop.Name === "ModuleReferences") return getRuntimeModuleReferencesArray(createIfMissing);

            const direct = getObjectValue(owner, prop);
            if (Array.isArray(direct)) return direct;

            if (createIfMissing) {
                owner[prop.Name] = [];
                return owner[prop.Name];
            }

            return [];
        }

        function makeTypedPropertyCollectionNode(
            owner: AnyDoc,
            ownerDoc: AnyDoc,
            prop: AnyDoc,
            path: string[],
            visited?: WeakSet<object>
        ): DesignerTreeNode | null {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (!typeEntity) return null;

            const value = getObjectValue(owner, prop);
            const specialItems = getSpecialApplicationPropertyItems(owner, prop);

            if (!Array.isArray(value) && !specialItems.length && prop.Many !== true) return null;

            const collection: AnyDoc = {
                id: `${owner.id || owner.Name || "object"}_${prop.Name}_typedCollection`,
                _type: COLLECTION_TYPE,
                Name: prop.Name,
                ItemEntity: makeHybridMetaEntityRef(typeEntity),
                Aggregation: prop.Aggregation,
                StorageKind: prop.StorageKind,
                Global: prop.Global,
                Index: prop.Index,
                __sourceProperty: prop
            };

            if (Array.isArray(value)) {
                return makeCollectionNode(owner, ownerDoc, collection, path.concat([prop.Name]), visited);
            }

            if (specialItems.length || owner === applicationDoc) {
                return makeCollectionNode(owner, ownerDoc, collection, path.concat([prop.Name]), visited);
            }

            return null;
        }

        function getNodeIndex(node: DesignerTreeNode): number {
            const src: any = node.collection || node.property || node.doc;
            const index = Number(src?.Index);
            return Number.isFinite(index) ? index : 999999;
        }

        function sortTreeNodesByIndex(nodes: DesignerTreeNode[]): DesignerTreeNode[] {
            return nodes.sort((a, b) => {
                const ai = getNodeIndex(a);
                const bi = getNodeIndex(b);
                if (ai !== bi) return ai - bi;
                return String(a.text || "").localeCompare(String(b.text || ""));
            });
        }

        function buildObjectChildren(
            obj: AnyDoc,
            ownerDoc: AnyDoc,
            path: string[],
            visited?: WeakSet<object>
        ): DesignerTreeNode[] {
            const result: DesignerTreeNode[] = [];

            if (!obj || typeof obj !== "object") {
                return result;
            }

            visited = visited || new WeakSet<object>();

            const visitObj = obj as object;

            if (visited.has(visitObj)) {
                return result;
            }

            visited.add(visitObj);

            try {
                const schema = getSchemaForObject(obj);

                const schemaCollections: AnyDoc[] = Array.isArray(schema?.Collections) ? schema.Collections : [];
                const ownCollections: AnyDoc[] = Array.isArray(obj?.Collections) ? obj.Collections : [];
                const collections = schemaCollections.length ? schemaCollections : ownCollections;

                const existingNames: Record<string, boolean> = {};
                const isApplicationRoot = !!applicationDoc && obj === applicationDoc;

                collections
                    .filter(c => c && c.Name)
                    .filter(c => !(isApplicationRoot && c.Global === true))
                    .sort((a, b) => {
                        const ai = Number(a.Index ?? 999999);
                        const ib = Number(b.Index ?? 999999);
                        if (ai !== ib) return ai - ib;
                        return String(a.Name || "").localeCompare(String(b.Name || ""));
                    })
                    .forEach(c => {
                        existingNames[c.Name] = true;
                        result.push(makeCollectionNode(obj, ownerDoc, c, path.concat([c.Name]), visited));
                    });

                getSyntheticCollectionsForObject(obj, existingNames)
                    .forEach(c => {
                        existingNames[c.Name] = true;
                        result.push(makeCollectionNode(obj, ownerDoc, c, path.concat([c.Name]), visited));
                    });

                const schemaProps: AnyDoc[] = Array.isArray(schema?.Properties) ? schema.Properties : [];

                schemaProps
                    .filter(p => p?.TypeEntity)
                    .filter(p => !(isApplicationRoot && p.Global === true))
                    .sort((a, b) => {
                        const ai = Number(a.Index ?? 999999);
                        const ib = Number(b.Index ?? 999999);
                        if (ai !== ib) return ai - ib;
                        return String(a.Name || "").localeCompare(String(b.Name || ""));
                    })
                    .forEach(p => {
                        if (existingNames[p.Name]) return;

                        const collectionNode = makeTypedPropertyCollectionNode(obj, ownerDoc, p, path, visited);
                        if (collectionNode) {
                            existingNames[p.Name] = true;
                            result.push(collectionNode);
                            return;
                        }

                        const objectNode = makeTypedPropertyNode(obj, ownerDoc, p, path, visited);
                        if (objectNode) {
                            existingNames[p.Name] = true;
                            result.push(objectNode);
                        }
                    });

                return result;
            } finally {
                visited.delete(visitObj);
            }
        }

        function buildApplicationGlobalRootItems(appDoc: AnyDoc): DesignerTreeNode[] {
            const result: DesignerTreeNode[] = [];

            const collections: AnyDoc[] = Array.isArray(appDoc?.Collections) ? appDoc.Collections : [];
            const props: AnyDoc[] = Array.isArray(appDoc?.Properties) ? appDoc.Properties : [];

            collections
                .filter(c => c && c.Name && c.Global === true)
                .forEach(c => result.push(makeCollectionNode(appDoc, appDoc, c, [c.Name])));

            props
                .filter(p => p && p.Name && p.Global === true && p.TypeEntity)
                .forEach(p => {
                    const collectionNode = makeTypedPropertyCollectionNode(appDoc, appDoc, p, []);
                    if (collectionNode) {
                        result.push(collectionNode);
                        return;
                    }

                    const objectNode = makeTypedPropertyNode(appDoc, appDoc, p, []);
                    if (objectNode) result.push(objectNode);
                });

            return sortTreeNodesByIndex(result);
        }

        function getApplicationDiagrams(create = false): AnyDoc[] {
            if (!applicationDoc) return [];

            if (!Array.isArray(applicationDoc.Diagrams) && create) {
                applicationDoc.Diagrams = [];
            }

            return Array.isArray(applicationDoc.Diagrams)
                ? applicationDoc.Diagrams
                : [];
        }

        function buildDiagramsTreeNode(): DesignerTreeNode {
            const diagrams = getApplicationDiagrams(false);

            return {
                id: "Application/Diagrams",
                text: `Diagrams (${diagrams.length})`,
                kind: "collection",
                icon: "chart",
                ownerDoc: applicationDoc,
                containerDoc: applicationDoc,
                collection: {
                    id: "__cosmoapps_diagrams__",
                    Name: "Diagrams",
                    Caption: "Диаграммы",
                    Description:
                        "Сохранённые частичные диаграммы классов этого приложения."
                },
                expanded: true,
                items: diagrams.map((diagram: AnyDoc) => ({
                    id: `Application/Diagrams/${diagram.id}`,
                    text:
                        diagram.Caption ||
                        diagram.Name ||
                        "Диаграмма",
                    kind: "document",
                    icon: "chart",
                    doc: diagram,
                    ownerDoc: applicationDoc
                }))
            };
        }

        function getSelectedDiagramDocument(): AnyDoc | null {
            const doc = selectedNode?.doc;

            return doc &&
                Array.isArray(doc.TypeIds) &&
                Array.isArray(doc.EnumIds)
                ? doc
                : null;
        }

        function openModelDiagram(diagram?: AnyDoc | null): void {
            const diagramService =
                (window as any).CosmoApps?.ModelDiagram;

            if (!diagramService?.show) {
                DevExpress.ui.dialog.alert(
                    "CosmoApps.ModelDiagram is not loaded. Add cosmoAppModelDiagram.js to the constructor scripts.",
                    "Model Diagram"
                );
                return;
            }

            let initialDiagram = diagram || getSelectedDiagramDocument();

            if (!initialDiagram && selectedNode?.doc?.id) {
                const selectedType = getRuntimeTypeDocs().find(
                    (typeDoc: AnyDoc) =>
                        String(typeDoc?.id || "") ===
                        String(selectedNode?.doc?.id || "")
                );

                if (selectedType) {
                    initialDiagram = {
                        id: "",
                        Name: "",
                        Caption:
                            `${selectedType.Name} diagram`,
                        TypeIds: [selectedType.id],
                        EnumIds: [],
                        Positions: {},
                        ViewMode: "full",
                        CaptionMode: false
                    };
                }
            }

            console.info(
                "[CosmoApps Diagram v117] using original designer model source",
                {
                    objects:
                        getRuntimeObjectsArray(false)
                            .slice(0, 5)
                            .map((item: AnyDoc) => ({
                                id: item?.id,
                                Name: item?.Name,
                                TypeName: item?.TypeName,
                                Properties:
                                    Array.isArray(item?.Properties)
                                        ? item.Properties.length
                                        : 0
                            })),
                    enums:
                        getRuntimeEnumsArray(false)
                            .slice(0, 5)
                            .map((item: AnyDoc) => ({
                                id: item?.id,
                                Name: item?.Name,
                                Values:
                                    Array.isArray(item?.Values)
                                        ? item.Values.length
                                        : 0
                            }))
                }
            );

            diagramService.show({
                project: {
                    Name:
                        applicationDoc?.Name ||
                        runtime?.Name ||
                        runtime?.ModuleName ||
                        "Current project",
                    objects:
                        Array.isArray((window as any).app?.objects)
                            ? (window as any).app.objects
                            : [],
                    enums:
                        Array.isArray((window as any).app?.enums)
                            ? (window as any).app.enums
                            : []
                },
                diagram: initialDiagram || null,
                title:
                    initialDiagram?.Caption ||
                    "Диаграмма модели приложения",
                readOnly: false,
                onSave: (savedDiagram: AnyDoc) => {
                    const diagrams =
                        getApplicationDiagrams(true);
                    const existingIndex =
                        diagrams.findIndex(
                            (item: AnyDoc) =>
                                String(item?.id || "") ===
                                String(savedDiagram.id)
                        );

                    if (existingIndex >= 0) {
                        diagrams[existingIndex] =
                            savedDiagram;
                    } else {
                        diagrams.push(savedDiagram);
                    }

                    applicationDoc.Diagrams = diagrams;
                    treeItems = buildTree();
                    tree?.option("items", treeItems);

                    const nodeId =
                        `Application/Diagrams/${savedDiagram.id}`;

                    selectedNode =
                        findTreeNodeById(
                            treeItems,
                            nodeId
                        ) || selectedNode;

                    window.setTimeout(() => {
                        try {
                            tree?.expandItem(
                                "Application/Diagrams"
                            );
                            tree?.selectItem(nodeId);
                            tree?.scrollToItem(nodeId);
                        } catch { /* ignore */ }

                        renderPropertyGrid();
                        renderInfo();
                    }, 0);

                    DevExpress.ui.notify(
                        "Диаграмма сохранена в модели приложения в памяти.",
                        "success",
                        2400
                    );
                }
            });
        }

        function showAIChangeDiagram(plan: AnyDoc): void {
            const diagramService =
                (window as any).CosmoApps?.ModelDiagram;

            if (!diagramService?.show) {
                DevExpress.ui.dialog.alert(
                    "CosmoApps.ModelDiagram is not loaded. Add cosmoAppModelDiagram.js to the constructor scripts.",
                    "AI Change Diagram"
                );
                return;
            }

            console.info(
                "[CosmoApps Diagram v117] using original designer model source",
                {
                    objects:
                        getRuntimeObjectsArray(false)
                            .slice(0, 5)
                            .map((item: AnyDoc) => ({
                                id: item?.id,
                                Name: item?.Name,
                                TypeName: item?.TypeName,
                                Properties:
                                    Array.isArray(item?.Properties)
                                        ? item.Properties.length
                                        : 0
                            })),
                    enums:
                        getRuntimeEnumsArray(false)
                            .slice(0, 5)
                            .map((item: AnyDoc) => ({
                                id: item?.id,
                                Name: item?.Name,
                                Values:
                                    Array.isArray(item?.Values)
                                        ? item.Values.length
                                        : 0
                            }))
                }
            );

            diagramService.show({
                project: {
                    Name:
                        applicationDoc?.Name ||
                        runtime?.Name ||
                        runtime?.ModuleName ||
                        "Current project",
                    objects:
                        Array.isArray((window as any).app?.objects)
                            ? (window as any).app.objects
                            : [],
                    enums:
                        Array.isArray((window as any).app?.enums)
                            ? (window as any).app.enums
                            : []
                },
                plan,
                title: "AI planned model changes",
                readOnly: true
            });
        }

        function buildTree(): DesignerTreeNode[] {
            const result: DesignerTreeNode[] = [];

            if (applicationDoc) {
                // Application — главный корневой объект конструктора, поэтому он всегда первым.
                // Global-узлы идут следом как вынесенные наружу разделы Application,
                // а не как замена самого Application.
                result.push({
                    id: `Application/${applicationDoc.id || applicationDoc.Name || "app"}`,
                    text: `Application: ${applicationDoc.Name || applicationDoc.id}`,
                    kind: "document",
                    icon: iconForDocument(applicationDoc),
                    doc: applicationDoc,
                    ownerDoc: applicationDoc,
                    expanded: true,
                    items: buildObjectChildren(applicationDoc, applicationDoc, ["Application", applicationDoc.id || applicationDoc.Name || "app"])
                });

                result.push(...buildApplicationGlobalRootItems(applicationDoc));
                result.push(buildDiagramsTreeNode());
            }

            return result;
        }

        function renderInfo(): void {
            const $info = $(`#${POPUP_ID}-info`);
            if (!$info.length || !selectedNode) return;

            const doc = selectedNode.doc;
            const schema = doc ? getSchemaForObject(doc, selectedNode.collection) : null;

            $info.empty();

            if (selectedPropertyRow) {
                const prop = selectedPropertyRow.meta;

                $("<div>").addClass("ca-md-info-title").text(selectedPropertyRow.name).appendTo($info);
                $("<div>")
                    .css("margin-bottom", "4px")
                    .text(prop
                        ? `Тип: ${displayValue("ValueType", prop.ValueType)}; Вид: ${displayValue("ValueKind", prop.ValueKind)}; Категория: ${prop.Category?.Name || "Общие"}`
                        : "Свойство")
                    .appendTo($info);

                const description =
                    selectedPropertyRow.description ||
                    prop?.Description ||
                    prop?.Note ||
                    "";

                if (description) {
                    $("<div>")
                        .text(description)
                        .appendTo($info);
                }
                return;
            }

            $("<div>").addClass("ca-md-info-title").text(selectedNode.text).appendTo($info);

            const itemEntity = selectedNode.collection ? resolveMetaEntityRef(selectedNode.collection.ItemEntity) : null;
            const schemaText = schema?.Name
                ? `Схема: ${schema.Name}`
                : selectedNode.kind === "collection"
                    ? `Тип элемента: ${itemEntity?.Name || "—"}`
                    : selectedNode.kind;

            $("<div>").css("margin-bottom", "4px").text(schemaText).appendTo($info);

            const description =
                doc?.Description ||
                selectedNode.collection?.Description ||
                "";

            if (description) {
                $("<div>")
                    .text(description)
                    .appendTo($info);
            }
        }


        function resolveAITypeReference(ref: any): AnyDoc | null {
            if (ref === undefined || ref === null || ref === "") return null;

            const id = typeof ref === "object" ? (ref.id || ref._type || ref.Type) : ref;
            const name = typeof ref === "object" ? (ref.Name || ref.TypeName) : ref;
            const candidates: AnyDoc[] = [];

            const add = (items: AnyDoc[]): void => {
                (items || []).forEach(x => {
                    if (x && candidates.indexOf(x) < 0) candidates.push(x);
                });
            };

            add(docs);
            add(runtimeObjects);
            add(Array.isArray(runtime?.objects) ? runtime.objects : []);
            add(getModelTypes());

            return candidates.find(x =>
                (!!id && (x.id === id || x._type === id || x.Type === id)) ||
                (!!name && (x.Name === name || x.TypeName === name || x.TypeName === `CosmoApps.${name}`))
            ) || null;
        }

        function getAIContextDoc(doc: AnyDoc): AnyDoc {
            if (!doc) return null;

            const result: AnyDoc = {};
            const allowed = [
                "id", "_type", "_partitionId", "Name", "Caption", "Description",
                "Index", "BaseType", "ValueType", "ValueKind", "StorageKind",
                "Required", "Many", "Aggregation", "Type", "TypeEntity",
                "ItemEntity", "DefaultValue", "Formula", "Category",
                "Global", "ViewType", "Columns", "Span", "ItemType",
                "DoNotShowCaption", "Property"
            ];

            allowed.forEach(name => {
                const value = doc[name];
                if (value === undefined || typeof value === "function") return;

                if (value && typeof value === "object" && !Array.isArray(value)) {
                    result[name] = {
                        id: value.id,
                        Name: value.Name,
                        _type: value._type
                    };
                } else {
                    result[name] = cloneData(value);
                }
            });

            if (Array.isArray(doc.Properties)) {
                result.Properties = doc.Properties.map((p: AnyDoc) => {
                    // In different model generations an entity type reference may be
                    // stored either in TypeEntity or in Type, and may be an object,
                    // an id, or a type name. Always resolve it through the designer's
                    // canonical model lookup before sending it to AI.
                    const referencedType =
                        resolveAITypeReference(p.TypeEntity) ||
                        resolveAITypeReference(p.Type);

                    return {
                        id: p.id,
                        Name: p.Name,
                        Caption: p.Caption,
                        Description: p.Description,
                        ValueType: p.ValueType,
                        ValueKind: p.ValueKind,
                        Required: p.Required,
                        Many: p.Many,
                        Aggregation: p.Aggregation,

                        // Keep scalar Type only when it is not an entity reference.
                        Type: referencedType ? undefined : p.Type,

                        TypeEntity: referencedType
                            ? {
                                id: referencedType.id,
                                Name: referencedType.Name,
                                _type: referencedType._type
                            }
                            : null,
                        Index: p.Index
                    };
                });
            }

            if (Array.isArray(doc.Collections)) {
                result.Collections = doc.Collections.map((c: AnyDoc) => {
                    const referencedType = resolveAITypeReference(c.ItemEntity || c.TypeEntity || c.Type);
                    const items = getCollectionItems(doc, c);

                    return {
                        id: c.id,
                        Name: c.Name,
                        Description: c.Description,
                        Many: true,
                        Aggregation: c.Aggregation,
                        StorageKind: c.StorageKind,
                        ItemEntity: referencedType
                            ? {
                                id: referencedType.id,
                                Name: referencedType.Name,
                                _type: referencedType._type
                            }
                            : null,
                        Index: c.Index,
                        Count: items.length,
                        Items: items.slice(0, 20).map((item: AnyDoc) => ({
                            id: item?.id,
                            Name: item?.Name,
                            Caption: item?.Caption,
                            Description: item?.Description,
                            Type: item?.Type,
                            ActionType: item?.ActionType,
                            Condition: item?.Condition
                        }))
                    };
                });
            }

            if (Array.isArray(doc.Views)) {
                result.Views = doc.Views.map((v: AnyDoc) => ({
                    id: v.id,
                    Name: v.Name,
                    ViewType: v.ViewType,
                    Columns: v.Columns ?? v.ColCount ?? v.colCount,
                    ItemCount: Array.isArray(v.Items) ? v.Items.length : 0
                }));
            }

            return result;
        }

        function readFirstBusinessValue(source: AnyDoc, names: string[]): any {
            if (!source) return null;

            for (const name of names) {
                const value = source[name];
                if (value !== undefined && value !== null && value !== "") {
                    return cloneData(value);
                }
            }

            return null;
        }

        function getAIProjectBriefStorageKey(): string {
            const appId = applicationDoc?.id || runtime?.id || runtime?.ModuleName || "application";
            return `CosmoApps.Designer.ProjectBrief.${appId}`;
        }

        function loadAIProjectBrief(): string {
            if (aiProjectBrief !== null) return aiProjectBrief;

            try {
                aiProjectBrief = String(window.localStorage.getItem(getAIProjectBriefStorageKey()) || "");
            } catch {
                aiProjectBrief = "";
            }

            return aiProjectBrief;
        }

        function saveAIProjectBrief(value: string): void {
            aiProjectBrief = String(value || "").trim();

            try {
                if (aiProjectBrief) {
                    window.localStorage.setItem(getAIProjectBriefStorageKey(), aiProjectBrief);
                } else {
                    window.localStorage.removeItem(getAIProjectBriefStorageKey());
                }
            } catch {
                // The brief remains available for the current designer session.
            }
        }

        function consumeInitialDesignerPrompt(): string {
            if (initialDesignerPromptConsumed) return "";
            initialDesignerPromptConsumed = true;

            try {
                const value = String(
                    window.sessionStorage.getItem(
                        initialDesignerPromptStorageKey
                    ) || ""
                ).trim();

                window.sessionStorage.removeItem(
                    initialDesignerPromptStorageKey
                );

                return value;
            } catch {
                return "";
            }
        }

        function startInitialDesignerRequest(): void {
            const brief = consumeInitialDesignerPrompt();
            if (!brief) return;

            saveAIProjectBrief(brief);

            // Make the hand-off visible: the Blueprint appears as the first user
            // message in the Designer conversation as well as being stored in
            // Project brief for authoritative project context.
            aiMessages.push({
                Role: "user",
                Content: brief
            });

            // Do not start an AI request automatically. The user explicitly
            // starts generation with Send / Ctrl+Enter.
            aiThinkingMode = "strict";
            saveAIThinkingMode(aiThinkingMode);
            aiThinkingModeBox?.option("value", aiThinkingMode);

            const request = [
                "Создай первую рабочую версию модели приложения по описанию проекта.",
                "Не задавай уточняющих вопросов, если можно сделать безопасное обратимое допущение.",
                "Сразу сформируй конкретный план изменений модели.",
                "Первая версия должна быть небольшой и целостной; уточнения можно внести после того, как модель станет видна."
            ].join("\n");

            aiPromptBox?.option("value", request);
            renderAssistant();
            DevExpress.ui.notify(
                "Blueprint загружен. Нажмите «Отправить», чтобы построить первую модель.",
                "info",
                3200
            );
        }

        function openAIProjectBriefEditor(): void {
            const $host = $("<div>").appendTo(document.body);
            let popupInstance: any = null;
            let editorInstance: any = null;
            const current = loadAIProjectBrief();

            ($host as any).dxPopup({
                title: "Описание проекта",
                width: () => Math.min(window.innerWidth - 40, 760),
                height: () => Math.min(window.innerHeight - 60, 520),
                showCloseButton: true,
                dragEnabled: true,
                resizeEnabled: true,
                contentTemplate: (contentElement: JQuery) => {
                    const $content = $(contentElement).css({
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        padding: "12px",
                        boxSizing: "border-box"
                    });

                    $("<div>")
                        .text(
                            "Опишите автоматизируемый бизнес, цель приложения, пользователей, ключевые процессы и важные ограничения. " +
                            "Только темы, связанные с этим описанием или фактической моделью, будут считаться относящимися к проекту."
                        )
                        .css({ fontSize: "12px", opacity: .78, lineHeight: "1.4" })
                        .appendTo($content);

                    const $editor = $("<div>").css({ flex: "1 1 auto", minHeight: 0 }).appendTo($content);
                    ($editor as any).dxTextArea({
                        value: current,
                        height: "100%",
                        placeholder: "Например: складское приложение для приёмки и отгрузки товаров. Пользователи сканируют места хранения и товары...",
                        onInitialized: (args: any) => editorInstance = args.component
                    } as any);
                },
                toolbarItems: [
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Сохранить",
                            type: "default",
                            icon: "save",
                            onClick: () => {
                                saveAIProjectBrief(editorInstance?.option("value") || "");
                                renderAssistant();
                                popupInstance?.hide();
                            }
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Очистить",
                            icon: "clear",
                            onClick: () => editorInstance?.option("value", "")
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Отмена",
                            onClick: () => popupInstance?.hide()
                        }
                    }
                ],
                onHidden: () => {
                    try { popupInstance?.dispose?.(); } catch { /* ignore */ }
                    $host.remove();
                }
            } as any);

            popupInstance = ($host as any).dxPopup("instance");
            popupInstance.show();
        }

        function compactBusinessDocument(doc: AnyDoc): AnyDoc {
            if (!doc) return null;

            return {
                id: doc.id || null,
                Name: doc.Name || doc.Caption || null,
                Description: doc.Description || doc.Text || doc.Content || null,
                Status: doc.Status ?? null,
                Type: doc.Type || doc._type || null
            };
        }

        function getProjectContextDocuments(): AnyDoc[] {
            const keywords = [
                "requirement", "requirements", "specification", "technicaltask", "business",
                "process", "workflow", "actor", "stakeholder", "term", "decision", "goal",
                "требован", "техническоезадание", "бизнес", "процесс", "роль", "термин", "решен", "цель"
            ];
            const candidates: AnyDoc[] = [];
            const seen: Record<string, boolean> = {};

            const add = (doc: AnyDoc): void => {
                if (!doc) return;
                const name = String(doc.Name || doc.Caption || doc.TypeName || "").toLowerCase().replace(/\s+/g, "");
                const description = String(doc.Description || "").toLowerCase();
                if (!keywords.some(k => name.indexOf(k) >= 0 || description.indexOf(k) >= 0)) return;

                const key = String(doc.id || doc.Name || doc.Caption || candidates.length);
                if (seen[key]) return;
                seen[key] = true;
                candidates.push(compactBusinessDocument(doc));
            };

            getAllDocs().forEach(add);
            (Array.isArray(runtime?.requirements) ? runtime.requirements : []).forEach(add);
            (Array.isArray(runtime?.Requirements) ? runtime.Requirements : []).forEach(add);
            (Array.isArray(runtime?.documents) ? runtime.documents : []).forEach(add);

            return candidates.slice(0, 40);
        }

        function buildProjectAIContext(): AnyDoc {
            const description =
                readFirstBusinessValue(applicationDoc, ["BusinessDescription", "DomainDescription", "Description"]) ||
                readFirstBusinessValue(runtime, ["BusinessDescription", "DomainDescription", "Description"]);

            const explicitBrief = loadAIProjectBrief();

            return {
                ApplicationName: applicationDoc?.Name || runtime?.Name || runtime?.ModuleName || null,
                ProjectBrief: explicitBrief || null,
                HasExplicitProjectBrief: !!explicitBrief,
                BusinessDescription: description || null,
                BusinessDomain: readFirstBusinessValue(applicationDoc, ["BusinessDomain", "Domain"]) ||
                    readFirstBusinessValue(runtime, ["BusinessDomain", "Domain"]),
                Goals: readFirstBusinessValue(applicationDoc, ["BusinessGoals", "Goals"]) ||
                    readFirstBusinessValue(runtime, ["BusinessGoals", "Goals"]),
                Actors: readFirstBusinessValue(applicationDoc, ["Actors", "Stakeholders", "UserRoles"]) ||
                    readFirstBusinessValue(runtime, ["Actors", "Stakeholders", "UserRoles"]),
                Processes: readFirstBusinessValue(applicationDoc, ["BusinessProcesses", "Processes", "Workflows"]) ||
                    readFirstBusinessValue(runtime, ["BusinessProcesses", "Processes", "Workflows"]),
                RequirementsText: readFirstBusinessValue(applicationDoc, ["Requirements", "RequirementsText", "TechnicalTask", "Specification"]) ||
                    readFirstBusinessValue(runtime, ["Requirements", "RequirementsText", "TechnicalTask", "Specification"]),
                RelatedDocuments: getProjectContextDocuments(),
                SourcePolicy: {
                    UserStatementsAreAuthoritative: true,
                    AssistantInferencesMustBeMarked: true,
                    UnconfirmedInferencesMustNotBecomeRequirements: true
                }
            };
        }

        function getAIMetaPropertySchema(prop: AnyDoc, depth = 0): AnyDoc {
            if (!prop) return null;

            const typeEntity = resolveAITypeReference(prop.TypeEntity);
            const values = Array.isArray(prop.Values)
                ? prop.Values.map((v: AnyDoc) => ({
                    Name: v?.Name,
                    Description: v?.Description || null
                }))
                : [];

            const result: AnyDoc = {
                Name: prop.Name,
                OldName: prop.OldName || null,
                Description: prop.Description || prop.Note || null,
                Required: !!prop.Required,
                Many: !!prop.Many,
                ValueType: prop.ValueType,
                ValueKind: prop.ValueKind,
                StorageKind: prop.StorageKind,
                DefaultValue: prop.DefaultValue ?? null,
                AllowedTypes: Array.isArray(prop.AllowedTypes) ? cloneData(prop.AllowedTypes) : [],
                Values: values,
                TypeEntity: typeEntity
                    ? { id: typeEntity.id, Name: typeEntity.Name, _type: typeEntity._type }
                    : null
            };

            // Typed metadata values such as Formula: CodeExpression must be
            // described from the referenced metatype instead of guessed by AI.
            if (typeEntity && depth < 2) {
                result.TypedValueSchema = getAITypeInstanceSchema(typeEntity, depth + 1);
            }

            return result;
        }

        function getAITypeInstanceSchema(typeDoc: AnyDoc, depth = 0): AnyDoc {
            if (!typeDoc) return null;

            return {
                id: typeDoc.id,
                Name: typeDoc.Name,
                _type: typeDoc._type,
                Description: typeDoc.Description || null,
                Properties: Array.isArray(typeDoc.Properties)
                    ? typeDoc.Properties
                        .filter((p: AnyDoc) => !!p?.Name)
                        .sort((a: AnyDoc, b: AnyDoc) => {
                            const ai = Number(a.Index ?? 999999);
                            const bi = Number(b.Index ?? 999999);
                            if (ai !== bi) return ai - bi;
                            return String(a.Name).localeCompare(String(b.Name));
                        })
                        .map((p: AnyDoc) => getAIMetaPropertySchema(p, depth))
                    : [],
                Collections: Array.isArray(typeDoc.Collections)
                    ? typeDoc.Collections.map((c: AnyDoc) => {
                        const itemType = resolveAITypeReference(c.ItemEntity || c.TypeEntity || c.Type);
                        return {
                            Name: c.Name,
                            Description: c.Description || null,
                            Aggregation: c.Aggregation,
                            StorageKind: c.StorageKind,
                            ItemEntity: itemType
                                ? { id: itemType.id, Name: itemType.Name, _type: itemType._type }
                                : null
                        };
                    })
                    : []
            };
        }

        function getAIExistingPropertyExamples(doc: AnyDoc): AnyDoc[] {
            if (!Array.isArray(doc?.Properties)) return [];

            return doc.Properties.slice(0, 12).map((p: AnyDoc) => {
                const result: AnyDoc = {};
                [
                    "id", "Name", "Type", "Many", "Aggregation", "Required",
                    "RO", "ReadOnly", "Readonly", "Browsable", "VisibleInList", "ShowInList",
                    "VisibleInDetail", "ShowInDetail", "VisibleInLookup", "ShowInLookup",
                    "Index", "Formula", "DefaultValue", "IsEnum"
                ].forEach(name => {
                    if (p[name] !== undefined) result[name] = cloneData(p[name]);
                });
                return result;
            });
        }

        function getAIExistingTypeExamples(): AnyDoc[] {
            return getAIApplicationTypeDocs().slice(0, 8).map((t: AnyDoc) => {
                const result: AnyDoc = {};
                [
                    "id", "Name", "TypeName", "BaseType", "Browsable", "Cacheable",
                    "IsRoot", "_type", "_extern"
                ].forEach(name => {
                    if (t[name] !== undefined) result[name] = cloneData(t[name]);
                });
                return result;
            });
        }

        function buildAIMetamodelEditingContract(doc: AnyDoc): AnyDoc {
            const propertyType = getMetaEntityByName("Property");
            const applicationType = getMetaEntityByName("Type") || getMetaEntityByName("MetaEntity");
            const codeExpressionType = getMetaEntityByName("CodeExpression");
            const codeType = getMetaEntityByName("Code") || getMetaEntityByName("Script");
            const ruleType = getMetaEntityByName("Rule");
            const actionType = getMetaEntityByName("Action");
            const eventType = getMetaEntityByName("Event");
            const propertySchema = getAITypeInstanceSchema(propertyType);
            const typeSchema = getAITypeInstanceSchema(applicationType);
            const codeExpressionSchema = getAITypeInstanceSchema(codeExpressionType);
            const codeSchema = getAITypeInstanceSchema(codeType);
            const ruleSchema = getAITypeInstanceSchema(ruleType);
            const actionSchema = getAITypeInstanceSchema(actionType);
            const eventSchema = getAITypeInstanceSchema(eventType);
            const propertyFields = Array.isArray(propertySchema?.Properties)
                ? propertySchema.Properties.map((p: AnyDoc) => p.Name)
                : [];
            const typeFields = Array.isArray(typeSchema?.Properties)
                ? typeSchema.Properties.map((p: AnyDoc) => p.Name)
                : [];
            const behaviorFields = (schema: AnyDoc): string[] =>
                Array.isArray(schema?.Properties)
                    ? schema.Properties.map((p: AnyDoc) => String(p?.Name || "")).filter(Boolean)
                    : [];

            return {
                Source: "CurrentCosmoAppsMetamodel",
                Rules: [
                    "The metamodel schemas describe the designer language, but AddProperty.Property is a runtime application property instance",
                    "For AddType use field names from TypeDefinitionSchema and preserve the runtime shape visible in ExistingTypeExamples",
                    "For AddProperty and UpdateProperty, runtime storage conventions in ExistingPropertyExamples and RuntimePropertyContract take precedence over numeric metamodel descriptors",
                    "Never copy numeric DataTypeEnum or ValueType values into runtime Property.Type",
                    "Do not emit ValueType, ValueKind, StorageKind or TypeEntity in a runtime application Property",
                    "Preserve the storage conventions visible in ExistingPropertyExamples",
                    "Rule.Condition and Rule.PreCondition may use CodeExpression values in the designer; saving flattens them to legacy runtime expression strings",
                    "Action.Script and Event.Script may use Code values in the designer; saving flattens them to the legacy runtime js field",
                    "Do not convert a typed value to a plain string when TypedValueSchema is supplied"
                ],
                TypeDefinitionSchema: typeSchema,
                TypeAllowedFields: typeFields,
                ExistingTypeExamples: getAIExistingTypeExamples(),
                PropertyDefinitionSchema: propertySchema,
                PropertyAllowedFields: propertyFields,
                RuntimePropertyContract: {
                    Purpose: "Shape of Property objects stored inside runtime.objects[].Properties",
                    ScalarTypes: [
                        "string", "int", "float", "boolean", "date",
                        "dateTime", "time", "color", "email", "url", "money"
                    ],
                    AllowedFields: [
                        "Name", "Description", "Type", "Many", "Aggregation", "Required",
                        "RO", "ReadOnly", "Readonly", "Browsable", "VisibleInList", "ShowInList",
                        "VisibleInDetail", "ShowInDetail", "VisibleInLookup", "ShowInLookup",
                        "Index", "Formula", "DefaultValue", "IsEnum", "Rules", "Events"
                    ],
                    ForbiddenDescriptorFields: [
                        "ValueType", "ValueKind", "StorageKind", "TypeEntity"
                    ],
                    TypeRules: [
                        "For a scalar property, Type is one of ScalarTypes",
                        "For a reference to an existing application type, Type is that type id",
                        "For a reference to a type created earlier in the same plan, Type is { TemporaryId: \"...\" }",
                        "Never use numeric DataTypeEnum or ValueType codes in runtime Property.Type",
                        "Never use Type = -1 together with TypeEntity for a runtime reference"
                    ],
                    ReferenceRules: [
                        "References require Aggregation",
                        "Use Hybrid by default for ordinary user-facing references unless id-only Value semantics are explicitly requested",
                        "When the user explicitly requests a reference, link, lookup or relation to a domain object, the resulting Property.Type must be an application type id or { TemporaryId: \"...\" }, never a scalar type",
                        "Do not replace a missing referenced type with string, text, id or another scalar property",
                        "If the requested referenced type does not exist and its minimal purpose is clear, create it with AddType and reference it through TemporaryId",
                        "If a missing type is created automatically as the target of a Hybrid reference, also add at least a required string property named Name",
                        "A type used through Hybrid must be displayable through Name because Hybrid values are expected to contain id, Name and _type",
                        "If the missing referenced type is ambiguous, ask a clarifying question and do not emit dependent operations",
                        "A warning does not make a scalar replacement for a requested reference valid"
                    ],
                    MoneyRules: [
                        "Use the runtime pseudo-type money for monetary values such as price, cost, amount, payment, balance and total",
                        "Do not use float for a monetary value merely because arithmetic is performed on it",
                        "For a monetary value calculated for one business row or position, prefer the property name Amount",
                        "Use Total for an aggregate over multiple rows",
                        "Avoid Sum as a property name when Amount or Total expresses the business meaning more precisely",
                        "Reuse an established naming convention from the current application when one exists"
                    ],
                    EnumChoiceRules: [
                        "A finite closed set of named choices must not be stored as string or text",
                        "Properties named Status, Stage, Priority, Kind or Mode are presumed to be closed enums unless the user explicitly requires runtime-editable values",
                        "A business property named Type, such as Activity.Type, Contact.Type or Payment.Type, is also presumed to be an enum",
                        "Create or reuse an enum for statuses, stages, priorities, kinds, modes and similar application-defined choices",
                        "Do not use string merely because the exact enum values were not supplied",
                        "Infer a reasonable minimal enum when the business meaning is clear, or ask a clarifying question when it is not",
                        "Use a separate entity type instead only when values are runtime-editable, open, independently managed or require their own business data"
                    ],
                    CollectionOwnershipRules: [
                        "Use Aggregated when collection items are embedded in and stored as part of the parent document",
                        "A concrete Aggregated item instance belongs to exactly one parent instance",
                        "The same item type may be reused by Aggregated collections of multiple parent types when the embedded structure is the same",
                        "Do not create separate item types merely because different document types own structurally identical embedded items",
                        "Use Deferred for reverse navigation to independently stored objects that contain a direct forward Hybrid or Value reference to the owner",
                        "For every new Hybrid or Value reference between independently stored business types, normally create the inverse Deferred collection on the referenced type in the same plan",
                        "Example: Trip.Driver -> Driver requires Driver.Trips as Deferred when Trip is an independently stored type",
                        "Do not create the inverse collection when the referencing type is only an Aggregated child/line type; avoid noisy reverse collections such as Product.OrderLines unless explicitly required",
                        "If several different forward references connect the same pair of types, use semantically distinct reverse collections when their meaning is clear; otherwise do not guess",
                        "If the item type contains a Hybrid or Value reference to the collection owner, the reverse collection must normally be Deferred, not Aggregated",
                        "A Deferred collection requires a direct forward reference from the item type to the owner type",
                        "Do not create a reverse collection through an indirect path such as Task -> Contact -> Company unless an explicit query definition is supplied"
                    ],
                    FormulaEditabilityRules: [
                        "Use the canonical metamodel field name ReadOnly with exact casing in new operations",
                        "Never emit Readonly or RO in new operations; they are legacy or incorrect aliases used only when reading older documents",
                        "All operation field names must exactly match canonical metamodel names, including letter case",
                        "Formula does not automatically imply ReadOnly",
                        "Determine whether evaluating the formula again preserves a valid value manually entered into the same property",
                        "Set ReadOnly to true when every evaluation derives the result from other values and therefore replaces any manual value",
                        "Leave the property editable when the formula explicitly reads the property's current value and preserves a valid non-empty or non-default value",
                        "A formula that keeps the current property value in one branch is a default, fallback or override-friendly formula",
                        "Do not decide ReadOnly merely from the presence of Formula"
                    ]
                },
                CodeExpressionSchema: codeExpressionSchema,
                CodeSchema: codeSchema,
                BehaviorDefinitionSchemas: { Rule: ruleSchema, Action: actionSchema, Event: eventSchema },
                BehaviorAllowedFields: {
                    Rule: behaviorFields(ruleSchema),
                    Action: behaviorFields(actionSchema),
                    Event: behaviorFields(eventSchema)
                },
                ExistingPropertyExamples: getAIExistingPropertyExamples(doc),
                TypedValueRules: {
                    Formula: {
                        Type: "CodeExpression",
                        Rules: [
                            "Use WithContext exactly as allowed by CodeExpressionSchema; it is not a boolean",
                            "For CurrentData context, refer to fields directly without this or data prefixes",
                            "Formula Code is an expression and normally must not contain return",
                            "Use the existing Formula value and Formula metadata description as syntax evidence"
                        ]
                    }
                }
            };
        }

        function getDesignerAITypeName(
            typeRef: any,
            runtimeTypes: AnyDoc[],
            runtimeEnums: AnyDoc[]
        ): string | null {
            if (!typeRef) return null;

            if (typeof typeRef === "string") {
                const foundType = runtimeTypes.find(
                    (item: AnyDoc) =>
                        String(item?.id || item?.Id || "") ===
                        typeRef ||
                        String(item?.Name || "") === typeRef
                );
                if (foundType?.Name) {
                    return String(foundType.Name);
                }

                const foundEnum = runtimeEnums.find(
                    (item: AnyDoc) =>
                        String(item?.id || item?.Id || "") ===
                        typeRef ||
                        String(item?.Name || "") === typeRef
                );
                if (foundEnum?.Name) {
                    return String(foundEnum.Name);
                }

                return typeRef;
            }

            const referenceId = String(
                typeRef?.id ||
                typeRef?.Id ||
                typeRef?.TemporaryId ||
                ""
            );

            if (!referenceId) return null;

            return getDesignerAITypeName(
                referenceId,
                runtimeTypes,
                runtimeEnums
            );
        }

        function buildDesignerAIRuntimeTypeSummary(
            typeDoc: AnyDoc,
            runtimeTypes: AnyDoc[],
            runtimeEnums: AnyDoc[]
        ): AnyDoc {
            const properties = Array.isArray(typeDoc?.Properties)
                ? typeDoc.Properties
                : [];
            const collections = Array.isArray(typeDoc?.Collections)
                ? typeDoc.Collections
                : [];

            const projectMember = (property: AnyDoc): AnyDoc => ({
                id: property?.id || property?.Id || null,
                Name: property?.Name || null,
                Caption: property?.Caption || null,
                Type: typeof property?.Type === "string"
                    ? property.Type
                    : cloneData(property?.Type),
                TypeName: getDesignerAITypeName(
                    property?.Type,
                    runtimeTypes,
                    runtimeEnums
                ),
                Many: property?.Many === true,
                Aggregation: property?.Aggregation || null,
                Required: property?.Required === true,
                ReadOnly: property?.ReadOnly === true,
                Formula: property?.Formula
                    ? {
                        Code:
                            property.Formula.Code ||
                            property.Formula.Expression ||
                            null,
                        WithContext:
                            property.Formula.WithContext ||
                            null
                    }
                    : null,
                DefaultValue:
                    property?.DefaultValue !== undefined
                        ? cloneData(property.DefaultValue)
                        : null,
                Rules: Array.isArray(property?.Rules) ? cloneData(property.Rules) : [],
                Events: Array.isArray(property?.Events) ? cloneData(property.Events) : []
            });

            return {
                id: typeDoc?.id || typeDoc?.Id || null,
                Name: typeDoc?.Name || null,
                Caption: typeDoc?.Caption || null,
                Description: typeDoc?.Description || null,
                TypeName: typeDoc?.TypeName || null,
                BaseType: typeDoc?.BaseType || null,
                Browsable: typeDoc?.Browsable !== false,
                Properties: properties.map(projectMember),
                Collections: collections.map(projectMember),
                Rules: Array.isArray(typeDoc?.Rules) ? cloneData(typeDoc.Rules) : [],
                Actions: Array.isArray(typeDoc?.Actions) ? cloneData(typeDoc.Actions) : [],
                Events: Array.isArray(typeDoc?.Events) ? cloneData(typeDoc.Events) : []
            };
        }

        function isDesignerAIExplicitModificationRequest(
            prompt: string
        ): boolean {
            const value = String(prompt || "")
                .trim()
                .toLowerCase();

            return (
                /^(?:да[,\s]+)?(добавь|создай|измени|удали|переименуй|сделай|замени|исправь|перенеси|настрой|реализуй|внеси|примени)\b/i
                    .test(value) ||
                /^(?:yes[,\s]+)?(add|create|change|delete|remove|rename|make|replace|fix|move|configure|implement|apply)\b/i
                    .test(value)
            );
        }

        function isDesignerAIApplyPreviousRecommendation(
            prompt: string
        ): boolean {
            const value = String(prompt || "")
                .trim()
                .toLowerCase();

            return (
                /^(да[,\s]*)?(сделай это|сделай так|внеси изменения|внеси эти изменения|примени изменения|реализуй это|добавь это)$/i
                    .test(value) ||
                /^(yes[,\s]*)?(do it|do that|make those changes|apply the changes|implement it|add it)$/i
                    .test(value)
            );
        }

        function getPreviousAssistantRecommendation(): string {
            for (
                let index = aiMessages.length - 2;
                index >= 0;
                index--
            ) {
                const message = aiMessages[index];

                if (message?.Role !== "assistant") {
                    continue;
                }

                const content =
                    String(message.Content || "").trim();

                if (content) {
                    return content;
                }
            }

            return "";
        }

        function isDesignerAIExplanationFollowUp(
            prompt: string
        ): boolean {
            if (isDesignerAIExplicitModificationRequest(prompt)) {
                return false;
            }

            const lastAssistantMessage = [...aiMessages]
                .reverse()
                .find((message: AnyDoc) =>
                    message?.Role === "assistant"
                );

            return (
                lastAssistantMessage?.Plan?.Intent === "Explain" ||
                lastAssistantMessage?.InternalPlan?.Intent ===
                "Explain"
            );
        }

        function isDesignerAICasualOrMetaRequest(
            prompt: string
        ): boolean {
            const value = String(prompt || "")
                .trim()
                .toLowerCase();

            if (!value) return false;

            return (
                /^(привет|здравствуй|здравствуйте|добрый\s+(день|вечер|утро)|hello|hi|hey)\b/i
                    .test(value) ||
                /^(как\s+тебя\s+зовут|кто\s+ты|ты\s+кто|какая\s+ты\s+модель|какая\s+модель\s+ии|что\s+ты\s+за\s+модель)/i
                    .test(value) ||
                /^(who\s+are\s+you|what(?:'s|\s+is)\s+your\s+name|what\s+model\s+are\s+you)/i
                    .test(value) ||
                /^(спасибо|благодарю|thanks|thank\s+you)[!.\s]*$/i
                    .test(value)
            );
        }

        async function answerDesignerAICasualOrMetaRequest(
            prompt: string,
            conversation: AnyDoc[]
        ): Promise<boolean> {
            const response = await callDesignerAIService(
                [
                    "Respond conversationally as the CosmoApps model designer assistant.",
                    "This is a casual or meta question, not a request to analyze or modify the application model.",
                    "Do not return Scenarios, Capabilities, Requirements or Operations.",
                    "Do not start business analysis.",
                    "Be brief and friendly.",
                    "When asked who you are, say that you are the CosmoApps AI assistant for discussing and changing application models.",
                    "When asked for the underlying AI model, state that this deployment uses DeepSeek 4 through the CosmoApps AI service.",
                    "Return valid compact JSON with this shape:",
                    '{"Intent":"Chat","Message":"...","BusinessAnalysis":{"Actors":[],"ReferenceData":[],"Documents":[],"Lifecycles":[],"QuantitiesAndBalances":[],"DerivedValues":[],"Assumptions":[]},"Scenarios":[],"Capabilities":[],"Questions":[],"Recommendations":[],"Operations":[],"Warnings":[],"NeedsMoreContext":false,"ContextRequests":[]}',
                    "",
                    "User message:",
                    prompt
                ].join("\n"),
                buildDesignerAIContext(),
                conversation,
                "ModelGeneration"
            );

            const parsed = tryParseDesignerAIContent(
                response.Content,
                response.FinishReason,
                "ModelGeneration"
            );

            if (!parsed.Success) {
                return false;
            }

            const plan = normalizeDesignerAIPlan(
                parsed.Value
            );

            plan.Intent = "Chat";
            plan.Operations = [];
            plan.Scenarios = [];
            plan.Capabilities = [];

            aiMessages.push({
                Role: "assistant",
                Content: String(
                    plan.Message ||
                    "I am the CosmoApps AI assistant."
                ),
                Plan: plan,
                InternalPlan: plan
            });

            return true;
        }

        function isDesignerAIExplanationRequest(
            prompt: string
        ): boolean {
            const value = String(prompt || "")
                .trim()
                .toLowerCase();

            return (
                /^(поясни|объясни|почему|что такое|зачем|покажи|перечисли|какие поля|что содержит)/i
                    .test(value) ||
                /^(explain|why|what is|show|list|which fields|what does)/i
                    .test(value) ||
                value.indexOf("я сейчас вижу") >= 0 ||
                value.indexOf("в модели сейчас") >= 0 ||
                value.indexOf("фактическ") >= 0
            );
        }

        async function answerDesignerAIExplanation(
            prompt: string,
            conversation: AnyDoc[]
        ): Promise<boolean> {
            const response = await callDesignerAIService(
                [
                    "Answer a question or follow-up design discussion about the current CosmoApps model.",
                    "Use the supplied ApplicationModel.Types.Properties and Collections as the source of truth.",
                    "When the user asks whether another design would be more logical, compare the alternatives and explain the trade-offs.",
                    "Never infer a property merely because it would be conventional.",
                    "If a property is absent from the supplied type, state that it is absent.",
                    "Do not generate model changes unless the user explicitly asks to change the model.",
                    "Return valid compact JSON with this shape:",
                    '{"Intent":"Explain","Message":"...","BusinessAnalysis":{"Actors":[],"ReferenceData":[],"Documents":[],"Lifecycles":[],"QuantitiesAndBalances":[],"DerivedValues":[],"Assumptions":[]},"Scenarios":[],"Capabilities":[],"Questions":[],"Recommendations":[],"Operations":[],"Warnings":[],"NeedsMoreContext":false,"ContextRequests":[]}',
                    "",
                    "User question:",
                    prompt
                ].join("\\n"),
                buildDesignerAIContext(),
                conversation,
                "ModelGeneration"
            );

            const parsed = tryParseDesignerAIContent(
                response.Content,
                response.FinishReason,
                "ModelGeneration"
            );

            if (!parsed.Success) {
                return false;
            }

            const plan = normalizeDesignerAIPlan(parsed.Value);
            plan.Intent = "Explain";
            plan.Operations = [];
            plan.Scenarios = [];
            plan.Capabilities = [];

            aiMessages.push({
                Role: "assistant",
                Content: String(
                    plan.Message ||
                    "The current model was inspected."
                ),
                Plan: plan,
                InternalPlan: plan
            });

            return true;
        }

        function buildDesignerAIPlatformCapabilityContext(): AnyDoc {
            const metaTypes = getModelTypes();
            const byName = new Map<string, AnyDoc>();

            metaTypes.forEach((item: AnyDoc) => {
                const name = String(item?.Name || "").trim();
                if (name) {
                    byName.set(
                        name.toLowerCase(),
                        item
                    );
                }
            });

            const getMetaType = (
                name: string
            ): AnyDoc | null =>
                byName.get(
                    String(name || "").toLowerCase()
                ) || null;

            const hasMetaType = (
                name: string
            ): boolean =>
                !!getMetaType(name);

            const hasProperty = (
                typeName: string,
                propertyName: string
            ): boolean => {
                const type = getMetaType(typeName);
                const properties =
                    Array.isArray(type?.Properties)
                        ? type.Properties
                        : [];

                return properties.some(
                    (property: AnyDoc) =>
                        String(
                            property?.Name || ""
                        ).toLowerCase() ===
                        String(
                            propertyName || ""
                        ).toLowerCase()
                );
            };

            const hasCollection = (
                typeName: string,
                collectionName: string
            ): boolean => {
                const type = getMetaType(typeName);
                const collections =
                    Array.isArray(type?.Collections)
                        ? type.Collections
                        : [];

                return collections.some(
                    (collection: AnyDoc) =>
                        String(
                            collection?.Name || ""
                        ).toLowerCase() ===
                        String(
                            collectionName || ""
                        ).toLowerCase()
                );
            };

            const relevantTypeNames = [
                "Type",
                "Property",
                "Rule",
                "Action",
                "Event",
                "Enum",
                "EnumValue",
                "View",
                "ViewItem",
                "Menu",
                "Navigation",
                "Security",
                "ManageAccess",
                "Code",
                "CodeExpression",
                "Script"
            ];

            const compactProperty = (
                property: AnyDoc
            ): AnyDoc => {
                const typeEntity =
                    resolveMetaEntityRef(
                        property?.TypeEntity
                    );

                return {
                    Name:
                        property?.Name || null,
                    Description:
                        property?.Description || null,
                    Required:
                        property?.Required === true,
                    Many:
                        property?.Many === true,
                    ValueType:
                        property?.ValueType ??
                        null,
                    TypeEntity:
                        typeEntity?.Name ||
                        property?.TypeEntity?.Name ||
                        null
                };
            };

            const compactCollection = (
                collection: AnyDoc
            ): AnyDoc => {
                const itemEntity =
                    resolveMetaEntityRef(
                        collection?.ItemEntity
                    );

                return {
                    Name:
                        collection?.Name || null,
                    Description:
                        collection?.Description ||
                        null,
                    Aggregation:
                        collection?.Aggregation ??
                        null,
                    ItemEntity:
                        itemEntity?.Name ||
                        collection?.ItemEntity?.Name ||
                        null
                };
            };

            const compactTypes =
                relevantTypeNames
                    .map((name: string) =>
                        getMetaType(name)
                    )
                    .filter(Boolean)
                    .map((type: AnyDoc) => ({
                        id: type.id || null,
                        Name: type.Name,
                        Description:
                            type.Description || null,
                        Properties:
                            (
                                Array.isArray(
                                    type.Properties
                                )
                                    ? type.Properties
                                    : []
                            ).map(compactProperty),
                        Collections:
                            (
                                Array.isArray(
                                    type.Collections
                                )
                                    ? type.Collections
                                    : []
                            ).map(
                                compactCollection
                            )
                    }));

            const sourcePartitionIds =
                Array.from(
                    new Set(
                        docs
                            .map(
                                (item: AnyDoc) =>
                                    String(
                                        item?._partitionId ||
                                        ""
                                    ).trim()
                            )
                            .filter(Boolean)
                    )
                );

            const sourceApplicationId =
                sourcePartitionIds.indexOf(
                    COSMOAPPS_METAMODEL_APPLICATION_ID
                ) >= 0
                    ? COSMOAPPS_METAMODEL_APPLICATION_ID
                    : (
                        sourcePartitionIds[0] ||
                        COSMOAPPS_METAMODEL_APPLICATION_ID
                    );

            const editingOperations = [
                "AddType",
                "AddEnum",
                "AddProperty",
                "AddCollection",
                "UpdateType",
                "UpdateProperty",
                "UpdateCollection",
                "AddRule",
                "UpdateRule",
                "AddAction",
                "UpdateAction",
                "AddEvent",
                "UpdateEvent",
                "AddNavigationGroup",
                "AddNavigationItem"
            ];

            const derived = {
                EntityTypes: {
                    Classification:
                        hasMetaType("Type")
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Type"
                    ]
                },
                Inheritance: {
                    Classification:
                        hasProperty(
                            "Type",
                            "BaseType"
                        )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Type.BaseType"
                    ]
                },
                ScalarAndReferenceProperties: {
                    Classification:
                        hasMetaType("Property")
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Property.Type",
                        "Property.Aggregation"
                    ]
                },
                Enumerations: {
                    Classification:
                        hasMetaType("Enum")
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Enum",
                        "EnumValue"
                    ]
                },
                ComputedFields: {
                    Classification:
                        hasProperty(
                            "Property",
                            "Formula"
                        ) &&
                            hasMetaType(
                                "CodeExpression"
                            )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Property.Formula",
                        "CodeExpression"
                    ]
                },
                ValidationRules: {
                    Classification:
                        hasMetaType("Rule") &&
                            hasProperty(
                                "Rule",
                                "Condition"
                            )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Rule",
                        "Rule.Condition",
                        "Rule.PreCondition",
                        "Rule.Context"
                    ]
                },
                InteractiveActions: {
                    Classification:
                        hasMetaType("Action") &&
                            hasProperty(
                                "Action",
                                "Script"
                            )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Action",
                        "Action.Script"
                    ]
                },
                FormEvents: {
                    Classification:
                        hasMetaType("Event") &&
                            hasProperty(
                                "Event",
                                "Script"
                            )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Event",
                        "Event.Script"
                    ]
                },
                Views: {
                    Classification:
                        hasMetaType("View")
                            ? "PlatformSupportedDesignerManual"
                            : "Unsupported",
                    Evidence: [
                        "View",
                        "ViewItem"
                    ]
                },
                Navigation: {
                    Classification:
                        (
                            hasMetaType("Menu") ||
                            hasMetaType(
                                "Navigation"
                            )
                        )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Menu",
                        "Navigation"
                    ]
                },
                RoleAwareActions: {
                    Classification:
                        hasProperty(
                            "Action",
                            "EnableRoles"
                        ) ||
                            hasProperty(
                                "Action",
                                "DisableRoles"
                            )
                            ? "NativeEditable"
                            : "Unsupported",
                    Evidence: [
                        "Action.EnableRoles",
                        "Action.DisableRoles"
                    ]
                },
                StatusLifecycle: {
                    Classification:
                        hasMetaType("Enum") &&
                            hasMetaType("Property") &&
                            (
                                hasMetaType("Action") ||
                                hasMetaType("Event") ||
                                hasMetaType("Rule")
                            )
                            ? "ModelComposableDesignerPartial"
                            : "Unsupported",
                    Evidence: [
                        "Enum",
                        "Property",
                        "Action/Event/Rule"
                    ]
                },
                CrossDocumentBehavior: {
                    Classification:
                        (
                            hasMetaType("Action") ||
                            hasMetaType("Event")
                        ) &&
                            (
                                hasMetaType("Code") ||
                                hasMetaType("Script")
                            )
                            ? "ModelComposableDesignerPartial"
                            : "RequiresCustomCode",
                    Evidence: [
                        "Action/Event",
                        "Code/Script"
                    ]
                },
                ScheduledReminders: {
                    Classification:
                        "RequiresCustomCode",
                    Evidence: [
                        "No scheduler primitive is declared in the loaded metamodel"
                    ]
                },
                ExternalIntegrations: {
                    Classification:
                        "RequiresCustomCode",
                    Evidence: [
                        "Code/Script or external service"
                    ]
                }
            };

            return {
                Source: {
                    ApplicationId:
                        sourceApplicationId,
                    ExpectedApplicationId:
                        COSMOAPPS_METAMODEL_APPLICATION_ID,
                    DocumentCount:
                        docs.length,
                    LoadedDynamically:
                        true,
                    RefreshRule:
                        "Rebuilt from the current cosmoAppModel.ashx metamodel on every designer metadata reload."
                },
                ClassificationLegend: {
                    NativeEditable:
                        "The platform has a native metamodel mechanism and the current AI OperationContract can generate it.",
                    PlatformSupportedDesignerManual:
                        "The platform metamodel supports it, but the current AI OperationContract cannot yet create or edit that mechanism directly.",
                    ModelComposableDesignerPartial:
                        "The capability can be composed from platform primitives, but the current AI OperationContract covers only part of the required mechanisms.",
                    RequiresCustomCode:
                        "The requested behavior requires executable code, an external service or a platform mechanism not represented by the current AI editing operations.",
                    Unsupported:
                        "The loaded metamodel does not expose a mechanism for this capability."
                },
                DesignerEditingSupport: {
                    Operations:
                        editingOperations,
                    RuleEditing:
                        true,
                    ActionEditing:
                        true,
                    EventEditing:
                        true,
                    ViewEditing:
                        false
                },
                DerivedCapabilities:
                    derived,
                MetamodelTypes:
                    compactTypes,
                MetamodelEvidence: {
                    TypeHasProperties:
                        hasCollection(
                            "Type",
                            "Properties"
                        ),
                    TypeHasRules:
                        hasCollection(
                            "Type",
                            "Rules"
                        ),
                    TypeHasEvents:
                        hasCollection(
                            "Type",
                            "Events"
                        ),
                    TypeHasActions:
                        hasCollection(
                            "Type",
                            "Actions"
                        ),
                    TypeHasViews:
                        hasCollection(
                            "Type",
                            "Views"
                        )
                }
            };
        }

        function buildDesignerAIContext(): AnyDoc {
            const doc = selectedNode?.doc || null;
            const schema = doc ? getSchemaForObject(doc, selectedNode?.collection) : null;
            const itemEntity = selectedNode?.collection
                ? resolveMetaEntityRef(selectedNode.collection.ItemEntity)
                : null;

            return {
                Task: {
                    TaskId: aiTaskId,
                    BoundaryRule: "Only operations discussed in this task may appear in the plan. Applying or starting a new task discards prior pending operations."
                },
                ThinkingMode: aiThinkingMode,
                Application: {
                    id: applicationDoc?.id || runtime?.id || null,
                    Name: applicationDoc?.Name || runtime?.Name || runtime?.ModuleName || null
                },
                ProjectContext: buildProjectAIContext(),
                PlatformCapabilities:
                    buildDesignerAIPlatformCapabilityContext(),
                Selection: selectedNode
                    ? {
                        NodeId: selectedNode.id,
                        Text: selectedNode.text,
                        Kind: selectedNode.kind,
                        Document: getAIContextDoc(doc),
                        Schema: schema
                            ? {
                                id: schema.id,
                                Name: schema.Name,
                                _type: schema._type
                            }
                            : null,
                        Collection: selectedNode.collection
                            ? {
                                id: selectedNode.collection.id,
                                Name: selectedNode.collection.Name,
                                Aggregation: selectedNode.collection.Aggregation,
                                ItemEntity: itemEntity
                                    ? {
                                        id: itemEntity.id,
                                        Name: itemEntity.Name,
                                        _type: itemEntity._type
                                    }
                                    : null
                            }
                            : null,
                        SelectedProperty: selectedPropertyRow
                            ? {
                                Name: selectedPropertyRow.name,
                                Value: cloneData(selectedPropertyRow.value),
                                Meta: getAIContextDoc(selectedPropertyRow.meta)
                            }
                            : null
                    }
                    : null,
                ModelSummary: {
                    ApplicationModel: {
                        TypeCount: getAIApplicationTypeDocs().length,
                        EnumCount: getAIApplicationEnumDocs().length,
                        IsStructurallyEmpty:
                            getAIApplicationTypeDocs().length === 0 &&
                            getAIApplicationEnumDocs().length === 0,
                        NavigationItems:
                            getAIApplicationNavigationItems(),
                        Types: getAIApplicationTypeDocs().map(
                            (x: AnyDoc) =>
                                buildDesignerAIRuntimeTypeSummary(
                                    x,
                                    getAIApplicationTypeDocs(),
                                    getAIApplicationEnumDocs()
                                )
                        ),
                        Enums: getAIApplicationEnumDocs().map((x: AnyDoc) => ({
                            id: x.id,
                            Name: x.Name,
                            ValueCount: Array.isArray(x.Values) ? x.Values.length : 0
                        }))
                    },
                    MetaModel: {
                        MetaEntityCount: getModelTypes().length,
                        MetaEntities: getModelTypes().map((x: AnyDoc) => ({
                            id: x.id,
                            Name: x.Name,
                            _type: x._type,
                            Description: x.Description || null
                        }))
                    }
                },
                AssistantScope: {
                    Product: "CosmoApps Model Designer",
                    AllowedTopics: [
                        "Current CosmoApps application model",
                        "CosmoApps metadata and semantics",
                        "Properties, collections, views, actions, events and code",
                        "Using and changing the selected model object",
                        "CosmoApps runtime and designer implementation",
                        "Business domain of the current application",
                        "Technical requirements and specifications",
                        "Business processes, actors, roles, terminology and rules",
                        "Data modelling and UI decisions derived from business needs",
                        "Testing, integrations, deployment and operation of the current application"
                    ],
                    RelevanceRule: "A general topic is allowed only when the user connects it to designing, implementing, testing, documenting, operating or improving the current application.",
                    RejectUnrelatedGeneralKnowledge: true
                },
                SemanticRules: {
                    ContextIsProjection: true,
                    MissingFieldsAreNotErrors: true,
                    IndexMeaning: "OrderingKey",
                    IndexMustBeConsecutive: false,
                    ScalarPropertiesHaveAggregation: false,
                    AggregationAppliesTo: ["EntityReference", "Collection"],
                    HybridValueShape: ["id", "Name", "_type"],
                    HybridShapeAppliesToRuntimeValuesNotPropertyDefinitions: true,
                    ApplicationReferenceDoesNotImplySingleApplicationSystem: true,
                    BaseTypeIsNotRequiredOnEveryMetaEntity: true,
                    ModelLayers: {
                        ApplicationTypes: "Concrete domain types stored in runtime.objects, for example Address, City or Shipment",
                        ApplicationEnums: "Concrete enumerations stored in runtime.enums",
                        MetaModelTypes: "Designer schemas such as Type, Property, Action and CodeExpression",
                        CountingRule: "When the user asks how many types or enums are in the project, use ModelSummary.ApplicationModel counts. Never use MetaModel.MetaEntityCount as the application type count."
                    },
                    Naming: {
                        Classes: "EnglishPascalCaseSingular",
                        Properties: "EnglishPascalCase",
                        Collections: "EnglishPascalCasePlural",
                        Rule: "Entity.Name, Property.Name and Collection.Name are English technical identifiers. Never use a Cosmos DB SQL reserved keyword as the exact technical identifier (case-insensitive), including Group, Order, Select, From, Where, Join, Value, Top, Offset, Limit, And, Or, Not, In, Like, Between, Distinct, By, Asc, Desc, As, Is, Null, Undefined, True, False, Array, Object, Exists, All, Any and Some. Use a business-specific name such as CustomerGroup, OrderRecord or GroupRef instead. When the user requests captions in a specific language, put localized display text into Caption for every new entity, property and collection, and into CaptionPlural for new entity types."
                    },
                    BusinessAnalysis: {
                        DiscussRequirementsBeforeChangingModel: true,
                        AskClarifyingQuestionsWhenBusinessRulesAreAmbiguous: true,
                        DistinguishUserFactsFromAssistantInferences: true,
                        DoNotCreateOperationsUnlessModificationIsExplicitlyRequested: true,
                        ExistingModelIsEvidenceNotNecessarilyTheRequirement: true,
                        DeriveEndToEndScenariosBeforeOperations: true,
                        ReviewCapabilitiesAgainstActualOperations: true,
                        PreferConventionalMinimalBusinessDefaultsOverOmission: true,
                        NeverClaimUnsupportedCapabilities: true,
                        PlatformCapabilityContextIsAuthoritative: true,
                        DistinguishPlatformSupportFromCurrentAIEditingSupport: true,
                        DoNotCallPlatformUnsupportedWhenTheMetamodelSupportsItButTheOperationContractCannotEditIt: true,
                        DoNotMarkBehaviorImplementedWhenRequiredRuleActionEventOrViewOperationsAreMissing: true
                    }
                },
                ValueKinds: {
                    scalar: 0,
                    entityRef: 1,
                    enum: 2,
                    expression: 3,
                    json: 4,
                    script: 5
                },
                StorageKinds: {
                    Structured: 0,
                    SemiStructured: 1,
                    OpaqueJson: 2
                },
                Aggregations: {
                    Value: 0,
                    Aggregated: 1,
                    Hybrid: 2,
                    Deferred: 3
                },
                MetamodelEditingContract: buildAIMetamodelEditingContract(doc),
                OperationContract: {
                    UniversalOperations: {
                        Preferred: true,
                        Rules: [
                            "Prefer AddObject, UpdateObject, MoveObject and DeleteObject for model changes.",
                            "Use metamodel collection names such as Properties, Actions, Items and NavigationItems.",
                            "Use exact ids for existing objects. Never recreate an existing object merely to move or edit it.",
                            "AddObject may declare TemporaryId; later operations may address that new parent through ParentRef.TemporaryId.",
                            "Legacy specialized operations remain accepted only for backward compatibility."
                        ],
                        AddObject: {
                            Type: "AddObject",
                            Required: ["Type", "Collection", "Object"],
                            Parent: "ParentId or ParentRef.TemporaryId",
                            Collection: "Destination collection name from the metamodel",
                            Object: "Object to add",
                            TemporaryId: "Optional id used only inside the plan"
                        },
                        UpdateObject: {
                            Type: "UpdateObject",
                            Required: ["Type", "ObjectId", "Changes"]
                        },
                        MoveObject: {
                            Type: "MoveObject",
                            Required: ["Type", "ObjectId", "Collection"],
                            Parent: "ParentId or ParentRef.TemporaryId"
                        },
                        DeleteObject: {
                            Type: "DeleteObject",
                            Required: ["Type", "ObjectId"]
                        }
                    },
                    TopLevel: {
                        Required: [
                            "Intent", "Message", "BusinessAnalysis", "Scenarios", "Capabilities",
                            "Questions", "Recommendations", "Operations", "Warnings",
                            "NeedsMoreContext", "ContextRequests"
                        ],
                        IntentValues: ["Explain", "Analyze", "Clarify", "Propose", "Modify"],
                        Rules: [
                            "Use Clarify when requirements are ambiguous and put concrete questions in Questions",
                            "Questions must be an array of plain strings, never objects.",
                            "Use Analyze or Propose for business analysis without model changes",
                            "Use Modify only when the user explicitly asks to change the model",
                            "Before producing Operations, derive the minimum end-to-end business scenarios implied by the request",
                            "Return BusinessAnalysis, Scenarios and Capabilities for every response, including Modify responses",
                            "Treat the task as business-system design, not merely as creation of plausible entity names",
                            "For each core scenario identify its trigger, document or entity, required line items, lifecycle state, quantities or amounts, parties, locations, resulting balances or reservations, and reverse navigation",
                            "Do not claim a capability is implemented merely because a related type, property or collection exists",
                            "Use PlatformCapabilities to distinguish what the CosmoApps platform can express from what the current AI OperationContract can generate",
                            "If PlatformCapabilities says PlatformSupportedDesignerManual, do not call the platform unsupported; mark the scenario/capability PartiallyImplemented and put the missing metamodel mechanism such as Rule, Action, Event or View into Missing",
                            "If PlatformCapabilities says ModelComposableDesignerPartial, implement the editable structural part and list the remaining executable mechanisms in Missing",
                            "If PlatformCapabilities says RequiresCustomCode, state that code or an external integration is required and do not fabricate structural Evidence for the missing behavior",
                            "Every generated formula must reference only properties that actually exist on the formula owner or on explicitly reachable referenced types. Never invent implicit collections such as Deals, Orders or Payments.",
                            "Do not generate a formula that reads the same computed property it is defining unless the metamodel explicitly models a stateful previous value.",
                            "A formula that depends on a Deferred collection through a Hybrid/reference property is not guaranteed to work in CurrentData. Mark that behavior partial unless the required Expand/Include context is explicitly available.",
                            "When comparing enum properties in formulas, use the runtime-stored enum representation rather than assuming the enum Name string.",
                            "A capability marked Implemented must contain structural Evidence and no Missing items",
                            "An AddRule, AddAction or AddEvent operation counts as implementation evidence for the behavior it creates",
                            "If the plan contains the concrete Rule, Action or Event operation required by a scenario/capability, do not list that same behavior in Missing and do not mark the capability NotImplemented",
                            "Use PartiallyImplemented when the structure supports only part of the scenario",
                            "Use NotImplemented when a requested or implied core scenario is not covered by Operations",
                            "When a missing core scenario can be implemented without unresolved business ambiguity, include the necessary Operations instead of waiting for the user to discover the omission",
                            "Ask clarification only for decisions that materially change business meaning; choose conventional minimal defaults for routine document structure and state them in BusinessAnalysis.Assumptions",
                            "Operations must be empty unless Intent is Modify",
                            "A Modify response that claims something was added, changed, removed, moved or grouped must contain the concrete corresponding Operations; never report a successful modification with Operations: []",
                            "Before returning a Modify plan, validate all references",
                            "Every EntityRef.TemporaryId must match an AddType TemporaryId somewhere in the same plan",
                            "Every Collection.ItemEntity.TemporaryId must match an AddType TemporaryId somewhere in the same plan",
                            "Every enum Property.Type.TemporaryId must match an AddEnum TemporaryId somewhere in the same plan",
                            "Use EntityId for an existing owner type and never invent a TemporaryId from its name",
                            "Do not return a plan while any reference is unresolved",
                            "Before returning a Modify plan, reject any new Type.Name, Property.Name, Collection.Name or Enum.Name that is an exact Cosmos DB SQL reserved keyword (case-insensitive), for example Group, Order, Select, From, Where, Join or Value",
                            "Before returning a Modify plan, reject string or text properties that clearly represent closed choices such as Status, Stage, Priority, Kind, Mode or business Type",
                            "Before returning a Modify plan, verify that reverse collections use Deferred when the item already contains a direct Hybrid or Value reference to the owner",
                            "Before returning a Modify plan, add the inverse Deferred collection for every unambiguous new Hybrid or Value reference between independently stored types; omit it only for Aggregated child types or genuinely ambiguous multi-reference relations",
                            "Do not reject reuse of the same ItemEntity in multiple Aggregated collections; this is valid reuse of an embedded item type",
                            "Before returning a Modify plan, do not create Deferred collections without a direct forward reference to the owner"
                        ],
                        AdditionalPropertiesAllowed: false
                    },
                    BusinessConsulting: {
                        BusinessAnalysis: {
                            Required: [
                                "Actors", "ReferenceData", "Documents", "Lifecycles",
                                "QuantitiesAndBalances", "DerivedValues", "Assumptions"
                            ]
                        },
                        Scenario: {
                            Required: ["Name", "Description", "Importance", "Evidence", "Missing"],
                            ImportanceValues: ["Core", "Supporting"]
                        },
                        Capability: {
                            Required: ["Name", "Status", "Evidence", "Missing"],
                            StatusValues: [
                                "Implemented", "PartiallyImplemented", "NotImplemented", "Assumption"
                            ]
                        },
                        Rules: [
                            "Scenario.Name and Capability.Name are EnglishPascalCase identifiers",
                            "Evidence contains exact model paths such as CustomerOrder.Lines or Waybill.Status",
                            "Implemented requires Evidence and an empty Missing list",
                            "PartiallyImplemented requires both Evidence and Missing",
                            "NotImplemented requires a non-empty Missing list",
                            "A document with items normally requires a header, Aggregated lines, item, quantity, price when relevant, line amount, document total and lifecycle state when effects depend on status",
                            "Reservation normally requires warehouse, requested quantity, reserved quantity or equivalent reservation record, activating state, release behavior and available quantity",
                            "Stock movement normally requires source and/or destination warehouse, lines, quantities and an explicit posting lifecycle; only posted movement changes stock",
                            "Partial execution normally requires ordered quantity, fulfilled or received quantity and remaining quantity or a deterministic derivation",
                            "For a company acting in multiple roles, provide direct role references or a role discriminator and reverse navigation for every relevant role"
                        ]
                    },
                    AddType: {
                        Type: "AddType",
                        Required: ["Type", "TemporaryId", "Entity"],
                        EntityAllowedFrom: "MetamodelEditingContract.TypeAllowedFields",
                        SchemaFrom: "MetamodelEditingContract.TypeDefinitionSchema",
                        Rules: [
                            "TemporaryId is a short unique identifier used only inside this plan, for example new-order",
                            "Entity.Name must use PascalCase singular",
                            "Entity.Name must not be a Cosmos DB SQL reserved keyword (case-insensitive); never use Group, Order, Select, From, Where, Join, Value and other SQL keywords as exact type names",
                            "Do not invent a permanent id; the Apply layer will create it",
                            "Use the runtime conventions visible in ExistingTypeExamples",
                            "New types may be referenced by { TemporaryId: \"...\" } in later operations"
                        ]
                    },
                    AddEnum: {
                        Type: "AddEnum",
                        Required: ["Type", "TemporaryId", "Enum"],
                        EnumRequired: ["Name", "Values"],
                        EnumAllowed: ["Name", "Caption", "Description", "Values"],
                        EnumValueRequired: ["Name"],
                        EnumValueAllowed: ["Name", "Caption", "Description", "Value"],
                        Rules: [
                            "Use the field Enum for the enum definition; never put an enum definition into Entity",
                            "TemporaryId must be unique inside the current plan",
                            "Enum.Name must be an English PascalCase technical identifier",
                            "Enum.Name must not be a Cosmos DB SQL reserved keyword (case-insensitive)",
                            "Enum.Values must contain at least two values",
                            "Every Enum.Values item must have an English PascalCase Name",
                            "Localized display text belongs in Caption",
                            "Value should be a unique integer; when omitted, Apply assigns consecutive values starting from zero",
                            "Do not use AddType to represent a finite closed choice",
                            "A later enum property references this enum through Property.Type: { TemporaryId: \"...\" }"
                        ]
                    },
                    AddProperty: {
                        Type: "AddProperty",
                        Required: ["Type", "Property"],
                        Target: "Use exactly one of EntityId for an existing type or EntityRef: { TemporaryId } for a type declared in the same plan",
                        PropertyAllowedFrom: "MetamodelEditingContract.RuntimePropertyContract.AllowedFields",
                        RuntimeShapeFrom: "MetamodelEditingContract.RuntimePropertyContract",
                        Rules: [
                            "EntityId must already exist, or EntityRef.TemporaryId must identify an AddType operation in the same plan",
                            "Property.Name must be an English PascalCase technical identifier",
                            "Property.Name must not be a Cosmos DB SQL reserved keyword (case-insensitive); use a business-specific identifier such as CustomerGroup or GroupRef instead of Group",
                            "For scalar properties, Property.Type must be a string from RuntimePropertyContract.ScalarTypes",
                            "For a reference to an existing type, Property.Type must be the existing application type id",
                            "For a reference to a new type, Property.Type must be { TemporaryId: \"...\" }",
                            "Do not emit ValueType, ValueKind, StorageKind or TypeEntity",
                            "Never use numeric DataTypeEnum values in Property.Type",
                            "Use Hybrid by default for ordinary user-facing references unless Value semantics are explicitly requested",
                            "When adding a Hybrid or Value reference from an independently stored type, also add the inverse Deferred collection on the referenced type unless such a collection already exists or the relation is ambiguous",
                            "Do not add that inverse collection when the referencing owner is only an Aggregated child/line type",
                            "If the user requested a reference, link, lookup or relation, never use a scalar Property.Type as a fallback",
                            "If an existing application type already has the required structure, reuse that type for Value, Hybrid or Aggregated properties",
                            "Embedded, inline, inside the owner or stored directly there normally changes Aggregation to Aggregated; it does not imply creation of a duplicate type",
                            "Aggregation and multiplicity are independent. A single owned/embedded child is an AddProperty with Aggregation=Aggregated and Many=false (or Many omitted). Do not pluralize the property name or turn it into a collection unless the user explicitly asks for multiple/list/collection child objects.",
                            "Create a new referenced type only when the requested object has a distinct structure or meaning that the existing type cannot represent",
                            "If the target type is missing and its minimal purpose is clear, add it first with AddType and then reference its TemporaryId",
                            "If the missing target type is created for a Hybrid reference, add at least a required string Name property to that type",
                            "Use money for monetary fields such as Price, Cost, Amount, Payment, Balance and Total",
                            "Prefer Amount for a monetary value calculated for one row or position; use Total for an aggregate over multiple rows; avoid Sum when Amount or Total is more precise",
                            "Use the canonical field name ReadOnly with exact casing; never emit Readonly or RO",
                            "All Property field names must exactly match canonical metamodel names, including letter case",
                            "Formula does not automatically imply ReadOnly",
                            "Set ReadOnly to true when recalculation necessarily replaces any manually entered value",
                            "Leave a formula property editable when its formula preserves the property's current valid non-empty or non-default value",
                            "If the target type is ambiguous, ask for clarification and omit operations that depend on it",
                            "Use Aggregation names used by the current application model",
                            "Use Index null or omit it when ordering is not certain"
                        ]
                    },
                    AddCollection: {
                        Type: "AddCollection",
                        Required: ["Type", "Collection"],
                        Target: "Use exactly one of EntityId for an existing type or EntityRef: { TemporaryId } for a type declared in the same plan",
                        CollectionRequired: ["Name", "ItemEntity", "Aggregation", "StorageKind"],
                        CollectionAllowed: [
                            "Name", "Caption", "Description", "ItemEntity", "Aggregation", "StorageKind", "Index", "Global"
                        ],
                        Rules: [
                            "Name must be an English PascalCase plural technical identifier",
                            "Use AddCollection only when multiplicity is genuinely many: the user explicitly describes multiple items, a list/collection, repeated lines/rows/addresses/contacts, or the business relation is inherently plural. Do not use AddCollection merely because the child type is Aggregated or embedded.",
                            "If the user describes one embedded/owned object in singular form, use AddProperty with Aggregation=Aggregated and Many=false instead.",
                            "For an existing owner type, use EntityId with its actual id from ModelSummary.ApplicationModel.Types",
                            "Use EntityRef: { TemporaryId } only when that exact TemporaryId is declared by an AddType operation in the same plan",
                            "Never construct or infer a TemporaryId from the name of an existing owner type",
                            "ItemEntity must reference an existing id from ModelSummary.ApplicationModel.Types or { TemporaryId } declared by an AddType operation in the same plan",
                            "Do not add Many because collections are inherently many",
                            "Use Aggregated when collection items are owned by the parent and stored as part of the parent object, for example Order.Lines containing OrderLine items",
                            "Use Deferred only for a reverse or independently stored collection whose items contain the forward reference to the owner, for example Company.Orders while Order.Company remains a Hybrid reference to Company",
                            "Do not infer Deferred merely because the user mentions that one type references another; determine whether the collection represents owned child items or a reverse navigation",
                            "When the user requests captions in a specific language, add Caption to every new collection as well as to every new entity and property",
                            "Do not rely only on the item type's CaptionPlural when a collection-specific caption can be provided",
                            "Use a concise plural collection name in the owner's context, for example Lines inside Order and Orders inside Company"
                        ]
                    },
                    UpdateType: {
                        Type: "UpdateType",
                        Required: ["Type", "EntityId", "Changes"],
                        ChangesAllowed: [
                            "BaseType", "Abstract", "Browsable", "Cacheable",
                            "Caption", "CaptionPlural", "Description"
                        ],
                        Rules: [
                            "EntityId must identify an existing type",
                            "Use Changes.BaseType for inheritance",
                            "For an existing base type use its actual id",
                            "For a base type created in the same plan use { TemporaryId: \"...\" }",
                            "Changing captions is not a substitute for changing BaseType"
                        ]
                    },
                    AddRule: {
                        Type: "AddRule",
                        Required: ["Type", "Rule"],
                        Target: "Use EntityId or EntityRef. PropertyId/PropertyName optionally targets Property.Rules.",
                        RuleAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Rule",
                        Rules: [
                            "Rule.Name is required",
                            "Condition and PreCondition follow the loaded Rule schema",
                            "Type-level rules are stored in Type.Rules; property-level rules are stored in Property.Rules",
                            "When targeting a property created in the same plan, place AddRule after that AddProperty and use PropertyName"
                        ]
                    },
                    UpdateRule: {
                        Type: "UpdateRule",
                        Required: ["Type", "EntityId", "Changes"],
                        Target: "RuleId or RuleName identifies the rule; PropertyId/PropertyName optionally targets Property.Rules",
                        ChangesAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Rule"
                    },
                    AddAction: {
                        Type: "AddAction",
                        Required: ["Type", "Action"],
                        Target: "Use EntityId or EntityRef; actions are stored in Type.Actions",
                        ActionAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Action",
                        Rules: [
                            "Action.Name is required",
                            "Use Action.Script for executable code; save converts it to legacy runtime js",
                            "Use EnableRoles/DisableRoles only when the loaded Action schema exposes them"
                        ]
                    },
                    UpdateAction: {
                        Type: "UpdateAction",
                        Required: ["Type", "EntityId", "Changes"],
                        Target: "ActionId or ActionName identifies the action",
                        ChangesAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Action"
                    },
                    AddEvent: {
                        Type: "AddEvent",
                        Required: ["Type", "Event"],
                        Target: "Use EntityId or EntityRef. PropertyId/PropertyName optionally targets Property.Events.",
                        EventAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Event",
                        Rules: [
                            "Event.Name is required and should follow event names/conventions already used by the runtime/project",
                            "Use Event.Script for executable code; save converts it to legacy runtime js",
                            "Type-level events are stored in Type.Events; property-level events in Property.Events",
                            "When targeting a property created in the same plan, place AddEvent after that AddProperty and use PropertyName"
                        ]
                    },
                    UpdateEvent: {
                        Type: "UpdateEvent",
                        Required: ["Type", "EntityId", "Changes"],
                        Target: "EventId or EventName identifies the event; PropertyId/PropertyName optionally targets Property.Events",
                        ChangesAllowedFrom: "MetamodelEditingContract.BehaviorAllowedFields.Event"
                    },
                    AddNavigationGroup: {
                        Type: "AddNavigationGroup",
                        Required: ["Type", "TemporaryId", "NavigationItem"],
                        NavigationItemRequired: ["Name", "Caption"],
                        ChildAttachment: {
                            Rule: "Every AddNavigationItem that belongs inside this newly created group must set ParentRef to this group's TemporaryId.",
                            Example: {
                                Group: {
                                    Type: "AddNavigationGroup",
                                    TemporaryId: "nav-reference",
                                    NavigationItem: {
                                        Name: "ReferenceData",
                                        Caption: "Справочники"
                                    }
                                },
                                Child: {
                                    Type: "AddNavigationItem",
                                    TemporaryId: "nav-customers",
                                    ParentRef: {
                                        TemporaryId: "nav-reference"
                                    },
                                    EntityId: "<customer-type-id>",
                                    NavigationItem: {
                                        Name: "Customers",
                                        Caption: "Клиенты"
                                    }
                                }
                            }
                        },
                        Rules: [
                            "Create a navigation group only when it will contain at least one item",
                            "A group is not populated merely by creating it: child items must explicitly reference it through ParentRef",
                            "Reuse an existing semantically matching group when one already exists",
                            "Folder is only a semantic classification hint; ParentRef or ParentId defines actual menu nesting",
                            "Do not reorganize existing navigation unless explicitly requested"
                        ]
                    },
                    AddNavigationItem: {
                        Type: "AddNavigationItem",
                        Required: ["Type", "TemporaryId", "NavigationItem"],
                        OptionalParent: [
                            "ParentId for an existing navigation group",
                            "ParentRef: { TemporaryId: \"...\" } for a group created by AddNavigationGroup in the same plan"
                        ],
                        TargetModes: {
                            EntityOrView: "Use exactly one of EntityId, EntityRef, ViewId or ViewRef. The designer resolves runtime NavigationItem.Type.",
                            Script: "Set NavigationItem.Type to <js> and NavigationItem.js to a JavaScript function expression such as () => { ... }. Do not set EntityId, EntityRef, ViewId or ViewRef."
                        },
                        Rules: [
                            "A navigation item may either open an entity/view or execute a script.",
                            "For a script item, use NavigationItem.Type=\"<js>\" and NavigationItem.js=\"() => { ... }\". The runtime invokes this function when the menu item is clicked.",
                            "Script navigation has no e parameter unless existing runtime source explicitly provides one. NavigationItem.js is Runtime client UI code and MUST follow the same UI contract as Actions/Events: use jQuery + DevExtreme widgets for popup/chart/grid/form UI instead of hand-built SVG/HTML when a matching DevExtreme widget exists. Preserve the active Runtime theme: do not impose hard-coded light/dark colors unless the user explicitly asks for a custom style.",
                            "When this item belongs to a newly created navigation group, ParentRef is REQUIRED and must reference that AddNavigationGroup.TemporaryId",
                            "When this item belongs to an existing navigation group, ParentId is REQUIRED and must equal the exact id of that group from ModelSummary.ApplicationModel.NavigationItems",
                            "Do not assume NavigationItem.Folder creates nesting; actual nesting is controlled only by ParentRef or ParentId",
                            "Never claim that an item was placed into a section/group unless AddNavigationItem contains ParentId or ParentRef",
                            "Do not set NavigationItem.Type manually; the designer resolves it from EntityId or EntityRef to the target type technical Name",
                            "Use EntityId or EntityRef directly on the operation. TargetType is also accepted as a compatibility alias and may be placed on NavigationItem.",
                            "EntityId references an existing type; EntityRef references a type created in this plan",
                            "Abstract types may have ListViews that include derived instances",
                            "A shared abstract-base ListView may satisfy navigation access for the hierarchy",
                            "Create separate derived-type items only for distinct workflows",
                            "Do not create navigation for Aggregated line types or technical child types",
                            "Document classifies true business documents",
                            "Existing navigation and explicit user intent take precedence"
                        ]
                    },
                    MoveNavigationItem: {
                        Type: "MoveNavigationItem",
                        Required: ["Type", "NavigationItemId"],
                        Destination: [
                            "ParentId for an existing navigation group",
                            "ParentRef: { TemporaryId: \"...\" } for a group created by AddNavigationGroup in the same plan"
                        ],
                        Rules: [
                            "Move an existing navigation item; do not recreate it with AddNavigationItem",
                            "Use NavigationItemId exactly as supplied by ModelSummary.ApplicationModel.NavigationItems",
                            "Use ParentId for an existing group and ParentRef only for a new AddNavigationGroup in the same plan",
                            "The destination must be a navigation group",
                            "Moving preserves id, caption, target type and other runtime properties"
                        ]
                    },
                    UpdateProperty: {
                        Type: "UpdateProperty",
                        Required: ["Type", "EntityId", "PropertyId", "Changes"],
                        ChangesAllowedFrom: "MetamodelEditingContract.RuntimePropertyContract.AllowedFields",
                        RuntimeShapeFrom: "MetamodelEditingContract.RuntimePropertyContract",
                        Rules: [
                            "PropertyId must already exist in Selection.Document.Properties",
                            "Changes must contain only runtime Property fields allowed by RuntimePropertyContract",
                            "Do not emit ValueType, ValueKind, StorageKind or TypeEntity",
                            "Never replace runtime Property.Type with a numeric DataTypeEnum value",
                            "For Formula use MetamodelEditingContract.TypedValueRules.Formula and CodeExpressionSchema",
                            "Do not silently convert scalar properties into references or collections"
                        ]
                    }
                },
                Capabilities: [
                    "ExplainSelection",
                    "ProposeModelChangePlan",
                    "AddType",
                    "AddProperty",
                    "UpdateType",
                    "UpdateProperty",
                    "AddCollection",
                    "AddRule",
                    "UpdateRule",
                    "AddAction",
                    "UpdateAction",
                    "AddEvent",
                    "UpdateEvent",
                    "AddObject",
                    "UpdateObject",
                    "MoveObject",
                    "DeleteObject",
                    "AddNavigationGroup",
                    "AddNavigationItem",
                    "MoveNavigationItem",
                    "UpdateCollection",
                    "ProposeDetailViewChanges"
                ]
            };
        }

        interface AIPlanValidationIssue {
            OperationIndex: number;
            Code: string;
            Message: string;
            Severity?: "error" | "warning";
        }

        interface AIPlanValidationResult {
            IsValid: boolean;
            Issues: AIPlanValidationIssue[];
        }

        function getExistingAITypeIdByName(name: any): string | null {
            const text = String(name || "").trim();
            if (!text) return null;

            const found = getAIApplicationTypeDocs().find((x: AnyDoc) =>
                String(x.Name || "") === text ||
                String(x.TypeName || "") === text ||
                String(x.TypeName || "").endsWith("." + text)
            );

            return found?.id ? String(found.id) : null;
        }


        function getAIPlanTypeNameByRef(
            ref: any,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): string | null {
            if (!ref) return null;

            if (typeof ref === "object" && ref.TemporaryId) {
                const tempId = String(ref.TemporaryId);
                const addType = operations.find((op: AnyDoc) =>
                    op?.Type === "AddType" &&
                    String(op?.TemporaryId || "") === tempId
                );
                return addType?.Entity?.Name ? String(addType.Entity.Name) : null;
            }

            const id = typeof ref === "object"
                ? (ref.EntityId || ref.id || ref.Type || null)
                : ref;

            if (!id) return null;

            const found = existingTypes.find((x: AnyDoc) =>
                String(x.id || x.Id || "") === String(id)
            );

            return found?.Name ? String(found.Name) : null;
        }

        function getAIPlanTypeIdByRef(
            ref: any,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): string | null {
            if (!ref) return null;

            if (typeof ref === "object" && ref.TemporaryId) {
                const tempId = String(ref.TemporaryId);
                const addType = operations.find((op: AnyDoc) =>
                    op?.Type === "AddType" &&
                    String(op?.TemporaryId || "") === tempId
                );
                return addType?.TemporaryId ? String(addType.TemporaryId) : null;
            }

            const id = typeof ref === "object"
                ? (ref.EntityId || ref.id || ref.Type || null)
                : ref;

            return id ? String(id) : null;
        }

        function getAIPlanPropertiesForType(
            typeRef: any,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): AnyDoc[] {
            const result: AnyDoc[] = [];
            const typeId = getAIPlanTypeIdByRef(typeRef, operations, existingTypes);
            const typeName = getAIPlanTypeNameByRef(typeRef, operations, existingTypes);

            const existingType = existingTypes.find((x: AnyDoc) =>
                (!!typeId && String(x.id || "") === String(typeId)) ||
                (!!typeName && String(x.Name || "") === String(typeName))
            );

            if (Array.isArray(existingType?.Properties)) {
                result.push(...existingType.Properties);
            }

            operations.forEach((op: AnyDoc) => {
                if (op?.Type !== "AddProperty") return;

                const ownerRef = op.EntityRef || op.EntityId;
                const ownerId = getAIPlanTypeIdByRef(ownerRef, operations, existingTypes);
                const ownerName = getAIPlanTypeNameByRef(ownerRef, operations, existingTypes);

                if (
                    (!!typeId && ownerId === typeId) ||
                    (!!typeName && ownerName === typeName)
                ) {
                    result.push(op.Property);
                }
            });

            return result;
        }

        function isClosedChoicePropertyName(name: any): boolean {
            const normalized = String(name || "").trim().toLowerCase();
            return ["status", "stage", "priority", "kind", "mode"].indexOf(normalized) >= 0;
        }

        function isBusinessTypeChoiceProperty(ownerName: any, propertyName: any): boolean {
            const owner = String(ownerName || "").trim().toLowerCase();
            const prop = String(propertyName || "").trim().toLowerCase();

            if (prop !== "type") return false;

            return [
                "activity", "contact", "payment", "document", "task",
                "interaction", "event", "request", "order"
            ].indexOf(owner) >= 0;
        }

        function isScalarStringType(typeValue: any): boolean {
            return typeValue === "string" || typeValue === "text";
        }

        function isReferenceAggregation(value: any): boolean {
            const normalized = String(value ?? "").toLowerCase();
            return normalized === "hybrid" ||
                normalized === "value" ||
                normalized === "2" ||
                normalized === "0";
        }

        function isHybrid(value: any): boolean {
            const normalized = String(value ?? "").toLowerCase();
            return normalized === "hybrid" || normalized === "2";
        }

        function isAggregated(value: any): boolean {
            const normalized = String(value ?? "").toLowerCase();
            return normalized === "aggregated" || normalized === "1";
        }

        function isDeferred(value: any): boolean {
            const normalized = String(value ?? "").toLowerCase();
            return normalized === "deferred" || normalized === "3";
        }

        interface AIFormulaDependencyFinding {
            Target: string;
            OperationIndex: number;
            Code: string;
            Message: string;
            Blocking: boolean;
        }

        function getAIFormulaCode(property: AnyDoc): string {
            const formula = property?.Formula;

            if (typeof formula === "string") {
                return formula.trim();
            }

            if (formula && typeof formula === "object") {
                return String(
                    formula.Code ||
                    formula.Expression ||
                    ""
                ).trim();
            }

            return "";
        }

        function isAITrivialConstantFormula(formulaCode: any): boolean {
            let code = String(formulaCode || "").trim();
            if (!code) return false;

            for (let i = 0; i < 6; i++) {
                const match = code.match(/^\(\s*([\s\S]*)\s*\)$/);
                if (!match) break;
                code = String(match[1] || "").trim();
            }

            return (
                /^(?:true|false|null|undefined)$/i.test(code) ||
                /^[-+]?\d+(?:\.\d+)?(?:[eE][-+]?\d+)?$/.test(code) ||
                /^[\"'][^\"']*[\"']$/.test(code)
            );
        }

        function getAIFormulaFindingsForTarget(
            plan: AnyDoc,
            target: string
        ): AIFormulaDependencyFinding[] {
            return analyzeAIPlanFormulaDependencies(plan).filter(
                (finding: AIFormulaDependencyFinding) =>
                    String(finding.Target || "") === String(target || "")
            );
        }

        function getAIBehaviorKindsForText(value: any): string[] {
            const text = String(value || "").toLowerCase();
            const kinds: string[] = [];
            const add = (kind: string): void => {
                if (kinds.indexOf(kind) < 0) kinds.push(kind);
            };

            if (/рассчит|расч[её]т|вычисл|итог|дебитор|просроч|бонус|скидк|наценк|calculat|computed|total|balance|overdue|bonus|discount|markup/.test(text)) {
                add("Formula");
            }
            if (/провер|лимит|не\s+может|не\s+долж|запрет|огранич|validation|validate|must\s+not|cannot|limit/.test(text)) {
                add("Validation");
            }
            if (/стади|воронк|transition|lifecycle|stage.*change|status.*change/.test(text)) {
                add("StatusTransition");
            }
            if (/кнопк|созда[её]тся\s+из|преобраз|конверт|override|переопредел|логир|action|button|convert/.test(text)) {
                add("Action");
            }
            if (/автомат|напомин|уведом|подсвет|automatic|remind|notify|highlight/.test(text)) {
                add("ExecutableBehavior");
            }
            if (/рол[ьи]|прав[ао]\s+доступ|видит\s+свои|видит\s+все|role|permission|access control|visibility/.test(text)) {
                add("SecurityBehavior");
            }

            if (/аналитик|отч[её]т|дашборд|report|reporting|analytics|dashboard/.test(text)) {
                add("ViewBehavior");
            }

            if (/интеграц|webhook|вебхук|website forms?|email integration|интеграц.*email|integration/.test(text)) {
                add("IntegrationBehavior");
            }

            return kinds;
        }

        function getAITypedRequirementKinds(item: AnyDoc): string[] {
            return buildFallbackTypedRequirements(item)
                .map((requirement: AnyDoc) =>
                    normalizeAIRequirementKind(requirement?.Kind)
                )
                .filter(Boolean);
        }

        function getAIUntypedBehaviorGaps(
            plan: AnyDoc,
            item: AnyDoc
        ): string[] {
            const requirementKinds = getAITypedRequirementKinds(item);
            const gaps: string[] = [];
            const fragments: string[] = [];

            [item?.Name, item?.Description, item?.Trigger, item?.Lifecycle, item?.BusinessEffect]
                .forEach((value: any) => {
                    const text = String(value || "").trim();
                    if (text) fragments.push(text);
                });

            (Array.isArray(item?.AcceptanceCriteria) ? item.AcceptanceCriteria : [])
                .forEach((value: any) => {
                    const text = String(value || "").trim();
                    if (text) fragments.push(text);
                });

            fragments.forEach((fragment: string) => {
                getAIBehaviorKindsForText(fragment).forEach((kind: string) => {
                    let covered = false;

                    if (kind === "ExecutableBehavior") {
                        covered = requirementKinds.some((value: string) =>
                            ["Action", "UpdateOnAction", "Validation", "StatusTransition"].indexOf(value) >= 0
                        );
                    } else if (
                        kind === "SecurityBehavior" ||
                        kind === "ViewBehavior" ||
                        kind === "IntegrationBehavior"
                    ) {
                        covered = false;
                    } else {
                        covered = requirementKinds.indexOf(kind) >= 0;
                    }

                    if (!covered) {
                        const message = `${kind}: ${fragment}`;
                        if (gaps.indexOf(message) < 0) gaps.push(message);
                    }
                });
            });

            return gaps;
        }

        function getAIPlanPropertyByTypeName(
            typeName: string,
            propertyName: string,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): AnyDoc | null {
            const normalizedType =
                String(typeName || "").toLowerCase();
            const normalizedProperty =
                String(propertyName || "").toLowerCase();

            const existingType = existingTypes.find(
                (item: AnyDoc) =>
                    String(item?.Name || "").toLowerCase() ===
                    normalizedType
            );

            const existingProperty = (
                Array.isArray(existingType?.Properties)
                    ? existingType.Properties
                    : []
            ).find(
                (property: AnyDoc) =>
                    String(property?.Name || "").toLowerCase() ===
                    normalizedProperty
            );

            if (existingProperty) {
                return existingProperty;
            }

            for (const operation of operations) {
                if (operation?.Type !== "AddProperty") continue;

                const ownerName =
                    getAIPlanTypeNameByRef(
                        operation.EntityRef ||
                        operation.EntityId,
                        operations,
                        existingTypes
                    );

                if (
                    String(ownerName || "").toLowerCase() ===
                    normalizedType &&
                    String(
                        operation?.Property?.Name || ""
                    ).toLowerCase() === normalizedProperty
                ) {
                    return operation.Property;
                }
            }

            return null;
        }

        function getAIPlanEnumDefinitionByRef(
            ref: any,
            operations: AnyDoc[]
        ): AnyDoc | null {
            const temporaryId =
                ref && typeof ref === "object"
                    ? String(ref.TemporaryId || "")
                    : "";

            if (!temporaryId) return null;

            const operation = operations.find(
                (item: AnyDoc) =>
                    item?.Type === "AddEnum" &&
                    String(item?.TemporaryId || "") ===
                    temporaryId
            );

            return operation?.Enum ||
                operation?.Entity ||
                null;
        }

        function analyzeAIPlanFormulaDependencies(
            plan: AnyDoc
        ): AIFormulaDependencyFinding[] {
            const findings: AIFormulaDependencyFinding[] = [];
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations)
                    ? plan.Operations
                    : [];
            const existingTypes: AnyDoc[] =
                getAIApplicationTypeDocs();

            const globalIdentifiers = new Set<string>([
                "date", "math", "json", "array", "object",
                "number", "string", "boolean", "regexp",
                "parseint", "parsefloat", "isnan", "infinity",
                "nan", "undefined", "console"
            ]);

            const languageIdentifiers = new Set<string>([
                "var", "let", "const", "function", "return",
                "if", "else", "for", "while", "do", "switch",
                "case", "break", "continue", "new", "this",
                "true", "false", "null", "typeof", "instanceof",
                "in", "of", "try", "catch", "finally", "throw"
            ]);

            operations.forEach(
                (operation: AnyDoc, operationIndex: number) => {
                    if (operation?.Type !== "AddProperty") {
                        return;
                    }

                    const property = operation.Property || {};
                    const formula =
                        getAIFormulaCode(property);

                    if (!formula) return;

                    const ownerRef =
                        operation.EntityRef ||
                        operation.EntityId;
                    const ownerName =
                        String(
                            getAIPlanTypeNameByRef(
                                ownerRef,
                                operations,
                                existingTypes
                            ) || "UnknownType"
                        );
                    const propertyName =
                        String(property?.Name || "").trim();
                    const target =
                        `${ownerName}.${propertyName}`;
                    const ownerProperties =
                        getAIPlanPropertiesForType(
                            ownerRef,
                            operations,
                            existingTypes
                        );
                    const ownerPropertyByName =
                        new Map<string, AnyDoc>();

                    ownerProperties.forEach(
                        (item: AnyDoc) => {
                            const name = String(
                                item?.Name || ""
                            ).trim();
                            if (name) {
                                ownerPropertyByName.set(
                                    name.toLowerCase(),
                                    item
                                );
                            }
                        }
                    );

                    const localIdentifiers =
                        new Set<string>();

                    Array.from(
                        formula.matchAll(
                            /\b(?:var|let|const)\s+([A-Za-z_][A-Za-z0-9_]*)/g
                        )
                    ).forEach((match: RegExpMatchArray) => {
                        localIdentifiers.add(
                            String(match[1]).toLowerCase()
                        );
                    });

                    Array.from(
                        formula.matchAll(
                            /\bfunction\s*\([^)]*\)/g
                        )
                    ).forEach((match: RegExpMatchArray) => {
                        const params = String(match[0])
                            .replace(/^.*?\(/, "")
                            .replace(/\).*$/, "")
                            .split(",")
                            .map(x => x.trim().toLowerCase())
                            .filter(Boolean);

                        params.forEach(x =>
                            localIdentifiers.add(x)
                        );
                    });

                    if (
                        propertyName &&
                        new RegExp(
                            `\\b${propertyName.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&")}\\b`
                        ).test(formula)
                    ) {
                        findings.push({
                            Target: target,
                            OperationIndex: operationIndex,
                            Code: "FormulaSelfReference",
                            Message:
                                `${target} formula references ${propertyName} itself. ` +
                                `This can be intentional fallback/state-preserving logic; review it only if the self-reference was not intended.`,
                            Blocking: false
                        });
                    }

                    // Dependency analysis must inspect JavaScript expressions, not
                    // words/member paths that merely occur inside string literals.
                    // This matters especially for app.query(`SELECT ... s.Product.id ...`):
                    // SELECT/FROM/WHERE and Product.id are SQL text, not formula dependencies.
                    // Preserve ${...} expressions inside template literals because those are
                    // real JavaScript and may legitimately reference model properties.
                    const stripTemplateLiteralText = (source: string): string => {
                        let result = "";
                        let i = 0;

                        while (i < source.length) {
                            if (source[i] !== "`") {
                                result += source[i++];
                                continue;
                            }

                            // Replace the literal part with spaces, but keep interpolation
                            // expressions so dependency checks still see ${Product.id}.
                            result += " ";
                            i++;
                            while (i < source.length) {
                                if (source[i] === "\\") {
                                    result += "  ";
                                    i += 2;
                                    continue;
                                }
                                if (source[i] === "`") {
                                    result += " ";
                                    i++;
                                    break;
                                }
                                if (source[i] === "$" && source[i + 1] === "{") {
                                    result += "  ";
                                    i += 2;
                                    let depth = 1;
                                    while (i < source.length && depth > 0) {
                                        const ch = source[i];
                                        if (ch === "\\") {
                                            result += source.substr(i, 2);
                                            i += 2;
                                            continue;
                                        }
                                        if (ch === "{") depth++;
                                        if (ch === "}") {
                                            depth--;
                                            if (depth === 0) {
                                                result += " ";
                                                i++;
                                                break;
                                            }
                                        }
                                        result += ch;
                                        i++;
                                    }
                                    continue;
                                }
                                result += " ";
                                i++;
                            }
                        }
                        return result;
                    };

                    const cleanedFormula = stripTemplateLiteralText(formula)
                        .replace(/\/\*[\s\S]*?\*\//g, " ")
                        .replace(/\/\/.*$/gm, " ")
                        .replace(/'(?:\\.|[^'\\])*'/g, " ")
                        .replace(/"(?:\\.|[^"\\])*"/g, " ");

                    const identifiers = Array.from(
                        cleanedFormula.matchAll(
                            /\b([A-Za-z_][A-Za-z0-9_]*)\b/g
                        )
                    );

                    const unresolved = new Set<string>();

                    identifiers.forEach(
                        (match: RegExpMatchArray) => {
                            const identifier =
                                String(match[1] || "");
                            const lower =
                                identifier.toLowerCase();
                            const index =
                                match.index || 0;
                            const previous =
                                index > 0
                                    ? cleanedFormula[index - 1]
                                    : "";

                            if (previous === ".") return;
                            if (
                                languageIdentifiers.has(lower) ||
                                globalIdentifiers.has(lower) ||
                                localIdentifiers.has(lower) ||
                                ownerPropertyByName.has(lower)
                            ) {
                                return;
                            }

                            // Function names introduced by callbacks or ordinary
                            // lowercase helper/method identifiers are not model
                            // dependencies. Capitalized identifiers are treated as
                            // candidate owner properties and must resolve.
                            if (/^[A-Z]/.test(identifier)) {
                                unresolved.add(identifier);
                            }
                        }
                    );

                    unresolved.forEach(
                        (identifier: string) => {
                            findings.push({
                                Target: target,
                                OperationIndex: operationIndex,
                                Code: "FormulaUnresolvedDependency",
                                Message:
                                    `${target} formula references "${identifier}", ` +
                                    `but ${ownerName} has no such property in the current model or generated plan.`,
                                Blocking: true
                            });
                        }
                    );

                    const collectionMethods =
                        new Set<string>([
                            "reduce", "map", "filter", "find",
                            "findindex", "some", "every",
                            "foreach", "includes", "indexof",
                            "slice", "concat", "join",
                            "sort", "reverse", "push", "pop",
                            "shift", "unshift", "at"
                        ]);

                    Array.from(
                        cleanedFormula.matchAll(
                            /\b([A-Za-z_][A-Za-z0-9_]*)\.([A-Za-z_][A-Za-z0-9_]*)\b/g
                        )
                    ).forEach((match: RegExpMatchArray) => {
                        const rootName = String(match[1] || "");
                        const memberName = String(match[2] || "");
                        const rootProperty =
                            ownerPropertyByName.get(
                                rootName.toLowerCase()
                            );

                        if (!rootProperty) return;

                        const isCollectionRoot =
                            rootProperty?.Many === true ||
                            isAggregated(
                                rootProperty?.Aggregation
                            ) ||
                            isDeferred(
                                rootProperty?.Aggregation
                            );

                        if (
                            isCollectionRoot &&
                            collectionMethods.has(
                                memberName.toLowerCase()
                            )
                        ) {
                            return;
                        }

                        const referencedTypeName =
                            getAIPlanTypeNameByRef(
                                rootProperty.Type,
                                operations,
                                existingTypes
                            );

                        if (!referencedTypeName) return;

                        // Hybrid runtime values are partial embedded references.
                        // Their built-in shape always exposes id, Name and _type
                        // even though these members are not ordinary Properties
                        // declared on the referenced application type.
                        if (
                            isHybrid(rootProperty.Aggregation) &&
                            ["id", "name", "_type"].indexOf(
                                memberName.toLowerCase()
                            ) >= 0
                        ) {
                            return;
                        }

                        const memberProperty =
                            getAIPlanPropertyByTypeName(
                                referencedTypeName,
                                memberName,
                                operations,
                                existingTypes
                            );

                        if (!memberProperty) {
                            findings.push({
                                Target: target,
                                OperationIndex: operationIndex,
                                Code: "FormulaMissingReferencedMember",
                                Message:
                                    `${target} formula uses ${rootName}.${memberName}, ` +
                                    `but ${referencedTypeName}.${memberName} does not exist in the current model or generated plan.`,
                                Blocking: true
                            });
                            return;
                        }

                        if (
                            isDeferred(
                                memberProperty.Aggregation
                            )
                        ) {
                            findings.push({
                                Target: target,
                                OperationIndex: operationIndex,
                                Code: "FormulaDeferredDependency",
                                Message:
                                    `${target} formula reads ${rootName}.${memberName}, ` +
                                    `which is Deferred. The formula is not guaranteed to have that collection in CurrentData unless it is explicitly expanded/included by the runtime.`,
                                Blocking: false
                            });
                        }
                    });

                    ownerProperties.forEach(
                        (item: AnyDoc) => {
                            const enumDefinition =
                                getAIPlanEnumDefinitionByRef(
                                    item?.Type,
                                    operations
                                );

                            if (!enumDefinition) return;

                            const enumPropertyName =
                                String(item?.Name || "");
                            const values =
                                Array.isArray(
                                    enumDefinition?.Values
                                )
                                    ? enumDefinition.Values
                                    : [];
                            const hasNumericValues =
                                values.some(
                                    (value: AnyDoc) =>
                                        typeof value?.Value ===
                                        "number"
                                );

                            if (!hasNumericValues) return;

                            const escaped =
                                enumPropertyName.replace(
                                    /[.*+?^${}()|[\]\\]/g,
                                    "\\$&"
                                );
                            const comparison =
                                new RegExp(
                                    `\\b${escaped}\\b\\s*={2,3}\\s*['\"]([^'\"]+)['\"]`,
                                    "g"
                                );
                            const matches =
                                Array.from(
                                    formula.matchAll(
                                        comparison
                                    )
                                );

                            if (matches.length) {
                                findings.push({
                                    Target: target,
                                    OperationIndex: operationIndex,
                                    Code: "FormulaEnumStringComparison",
                                    Message:
                                        `${target} compares enum property ${enumPropertyName} to string names ` +
                                        `while the generated enum declares numeric Value entries. Verify the runtime enum representation or compare against the stored enum value.`,
                                    Blocking: false
                                });
                            }
                        }
                    );
                }
            );

            const unique = new Map<string, AIFormulaDependencyFinding>();
            findings.forEach(
                (finding: AIFormulaDependencyFinding) => {
                    const key = [
                        finding.Target,
                        finding.Code,
                        finding.Message
                    ].join("|");
                    if (!unique.has(key)) {
                        unique.set(key, finding);
                    }
                }
            );

            return Array.from(unique.values());
        }


        function repairAIFormulaReverseCollections(
            plan: AnyDoc
        ): string[] {
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations)
                    ? plan.Operations
                    : [];
            const existingTypes =
                getAIApplicationTypeDocs();
            const added: string[] = [];

            const normalizeName = (value: any): string =>
                String(value || "")
                    .replace(/[^a-z0-9]/gi, "")
                    .toLowerCase();

            const pluralCandidates = (typeName: string): string[] => {
                const name = String(typeName || "").trim();
                if (!name) return [];
                const values = [
                    name + "s",
                    name + "es"
                ];
                if (/y$/i.test(name)) {
                    values.push(name.replace(/y$/i, "ies"));
                }
                return values.map(normalizeName);
            };

            const typeRefByName = (typeName: string): any => {
                const addType = operations.find(
                    (op: AnyDoc) =>
                        op?.Type === "AddType" &&
                        String(op?.Entity?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );
                if (addType?.TemporaryId) {
                    return {
                        TemporaryId:
                            String(addType.TemporaryId)
                    };
                }

                const existing = existingTypes.find(
                    (item: AnyDoc) =>
                        String(item?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );
                return existing?.id
                    ? String(existing.id)
                    : null;
            };

            const ownerHasMember = (
                ownerName: string,
                memberName: string
            ): boolean =>
                !!getAIPlanPropertyByTypeName(
                    ownerName,
                    memberName,
                    operations,
                    existingTypes
                ) ||
                operations.some(
                    (op: AnyDoc) =>
                        op?.Type === "AddCollection" &&
                        String(
                            getAIPlanTypeNameByRef(
                                op.EntityRef ||
                                op.EntityId,
                                operations,
                                existingTypes
                            ) || ""
                        ).toLowerCase() ===
                        ownerName.toLowerCase() &&
                        String(
                            op?.Collection?.Name || ""
                        ).toLowerCase() ===
                        memberName.toLowerCase()
                );

            const findReverseCandidate = (
                ownerName: string,
                memberName: string
            ): AnyDoc | null => {
                const candidates: AnyDoc[] = [];

                operations.forEach((op: AnyDoc) => {
                    if (op?.Type !== "AddProperty") return;

                    const property =
                        op.Property || {};

                    if (
                        !isReferenceAggregation(
                            property.Aggregation
                        )
                    ) {
                        return;
                    }

                    const targetName =
                        getAIPlanTypeNameByRef(
                            property.Type,
                            operations,
                            existingTypes
                        );

                    if (
                        !targetName ||
                        targetName.toLowerCase() !==
                        ownerName.toLowerCase()
                    ) {
                        return;
                    }

                    const sourceName =
                        getAIPlanTypeNameByRef(
                            op.EntityRef ||
                            op.EntityId,
                            operations,
                            existingTypes
                        );

                    if (!sourceName) return;

                    if (
                        pluralCandidates(sourceName)
                            .indexOf(
                                normalizeName(memberName)
                            ) < 0
                    ) {
                        return;
                    }

                    candidates.push({
                        SourceName: sourceName,
                        SourceRef:
                            typeRefByName(sourceName)
                    });
                });

                return candidates.length === 1
                    ? candidates[0]
                    : null;
            };

            const addReverse = (
                ownerName: string,
                memberName: string
            ): void => {
                if (
                    !ownerName ||
                    !memberName ||
                    ownerHasMember(
                        ownerName,
                        memberName
                    )
                ) {
                    return;
                }

                const candidate =
                    findReverseCandidate(
                        ownerName,
                        memberName
                    );
                const ownerRef =
                    typeRefByName(ownerName);

                if (
                    !candidate?.SourceRef ||
                    !ownerRef
                ) {
                    return;
                }

                const operation: AnyDoc = {
                    Type: "AddCollection",
                    Collection: {
                        Name: memberName,
                        Caption: memberName,
                        ItemEntity:
                            cloneData(
                                candidate.SourceRef
                            ),
                        Many: true,
                        Aggregation: "Deferred",
                        ShowInList: false,
                        ShowInDetail: true
                    }
                };

                if (
                    typeof ownerRef === "object"
                ) {
                    operation.EntityRef =
                        cloneData(ownerRef);
                } else {
                    operation.EntityId =
                        String(ownerRef);
                }

                operations.push(operation);
                added.push(
                    `${ownerName}.${memberName}`
                );
            };

            // Iterate because repairing one missing collection may expose
            // the next dependency on the following analysis pass.
            for (
                let pass = 0;
                pass < 3;
                pass++
            ) {
                const before = added.length;
                const findings =
                    analyzeAIPlanFormulaDependencies(
                        plan
                    );

                findings.forEach(
                    (
                        finding:
                            AIFormulaDependencyFinding
                    ) => {
                        if (
                            !finding.Blocking
                        ) {
                            return;
                        }

                        if (
                            finding.Code ===
                            "FormulaUnresolvedDependency"
                        ) {
                            const ownerName =
                                String(
                                    finding.Target ||
                                    ""
                                ).split(".")[0];
                            const match =
                                finding.Message.match(
                                    /references\s+"([^"]+)"/i
                                );

                            if (match?.[1]) {
                                addReverse(
                                    ownerName,
                                    match[1]
                                );
                            }
                            return;
                        }

                        if (
                            finding.Code ===
                            "FormulaMissingReferencedMember"
                        ) {
                            const match =
                                finding.Message.match(
                                    /but\s+([A-Za-z_][A-Za-z0-9_]*)\.([A-Za-z_][A-Za-z0-9_]*)\s+does not exist/i
                                );

                            if (match) {
                                addReverse(
                                    match[1],
                                    match[2]
                                );
                            }
                        }
                    }
                );

                if (added.length === before) {
                    break;
                }
            }

            if (added.length) {
                plan.Warnings =
                    Array.isArray(plan.Warnings)
                        ? plan.Warnings
                        : [];

                added.forEach(
                    (path: string) =>
                        plan.Warnings.push(
                            `${path} was added as a Deferred reverse collection because a generated formula depends on it and exactly one direct forward reference defines the relationship.`
                        )
                );
            }

            return added;
        }

        function repairAIUnsafeDeferredAggregateFormulas(
            plan: AnyDoc
        ): string[] {
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations)
                    ? plan.Operations
                    : [];
            const changed: string[] = [];

            const findings =
                analyzeAIPlanFormulaDependencies(
                    plan
                );

            const deferredTargets =
                new Set<string>(
                    findings
                        .filter(
                            (
                                finding:
                                    AIFormulaDependencyFinding
                            ) =>
                                finding.Code ===
                                "FormulaDeferredDependency"
                        )
                        .map(
                            (
                                finding:
                                    AIFormulaDependencyFinding
                            ) =>
                                String(
                                    finding.Target ||
                                    ""
                                )
                        )
                        .filter(Boolean)
                );

            if (!deferredTargets.size) {
                return changed;
            }

            const existingTypes =
                getAIApplicationTypeDocs();

            operations.forEach(
                (operation: AnyDoc) => {
                    if (
                        operation?.Type !==
                        "AddProperty"
                    ) {
                        return;
                    }

                    const property =
                        operation.Property ||
                        {};
                    const formulaCode =
                        getAIFormulaCode(
                            property
                        );

                    if (!formulaCode) return;

                    const ownerName =
                        getAIPlanTypeNameByRef(
                            operation.EntityRef ||
                            operation.EntityId,
                            operations,
                            existingTypes
                        );

                    if (!ownerName) return;

                    const target =
                        `${ownerName}.${String(property.Name || "")}`;

                    if (
                        !deferredTargets.has(target)
                    ) {
                        return;
                    }

                    delete property.Formula;

                    if (
                        property.ReadOnly === true
                    ) {
                        property.ReadOnly = false;
                    }
                    if (
                        property.RO === true
                    ) {
                        property.RO = false;
                    }
                    if (
                        property.Readonly === true
                    ) {
                        property.Readonly = false;
                    }

                    changed.push(target);
                }
            );

            if (changed.length) {
                plan.Warnings =
                    Array.isArray(plan.Warnings)
                        ? plan.Warnings
                        : [];

                changed.forEach(
                    (target: string) =>
                        plan.Warnings.push(
                            `${target} was changed from a Formula to a stored value because the generated calculation depended on Deferred/cross-record data that is not guaranteed in CurrentData. The automatic calculation remains missing and should be implemented by Action/Rule/query/report logic.`
                        )
                );
            }

            return changed;
        }


        function applyAIFormulaDependencyCoverageAudit(
            plan: AnyDoc
        ): AIFormulaDependencyFinding[] {
            const findings =
                analyzeAIPlanFormulaDependencies(plan);

            if (!findings.length) return findings;

            const byTarget =
                new Map<string, AIFormulaDependencyFinding[]>();

            findings.forEach(
                (finding: AIFormulaDependencyFinding) => {
                    if (!byTarget.has(finding.Target)) {
                        byTarget.set(finding.Target, []);
                    }
                    byTarget.get(finding.Target)!.push(finding);
                }
            );

            const affectsItem = (
                item: AnyDoc,
                target: string
            ): boolean => {
                const required = Array.isArray(
                    item?.RequiredModelElements
                )
                    ? item.RequiredModelElements.map(
                        normalizeAIRequiredModelElement
                    )
                    : [];
                const evidence = Array.isArray(
                    item?.Evidence
                )
                    ? item.Evidence.map(
                        normalizeAIRequiredModelElement
                    )
                    : [];
                const requirements =
                    buildFallbackTypedRequirements(item);

                return (
                    required.indexOf(target) >= 0 ||
                    evidence.indexOf(target) >= 0 ||
                    requirements.some(
                        (requirement: AnyDoc) =>
                            normalizeAIRequirementKind(
                                requirement?.Kind
                            ) === "Formula" &&
                            normalizeAIRequiredModelElement(
                                requirement?.Target
                            ) === target
                    )
                );
            };

            const applyToItem = (
                item: AnyDoc,
                isCapability: boolean
            ): void => {
                const missing = Array.isArray(item?.Missing)
                    ? item.Missing.slice()
                    : [];

                byTarget.forEach(
                    (
                        targetFindings: AIFormulaDependencyFinding[],
                        target: string
                    ) => {
                        if (!affectsItem(item, target)) {
                            return;
                        }

                        targetFindings.forEach(
                            (finding: AIFormulaDependencyFinding) => {
                                const marker =
                                    `FormulaDependency: ${finding.Target} — ${finding.Code}`;
                                if (missing.indexOf(marker) < 0) {
                                    missing.push(marker);
                                }
                            }
                        );
                    }
                );

                item.Missing = missing;

                if (
                    isCapability &&
                    missing.length > 0 &&
                    String(item?.Status || "") ===
                    "Implemented"
                ) {
                    item.Status =
                        Array.isArray(item?.Evidence) &&
                            item.Evidence.length
                            ? "PartiallyImplemented"
                            : "NotImplemented";
                }
            };

            (Array.isArray(plan?.Scenarios)
                ? plan.Scenarios
                : []
            ).forEach(
                (item: AnyDoc) =>
                    applyToItem(item, false)
            );

            (Array.isArray(plan?.Capabilities)
                ? plan.Capabilities
                : []
            ).forEach(
                (item: AnyDoc) =>
                    applyToItem(item, true)
            );

            return findings;
        }

        function validateAIPlanSemantics(plan: AnyDoc): AIPlanValidationIssue[] {
            const issues: AIPlanValidationIssue[] = [];
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const existingTypes = getAIApplicationTypeDocs();

            const addIssue = (
                operationIndex: number,
                code: string,
                message: string,
                severity: "error" | "warning" = "error"
            ): void => {
                issues.push({
                    OperationIndex: operationIndex,
                    Code: code,
                    Message: message,
                    Severity: severity
                });
            };

            operations.forEach((operation: AnyDoc, index: number) => {
                if (operation?.Type !== "AddProperty") return;

                const prop = operation.Property || {};
                const ownerRef = operation.EntityRef || operation.EntityId;
                const ownerName = getAIPlanTypeNameByRef(ownerRef, operations, existingTypes) || "UnknownType";
                const propName = String(prop.Name || "");

                if (
                    isScalarStringType(prop.Type) &&
                    (
                        isClosedChoicePropertyName(propName) ||
                        isBusinessTypeChoiceProperty(ownerName, propName)
                    )
                ) {
                    addIssue(
                        index,
                        "ClosedChoiceStoredAsString",
                        `${ownerName}.${propName} is declared as ${prop.Type}, but this property represents a closed choice by default. Create or reuse an enum, or explicitly model it as a runtime-editable reference type.`
                    );
                }
            });

            operations.forEach((operation: AnyDoc, index: number) => {
                if (operation?.Type !== "AddCollection") return;

                const collection = operation.Collection || {};
                const ownerRef = operation.EntityRef || operation.EntityId;
                const itemRef = collection.ItemEntity;

                const ownerName = getAIPlanTypeNameByRef(ownerRef, operations, existingTypes) || "UnknownOwner";
                const itemName = getAIPlanTypeNameByRef(itemRef, operations, existingTypes) || "UnknownItem";
                const itemProperties = getAIPlanPropertiesForType(itemRef, operations, existingTypes);

                const forwardReference = itemProperties.find((p: AnyDoc) => {
                    if (!p || !isReferenceAggregation(p.Aggregation)) return false;

                    const targetName = getAIPlanTypeNameByRef(p.Type, operations, existingTypes);
                    return !!targetName && targetName === ownerName;
                });

                if (isAggregated(collection.Aggregation)) {
                    if (forwardReference) {
                        addIssue(
                            index,
                            "ReverseCollectionMustBeDeferred",
                            `${ownerName}.${collection.Name || "Collection"} is Aggregated, but ${itemName}.${forwardReference.Name} already contains a forward ${forwardReference.Aggregation || "reference"} reference to ${ownerName}. The reverse collection should be Deferred.`
                        );
                    }

                }

                if (isDeferred(collection.Aggregation) && !forwardReference) {
                    addIssue(
                        index,
                        "DeferredCollectionWithoutForwardReference",
                        `${ownerName}.${collection.Name || "Collection"} is Deferred, but ${itemName} has no direct Hybrid or Value reference to ${ownerName}. Do not create this reverse collection without an explicit query definition.`
                    );
                }
            });

            analyzeAIPlanFormulaDependencies(plan).forEach(
                (finding: AIFormulaDependencyFinding) => {
                    addIssue(
                        finding.OperationIndex,
                        finding.Code,
                        finding.Message,
                        finding.Blocking
                            ? "error"
                            : "warning"
                    );
                }
            );

            return issues;
        }


        function getAIPlanBusinessTypeNames(plan: AnyDoc): Set<string> {
            const names = new Set<string>();

            getAIApplicationTypeDocs().forEach((typeDoc: AnyDoc) => {
                const name = String(typeDoc?.Name || "").trim();
                if (name) names.add(name);
            });

            (Array.isArray(plan?.Operations) ? plan.Operations : [])
                .forEach((operation: AnyDoc) => {
                    if (operation?.Type !== "AddType") return;
                    const name = String(operation?.Entity?.Name || "").trim();
                    if (name) names.add(name);
                });

            return names;
        }

        function hasAIPlanDirectTypeRelation(
            plan: AnyDoc,
            fromTypeName: string,
            toTypeName: string
        ): boolean {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];
            const existingTypes = getAIApplicationTypeDocs();
            const fromLower = String(fromTypeName || "").toLowerCase();
            const toLower = String(toTypeName || "").toLowerCase();

            const resolvesTo = (ref: any): boolean =>
                String(
                    getAIPlanTypeNameByRef(ref, operations, existingTypes) || ""
                ).toLowerCase() === toLower;

            const existingFrom = existingTypes.find(
                (typeDoc: AnyDoc) =>
                    String(typeDoc?.Name || "").toLowerCase() === fromLower
            );

            const existingMembers = [
                ...(Array.isArray(existingFrom?.Properties) ? existingFrom.Properties : []),
                ...(Array.isArray(existingFrom?.Collections) ? existingFrom.Collections : [])
            ];

            if (existingMembers.some((member: AnyDoc) =>
                resolvesTo(member?.Type || member?.ItemEntity || member?.TypeEntity)
            )) {
                return true;
            }

            return operations.some((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddProperty" &&
                    operation?.Type !== "AddCollection"
                ) {
                    return false;
                }

                const ownerName = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    operations,
                    existingTypes
                );

                if (String(ownerName || "").toLowerCase() !== fromLower) {
                    return false;
                }

                const member = operation?.Property || operation?.Collection || {};

                return resolvesTo(
                    member.Type || member.ItemEntity || member.TypeEntity
                );
            });
        }

        function hasAIPlanTypeRelationPath(
            plan: AnyDoc,
            fromTypeName: string,
            toTypeName: string,
            maxDepth: number = 3
        ): boolean {
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations) ? plan.Operations : [];
            const existingTypes = getAIApplicationTypeDocs();
            const adjacency = new Map<string, Set<string>>();

            const addEdge = (left: string, right: string): void => {
                const a = String(left || "").toLowerCase();
                const b = String(right || "").toLowerCase();
                if (!a || !b || a === b) return;

                if (!adjacency.has(a)) adjacency.set(a, new Set<string>());
                if (!adjacency.has(b)) adjacency.set(b, new Set<string>());

                // Semantic reachability is undirected. Direct=true remains
                // the strict case when the source record itself must store/select To.
                adjacency.get(a)!.add(b);
                adjacency.get(b)!.add(a);
            };

            existingTypes.forEach((typeDoc: AnyDoc) => {
                const owner = String(typeDoc?.Name || "");
                const members = [
                    ...(Array.isArray(typeDoc?.Properties) ? typeDoc.Properties : []),
                    ...(Array.isArray(typeDoc?.Collections) ? typeDoc.Collections : [])
                ];

                members.forEach((member: AnyDoc) => {
                    const target = getAIPlanTypeNameByRef(
                        member?.Type || member?.ItemEntity || member?.TypeEntity,
                        operations,
                        existingTypes
                    );
                    if (target) addEdge(owner, target);
                });
            });

            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddProperty" &&
                    operation?.Type !== "AddCollection"
                ) return;

                const owner = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    operations,
                    existingTypes
                );
                const member = operation?.Property || operation?.Collection || {};
                const target = getAIPlanTypeNameByRef(
                    member.Type || member.ItemEntity || member.TypeEntity,
                    operations,
                    existingTypes
                );

                if (owner && target) addEdge(owner, target);
            });

            const start = String(fromTypeName || "").toLowerCase();
            const goal = String(toTypeName || "").toLowerCase();
            if (!start || !goal) return false;
            if (start === goal) return true;

            const queue: { Name: string; Depth: number }[] = [
                { Name: start, Depth: 0 }
            ];
            const visited = new Set<string>([start]);

            while (queue.length) {
                const current = queue.shift()!;
                if (current.Depth >= maxDepth) continue;

                const next = adjacency.get(current.Name);
                if (!next) continue;

                for (const candidate of Array.from(next)) {
                    if (candidate === goal) return true;
                    if (visited.has(candidate)) continue;

                    visited.add(candidate);
                    queue.push({
                        Name: candidate,
                        Depth: current.Depth + 1
                    });
                }
            }

            return false;
        }

        function repairAIInvalidSmallEnums(
            plan: AnyDoc
        ): string[] {
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations)
                    ? plan.Operations
                    : [];
            const repaired: string[] = [];
            const invalidIds =
                new Map<string, AnyDoc>();

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type !== "AddEnum") return;

                const enumDefinition =
                    operation?.Enum ||
                    operation?.Entity ||
                    {};
                const values =
                    Array.isArray(enumDefinition?.Values)
                        ? enumDefinition.Values
                        : [];

                if (values.length >= 2) return;

                const temporaryId =
                    String(
                        operation?.TemporaryId || ""
                    ).trim();

                if (temporaryId) {
                    invalidIds.set(
                        temporaryId,
                        {
                            Operation: operation,
                            Values: values,
                            Name: String(
                                enumDefinition?.Name ||
                                temporaryId
                            )
                        }
                    );
                }
            });

            if (!invalidIds.size) {
                return repaired;
            }

            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddProperty"
                ) {
                    return;
                }

                const typeRef =
                    operation?.Property?.Type;

                if (
                    !typeRef ||
                    typeof typeRef !== "object"
                ) {
                    return;
                }

                const temporaryId =
                    String(
                        typeRef?.TemporaryId || ""
                    ).trim();
                const invalid =
                    invalidIds.get(temporaryId);

                if (!invalid) return;

                const values =
                    invalid.Values as AnyDoc[];

                operation.Property.Type =
                    "string";
                operation.Property.Aggregation =
                    operation.Property.Aggregation ||
                    "Value";

                if (
                    values.length === 1 &&
                    operation.Property.DefaultValue ===
                    undefined
                ) {
                    operation.Property.DefaultValue =
                        String(
                            values[0]?.Name ||
                            values[0]?.Caption ||
                            ""
                        );
                }

                repaired.push(
                    `${String(invalid.Name)} -> string`
                );
            });

            plan.Operations = operations.filter(
                (operation: AnyDoc) => {
                    if (
                        operation?.Type !== "AddEnum"
                    ) {
                        return true;
                    }

                    return !invalidIds.has(
                        String(
                            operation?.TemporaryId || ""
                        ).trim()
                    );
                }
            );

            if (repaired.length) {
                plan.Warnings =
                    Array.isArray(plan.Warnings)
                        ? plan.Warnings
                        : [];

                Array.from(invalidIds.values())
                    .forEach((invalid: AnyDoc) => {
                        plan.Warnings.push(
                            `Enum ${String(invalid.Name)} had fewer than two values and was removed. Referencing properties were converted to string/value fields.`
                        );
                    });
            }

            return repaired;
        }

        function normalizeAIConceptualGraphAgainstPlan(
            plan: AnyDoc
        ): void {
            const operations: AnyDoc[] =
                Array.isArray(plan?.Operations)
                    ? plan.Operations
                    : [];
            const enumNames = new Set<string>();

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type !== "AddEnum") return;
                const name = String(
                    operation?.Enum?.Name ||
                    operation?.Entity?.Name ||
                    ""
                ).trim();
                if (name) enumNames.add(name.toLowerCase());
            });

            getAIApplicationEnumDocs().forEach((enumDoc: AnyDoc) => {
                const name = String(enumDoc?.Name || "").trim();
                if (name) enumNames.add(name.toLowerCase());
            });

            (plan as AnyDoc).ConceptualTypes =
                (Array.isArray((plan as AnyDoc).ConceptualTypes)
                    ? (plan as AnyDoc).ConceptualTypes
                    : []
                ).filter(
                    (name: any) =>
                        !enumNames.has(
                            String(name || "").toLowerCase()
                        )
                );

            (plan as AnyDoc).SemanticRelations =
                (Array.isArray((plan as AnyDoc).SemanticRelations)
                    ? (plan as AnyDoc).SemanticRelations
                    : []
                ).filter(
                    (relation: AnyDoc) =>
                        !enumNames.has(
                            String(relation?.From || "").toLowerCase()
                        ) &&
                        !enumNames.has(
                            String(relation?.To || "").toLowerCase()
                        )
                );
        }

        function normalizeAISemanticRelationDirectness(
            plan: AnyDoc,
            blueprint: DesignerAIBusinessBlueprint
        ): void {
            const relations =
                Array.isArray(
                    (plan as AnyDoc)
                        .SemanticRelations
                )
                    ? (plan as AnyDoc)
                        .SemanticRelations
                    : [];

            const allBlueprintItems: AnyDoc[] = [
                ...(
                    Array.isArray(
                        blueprint?.Scenarios
                    )
                        ? blueprint.Scenarios
                        : []
                ),
                ...(
                    Array.isArray(
                        blueprint?.Capabilities
                    )
                        ? blueprint.Capabilities
                        : []
                )
            ];

            const normal = (value: any): string =>
                String(value || "")
                    .replace(/[^a-z0-9]/gi, "")
                    .toLowerCase();

            const hasExplicitDirectRequirement = (
                relation: AnyDoc
            ): boolean => {
                const from =
                    String(
                        relation?.From || ""
                    );
                const to =
                    String(
                        relation?.To || ""
                    );
                const fromKey =
                    normal(from);
                const toKey =
                    normal(to);

                return allBlueprintItems.some(
                    (item: AnyDoc) =>
                        (
                            Array.isArray(
                                item?.Requirements
                            )
                                ? item.Requirements
                                : []
                        ).some(
                            (requirement: AnyDoc) => {
                                const kind =
                                    normalizeAIRequirementKind(
                                        requirement?.Kind
                                    );

                                if (
                                    [
                                        "ReferenceSelection",
                                        "EmbeddedObject",
                                        "EmbeddedCollection",
                                        "ReverseCollection"
                                    ].indexOf(kind) < 0
                                ) {
                                    return false;
                                }

                                const target =
                                    String(
                                        requirement?.Target ||
                                        ""
                                    );
                                const parts =
                                    target.split(".");
                                const ownerKey =
                                    normal(parts[0]);
                                const memberKey =
                                    normal(
                                        parts[
                                        parts.length - 1
                                        ]
                                    );
                                const referenceKey =
                                    normal(
                                        requirement
                                            ?.ReferenceType
                                    );

                                return (
                                    ownerKey === fromKey &&
                                    (
                                        referenceKey ===
                                        toKey ||
                                        memberKey ===
                                        toKey ||
                                        memberKey ===
                                        toKey + "s" ||
                                        memberKey ===
                                        toKey + "es"
                                    )
                                );
                            }
                        )
                );
            };

            relations.forEach(
                (relation: AnyDoc) => {
                    if (
                        relation?.Direct !== true
                    ) {
                        return;
                    }

                    const from =
                        String(
                            relation?.From || ""
                        );
                    const to =
                        String(
                            relation?.To || ""
                        );

                    if (
                        hasAIPlanDirectTypeRelation(
                            plan,
                            from,
                            to
                        )
                    ) {
                        return;
                    }

                    if (
                        hasExplicitDirectRequirement(
                            relation
                        )
                    ) {
                        return;
                    }

                    if (
                        hasAIPlanTypeRelationPath(
                            plan,
                            from,
                            to,
                            3
                        )
                    ) {
                        relation.Direct = false;

                        plan.Warnings =
                            Array.isArray(
                                plan.Warnings
                            )
                                ? plan.Warnings
                                : [];

                        plan.Warnings.push(
                            `Semantic relation ${from} -> ${to} was normalized from Direct=true to an indirect typed path because the blueprint contains no explicit direct-reference requirement and the generated graph already connects the concepts.`
                        );
                    }
                }
            );
        }

        function getAISemanticRelationGaps(plan: AnyDoc): AnyDoc[] {
            const relations = Array.isArray((plan as AnyDoc)?.SemanticRelations)
                ? (plan as AnyDoc).SemanticRelations
                : [];
            const typeNames = getAIPlanBusinessTypeNames(plan);
            const byLower = new Map<string, string>();

            typeNames.forEach((name: string) =>
                byLower.set(name.toLowerCase(), name)
            );

            return relations
                .map((relation: AnyDoc) => {
                    const from = String(relation?.From || "").trim();
                    const to = String(relation?.To || "").trim();
                    if (!from || !to) return null;

                    const fromActual = byLower.get(from.toLowerCase()) || "";
                    const toActual = byLower.get(to.toLowerCase()) || "";

                    if (!fromActual) {
                        return {
                            Relation: relation,
                            Code: "SemanticRelationSourceMissing",
                            Message:
                                `Required semantic relation ${from} -> ${to} cannot be represented because source type ${from} does not exist in the current model or generated plan.`
                        };
                    }

                    if (!toActual) {
                        return {
                            Relation: relation,
                            Code: "SemanticRelationTargetMissing",
                            Message:
                                `Required semantic relation ${from} -> ${to} cannot be represented because target type ${to} does not exist in the current model or generated plan.`
                        };
                    }

                    const relationSatisfied =
                        relation?.Direct === true
                            ? hasAIPlanDirectTypeRelation(
                                plan,
                                fromActual,
                                toActual
                            )
                            : hasAIPlanTypeRelationPath(
                                plan,
                                fromActual,
                                toActual,
                                3
                            );

                    if (!relationSatisfied) {
                        return {
                            Relation: relation,
                            Code: "SemanticRelationMissing",
                            Message:
                                `Business graph requires ${from} ${String(relation?.Relation || "references")} ${to}, but the generated/current model has no ${relation?.Direct === true ? "direct typed edge" : "short typed path"} connecting them.` +
                                (relation?.Reason ? ` Reason: ${String(relation.Reason)}` : "")
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        }

        function applyAISemanticRelationCoverage(plan: AnyDoc): void {
            const gaps = getAISemanticRelationGaps(plan);
            if (!gaps.length) return;

            const attach = (
                items: AnyDoc[],
                idField: "ScenarioIds" | "CapabilityIds"
            ): void => {
                gaps.forEach((gap: AnyDoc) => {
                    const ids = Array.isArray(gap?.Relation?.[idField])
                        ? gap.Relation[idField]
                        : [];
                    if (!ids.length) return;

                    items.forEach((item: AnyDoc) => {
                        if (ids.indexOf(String(item?.Id || "")) < 0) return;

                        item.Missing = Array.isArray(item.Missing)
                            ? item.Missing
                            : [];

                        const label =
                            `SemanticRelation: ${gap.Relation.From} -> ${gap.Relation.To}`;

                        if (item.Missing.indexOf(label) < 0) {
                            item.Missing.push(label);
                        }

                        if (item.Status === "Implemented") {
                            item.Status = item.Evidence?.length
                                ? "PartiallyImplemented"
                                : "NotImplemented";
                        }
                    });
                });
            };

            attach(
                Array.isArray(plan?.Scenarios) ? plan.Scenarios : [],
                "ScenarioIds"
            );
            attach(
                Array.isArray(plan?.Capabilities) ? plan.Capabilities : [],
                "CapabilityIds"
            );
        }

        function getAIScenarioConceptualTypes(
            plan: AnyDoc,
            scenario: AnyDoc
        ): string[] {
            const conceptualTypes =
                Array.isArray((plan as AnyDoc).ConceptualTypes)
                    ? (plan as AnyDoc).ConceptualTypes
                        .map((x: any) =>
                            String(x || "").trim()
                        )
                        .filter(Boolean)
                    : [];
            const byLower =
                new Map<string, string>();

            conceptualTypes.forEach((name: string) =>
                byLower.set(name.toLowerCase(), name)
            );

            const found = new Set<string>();

            const addPath = (value: any): void => {
                const text =
                    String(value || "").trim();
                if (!text) return;

                const root =
                    text.split(".")[0];
                const actual =
                    byLower.get(root.toLowerCase());

                if (actual) {
                    found.add(actual);
                }
            };

            (Array.isArray(
                scenario?.RequiredModelElements
            )
                ? scenario.RequiredModelElements
                : []
            ).forEach(addPath);

            (Array.isArray(scenario?.Requirements)
                ? scenario.Requirements
                : []
            ).forEach((requirement: AnyDoc) => {
                addPath(requirement?.Target);
                addPath(requirement?.ReferenceType);
                addPath(requirement?.Source);
            });

            const relationIds =
                String(scenario?.Id || "");

            (Array.isArray(
                (plan as AnyDoc).SemanticRelations
            )
                ? (plan as AnyDoc).SemanticRelations
                : []
            ).forEach((relation: AnyDoc) => {
                const ids =
                    Array.isArray(
                        relation?.ScenarioIds
                    )
                        ? relation.ScenarioIds
                        : [];

                if (
                    ids.indexOf(
                        relationIds
                    ) < 0
                ) {
                    return;
                }

                addPath(relation?.From);
                addPath(relation?.To);
            });

            return Array.from(found);
        }

        function getAIScenarioDisconnectedTypes(
            plan: AnyDoc,
            scenario: AnyDoc
        ): string[] {
            const types =
                getAIScenarioConceptualTypes(
                    plan,
                    scenario
                );

            if (types.length < 2) {
                return [];
            }

            const connected =
                new Set<string>([
                    types[0]
                ]);
            let changed = true;

            while (changed) {
                changed = false;

                types.forEach((candidate: string) => {
                    if (
                        connected.has(candidate)
                    ) {
                        return;
                    }

                    const touches =
                        Array.from(
                            connected
                        ).some(
                            (existing: string) =>
                                hasAIPlanTypeRelationPath(
                                    plan,
                                    existing,
                                    candidate,
                                    3
                                )
                        );

                    if (touches) {
                        connected.add(candidate);
                        changed = true;
                    }
                });
            }

            return types.filter(
                (name: string) =>
                    !connected.has(name)
            );
        }

        function validateAIPlanClaimSemantics(plan: AnyDoc): AIPlanValidationIssue[] {
            const issues: AIPlanValidationIssue[] = [];
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const existingTypes = getAIApplicationTypeDocs();

            const addIssue = (
                operationIndex: number,
                code: string,
                message: string,
                severity: "error" | "warning" = "warning"
            ): void => {
                issues.push({
                    OperationIndex: operationIndex,
                    Code: code,
                    Message: message,
                    Severity: severity
                });
            };

            operations.forEach((operation: AnyDoc, operationIndex: number) => {
                if (operation?.Type !== "AddProperty") return;

                const property = operation.Property || {};
                const formulaCode = getAIFormulaCode(property);

                if (!formulaCode || !isAITrivialConstantFormula(formulaCode)) return;

                const ownerName =
                    getAIPlanTypeNameByRef(
                        operation.EntityRef || operation.EntityId,
                        operations,
                        existingTypes
                    ) || "UnknownType";
                const target = `${ownerName}.${String(property.Name || "Property")}`;

                addIssue(
                    operationIndex,
                    "TrivialFormulaPlaceholder",
                    `${target} has Formula "${formulaCode}", which is only a constant placeholder. Use DefaultValue for a constant, or generate the real business calculation before claiming the field is calculated.`,
                    "warning"
                );
            });

            const message = String(plan?.Message || "");
            const addedTypeCount = operations.filter((operation: AnyDoc) => operation?.Type === "AddType").length;
            const addedEnumCount = operations.filter((operation: AnyDoc) => operation?.Type === "AddEnum").length;

            const entityCountMatch = message.match(
                /(\d+)\s+(?:сущност|тип(?:а|ов)?|entit(?:y|ies)|types?)/i
            );
            if (entityCountMatch && Number(entityCountMatch[1]) !== addedTypeCount) {
                addIssue(
                    -1,
                    "MessageEntityCountMismatch",
                    `Message claims ${entityCountMatch[1]} created entities/types, but Operations contains ${addedTypeCount} AddType operations. The operation plan is authoritative.`
                );
            }

            const enumCountMatch = message.match(
                /(\d+)\s+(?:перечислен|справочник|enum)/i
            );
            if (enumCountMatch && Number(enumCountMatch[1]) !== addedEnumCount) {
                addIssue(
                    -1,
                    "MessageEnumCountMismatch",
                    `Message claims ${enumCountMatch[1]} enums/reference lists, but Operations contains ${addedEnumCount} AddEnum operations. The operation plan is authoritative.`
                );
            }

            const createdTypeNames = new Set<string>(
                operations
                    .filter((operation: AnyDoc) => operation?.Type === "AddType")
                    .map((operation: AnyDoc) => String(operation?.Entity?.Name || "").trim())
                    .filter(Boolean)
            );

            const listedEntitiesMatch = message.match(
                /(?:сущност(?:ей|и)|entities|types)[^:(]*\(([^)]+)\)/i
            );

            if (listedEntitiesMatch) {
                String(listedEntitiesMatch[1] || "")
                    .split(/[,;]/)
                    .map((value: string) => value.trim())
                    .filter((value: string) => /^[A-Za-z_][A-Za-z0-9_]*$/.test(value))
                    .forEach((name: string) => {
                        if (!createdTypeNames.has(name)) {
                            addIssue(
                                -1,
                                "MessageClaimsMissingType",
                                `Message says type "${name}" was created, but there is no AddType operation for it.`
                            );
                        }
                    });
            }

            const conceptualTypes =
                Array.isArray(
                    (plan as AnyDoc).ConceptualTypes
                )
                    ? (plan as AnyDoc).ConceptualTypes
                    : [];

            const actualBusinessTypes =
                getAIPlanBusinessTypeNames(plan);

            conceptualTypes.forEach(
                (typeName: any) => {
                    const expected =
                        String(typeName || "").trim();

                    if (!expected) return;

                    const exists =
                        Array.from(
                            actualBusinessTypes
                        ).some(
                            (actual: string) =>
                                actual.toLowerCase() ===
                                expected.toLowerCase()
                        );

                    if (!exists) {
                        addIssue(
                            -1,
                            "ConceptualTypeMissing",
                            `Business blueprint mentions type ${expected}, but it does not exist in the current model or generated plan.`,
                            "warning"
                        );
                    }
                }
            );

            const generatedTypeNames =
                operations
                    .filter((operation: AnyDoc) =>
                        operation?.Type === "AddType"
                    )
                    .map((operation: AnyDoc) =>
                        String(operation?.Entity?.Name || "").trim()
                    )
                    .filter(Boolean);

            const relationDegree = new Map<string, number>();

            const incrementDegree = (typeName: string): void => {
                const key = String(typeName || "").toLowerCase();
                if (!key) return;
                relationDegree.set(
                    key,
                    (relationDegree.get(key) || 0) + 1
                );
            };

            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddProperty" &&
                    operation?.Type !== "AddCollection"
                ) return;

                const ownerName = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    operations,
                    existingTypes
                );
                const member =
                    operation?.Property ||
                    operation?.Collection ||
                    {};
                const targetName = getAIPlanTypeNameByRef(
                    member.Type ||
                    member.ItemEntity ||
                    member.TypeEntity,
                    operations,
                    existingTypes
                );

                if (
                    ownerName &&
                    targetName &&
                    String(ownerName).toLowerCase() !==
                    String(targetName).toLowerCase()
                ) {
                    incrementDegree(ownerName);
                    incrementDegree(targetName);
                }
            });

            generatedTypeNames.forEach((typeName: string) => {
                if (
                    (relationDegree.get(typeName.toLowerCase()) || 0) > 0
                ) return;

                const scalarProperties = operations.filter(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddProperty" &&
                        String(
                            getAIPlanTypeNameByRef(
                                operation.EntityRef ||
                                operation.EntityId,
                                operations,
                                existingTypes
                            ) || ""
                        ).toLowerCase() === typeName.toLowerCase()
                );

                const onlyLightweightScalars =
                    scalarProperties.length <= 3 &&
                    scalarProperties.every((operation: AnyDoc) => {
                        const property =
                            operation?.Property || {};

                        return (
                            !property?.Many &&
                            !isReferenceAggregation(
                                property?.Aggregation
                            ) &&
                            isScalarStringType(
                                property?.Type
                            )
                        );
                    });

                const participatesWithOtherTypes =
                    (Array.isArray(plan?.Scenarios)
                        ? plan.Scenarios
                        : []
                    ).some((scenario: AnyDoc) => {
                        const scenarioTypes =
                            getAIScenarioConceptualTypes(
                                plan,
                                scenario
                            );

                        return (
                            scenarioTypes.length >= 2 &&
                            scenarioTypes.some(
                                (name: string) =>
                                    name.toLowerCase() ===
                                    typeName.toLowerCase()
                            )
                        );
                    });

                if (
                    onlyLightweightScalars ||
                    participatesWithOtherTypes
                ) {
                    addIssue(
                        -1,
                        "IsolatedGeneratedType",
                        `Generated type ${typeName} is isolated from the business graph${participatesWithOtherTypes ? " although it participates in a multi-type business scenario" : ""}. Verify that it is a real standalone business concept; otherwise connect it to the records it depends on or remove it.`,
                        "warning"
                    );
                }
            });

            (Array.isArray(plan?.Scenarios)
                ? plan.Scenarios
                : []
            ).forEach((scenario: AnyDoc) => {
                const importance =
                    String(
                        scenario?.Importance ||
                        ""
                    ).toLowerCase();

                if (
                    importance &&
                    importance !== "core"
                ) {
                    return;
                }

                const participating =
                    getAIScenarioConceptualTypes(
                        plan,
                        scenario
                    );
                const disconnected =
                    getAIScenarioDisconnectedTypes(
                        plan,
                        scenario
                    );

                if (
                    participating.length >= 2 &&
                    disconnected.length
                ) {
                    addIssue(
                        -1,
                        "ScenarioBusinessGraphDisconnected",
                        `Core scenario "${String(scenario?.Name || scenario?.Id || "Scenario")}" involves ${participating.join(", ")}, but the generated/current typed graph leaves these concepts disconnected: ${disconnected.join(", ")}.`,
                        "warning"
                    );
                }
            });

            getAISemanticRelationGaps(plan).forEach((gap: AnyDoc) => {
                addIssue(
                    -1,
                    gap.Code,
                    gap.Message,
                    "warning"
                );
            });

            return issues;
        }

        function validateAIPlanBusinessCompleteness(plan: AnyDoc): AIPlanValidationIssue[] {
            const issues: AIPlanValidationIssue[] = [];
            const scenarios: AnyDoc[] = Array.isArray(plan?.Scenarios) ? plan.Scenarios : [];
            const capabilities: AnyDoc[] = Array.isArray(plan?.Capabilities) ? plan.Capabilities : [];
            const isModify = String(plan?.Intent || "") === "Modify";

            const addIssue = (
                code: string,
                message: string,
                severity: "error" | "warning" = "error"
            ): void => {
                issues.push({
                    OperationIndex: -1,
                    Code: code,
                    Message: message,
                    Severity: severity
                });
            };

            if (!plan?.BusinessAnalysis || typeof plan.BusinessAnalysis !== "object") {
                addIssue("MissingBusinessAnalysis", "BusinessAnalysis is required.");
            } else {
                [
                    "Actors", "ReferenceData", "Documents", "Lifecycles",
                    "QuantitiesAndBalances", "DerivedValues", "Assumptions"
                ].forEach(field => {
                    if (!Array.isArray(plan.BusinessAnalysis[field])) {
                        addIssue("InvalidBusinessAnalysis", `BusinessAnalysis.${field} must be an array.`);
                    }
                });
            }

            const hasOperations = Array.isArray(plan?.Operations) && plan.Operations.length > 0;
            const isConcreteModify = isModify && hasOperations;

            // Scenarios and Capabilities are analysis/coverage metadata, not structural
            // prerequisites for applying a concrete Modify plan. A focused modification
            // (for example, adding one Product action) is valid when it contains real
            // Operations even if the model returns no new scenario/capability arrays.
            // Primary model generation still receives scenarios/capabilities from the
            // BusinessBlueprint and they are validated whenever present, but their absence
            // must not turn an otherwise executable Modify plan into a hard failure.
            // Scenarios and Capabilities are semantic coverage metadata. Their absence
            // must never block an otherwise executable plan; only objective structural/runtime
            // defects are hard validation errors. Keep the diagnostic as a warning so missing
            // coverage remains visible during full model generation.
            if (!scenarios.length) {
                addIssue("MissingScenarios", "At least one end-to-end business scenario was not provided.", "warning");
            }

            if (!capabilities.length) {
                addIssue("MissingCapabilities", "At least one capability assessment was not provided.", "warning");
            }

            scenarios.forEach((scenario: AnyDoc, index: number) => {
                const name = String(scenario?.Name || "").trim();
                const importance = String(scenario?.Importance || "").trim();
                const evidence = Array.isArray(scenario?.Evidence) ? scenario.Evidence : [];
                const missing = Array.isArray(scenario?.Missing) ? scenario.Missing : [];

                if (!name) addIssue("ScenarioMissingName", `Scenario ${index + 1} requires Name.`);
                if (importance !== "Core" && importance !== "Supporting") {
                    addIssue("ScenarioInvalidImportance", `Scenario ${name || index + 1} must use Core or Supporting.`);
                }

                if (isModify && importance === "Core" && evidence.length === 0 && missing.length === 0) {
                    addIssue(
                        "CoreScenarioWithoutCoverage",
                        `Core scenario ${name || index + 1} has neither Evidence nor Missing items.`,
                        "warning"
                    );
                }

                if (isModify && importance === "Core" && missing.length > 0) {
                    addIssue(
                        "CoreScenarioIncomplete",
                        `Core scenario ${name || index + 1} is incomplete: ${missing.join(", ")}.`,
                        "warning"
                    );
                }
            });

            capabilities.forEach((capability: AnyDoc, index: number) => {
                const name = String(capability?.Name || "").trim();
                const status = String(capability?.Status || "").trim();
                const evidence = Array.isArray(capability?.Evidence) ? capability.Evidence : [];
                const missing = Array.isArray(capability?.Missing) ? capability.Missing : [];

                if (!name) addIssue("CapabilityMissingName", `Capability ${index + 1} requires Name.`);

                if (["Implemented", "PartiallyImplemented", "NotImplemented", "Assumption"].indexOf(status) < 0) {
                    addIssue("CapabilityInvalidStatus", `Capability ${name || index + 1} has invalid Status "${status}".`);
                } else if (status === "Implemented") {
                    if (!evidence.length) {
                        addIssue(
                            "ImplementedCapabilityWithoutEvidence",
                            `Capability ${name || index + 1} is Implemented but has no Evidence.`,
                            "warning"
                        );
                    }
                    if (missing.length) {
                        addIssue("ImplementedCapabilityHasMissingParts", `Capability ${name || index + 1} is Implemented but has Missing items: ${missing.join(", ")}.`);
                    }
                } else if (status === "PartiallyImplemented") {
                    if (!evidence.length || !missing.length) {
                        addIssue(
                            "InvalidPartialCapability",
                            `Capability ${name || index + 1} marked PartiallyImplemented requires Evidence and Missing.`,
                            "warning"
                        );
                    }
                } else if (status === "NotImplemented" && !missing.length) {
                    addIssue(
                        "InvalidNotImplementedCapability",
                        `Capability ${name || index + 1} is NotImplemented but has no Missing explanation.`,
                        "warning"
                    );
                }
            });

            return issues;
        }

        function isAIScriptNavigationItem(operation: AnyDoc): boolean {
            const navigationItem =
                operation?.NavigationItem &&
                    typeof operation.NavigationItem === "object"
                    ? operation.NavigationItem
                    : {};

            return (
                String(navigationItem?.Type || "").trim() === "<js>" ||
                (
                    typeof navigationItem?.js === "string" &&
                    navigationItem.js.trim() !== ""
                )
            );
        }

        function getAINavigationScript(operation: AnyDoc): string {
            const navigationItem =
                operation?.NavigationItem &&
                    typeof operation.NavigationItem === "object"
                    ? operation.NavigationItem
                    : {};

            return String(
                navigationItem?.js ??
                operation?.js ??
                ""
            ).trim();
        }

        function getAINavigationTarget(operation: AnyDoc): AnyDoc {
            const nested =
                operation?.Target &&
                    typeof operation.Target === "object"
                    ? operation.Target
                    : {};
            const navigationItem =
                operation?.NavigationItem &&
                    typeof operation.NavigationItem === "object"
                    ? operation.NavigationItem
                    : {};

            const rawTarget =
                nested.EntityRef ??
                nested.EntityId ??
                nested.ViewRef ??
                nested.ViewId ??
                nested.TargetType ??
                nested.TypeRef ??
                operation?.EntityRef ??
                operation?.EntityId ??
                operation?.ViewRef ??
                operation?.ViewId ??
                operation?.TargetType ??
                operation?.TypeRef ??
                navigationItem.EntityRef ??
                navigationItem.EntityId ??
                navigationItem.ViewRef ??
                navigationItem.ViewId ??
                navigationItem.TargetType ??
                navigationItem.TypeRef ??
                navigationItem.Target ??
                null;

            const result: AnyDoc = {
                EntityId:
                    nested.EntityId ??
                    operation?.EntityId ??
                    navigationItem.EntityId ??
                    null,
                EntityRef:
                    nested.EntityRef ??
                    operation?.EntityRef ??
                    navigationItem.EntityRef ??
                    null,
                ViewId:
                    nested.ViewId ??
                    operation?.ViewId ??
                    navigationItem.ViewId ??
                    null,
                ViewRef:
                    nested.ViewRef ??
                    operation?.ViewRef ??
                    navigationItem.ViewRef ??
                    null
            };

            if (
                !result.EntityId &&
                !result.EntityRef &&
                !result.ViewId &&
                !result.ViewRef &&
                rawTarget !== undefined &&
                rawTarget !== null
            ) {
                if (typeof rawTarget === "object") {
                    if (rawTarget.TemporaryId) {
                        result.EntityRef = {
                            TemporaryId:
                                String(rawTarget.TemporaryId)
                        };
                    } else if (
                        rawTarget.EntityId ||
                        rawTarget.id ||
                        rawTarget.Id
                    ) {
                        result.EntityId = String(
                            rawTarget.EntityId ||
                            rawTarget.id ||
                            rawTarget.Id
                        );
                    } else if (rawTarget.ViewId) {
                        result.ViewId =
                            String(rawTarget.ViewId);
                    }
                } else {
                    const value = String(rawTarget).trim();

                    if (value) {
                        const existingType =
                            getRuntimeObjectsArray(false).find(
                                (typeDoc: AnyDoc) =>
                                    String(typeDoc?.id || "") === value ||
                                    String(typeDoc?.Name || "") === value
                            );

                        if (existingType) {
                            result.EntityId = String(
                                existingType.id
                            );
                        } else {
                            result.EntityRef = {
                                TemporaryId: value
                            };
                        }
                    }
                }
            }

            return result;
        }

        function setAINavigationEntityId(
            operation: AnyDoc,
            entityId: string
        ): void {
            operation.EntityId = entityId;
            delete operation.EntityRef;
            delete operation.TargetType;
            delete operation.TypeRef;

            if (
                operation.Target &&
                typeof operation.Target === "object"
            ) {
                operation.Target.EntityId = entityId;
                delete operation.Target.EntityRef;
                delete operation.Target.TargetType;
                delete operation.Target.TypeRef;
                delete operation.Target.ViewId;
                delete operation.Target.ViewRef;
            }

            if (
                operation.NavigationItem &&
                typeof operation.NavigationItem === "object"
            ) {
                operation.NavigationItem.EntityId = entityId;
                delete operation.NavigationItem.EntityRef;
                delete operation.NavigationItem.TargetType;
                delete operation.NavigationItem.TypeRef;
                delete operation.NavigationItem.Target;
                delete operation.NavigationItem.ViewId;
                delete operation.NavigationItem.ViewRef;
            }

            delete operation.ViewId;
            delete operation.ViewRef;
        }

        function repairAINavigationTargets(plan: AnyDoc): void {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];

            const normalizeTemporaryTypeName = (
                value: any
            ): string => {
                const raw = String(value || "")
                    .trim()
                    .replace(
                        /^(?:new|type|entity)[-_]+/i,
                        ""
                    )
                    .replace(
                        /[-_]+([a-z])/g,
                        (_m: string, c: string) =>
                            String(c).toUpperCase()
                    );

                if (!raw) return "";

                const lower = raw.toLowerCase();

                if (
                    [
                        "client",
                        "customer",
                        "supplier",
                        "vendor",
                        "counterparty",
                        "carrier"
                    ].indexOf(lower) >= 0
                ) {
                    return "Company";
                }

                return upperFirst(raw);
            };

            const declaredTemporaryIds =
                new Set<string>();

            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type === "AddType" &&
                    operation?.TemporaryId
                ) {
                    declaredTemporaryIds.add(
                        String(operation.TemporaryId)
                    );
                }
            });

            // A model may correctly decide to reuse an existing type, but still
            // emit a guessed TemporaryId such as type-company/type-customer in
            // AddNavigationItem. Resolve those references to the existing type
            // before normal navigation matching and validation.
            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddNavigationItem" ||
                    isAIScriptNavigationItem(operation)
                ) {
                    return;
                }

                const currentTarget =
                    getAINavigationTarget(operation);
                const temporaryId =
                    String(
                        currentTarget.EntityRef
                            ?.TemporaryId ||
                        ""
                    );

                if (
                    !temporaryId ||
                    declaredTemporaryIds.has(
                        temporaryId
                    )
                ) {
                    return;
                }

                const inferredName =
                    normalizeTemporaryTypeName(
                        temporaryId
                    );
                const existingId =
                    inferredName
                        ? getExistingAITypeIdByName(
                            inferredName
                        )
                        : null;

                if (!existingId) {
                    return;
                }

                setAINavigationEntityId(
                    operation,
                    existingId
                );
            });

            const addTypes = operations.filter(
                (operation: AnyDoc) =>
                    operation?.Type === "AddType" &&
                    operation?.TemporaryId &&
                    operation?.Entity?.Name
            );

            const navigationOperations = operations.filter(
                (operation: AnyDoc) =>
                    operation?.Type === "AddNavigationItem" &&
                    !isAIScriptNavigationItem(operation)
            );

            const usedTypeTemporaryIds: Record<string, boolean> = {};

            navigationOperations.forEach((operation: AnyDoc) => {
                const currentTarget = getAINavigationTarget(operation);

                if (currentTarget.EntityRef?.TemporaryId) {
                    usedTypeTemporaryIds[
                        String(currentTarget.EntityRef.TemporaryId)
                    ] = true;
                    return;
                }

                if (
                    currentTarget.EntityId ||
                    currentTarget.ViewId ||
                    currentTarget.ViewRef
                ) {
                    return;
                }

                const navigationItem = operation?.NavigationItem || {};
                const searchText = [
                    operation?.TemporaryId,
                    operation?.Name,
                    operation?.Caption,
                    navigationItem?.Name,
                    navigationItem?.Caption,
                    navigationItem?.TargetType,
                    navigationItem?.TypeName
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase()
                    .replace(/[^a-zа-я0-9]+/gi, " ");

                let matchingType = addTypes.find(
                    (candidate: AnyDoc) => {
                        const typeName = String(
                            candidate?.Entity?.Name || ""
                        ).toLowerCase();
                        const caption = String(
                            candidate?.Entity?.Caption || ""
                        ).toLowerCase();

                        return (
                            !!typeName &&
                            (
                                searchText.indexOf(typeName) >= 0 ||
                                (
                                    caption &&
                                    searchText.indexOf(caption) >= 0
                                )
                            )
                        );
                    }
                );

                if (!matchingType) {
                    const candidates = addTypes.filter(
                        (candidate: AnyDoc) => {
                            const temporaryId = String(
                                candidate?.TemporaryId || ""
                            );
                            const name = String(
                                candidate?.Entity?.Name || ""
                            );

                            return (
                                !usedTypeTemporaryIds[temporaryId] &&
                                !/Line$/i.test(name)
                            );
                        }
                    );

                    if (candidates.length) {
                        const navigationIndex =
                            navigationOperations.indexOf(operation);

                        matchingType =
                            candidates[
                            Math.min(
                                navigationIndex,
                                candidates.length - 1
                            )
                            ];
                    }
                }

                if (matchingType) {
                    operation.EntityRef = {
                        TemporaryId: String(
                            matchingType.TemporaryId
                        )
                    };

                    usedTypeTemporaryIds[
                        String(matchingType.TemporaryId)
                    ] = true;
                }
            });
            // If the AI created a navigation group but used Folder/group naming
            // instead of ParentRef, repair the mechanical nesting deterministically.
            // ParentRef remains the authoritative contract; this is a compatibility
            // fallback for older/generated plans.
            const navigationGroups = operations.filter(
                (operation: AnyDoc) =>
                    operation?.Type === "AddNavigationGroup"
            );

            const normalizeNavigationGroupKey = (value: any): string =>
                String(value || "")
                    .trim()
                    .toLowerCase()
                    .replace(/ё/g, "е")
                    .replace(/[^a-zа-я0-9]+/gi, "");

            operations.forEach((operation: AnyDoc) => {
                if (
                    operation?.Type !== "AddNavigationItem" ||
                    operation?.ParentId ||
                    operation?.ParentRef?.TemporaryId
                ) {
                    return;
                }

                const definition = operation?.NavigationItem || {};
                const hintedGroup =
                    definition.ParentGroup ||
                    definition.Group ||
                    definition.Folder ||
                    operation.ParentGroup ||
                    operation.Group ||
                    null;

                const hintKey =
                    normalizeNavigationGroupKey(hintedGroup);

                if (!hintKey) return;

                const matchingGroups =
                    navigationGroups.filter(
                        (groupOperation: AnyDoc) => {
                            const groupDefinition =
                                groupOperation?.NavigationItem || {};

                            const candidates = [
                                groupOperation?.TemporaryId,
                                groupDefinition?.Name,
                                groupDefinition?.Caption,
                                groupDefinition?.Folder
                            ];

                            return candidates.some(
                                (candidate: any) =>
                                    normalizeNavigationGroupKey(
                                        candidate
                                    ) === hintKey
                            );
                        }
                    );

                if (matchingGroups.length === 1) {
                    operation.ParentRef = {
                        TemporaryId: String(
                            matchingGroups[0].TemporaryId
                        )
                    };
                }
            });

            // Navigation TemporaryId is only an internal plan identifier.
            // Large AI plans occasionally omit it; repair this mechanical
            // omission deterministically before strict validation.
            const usedNavigationTemporaryIds =
                new Set<string>();

            operations.forEach((operation: AnyDoc) => {
                if (
                    (
                        operation?.Type === "AddNavigationGroup" ||
                        operation?.Type === "AddNavigationItem"
                    ) &&
                    operation?.TemporaryId
                ) {
                    usedNavigationTemporaryIds.add(
                        String(operation.TemporaryId)
                    );
                }
            });

            operations.forEach(
                (operation: AnyDoc, index: number) => {
                    if (
                        operation?.Type !== "AddNavigationGroup" &&
                        operation?.Type !== "AddNavigationItem"
                    ) {
                        return;
                    }

                    if (
                        String(operation?.TemporaryId || "").trim()
                    ) {
                        return;
                    }

                    const definition =
                        operation?.NavigationItem || {};
                    const rawName =
                        String(
                            definition?.Name ||
                            definition?.Caption ||
                            (
                                operation?.Type ===
                                "AddNavigationGroup"
                                    ? "group"
                                    : "item"
                            )
                        )
                            .trim()
                            .toLowerCase()
                            .replace(/[^a-zа-я0-9]+/gi, "-")
                            .replace(/^-+|-+$/g, "") ||
                        "item";

                    let candidate =
                        `nav-${rawName}-${index + 1}`;
                    let suffix = 2;

                    while (
                        usedNavigationTemporaryIds.has(candidate)
                    ) {
                        candidate =
                            `nav-${rawName}-${index + 1}-${suffix++}`;
                    }

                    operation.TemporaryId = candidate;
                    usedNavigationTemporaryIds.add(candidate);
                }
            );

        }

        const COSMOS_SQL_RESERVED_IDENTIFIERS = new Set<string>([
            "all", "and", "any", "array", "as", "asc", "between", "by",
            "desc", "distinct", "exists", "false", "from", "group", "in",
            "is", "join", "like", "limit", "not", "null", "object",
            "offset", "or", "order", "select", "some", "top", "true",
            "undefined", "value", "where"
        ]);

        function isCosmosSQLReservedIdentifier(name: any): boolean {
            return COSMOS_SQL_RESERVED_IDENTIFIERS.has(
                String(name || "").trim().toLowerCase()
            );
        }

        function getCosmosSQLReservedIdentifierMessage(
            kind: string,
            name: string
        ): string {
            return `${kind} name "${name}" is a reserved Cosmos DB SQL keyword. Rename it to a business-specific identifier such as CustomerGroup, OrderRecord or GroupRef; do not escape or quote the reserved word.`;
        }

        function validateAIPlanReferences(plan: AnyDoc): AIPlanValidationResult {
            repairAINavigationTargets(plan);

            const issues: AIPlanValidationIssue[] = [];
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];

            const declaredTypeTemporaryIds: Record<string, number> = {};
            const declaredEnumTemporaryIds: Record<string, number> = {};
            const declaredNavigationTemporaryIds: Record<string, number> = {};

            const addIssue = (operationIndex: number, code: string, message: string): void => {
                issues.push({
                    OperationIndex: operationIndex,
                    Code: code,
                    Message: message,
                    Severity: "error"
                });
            };

            const validateTypeTemporaryRef = (
                ref: any,
                operationIndex: number,
                path: string,
                allowCurrentOrEarlierOnly = true
            ): void => {
                if (!ref || typeof ref !== "object" || !ref.TemporaryId) return;

                const temporaryId = String(ref.TemporaryId);
                const declarationIndex = declaredTypeTemporaryIds[temporaryId];

                if (declarationIndex === undefined) {
                    const inferredName = upperFirst(temporaryId.replace(/^new-/, "").replace(/-([a-z])/g, (_m, c) => String(c).toUpperCase()));
                    const existingId = getExistingAITypeIdByName(inferredName);
                    const suggestion = existingId
                        ? ` Existing type "${inferredName}" was found with id ${existingId}; use EntityId or the existing id instead.`
                        : "";

                    addIssue(
                        operationIndex,
                        "UnresolvedTypeTemporaryId",
                        `${path} references TemporaryId "${temporaryId}", but no AddType operation declares it.${suggestion}`
                    );
                    return;
                }

            };

            const validateEnumTemporaryRef = (
                ref: any,
                operationIndex: number,
                path: string
            ): void => {
                if (!ref || typeof ref !== "object" || !ref.TemporaryId) return;

                const temporaryId = String(ref.TemporaryId);
                const declarationIndex = declaredEnumTemporaryIds[temporaryId];

                if (declarationIndex === undefined) {
                    addIssue(
                        operationIndex,
                        "UnresolvedEnumTemporaryId",
                        `${path} references TemporaryId "${temporaryId}", but no AddEnum operation declares it.`
                    );
                    return;
                }

            };

            operations.forEach((operation: AnyDoc, index: number) => {
                const kind = String(operation?.Type || "");

                if (kind === "AddType") {
                    const temporaryId = String(operation?.TemporaryId || "").trim();
                    const typeName = String(operation?.Entity?.Name || "").trim();

                    if (!temporaryId) {
                        addIssue(index, "MissingTypeTemporaryId", "AddType requires TemporaryId.");
                    } else if (declaredTypeTemporaryIds[temporaryId] !== undefined) {
                        addIssue(index, "DuplicateTypeTemporaryId", `TemporaryId "${temporaryId}" is declared more than once by AddType.`);
                    } else {
                        declaredTypeTemporaryIds[temporaryId] = index;
                    }

                    if (typeName && isCosmosSQLReservedIdentifier(typeName)) {
                        addIssue(
                            index,
                            "ReservedCosmosIdentifier",
                            getCosmosSQLReservedIdentifierMessage("Type", typeName)
                        );
                    }
                }

                if (
                    kind === "AddNavigationGroup" ||
                    kind === "AddNavigationItem"
                ) {
                    const temporaryId = String(
                        operation?.TemporaryId || ""
                    ).trim();

                    if (!temporaryId) {
                        addIssue(
                            index,
                            "MissingNavigationTemporaryId",
                            `${kind} requires TemporaryId.`
                        );
                    } else if (
                        declaredNavigationTemporaryIds[temporaryId] !== undefined
                    ) {
                        addIssue(
                            index,
                            "DuplicateNavigationTemporaryId",
                            `TemporaryId "${temporaryId}" is declared more than once by navigation operations.`
                        );
                    } else {
                        declaredNavigationTemporaryIds[temporaryId] = index;
                    }
                }

                if (kind === "AddEnum") {
                    const temporaryId = String(operation?.TemporaryId || "").trim();
                    const enumDefinition = operation?.Enum || operation?.Entity;

                    if (!temporaryId) {
                        addIssue(index, "MissingEnumTemporaryId", "AddEnum requires TemporaryId.");
                    } else if (declaredEnumTemporaryIds[temporaryId] !== undefined) {
                        addIssue(index, "DuplicateEnumTemporaryId", `TemporaryId "${temporaryId}" is declared more than once by AddEnum.`);
                    } else {
                        declaredEnumTemporaryIds[temporaryId] = index;
                    }

                    if (!enumDefinition || !String(enumDefinition.Name || "").trim()) {
                        addIssue(index, "MissingEnumName", "AddEnum requires Enum.Name.");
                    } else {
                        const enumName = String(enumDefinition.Name || "").trim();
                        if (isCosmosSQLReservedIdentifier(enumName)) {
                            addIssue(
                                index,
                                "ReservedCosmosIdentifier",
                                getCosmosSQLReservedIdentifierMessage("Enum", enumName)
                            );
                        }
                    }

                    if (!Array.isArray(enumDefinition?.Values) || enumDefinition.Values.length < 2) {
                        addIssue(index, "MissingEnumValues", "AddEnum requires at least two Enum.Values.");
                    } else {
                        enumDefinition.Values.forEach((value: AnyDoc, valueIndex: number) => {
                            if (!String(value?.Name || "").trim()) {
                                addIssue(
                                    index,
                                    "MissingEnumValueName",
                                    `AddEnum value ${valueIndex + 1} requires Name.`
                                );
                            }
                        });
                    }
                }
            });

            const referencedEnumTemporaryIds =
                new Set<string>();

            const collectEnumTemporaryRefs = (value: any): void => {
                if (!value) return;

                if (Array.isArray(value)) {
                    value.forEach(collectEnumTemporaryRefs);
                    return;
                }

                if (typeof value !== "object") {
                    return;
                }

                const temporaryId =
                    String(value.TemporaryId || "").trim();

                if (
                    temporaryId &&
                    declaredEnumTemporaryIds[
                    temporaryId
                    ] !== undefined
                ) {
                    referencedEnumTemporaryIds.add(
                        temporaryId
                    );
                }

                Object.keys(value).forEach(
                    (key: string) =>
                        collectEnumTemporaryRefs(value[key])
                );
            };

            operations.forEach(
                (operation: AnyDoc) => {
                    if (operation?.Type === "AddEnum") {
                        return;
                    }

                    collectEnumTemporaryRefs(operation);
                }
            );

            Object.keys(
                declaredEnumTemporaryIds
            ).forEach((temporaryId: string) => {
                if (
                    referencedEnumTemporaryIds.has(
                        temporaryId
                    )
                ) {
                    return;
                }

                const operationIndex =
                    declaredEnumTemporaryIds[
                    temporaryId
                    ];
                const operation =
                    operations[operationIndex];
                const enumName =
                    String(
                        operation?.Enum?.Name ||
                        operation?.Entity?.Name ||
                        temporaryId
                    );

                addIssue(
                    operationIndex,
                    "OrphanEnum",
                    `AddEnum "${enumName}" (${temporaryId}) is not referenced by any generated model operation. Either attach it to a property or remove the enum.`
                );
            });

            operations.forEach((operation: AnyDoc, index: number) => {
                const kind = String(operation?.Type || "");

                if (kind === "AddProperty" || kind === "AddCollection") {
                    const member = kind === "AddProperty" ? operation?.Property : operation?.Collection;
                    const memberName = String(member?.Name || "").trim();
                    if (memberName && isCosmosSQLReservedIdentifier(memberName)) {
                        addIssue(
                            index,
                            "ReservedCosmosIdentifier",
                            getCosmosSQLReservedIdentifierMessage(
                                kind === "AddProperty" ? "Property" : "Collection",
                                memberName
                            )
                        );
                    }

                    const hasEntityId = operation?.EntityId !== undefined && operation?.EntityId !== null && operation?.EntityId !== "";
                    const hasEntityRef = !!operation?.EntityRef;

                    if (hasEntityId === hasEntityRef) {
                        addIssue(
                            index,
                            "InvalidOwnerReference",
                            `${kind} must use exactly one owner reference: EntityId for an existing type or EntityRef: { TemporaryId } for a new type.`
                        );
                    }

                    if (hasEntityRef) {
                        validateTypeTemporaryRef(operation.EntityRef, index, `${kind}.EntityRef`);
                    }
                }

                if (
                    kind === "UpdateType" ||
                    kind === "UpdateProperty" ||
                    kind === "UpdateCollection"
                ) {
                    if (!operation?.EntityId) {
                        addIssue(index, "MissingExistingOwnerId", `${kind} requires EntityId for an existing owner type.`);
                    }

                    if (operation?.EntityRef) {
                        addIssue(index, "UnexpectedTemporaryOwner", `${kind} must not use EntityRef; updates target existing objects by EntityId.`);
                    }
                }

                if (
                    kind === "AddRule" ||
                    kind === "AddAction" ||
                    kind === "AddEvent"
                ) {
                    const suffix =
                        kind.substring(3) as
                            "Rule" | "Action" | "Event";
                    const definition =
                        getAIBehaviorDefinition(operation);
                    const hasEntityId =
                        operation?.EntityId !== undefined &&
                        operation?.EntityId !== null &&
                        String(operation.EntityId).trim() !== "";
                    const hasEntityRef =
                        !!operation?.EntityRef;

                    if (hasEntityId === hasEntityRef) {
                        addIssue(
                            index,
                            "InvalidBehaviorOwnerReference",
                            `${kind} must use exactly one owner reference: EntityId or EntityRef.`
                        );
                    }

                    if (hasEntityRef) {
                        validateTypeTemporaryRef(
                            operation.EntityRef,
                            index,
                            `${kind}.EntityRef`
                        );
                    }

                    if (
                        !String(
                            definition?.Name || ""
                        ).trim()
                    ) {
                        addIssue(
                            index,
                            "MissingBehaviorName",
                            `${kind} requires ${suffix}.Name.`
                        );
                    }

                    if (
                        suffix === "Action" &&
                        (
                            operation?.PropertyId ||
                            operation?.PropertyName
                        )
                    ) {
                        addIssue(
                            index,
                            "PropertyActionNotSupported",
                            "Legacy runtime actions are supported only on Type.Actions, not on a property."
                        );
                    }
                }

                if (
                    kind === "UpdateRule" ||
                    kind === "UpdateAction" ||
                    kind === "UpdateEvent"
                ) {
                    const suffix =
                        kind.substring(6) as
                            "Rule" | "Action" | "Event";

                    if (!operation?.EntityId) {
                        addIssue(
                            index,
                            "MissingExistingOwnerId",
                            `${kind} requires EntityId for an existing owner type.`
                        );
                    }

                    if (operation?.EntityRef) {
                        addIssue(
                            index,
                            "UnexpectedTemporaryOwner",
                            `${kind} must target an existing type by EntityId.`
                        );
                    }

                    const targetId =
                        String(
                            operation?.[`${suffix}Id`] || ""
                        ).trim();
                    const targetName =
                        String(
                            operation?.[`${suffix}Name`] || ""
                        ).trim();

                    if (!targetId && !targetName) {
                        addIssue(
                            index,
                            "MissingBehaviorTarget",
                            `${kind} requires ${suffix}Id or ${suffix}Name.`
                        );
                    }

                    if (
                        !operation?.Changes ||
                        typeof operation.Changes !== "object"
                    ) {
                        addIssue(
                            index,
                            "MissingBehaviorChanges",
                            `${kind} requires Changes.`
                        );
                    }

                    if (
                        suffix === "Action" &&
                        (
                            operation?.PropertyId ||
                            operation?.PropertyName
                        )
                    ) {
                        addIssue(
                            index,
                            "PropertyActionNotSupported",
                            "Legacy runtime actions are supported only on Type.Actions, not on a property."
                        );
                    }
                }

                if (kind === "UpdateType") {
                    const baseType = operation?.Changes?.BaseType;

                    if (!operation?.Changes || typeof operation.Changes !== "object") {
                        addIssue(
                            index,
                            "MissingTypeChanges",
                            "UpdateType requires Changes."
                        );
                    }

                    if (
                        baseType &&
                        typeof baseType === "object" &&
                        baseType.TemporaryId
                    ) {
                        validateTypeTemporaryRef(
                            baseType,
                            index,
                            "UpdateType.Changes.BaseType"
                        );
                    }
                }

                if (kind === "AddNavigationGroup") {
                    if (!String(
                        operation?.NavigationItem?.Name || ""
                    ).trim()) {
                        addIssue(
                            index,
                            "MissingNavigationGroupName",
                            "AddNavigationGroup requires NavigationItem.Name."
                        );
                    }
                }

                if (kind === "AddNavigationItem") {
                    const target =
                        getAINavigationTarget(operation);
                    const targetCount = [
                        !!target.EntityId,
                        !!target.EntityRef,
                        !!target.ViewId,
                        !!target.ViewRef
                    ].filter(Boolean).length;
                    const scriptMode =
                        isAIScriptNavigationItem(operation);
                    const navigationScript =
                        getAINavigationScript(operation);

                    if (scriptMode) {
                        if (targetCount !== 0) {
                            addIssue(
                                index,
                                "AmbiguousNavigationTarget",
                                "Script AddNavigationItem must not also specify EntityId, EntityRef, ViewId or ViewRef."
                            );
                        }

                        if (
                            String(
                                operation?.NavigationItem?.Type || ""
                            ).trim() !== "<js>"
                        ) {
                            addIssue(
                                index,
                                "InvalidScriptNavigationType",
                                "Script AddNavigationItem requires NavigationItem.Type=\"<js>\"."
                            );
                        }

                        if (!navigationScript) {
                            addIssue(
                                index,
                                "MissingNavigationScript",
                                "Script AddNavigationItem requires NavigationItem.js."
                            );
                        } else {
                            try {
                                new Function(
                                    "return (" +
                                    navigationScript +
                                    ");"
                                );
                            } catch (error: any) {
                                addIssue(
                                    index,
                                    "InvalidNavigationScript",
                                    "NavigationItem.js must be a valid JavaScript function expression: " +
                                    String(
                                        error?.message ||
                                        error
                                    )
                                );
                            }
                        }
                    } else if (targetCount !== 1) {
                        addIssue(
                            index,
                            "InvalidNavigationTarget",
                            "AddNavigationItem must either use script mode (NavigationItem.Type=<js> plus NavigationItem.js) or exactly one of EntityId, EntityRef, ViewId or ViewRef."
                        );
                    }

                    if (!scriptMode && target.EntityRef) {
                        const rawTemporaryId = String(
                            target.EntityRef?.TemporaryId || ""
                        );

                        if (
                            rawTemporaryId &&
                            declaredTypeTemporaryIds[
                            rawTemporaryId
                            ] === undefined
                        ) {
                            const matchingTypeOperation =
                                operations.find(
                                    (candidate: AnyDoc) =>
                                        candidate?.Type ===
                                        "AddType" &&
                                        String(
                                            candidate?.Entity
                                                ?.Name || ""
                                        ) === rawTemporaryId
                                );

                            if (matchingTypeOperation) {
                                target.EntityRef = {
                                    TemporaryId:
                                        String(
                                            matchingTypeOperation
                                                .TemporaryId
                                        )
                                };
                            } else {
                                const normalizedAlias =
                                    rawTemporaryId
                                        .trim()
                                        .replace(
                                            /^(?:new|type|entity)[-_]+/i,
                                            ""
                                        )
                                        .toLowerCase();
                                const companyAliases = [
                                    "company",
                                    "client",
                                    "customer",
                                    "supplier",
                                    "vendor",
                                    "counterparty",
                                    "carrier"
                                ];

                                if (
                                    companyAliases.indexOf(
                                        normalizedAlias
                                    ) >= 0
                                ) {
                                    const companyId =
                                        getExistingAITypeIdByName(
                                            "Company"
                                        );

                                    if (companyId) {
                                        setAINavigationEntityId(
                                            operation,
                                            companyId
                                        );
                                        target.EntityId =
                                            companyId;
                                        target.EntityRef = null;
                                    }
                                }
                            }
                        }

                        if (target.EntityRef) {
                            validateTypeTemporaryRef(
                                target.EntityRef,
                                index,
                                "AddNavigationItem.EntityRef"
                            );
                        }
                    }

                    if (
                        operation?.ParentRef?.TemporaryId &&
                        declaredNavigationTemporaryIds[
                        String(operation.ParentRef.TemporaryId)
                        ] === undefined
                    ) {
                        addIssue(
                            index,
                            "UnresolvedNavigationParent",
                            `AddNavigationItem.ParentRef references undeclared navigation TemporaryId "${operation.ParentRef.TemporaryId}".`
                        );
                    }

                    if (operation?.ParentId) {
                        const parentId =
                            String(operation.ParentId);

                        const existingParent =
                            findNavigationItemRecursive(
                                getRuntimeNavigationItemsArray(false),
                                parentId
                            );

                        if (!existingParent) {
                            addIssue(
                                index,
                                "UnresolvedNavigationParentId",
                                `AddNavigationItem.ParentId "${parentId}" does not identify an existing navigation group.`
                            );
                        }
                    }

                    if (
                        operation?.ParentId &&
                        operation?.ParentRef
                    ) {
                        addIssue(
                            index,
                            "AmbiguousNavigationParent",
                            "AddNavigationItem must use either ParentId for an existing group or ParentRef for a group created in this plan, not both."
                        );
                    }

                    if (operation?.ParentRef?.TemporaryId) {
                        const parentTemporaryId = String(
                            operation.ParentRef.TemporaryId
                        );
                        const parentOperation = operations.find(
                            (candidate: AnyDoc) =>
                                String(candidate?.TemporaryId || "") ===
                                parentTemporaryId
                        );

                        if (
                            parentOperation &&
                            parentOperation.Type !==
                            "AddNavigationGroup"
                        ) {
                            addIssue(
                                index,
                                "InvalidNavigationParentType",
                                `AddNavigationItem.ParentRef "${parentTemporaryId}" must reference AddNavigationGroup, not ${parentOperation.Type}.`
                            );
                        }
                    }
                }


                if (kind === "MoveNavigationItem") {
                    const navigationItemId =
                        String(operation?.NavigationItemId || "").trim();

                    if (!navigationItemId) {
                        addIssue(
                            index,
                            "MissingNavigationItemId",
                            "MoveNavigationItem requires NavigationItemId."
                        );
                    }

                    const currentItem =
                        navigationItemId
                            ? findNavigationItemRecursive(
                                getRuntimeNavigationItemsArray(false),
                                navigationItemId
                            )
                            : null;

                    if (navigationItemId && !currentItem) {
                        addIssue(
                            index,
                            "UnknownNavigationItemId",
                            `MoveNavigationItem.NavigationItemId "${navigationItemId}" does not identify an existing navigation item.`
                        );
                    }

                    const hasParentId =
                        !!String(operation?.ParentId || "").trim();
                    const hasParentRef =
                        !!String(operation?.ParentRef?.TemporaryId || "").trim();

                    if (Number(hasParentId) + Number(hasParentRef) !== 1) {
                        addIssue(
                            index,
                            "InvalidNavigationMoveDestination",
                            "MoveNavigationItem requires exactly one destination: ParentId or ParentRef."
                        );
                    }

                    if (hasParentId) {
                        const parentId = String(operation.ParentId);

                        if (parentId === navigationItemId) {
                            addIssue(
                                index,
                                "NavigationCannotParentItself",
                                "MoveNavigationItem cannot move an item into itself."
                            );
                        }

                        const existingParent =
                            findNavigationItemRecursive(
                                getRuntimeNavigationItemsArray(false),
                                parentId
                            );

                        if (!existingParent) {
                            addIssue(
                                index,
                                "UnresolvedNavigationMoveParentId",
                                `MoveNavigationItem.ParentId "${parentId}" does not identify an existing navigation group.`
                            );
                        } else {
                            const parentIsGroup =
                                existingParent?.IsGroup === true ||
                                (
                                    !existingParent?.Type &&
                                    !existingParent?.EntityId &&
                                    !existingParent?.TargetType
                                );

                            if (!parentIsGroup) {
                                addIssue(
                                    index,
                                    "NavigationMoveParentIsNotGroup",
                                    `MoveNavigationItem.ParentId "${parentId}" identifies a navigation item, not a group.`
                                );
                            }
                        }
                    }

                    if (hasParentRef) {
                        const parentTemporaryId =
                            String(operation.ParentRef.TemporaryId);
                        const parentOperation =
                            operations.find(
                                (candidate: AnyDoc) =>
                                    String(candidate?.TemporaryId || "") ===
                                    parentTemporaryId
                            );

                        if (
                            !parentOperation ||
                            parentOperation.Type !== "AddNavigationGroup"
                        ) {
                            addIssue(
                                index,
                                "InvalidNavigationMoveParentRef",
                                `MoveNavigationItem.ParentRef "${parentTemporaryId}" must reference AddNavigationGroup in the same plan.`
                            );
                        }
                    }
                }


                if (
                    kind === "AddObject" ||
                    kind === "UpdateObject" ||
                    kind === "MoveObject" ||
                    kind === "DeleteObject"
                ) {
                    if (kind === "AddObject") {
                        const targetCollection = String(operation?.Collection || "").trim();
                        const objectName = String(operation?.Object?.Name || "").trim();
                        if (
                            objectName &&
                            /^(Types|Properties|Enums|Collections)$/i.test(targetCollection) &&
                            isCosmosSQLReservedIdentifier(objectName)
                        ) {
                            addIssue(
                                index,
                                "ReservedCosmosIdentifier",
                                getCosmosSQLReservedIdentifierMessage(
                                    /^Types$/i.test(targetCollection)
                                        ? "Type"
                                        : (/^Enums$/i.test(targetCollection) ? "Enum" : "Property"),
                                    objectName
                                )
                            );
                        }

                        if (
                            !targetCollection
                        ) {
                            addIssue(
                                index,
                                "MissingCollection",
                                "AddObject requires Collection."
                            );
                        }

                        if (
                            !operation?.Object ||
                            typeof operation.Object !== "object"
                        ) {
                            addIssue(
                                index,
                                "MissingObject",
                                "AddObject requires Object."
                            );
                        }

                        if (
                            !operation?.ParentId &&
                            !operation?.ParentRef?.TemporaryId
                        ) {
                            addIssue(
                                index,
                                "MissingParent",
                                "AddObject requires ParentId or ParentRef."
                            );
                        }
                    } else {
                        const objectId =
                            String(
                                operation?.ObjectId ||
                                ""
                            ).trim();

                        if (!objectId) {
                            addIssue(
                                index,
                                "MissingObjectId",
                                `${kind} requires ObjectId.`
                            );
                        }

                        if (
                            kind === "UpdateObject" &&
                            (
                                !operation?.Changes ||
                                typeof operation.Changes !== "object"
                            )
                        ) {
                            addIssue(
                                index,
                                "MissingChanges",
                                "UpdateObject requires Changes."
                            );
                        }

                        if (
                            kind === "MoveObject" &&
                            (
                                !String(
                                    operation?.Collection ||
                                    ""
                                ).trim() ||
                                (
                                    !operation?.ParentId &&
                                    !operation?.ParentRef?.TemporaryId
                                )
                            )
                        ) {
                            addIssue(
                                index,
                                "InvalidMoveObject",
                                "MoveObject requires Collection and ParentId or ParentRef."
                            );
                        }
                    }
                }

                if (kind === "AddRule" || kind === "AddAction" || kind === "AddEvent") {
                    if (operation?.EntityRef) {
                        validateTypeTemporaryRef(operation.EntityRef, index, `${kind}.EntityRef`);
                    }

                    const definition = kind === "AddRule"
                        ? operation?.Rule
                        : kind === "AddAction"
                            ? operation?.Action
                            : operation?.Event;
                    const suffix = kind.substring(3);

                    if (!String(definition?.Name || "").trim()) {
                        addIssue(index, `Missing${suffix}Name`, `${kind} requires ${suffix}.Name.`);
                    }

                    if (kind === "AddAction" && (operation?.PropertyId || operation?.PropertyName)) {
                        addIssue(index, "ActionCannotTargetProperty", "AddAction is supported only on Type.Actions in the legacy runtime format.");
                    }
                }

                if (kind === "UpdateRule" || kind === "UpdateAction" || kind === "UpdateEvent") {
                    const suffix = kind.substring(6);
                    const targetId = operation?.[`${suffix}Id`];
                    const targetName = operation?.[`${suffix}Name`];

                    if (!String(operation?.EntityId || "").trim()) {
                        addIssue(index, `Missing${suffix}Owner`, `${kind} requires EntityId.`);
                    }
                    if (!String(targetId || targetName || "").trim()) {
                        addIssue(index, `Missing${suffix}Target`, `${kind} requires ${suffix}Id or ${suffix}Name.`);
                    }
                }

                if (kind === "AddProperty") {
                    const property = operation?.Property || {};
                    const generatedScalarType = String(property.Type || "").toLowerCase();
                    if (generatedScalarType === "text" || generatedScalarType === "html") {
                        property.Type = "string";
                        operation.Property = property;
                    }
                    const propertyType = property.Type;

                    if (propertyType && typeof propertyType === "object" && propertyType.TemporaryId) {
                        const temporaryId = String(propertyType.TemporaryId);

                        if (declaredEnumTemporaryIds[temporaryId] !== undefined) {
                            validateEnumTemporaryRef(propertyType, index, "AddProperty.Property.Type");
                        } else {
                            validateTypeTemporaryRef(propertyType, index, "AddProperty.Property.Type");
                        }
                    }

                }

                if (kind === "AddCollection") {
                    validateTypeTemporaryRef(
                        operation?.Collection?.ItemEntity,
                        index,
                        "AddCollection.Collection.ItemEntity"
                    );
                }
            });

            issues.push(...validateAIPlanSemantics(plan));
            issues.push(...validateAIPlanClaimSemantics(plan));
            issues.push(...validateAIPlanBusinessCompleteness(plan));

            return {
                IsValid: !issues.some(x => (x.Severity || "error") === "error"),
                Issues: issues
            };
        }

        // Canonical AI contract: a collection is an AddProperty with Many=true.
        // Runtime stores both scalar and collection members in Type.Properties.
        // Convert legacy AddCollection before validation/apply, preserving the
        // collection semantics (Deferred remains a query-backed getter).
        function removeDuplicateGeneratedCollections(plan: AnyDoc): void {
            if (!Array.isArray(plan?.Operations)) return;
            const operations: AnyDoc[] = plan.Operations;
            const existingTypes = getAIApplicationTypeDocs();
            const canonicalRef = (ref: any): string => {
                if (ref && typeof ref === "object") {
                    if (ref.TemporaryId) return "temp:" + String(ref.TemporaryId).toLowerCase();
                    if (ref.Id || ref.id) return "id:" + String(ref.Id || ref.id).toLowerCase();
                    if (ref.Name) return "name:" + String(ref.Name).toLowerCase();
                }
                const resolved = String(getAIPlanTypeNameByRef(ref, operations, existingTypes) || "").trim();
                return resolved ? "name:" + resolved.toLowerCase() : "";
            };
            let converted = 0;
            for (const op of operations) {
                if (op?.Type !== "AddCollection") continue;
                const collection = op.Collection || {};
                const property: AnyDoc = { ...collection, Type: collection.ItemEntity || collection.Type, Many: true };
                delete property.ItemEntity;
                op.Type = "AddProperty";
                op.Property = property;
                delete op.Collection;
                converted++;
            }
            const firstByKey = new Map<string, number>();
            const redundant = new Set<number>();

            const codeText = (value: any): string => {
                if (value === undefined || value === null) return "";
                if (typeof value === "string") return value.trim();
                if (typeof value === "object") {
                    const candidate =
                        value.Code ??
                        value.js ??
                        value.Expression ??
                        value.Value ??
                        value.Text;
                    return candidate === undefined || candidate === null
                        ? ""
                        : String(candidate).trim();
                }
                return String(value).trim();
            };

            const hasValue = (value: any): boolean =>
                value !== undefined &&
                value !== null &&
                !(typeof value === "string" && value.trim() === "");

            const structurallyEquivalentProperty = (
                prior: AnyDoc,
                next: AnyDoc
            ): boolean => {
                // For one owner + one Name there can only be one physical property.
                // Treat repeated declarations as the same member when their core
                // structural identity matches. Formula/query/Required/Caption/etc.
                // are competing metadata/behavior definitions for that same member,
                // not a reason to create a second property with the same name.
                const priorType = canonicalRef(prior.Type);
                const nextType = canonicalRef(next.Type);
                if (priorType && nextType && priorType !== nextType) return false;

                const priorMany = prior.Many === true;
                const nextMany = next.Many === true;
                if (priorMany !== nextMany) return false;

                const priorAggregation = String(prior.Aggregation || "").toLowerCase();
                const nextAggregation = String(next.Aggregation || "").toLowerCase();
                if (
                    priorAggregation &&
                    nextAggregation &&
                    priorAggregation !== nextAggregation
                ) {
                    return false;
                }

                return true;
            };

            const mergeDuplicatePropertyMetadata = (
                target: AnyDoc,
                duplicate: AnyDoc,
                owner: string,
                propertyName: string
            ): void => {
                const ignoredStructural = new Set([
                    "Name", "Type", "Many", "Aggregation",
                    "Criteria", "Query", "Filter"
                ]);
                const conflicts: string[] = [];

                Object.keys(duplicate || {}).forEach((field: string) => {
                    if (ignoredStructural.has(field)) return;

                    const current = target[field];
                    const incoming = duplicate[field];

                    if (!hasValue(current) && hasValue(incoming)) {
                        target[field] = cloneData(incoming);
                        return;
                    }

                    if (!hasValue(incoming)) return;

                    const currentText =
                        field === "Formula"
                            ? codeText(current)
                            : JSON.stringify(current);
                    const incomingText =
                        field === "Formula"
                            ? codeText(incoming)
                            : JSON.stringify(incoming);

                    if (currentText !== incomingText) {
                        conflicts.push(field);
                    }
                });

                if (conflicts.length) {
                    plan.Warnings = Array.isArray(plan.Warnings)
                        ? plan.Warnings
                        : [];
                    plan.Warnings.push(
                        `Duplicate generated property ${owner}.${propertyName} had conflicting metadata/behavior (${conflicts.join(", ")}). ` +
                        "The first generated definition was kept and the later duplicate was removed."
                    );
                }
            };

            operations.forEach((op: AnyDoc, index: number) => {
                if (op?.Type !== "AddProperty") return;

                const prop = op.Property || {};
                const owner = canonicalRef(op.EntityRef || op.EntityId);
                const name = String(prop.Name || "").trim().toLowerCase();
                if (!owner || !name) return;

                const key = JSON.stringify([owner, name]);
                const priorIndex = firstByKey.get(key);

                if (priorIndex === undefined) {
                    firstByKey.set(key, index);
                    return;
                }

                const priorOperation = operations[priorIndex];
                const prior = priorOperation?.Property || {};

                // Duplicate AddProperty operations can be produced by later semantic/
                // coverage passes. If they describe the same structural property,
                // merge only missing metadata into the first definition and remove
                // the later duplicate. Truly different Type/Aggregation/Many/formula
                // definitions remain visible and will still fail validation/apply.
                if (!structurallyEquivalentProperty(prior, prop)) {
                    return;
                }

                mergeDuplicatePropertyMetadata(
                    prior,
                    prop,
                    owner,
                    String(prop.Name || prior.Name || "")
                );
                redundant.add(index);
            });

            if (redundant.size) {
                plan.Operations = operations.filter(
                    (_: AnyDoc, i: number) => !redundant.has(i)
                );
            }

            // A long/chunked AI plan may repeat already-generated members in later
            // semantic/coverage passes. For one owner, member kind and member Name,
            // there can only be one physical declaration. Keep the first declaration
            // authoritative, merge only missing metadata where safe, and remove later
            // duplicates so apply never fails on "already exists".
            const dedupeNamedMemberOperations = (): number => {
                const currentOperations: AnyDoc[] =
                    Array.isArray(plan?.Operations)
                        ? plan.Operations
                        : [];

                const firstNamedMember = new Map<string, AnyDoc>();
                const removeIndexes = new Set<number>();
                let removed = 0;

                const memberDescriptor = (
                    operation: AnyDoc
                ): {
                    owner: string;
                    kind: string;
                    member: AnyDoc | null;
                    name: string;
                } | null => {
                    const kind = String(operation?.Type || "");
                    const field =
                        kind === "AddAction" ? "Action" :
                        kind === "AddRule" ? "Rule" :
                        kind === "AddEvent" ? "Event" :
                        kind === "AddProperty" ? "Property" :
                        "";

                    if (!field) return null;

                    const owner = canonicalRef(
                        operation?.EntityRef ||
                        operation?.EntityId
                    );
                    const member = operation?.[field] || null;
                    const name = String(member?.Name || "").trim();

                    if (!owner || !name) return null;

                    return {
                        owner,
                        kind,
                        member,
                        name
                    };
                };

                const memberCodeText = (
                    kind: string,
                    member: AnyDoc
                ): string => {
                    if (!member) return "";

                    const codeValue =
                        kind === "AddAction"
                            ? member.Script
                            : kind === "AddRule"
                                ? {
                                    PreCondition: member.PreCondition,
                                    Condition: member.Condition
                                }
                                : kind === "AddEvent"
                                    ? member.Script
                                    : kind === "AddProperty"
                                        ? member.Formula
                                        : null;

                    try {
                        return JSON.stringify(codeValue || "");
                    } catch {
                        return String(codeValue || "");
                    }
                };

                currentOperations.forEach(
                    (operation: AnyDoc, index: number) => {
                        const descriptor =
                            memberDescriptor(operation);
                        if (!descriptor) return;

                        const key = JSON.stringify([
                            descriptor.owner,
                            descriptor.kind,
                            descriptor.name.toLowerCase()
                        ]);

                        const priorOperation =
                            firstNamedMember.get(key);

                        if (!priorOperation) {
                            firstNamedMember.set(
                                key,
                                operation
                            );
                            return;
                        }

                        const priorDescriptor =
                            memberDescriptor(priorOperation);

                        if (
                            !priorDescriptor ||
                            !priorDescriptor.member
                        ) {
                            return;
                        }

                        // For AddProperty, retain the v13 structural safety rule:
                        // only collapse when the physical member shape is compatible.
                        if (
                            descriptor.kind ===
                                "AddProperty" &&
                            !structurallyEquivalentProperty(
                                priorDescriptor.member,
                                descriptor.member
                            )
                        ) {
                            return;
                        }

                        const conflicts: string[] = [];
                        const ignoredFields =
                            descriptor.kind ===
                                "AddProperty"
                                ? new Set([
                                    "Name",
                                    "Type",
                                    "Many",
                                    "Aggregation"
                                ])
                                : new Set(["Name"]);

                        Object.keys(
                            descriptor.member || {}
                        ).forEach((field: string) => {
                            if (ignoredFields.has(field)) {
                                return;
                            }

                            const current =
                                priorDescriptor.member[field];
                            const incoming =
                                descriptor.member[field];

                            if (
                                !hasValue(current) &&
                                hasValue(incoming)
                            ) {
                                priorDescriptor.member[field] =
                                    cloneData(incoming);
                                return;
                            }

                            if (!hasValue(incoming)) return;

                            let currentText = "";
                            let incomingText = "";

                            try {
                                currentText =
                                    JSON.stringify(current);
                            } catch {
                                currentText =
                                    String(current);
                            }

                            try {
                                incomingText =
                                    JSON.stringify(incoming);
                            } catch {
                                incomingText =
                                    String(incoming);
                            }

                            if (
                                currentText !==
                                incomingText
                            ) {
                                conflicts.push(field);
                            }
                        });

                        if (conflicts.length) {
                            plan.Warnings =
                                Array.isArray(
                                    plan.Warnings
                                )
                                    ? plan.Warnings
                                    : [];

                            const firstCode =
                                memberCodeText(
                                    descriptor.kind,
                                    priorDescriptor.member
                                );
                            const nextCode =
                                memberCodeText(
                                    descriptor.kind,
                                    descriptor.member
                                );

                            plan.Warnings.push(
                                `Duplicate generated ${descriptor.kind} ${descriptor.owner}.${descriptor.name} ` +
                                `had conflicting fields (${conflicts.join(", ")}). ` +
                                `The first declaration was kept; the later duplicate was removed.` +
                                (
                                    firstCode !== nextCode &&
                                    (firstCode || nextCode)
                                        ? " Executable behavior also differed."
                                        : ""
                                )
                            );
                        }

                        removeIndexes.add(index);
                        removed++;
                    }
                );

                if (removeIndexes.size) {
                    plan.Operations =
                        currentOperations.filter(
                            (_: AnyDoc, index: number) =>
                                !removeIndexes.has(index)
                        );
                }

                return removed;
            };

            const duplicateNamedMembersRemoved =
                dedupeNamedMemberOperations();

            const dedupeNavigationTemporaryIds = (): number => {
                const currentOperations: AnyDoc[] =
                    Array.isArray(plan?.Operations)
                        ? plan.Operations
                        : [];

                const navigationKinds = new Set([
                    "AddNavigationGroup",
                    "AddNavigationItem"
                ]);

                const firstByTemporaryId =
                    new Map<string, AnyDoc>();
                const removeIndexes =
                    new Set<number>();
                let removed = 0;

                currentOperations.forEach(
                    (operation: AnyDoc, index: number) => {
                        const kind =
                            String(operation?.Type || "");

                        if (!navigationKinds.has(kind)) {
                            return;
                        }

                        const temporaryId =
                            String(
                                operation?.TemporaryId || ""
                            ).trim();

                        if (!temporaryId) return;

                        const key =
                            temporaryId.toLowerCase();

                        const prior =
                            firstByTemporaryId.get(key);

                        if (!prior) {
                            firstByTemporaryId.set(
                                key,
                                operation
                            );
                            return;
                        }

                        const priorItem =
                            prior.NavigationItem || {};
                        const nextItem =
                            operation.NavigationItem || {};

                        Object.keys(nextItem).forEach(
                            (field: string) => {
                                const current =
                                    priorItem[field];
                                const incoming =
                                    nextItem[field];

                                if (
                                    (
                                        current === undefined ||
                                        current === null ||
                                        current === ""
                                    ) &&
                                    incoming !== undefined &&
                                    incoming !== null &&
                                    incoming !== ""
                                ) {
                                    priorItem[field] =
                                        cloneData(incoming);
                                }
                            }
                        );

                        if (
                            !prior.ParentRef &&
                            operation.ParentRef
                        ) {
                            prior.ParentRef =
                                cloneData(
                                    operation.ParentRef
                                );
                        }

                        if (
                            !prior.EntityRef &&
                            operation.EntityRef
                        ) {
                            prior.EntityRef =
                                cloneData(
                                    operation.EntityRef
                                );
                        }

                        plan.Warnings =
                            Array.isArray(plan.Warnings)
                                ? plan.Warnings
                                : [];

                        plan.Warnings.push(
                            `Duplicate navigation TemporaryId "${temporaryId}" was generated more than once. ` +
                            "The first declaration was kept and the later duplicate was removed."
                        );

                        removeIndexes.add(index);
                        removed++;
                    }
                );

                if (removeIndexes.size) {
                    plan.Operations =
                        currentOperations.filter(
                            (_: AnyDoc, index: number) =>
                                !removeIndexes.has(index)
                        );
                }

                return removed;
            };

            const duplicateNavigationIdsRemoved =
                dedupeNavigationTemporaryIds();

            const dedupeTypeTemporaryIds = (): number => {
                const currentOperations: AnyDoc[] =
                    Array.isArray(plan?.Operations)
                        ? plan.Operations
                        : [];

                const firstByTemporaryId =
                    new Map<string, AnyDoc>();
                const removeIndexes =
                    new Set<number>();
                let removed = 0;

                currentOperations.forEach(
                    (operation: AnyDoc, index: number) => {
                        if (operation?.Type !== "AddType") {
                            return;
                        }

                        const temporaryId =
                            String(
                                operation?.TemporaryId || ""
                            ).trim();

                        if (!temporaryId) return;

                        const key =
                            temporaryId.toLowerCase();
                        const prior =
                            firstByTemporaryId.get(key);

                        if (!prior) {
                            firstByTemporaryId.set(
                                key,
                                operation
                            );
                            return;
                        }

                        const priorEntity =
                            prior.Entity &&
                                typeof prior.Entity === "object"
                                ? prior.Entity
                                : {};
                        const nextEntity =
                            operation.Entity &&
                                typeof operation.Entity === "object"
                                ? operation.Entity
                                : {};

                        // Keep the first type declaration authoritative and merge
                        // only metadata that was missing from it.
                        Object.keys(nextEntity).forEach(
                            (field: string) => {
                                const current =
                                    priorEntity[field];
                                const incoming =
                                    nextEntity[field];

                                if (
                                    (
                                        current === undefined ||
                                        current === null ||
                                        current === ""
                                    ) &&
                                    incoming !== undefined &&
                                    incoming !== null &&
                                    incoming !== ""
                                ) {
                                    priorEntity[field] =
                                        cloneData(incoming);
                                }
                            }
                        );

                        plan.Warnings =
                            Array.isArray(plan.Warnings)
                                ? plan.Warnings
                                : [];

                        plan.Warnings.push(
                            `Duplicate AddType TemporaryId "${temporaryId}" was generated more than once. ` +
                            "The first declaration was kept and the later duplicate was removed."
                        );

                        removeIndexes.add(index);
                        removed++;
                    }
                );

                if (removeIndexes.size) {
                    plan.Operations =
                        currentOperations.filter(
                            (_: AnyDoc, index: number) =>
                                !removeIndexes.has(index)
                        );
                }

                return removed;
            };

            const duplicateTypeIdsRemoved =
                dedupeTypeTemporaryIds();

            if (
                converted ||
                redundant.size ||
                duplicateNamedMembersRemoved ||
                duplicateNavigationIdsRemoved ||
                duplicateTypeIdsRemoved
            ) {
                console.info(
                    "[DesignerAI] Canonicalized generated operations:",
                    "AddCollection converted=" + converted,
                    "duplicate AddProperty removed=" + redundant.size,
                    "duplicate named members removed=" + duplicateNamedMembersRemoved,
                    "duplicate navigation TemporaryIds removed=" + duplicateNavigationIdsRemoved,
                    "duplicate type TemporaryIds removed=" + duplicateTypeIdsRemoved
                );
            }
        }

        function removeUnusedGeneratedEnums(plan: AnyDoc): void {
            if (!Array.isArray(plan?.Operations)) return;

            const validation = validateAIPlanReferences(plan);
            const orphanIndices = new Set<number>();

            validation.Issues.forEach((issue: AIPlanValidationIssue) => {
                if (issue.Code !== "OrphanEnum") return;
                const index = issue.OperationIndex;
                const operation = plan.Operations[index];
                if (!operation || operation.Type !== "AddEnum") return;

                // A name-only reference may indicate a malformed link rather than
                // a genuinely unused enum; leave it visible for manual correction.
                const enumName = String(operation.Enum?.Name || "").trim();
                const otherOperations = plan.Operations.filter((_: AnyDoc, i: number) => i !== index);
                if (enumName && otherOperations.some((item: AnyDoc) =>
                    JSON.stringify(item).includes('"' + enumName + '"')
                )) return;

                orphanIndices.add(index);
            });

            if (!orphanIndices.size) return;
            plan.Operations = plan.Operations.filter((_: AnyDoc, index: number) =>
                !orphanIndices.has(index)
            );
            console.info("[DesignerAI] Removed unused generated enums:", orphanIndices.size);
        }

        function formatAIPlanValidationIssues(result: AIPlanValidationResult): string {
            const errors = result.Issues.filter(x => (x.Severity || "error") === "error");
            const warnings = result.Issues.filter(x => x.Severity === "warning");
            const lines: string[] = [];

            if (errors.length) {
                lines.push(`${errors.length} error${errors.length === 1 ? "" : "s"}`);
                lines.push("");
                errors.forEach(issue => {
                    lines.push(
                        issue.OperationIndex >= 0
                            ? `Operation ${issue.OperationIndex + 1} [${issue.Code}]`
                            : `Plan [${issue.Code}]`
                    );
                    lines.push(issue.Message);
                    lines.push("");
                });
            }

            if (warnings.length) {
                lines.push(`${warnings.length} warning${warnings.length === 1 ? "" : "s"}`);
                lines.push("");
                warnings.forEach(issue => {
                    lines.push(
                        issue.OperationIndex >= 0
                            ? `Operation ${issue.OperationIndex + 1} [${issue.Code}]`
                            : `Plan [${issue.Code}]`
                    );
                    lines.push(issue.Message);
                    lines.push("");
                });
            }

            return lines.join("\n").trim();
        }


        function getLatestAIPlan(): AnyDoc | null {
            for (let i = aiMessages.length - 1; i >= 0; i--) {
                const message = aiMessages[i];
                if (
                    message?.Role === "assistant" &&
                    (message.InternalPlan || message.Plan) &&
                    !message.Error
                ) {
                    return message.InternalPlan || message.Plan;
                }
            }
            return null;
        }

        function canApplyCurrentAIPlan(): boolean {
            const plan = getLatestAIPlan();
            if (!plan ||
                !Array.isArray(plan.Operations) ||
                plan.Operations.length === 0 ||
                plan.NeedsMoreContext) {
                return false;
            }

            return validateAIPlanReferences(plan).IsValid;
        }

        function startNewAITask(message?: string): void {
            aiTaskId = new DevExpress.data.Guid().toString();
            designerAIPipelineRequestSequence = 0;
            designerAIPipelineServiceSequence = 0;
            designerAIPipelineTrace = [];
            (window as any).cosmoDesignerAITrace = [];
            aiMessages = [];
            aiPromptBox?.option("value", "");
            aiApplyButton?.option("disabled", true);
            renderAssistant();

            if (message) {
                DevExpress.ui.notify(message, "success", 2600);
            }
        }

        function getAIEntityRefLabel(ref: AnyDoc): string {
            if (!ref) return "unknown type";
            if (ref.TemporaryId) return String(ref.TemporaryId).replace(/^new-/, "");
            const id = ref.EntityId || ref.id || ref;
            const type = getAIApplicationTypeDocs().find((x: AnyDoc) => String(x.id) === String(id));
            return String(type?.Name || id || "unknown type");
        }


        function getCurrentGenericModelContext(): GenericModelContext {
            return {
                application:
                    applicationDoc,
                objects:
                    getRuntimeObjectsArray(
                        false
                    ),
                enums:
                    getRuntimeEnumsArray(
                        false
                    ),
                navigationItems:
                    getRuntimeNavigationItemsArray(
                        false
                    )
            };
        }

        function getObjectHumanLabel(
            obj: AnyDoc
        ): string {
            if (!obj) return "объект";

            return String(
                obj.Caption ||
                obj.Name ||
                obj.TypeName ||
                obj.id ||
                "объект"
            );
        }

        function getCollectionHumanLabel(
            collectionName: string
        ): string {
            const name =
                String(
                    collectionName ||
                    ""
                );

            const labels: Record<string, string> = {
                NavigationItems:
                    "навигация",
                Navigation:
                    "навигация",
                Items:
                    "пункты меню",
                Types:
                    "типы",
                Entities:
                    "типы",
                Enums:
                    "перечисления",
                Properties:
                    "свойства",
                Collections:
                    "коллекции",
                Actions:
                    "действия",
                Rules:
                    "правила",
                Events:
                    "события"
            };

            return (
                labels[name] ||
                name ||
                "коллекция"
            );
        }

        function getGenericObjectKindLabel(
            obj: AnyDoc,
            location?: GenericObjectLocation | null
        ): string {
            const collectionName =
                String(
                    location?.collectionName ||
                    ""
                );

            if (
                collectionName ===
                    "NavigationItems" ||
                collectionName ===
                    "Items" ||
                isGenericNavigationObject(
                    obj,
                    getCurrentGenericModelContext()
                )
            ) {
                return "пункт меню";
            }

            const schema =
                getSchemaForObject(
                    obj
                );
            const schemaName =
                String(
                    schema?.Name ||
                    ""
                );

            const labels: Record<string, string> = {
                MetaEntity:
                    "тип",
                Property:
                    "свойство",
                MetaProperty:
                    "свойство",
                Collection:
                    "коллекция",
                MetaCollection:
                    "коллекция",
                Action:
                    "действие",
                Rule:
                    "правило",
                Event:
                    "событие",
                Menu:
                    "пункт меню",
                Enum:
                    "перечисление"
            };

            return (
                labels[schemaName] ||
                "объект"
            );
        }

        function getGenericParentHumanLabel(
            parent: AnyDoc | null,
            collectionName?: string | null
        ): string {
            const collection =
                String(
                    collectionName ||
                    ""
                );

            if (
                parent ===
                    applicationDoc ||
                (
                    parent?.id &&
                    applicationDoc?.id &&
                    String(parent.id) ===
                    String(applicationDoc.id)
                )
            ) {
                if (
                    collection ===
                        "NavigationItems" ||
                    collection ===
                        "Navigation"
                ) {
                    return "корень навигации";
                }

                return "приложение";
            }

            return parent
                ? `«${getObjectHumanLabel(parent)}»`
                : "корень";
        }

        function resolvePlannedParentLabel(
            operation: AnyDoc,
            operations?: AnyDoc[]
        ): {
            label: string;
            collectionName: string;
        } {
            const collectionName =
                String(
                    operation?.Collection ||
                    ""
                );

            if (operation?.ParentId) {
                const location =
                    findGenericObject(
                        getCurrentGenericModelContext(),
                        String(
                            operation.ParentId
                        )
                    );

                return {
                    label:
                        getGenericParentHumanLabel(
                            location?.object ||
                            null,
                            collectionName
                        ),
                    collectionName
                };
            }

            const temporaryId =
                String(
                    operation?.ParentRef
                        ?.TemporaryId ||
                    ""
                ).trim();

            if (
                temporaryId &&
                Array.isArray(operations)
            ) {
                const parentOperation =
                    operations.find(
                        (candidate: AnyDoc) =>
                            String(
                                candidate?.TemporaryId ||
                                ""
                            ) === temporaryId
                    );

                const parentObject =
                    parentOperation?.Object ||
                    parentOperation
                        ?.NavigationItem ||
                    parentOperation
                        ?.Entity ||
                    null;

                if (parentObject) {
                    return {
                        label:
                            `«${getObjectHumanLabel(parentObject)}»`,
                        collectionName
                    };
                }
            }

            return {
                label:
                    temporaryId
                        ? `новый объект «${temporaryId}»`
                        : "назначение",
                collectionName
            };
        }

        function describeAIOperation(operation: AnyDoc, index: number, operations?: AnyDoc[]): AnyDoc {
            const kind = String(operation?.Type || "Operation");
            const entity = operation?.Entity || {};
            const property = operation?.Property || {};
            const collection = operation?.Collection || {};
            const ownerRef = operation?.EntityRef || operation?.EntityId;
            const owner = getAIEntityRefLabel(ownerRef);

            switch (kind) {
                case "AddType":
                    return {
                        Title: `Create type ${entity.Name || operation.TemporaryId || index + 1}`,
                        Detail: [entity.Caption, entity.BaseType ? `base: ${entity.BaseType}` : ""].filter(Boolean).join(" · ")
                    };
                case "AddEnum": {
                    const enumDefinition = operation?.Enum || operation?.Entity || {};
                    const values = Array.isArray(enumDefinition.Values) ? enumDefinition.Values : [];
                    const valuesText = values.map((v: AnyDoc, valueIndex: number) => {
                        const technicalName = v?.Name || `Value${valueIndex}`;
                        const caption = v?.Caption && v.Caption !== technicalName
                            ? ` — ${v.Caption}`
                            : "";
                        const numericValue = v?.Value !== undefined ? v.Value : valueIndex;
                        return `${technicalName}${caption} = ${numericValue}`;
                    }).join(", ");

                    return {
                        Title: `Create enum ${enumDefinition.Name || operation.TemporaryId || index + 1}`,
                        Detail: [
                            enumDefinition.Caption,
                            `${values.length} values`,
                            valuesText
                        ].filter(Boolean).join(" · ")
                    };
                }
                case "AddProperty":
                    return {
                        Title: `Add property ${property.Name || index + 1} to ${owner}`,
                        Detail: [property.Caption, property.Type ? `type: ${typeof property.Type === "object" ? getAIEntityRefLabel(property.Type) : property.Type}` : "", property.Aggregation ? `aggregation: ${property.Aggregation}` : "", property.ReadOnly ? "read-only" : "", property.Formula?.Code ? `formula: ${property.Formula.Code}` : ""].filter(Boolean).join(" · ")
                    };
                case "AddNavigationGroup":
                    return {
                        Title:
                            `Create navigation group ${operation?.NavigationItem?.Caption ||
                            operation?.NavigationItem?.Name ||
                            operation?.TemporaryId ||
                            index + 1
                            }`,
                        Detail:
                            isAIScriptNavigationItem(operation)
                                ? "script"
                                : (
                                    operation?.NavigationItem?.Folder
                                        ? `folder: ${operation.NavigationItem.Folder}`
                                        : ""
                                )
                    };
                case "AddNavigationItem":
                    return {
                        Title:
                            `Add navigation item ${operation?.NavigationItem?.Caption ||
                            operation?.NavigationItem?.Name ||
                            operation?.TemporaryId ||
                            index + 1
                            }`,
                        Detail:
                            operation?.NavigationItem?.Folder
                                ? `folder: ${operation.NavigationItem.Folder}`
                                : ""
                    };
                case "AddObject": {
                    const parent =
                        resolvePlannedParentLabel(
                            operation,
                            operations
                        );
                    const object =
                        operation?.Object ||
                        {};
                    const objectLabel =
                        getObjectHumanLabel(
                            object
                        );

                    return {
                        Title:
                            `Добавить «${objectLabel}»`,
                        Detail:
                            `в ${getCollectionHumanLabel(parent.collectionName)} ${parent.label}`
                    };
                }
                case "UpdateObject": {
                    const location =
                        findGenericObject(
                            getCurrentGenericModelContext(),
                            String(
                                operation?.ObjectId ||
                                ""
                            )
                        );
                    const object =
                        location?.object ||
                        null;
                    const kindLabel =
                        getGenericObjectKindLabel(
                            object,
                            location
                        );
                    const label =
                        object
                            ? getObjectHumanLabel(
                                object
                            )
                            : String(
                                operation?.ObjectId ||
                                index + 1
                            );
                    const fields =
                        Object.keys(
                            operation?.Changes ||
                            {}
                        );

                    return {
                        Title:
                            `Изменить ${kindLabel} «${label}»`,
                        Detail:
                            fields.length
                                ? `Поля: ${fields.join(", ")}`
                                : ""
                    };
                }
                case "MoveObject": {
                    const context =
                        getCurrentGenericModelContext();
                    const location =
                        findGenericObject(
                            context,
                            String(
                                operation?.ObjectId ||
                                ""
                            )
                        );
                    const object =
                        location?.object ||
                        null;
                    const kindLabel =
                        getGenericObjectKindLabel(
                            object,
                            location
                        );
                    const label =
                        object
                            ? getObjectHumanLabel(
                                object
                            )
                            : String(
                                operation?.ObjectId ||
                                index + 1
                            );
                    const sourceLabel =
                        getGenericParentHumanLabel(
                            location?.parent ||
                            null,
                            location?.collectionName ||
                            null
                        );
                    const destination =
                        resolvePlannedParentLabel(
                            operation,
                            operations
                        );

                    return {
                        Title:
                            `Переместить ${kindLabel} «${label}»`,
                        Detail:
                            sourceLabel ===
                            destination.label
                                ? `в ${destination.label}`
                                : `из ${sourceLabel} в ${destination.label}`
                    };
                }
                case "DeleteObject": {
                    const location =
                        findGenericObject(
                            getCurrentGenericModelContext(),
                            String(
                                operation?.ObjectId ||
                                ""
                            )
                        );
                    const object =
                        location?.object ||
                        null;
                    const kindLabel =
                        getGenericObjectKindLabel(
                            object,
                            location
                        );
                    const label =
                        object
                            ? getObjectHumanLabel(
                                object
                            )
                            : String(
                                operation?.ObjectId ||
                                index + 1
                            );

                    return {
                        Title:
                            `Удалить ${kindLabel} «${label}»`,
                        Detail:
                            location?.parent
                                ? `из ${getGenericParentHumanLabel(location.parent, location.collectionName)}`
                                : ""
                    };
                }
                case "MoveNavigationItem": {
                    const currentItem =
                        findNavigationItemRecursive(
                            getRuntimeNavigationItemsArray(false),
                            String(operation?.NavigationItemId || "")
                        );
                    const parent =
                        operation?.ParentId
                            ? findNavigationItemRecursive(
                                getRuntimeNavigationItemsArray(false),
                                String(operation.ParentId)
                            )
                            : null;

                    return {
                        Title:
                            `Move navigation item ${currentItem?.Caption || currentItem?.Name || operation?.NavigationItemId || index + 1}`,
                        Detail:
                            parent
                                ? `to ${parent?.Caption || parent?.Name || operation.ParentId}`
                                : (
                                    operation?.ParentRef?.TemporaryId
                                        ? `to new group ${operation.ParentRef.TemporaryId}`
                                        : ""
                                )
                    };
                }
                case "UpdateType":
                    return {
                        Title: `Update type ${owner}`,
                        Detail: operation?.Changes?.BaseType
                            ? `base: ${getAIEntityRefLabel(operation.Changes.BaseType)}`
                            : Object.keys(operation.Changes || {}).join(", ")
                    };
                case "UpdateProperty":
                    return {
                        Title: `Update property ${operation.PropertyId || index + 1} in ${owner}`,
                        Detail: Object.keys(operation.Changes || {}).join(", ")
                    };
                case "AddCollection":
                    return {
                        Title: `Add collection ${collection.Name || index + 1} to ${owner}`,
                        Detail: [collection.Caption, collection.ItemEntity ? `items: ${getAIEntityRefLabel(collection.ItemEntity)}` : "", collection.Aggregation ? `aggregation: ${collection.Aggregation}` : ""].filter(Boolean).join(" · ")
                    };
                case "UpdateCollection":
                    return {
                        Title: `Update collection ${operation.CollectionId || index + 1} in ${owner}`,
                        Detail: Object.keys(operation.Changes || {}).join(", ")
                    };
                default:
                    return { Title: kind, Detail: "" };
            }
        }

        function copyTextToClipboard(text: string): Promise<void> {
            const clipboard = (navigator as any).clipboard;
            if (clipboard && typeof clipboard.writeText === "function" && (window as any).isSecureContext) {
                return clipboard.writeText(text);
            }

            return new Promise<void>((resolve, reject) => {
                const $textarea = $("<textarea>")
                    .val(text)
                    .attr("readonly", "readonly")
                    .css({
                        position: "fixed",
                        left: "-10000px",
                        top: "-10000px",
                        opacity: 0
                    })
                    .appendTo(document.body);

                const element = $textarea.get(0) as HTMLTextAreaElement;
                element.focus();
                element.select();

                try {
                    const copied = (document as any).execCommand("copy");
                    $textarea.remove();
                    copied ? resolve() : reject(new Error("Copy command was rejected"));
                } catch (error) {
                    $textarea.remove();
                    reject(error);
                }
            });
        }


        function createRuntimeTypeFromAIOperation(operation: AnyDoc): AnyDoc {
            const entity = cloneData(operation?.Entity || {});
            const name = String(entity.Name || "").trim();

            if (!name) {
                throw new Error("AddType.Entity.Name is required.");
            }

            const id = new DevExpress.data.Guid().toString();

            return {
                id,
                projectId: runtime.id,
                _partitionKey: runtime.id,
                _partitionId: runtime.id,
                _type: "_Type",
                _extern: false,
                BaseType: entity.BaseType || "object",
                Browsable: entity.Browsable !== false,
                Cacheable: entity.Cacheable === true,
                IsRoot: entity.IsRoot === true,
                Properties: [],
                Collections: [],
                Rules: [],
                ApperanceRules: [],
                Actions: [],
                Events: [],
                formLayout: entity.formLayout || { Width: "1200", Height: "800", items: [] },
                Name: name,
                Caption: entity.Caption,
                CaptionPlural: entity.CaptionPlural,
                Description: entity.Description,
                TypeName: entity.TypeName || `${runtime.ModuleName || runtime.Name || "App"}.${name}`,
                Widgets: [],
                Advanced: []
            };
        }

        function createRuntimeEnumFromAIOperation(operation: AnyDoc): AnyDoc {
            // Enum is the canonical operation field. Entity is accepted only as a
            // compatibility fallback for plans produced before the contract was explicit.
            const source = cloneData(operation?.Enum || operation?.Entity || {});
            const name = String(source.Name || "").trim();

            if (!name) {
                throw new Error("AddEnum.Enum.Name is required.");
            }

            if (!Array.isArray(source.Values) || source.Values.length < 2) {
                throw new Error(`AddEnum "${name}" must contain at least two Values.`);
            }

            const seenNames: Record<string, boolean> = {};
            const seenValues: Record<string, boolean> = {};
            const id = new DevExpress.data.Guid().toString();

            const values = source.Values.map((value: AnyDoc, index: number) => {
                const valueName = String(value?.Name || "").trim();
                const numericValue = value?.Value !== undefined ? value.Value : index;

                if (!valueName) {
                    throw new Error(`AddEnum "${name}" value ${index + 1} requires Name.`);
                }

                if (seenNames[valueName]) {
                    throw new Error(`AddEnum "${name}" contains duplicate value name "${valueName}".`);
                }

                const valueKey = String(numericValue);
                if (seenValues[valueKey]) {
                    throw new Error(`AddEnum "${name}" contains duplicate numeric value "${valueKey}".`);
                }

                seenNames[valueName] = true;
                seenValues[valueKey] = true;

                return {
                    id: new DevExpress.data.Guid().toString(),
                    Code: String(value?.Code || valueName),
                    Name: valueName,
                    Caption: value.Caption,
                    Description: value.Description,
                    Value: numericValue,
                    _partitionId: runtime.id
                };
            });

            return {
                id,
                projectId: runtime.id,
                _partitionKey: runtime.id,
                _partitionId: runtime.id,
                _type: "_Enum",
                Name: name,
                Caption: source.Caption,
                Description: source.Description,
                Values: values
            };
        }

        function resolveAIApplyReferenceId(
            ref: any,
            typeTemporaryIds: Record<string, string>,
            enumTemporaryIds: Record<string, string>,
            path: string
        ): string {
            if (ref === undefined || ref === null || ref === "") {
                throw new Error(`${path} is required.`);
            }

            if (typeof ref === "object" && ref.TemporaryId) {
                const temporaryId = String(ref.TemporaryId);
                const resolved = typeTemporaryIds[temporaryId] || enumTemporaryIds[temporaryId];

                if (!resolved) {
                    throw new Error(`${path} contains unresolved TemporaryId "${temporaryId}".`);
                }

                return resolved;
            }

            if (typeof ref === "object") {
                const id = ref.EntityId || ref.id || ref.Type;
                if (id) return String(id);
            }

            return String(ref);
        }

        function findStagedTypeById(stagedObjects: AnyDoc[], id: string, path: string): AnyDoc {
            const found = stagedObjects.find((x: AnyDoc) => String(x?.id || "") === String(id));

            if (!found) {
                throw new Error(`${path}: application type "${id}" was not found.`);
            }

            return found;
        }

        function normalizeAIPropertyForRuntime(
            source: AnyDoc,
            typeTemporaryIds: Record<string, string>,
            enumTemporaryIds: Record<string, string>,
            stagedEnums: AnyDoc[]
        ): AnyDoc {
            const property = cloneData(source || {});

            if (!property.Name) {
                throw new Error("Property.Name is required.");
            }

            property.id = property.id || new DevExpress.data.Guid().toString();
            property._type = property._type || PROPERTY_TYPE;
            property.projectId = property.projectId || runtime.id;
            property._partitionId = property._partitionId || runtime.id;
            property._partitionKey = property._partitionKey || runtime.id;

            if (property.Type && typeof property.Type === "object") {
                property.Type = resolveAIApplyReferenceId(
                    property.Type,
                    typeTemporaryIds,
                    enumTemporaryIds,
                    `Property ${property.Name}.Type`
                );
            }

            // Legacy runtime schema stores enum defaults as the enum value Code
            // string, not as an enum value object and not as the numeric Value.
            // Normalize AI-produced defaults only after the enum Type reference
            // has been resolved to its runtime enum id.
            if (property.DefaultValue !== undefined && property.DefaultValue !== null) {
                const enumType = (stagedEnums || []).find(
                    (item: AnyDoc) =>
                        String(item?.id || "") === String(property.Type || "")
                );

                if (enumType && Array.isArray(enumType.Values)) {
                    const rawDefault = property.DefaultValue;
                    const rawCode =
                        rawDefault && typeof rawDefault === "object"
                            ? String(
                                rawDefault.Code ??
                                rawDefault.Name ??
                                rawDefault.Value ??
                                ""
                            ).trim()
                            : String(rawDefault).trim();

                    const enumValue = enumType.Values.find(
                        (value: AnyDoc) => {
                            const candidates = [
                                value?.Code,
                                value?.Name,
                                value?.Value,
                                value?.Caption
                            ]
                                .filter((candidate: any) =>
                                    candidate !== undefined &&
                                    candidate !== null
                                )
                                .map((candidate: any) =>
                                    String(candidate)
                                );

                            return candidates.indexOf(rawCode) >= 0;
                        }
                    );

                    if (enumValue) {
                        property.DefaultValue = String(
                            enumValue.Code ?? enumValue.Name ?? ""
                        );
                    } else if (rawDefault && typeof rawDefault === "object") {
                        property.DefaultValue = rawCode;
                    }
                }
            }

            const scalarTypeName = String(property.Type || "").toLowerCase();
            if (scalarTypeName === "text" || scalarTypeName === "html") {
                property.Type = "string";
            }

            return property;
        }

        function normalizeAICollectionForRuntime(
            source: AnyDoc,
            typeTemporaryIds: Record<string, string>,
            enumTemporaryIds: Record<string, string>
        ): AnyDoc {
            const sourceCollection = cloneData(source || {});

            if (!sourceCollection.Name) {
                throw new Error("Collection.Name is required.");
            }

            const property: AnyDoc = {
                ...sourceCollection,
                id: sourceCollection.id || new DevExpress.data.Guid().toString(),
                _type: PROPERTY_TYPE,
                projectId: sourceCollection.projectId || runtime.id,
                _partitionId: sourceCollection._partitionId || runtime.id,
                _partitionKey: sourceCollection._partitionKey || runtime.id,
                Type: resolveAIApplyReferenceId(
                    sourceCollection.ItemEntity || sourceCollection.Type,
                    typeTemporaryIds,
                    enumTemporaryIds,
                    `Collection ${sourceCollection.Name}.ItemEntity`
                ),
                Many: true
            };

            delete property.ItemEntity;

            if (property.StorageKind === undefined || property.StorageKind === null) {
                property.StorageKind = 0;
            } else if (typeof property.StorageKind === "string") {
                const storageKind = property.StorageKind.trim().toLowerCase();

                if (
                    storageKind === "structured" ||
                    storageKind === "embedded" ||
                    storageKind === "default" ||
                    storageKind === "0"
                ) {
                    property.StorageKind = 0;
                } else {
                    const numericStorageKind = Number(property.StorageKind);

                    if (!Number.isFinite(numericStorageKind)) {
                        throw new Error(
                            `Property ${property.Name}.StorageKind must be numeric; received "${property.StorageKind}".`
                        );
                    }

                    property.StorageKind = numericStorageKind;
                }
            }

            return property;
        }

        function getAIBehaviorCollectionName(kind: string): "Rules" | "Actions" | "Events" {
            if (kind.indexOf("Rule") >= 0) return "Rules";
            if (kind.indexOf("Action") >= 0) return "Actions";
            return "Events";
        }

        function getAIBehaviorDefinition(operation: AnyDoc): AnyDoc {
            const kind = String(operation?.Type || "");
            if (kind.indexOf("Rule") >= 0) return operation?.Rule || {};
            if (kind.indexOf("Action") >= 0) return operation?.Action || {};
            return operation?.Event || {};
        }

        function findAIBehaviorOwner(
            stagedObjects: AnyDoc[],
            operation: AnyDoc,
            typeTemporaryIds: Record<string, string>,
            enumTemporaryIds: Record<string, string>,
            operationLabel: string
        ): { TypeDoc: AnyDoc; Container: AnyDoc } {
            const ownerId = operation?.EntityId
                ? String(operation.EntityId)
                : resolveAIApplyReferenceId(operation?.EntityRef, typeTemporaryIds, enumTemporaryIds, `${operationLabel}.EntityRef`);
            const typeDoc = findStagedTypeById(stagedObjects, ownerId, operationLabel);
            const propertyId = String(operation?.PropertyId || "").trim();
            const propertyName = String(operation?.PropertyName || "").trim();

            if (!propertyId && !propertyName) return { TypeDoc: typeDoc, Container: typeDoc };

            const property = (Array.isArray(typeDoc?.Properties) ? typeDoc.Properties : []).find((item: AnyDoc) =>
                (propertyId && String(item?.id || "") === propertyId) ||
                (propertyName && String(item?.Name || "") === propertyName)
            );
            if (!property) throw new Error(`${operationLabel}: property ${typeDoc.Name}.${propertyName || propertyId} was not found.`);
            return { TypeDoc: typeDoc, Container: property };
        }

        function normalizeAIBehaviorDefinition(definition: AnyDoc, kind: "Rule" | "Action" | "Event"): AnyDoc {
            const result = cloneData(definition || {});
            const name = String(result?.Name || "").trim();
            if (!name) throw new Error(`${kind}.Name is required.`);

            result.id = result.id || new DevExpress.data.Guid().toString();
            result.Name = name;

            if (kind === "Action") {
                // Legacy constructor defaults. Runtime action rendering relies on
                // these values even when the user/AI did not specify them explicitly.
                result.Mode =
                    result.Mode || "Override";

                if (
                    result.ActionType === undefined &&
                    result.Type === undefined
                ) {
                    result.ActionType = "Simple";
                }

                result.TargetView =
                    result.TargetView || "Any";
                result.Permission =
                    result.Permission || "Default";
                result.ViewNesting =
                    result.ViewNesting || "Any";

                if (
                    result.Independent === undefined ||
                    result.Independent === null
                ) {
                    result.Independent = false;
                }
            }

            return result;
        }

        function findNavigationItemRecursive(
            items: AnyDoc[],
            id: string
        ): AnyDoc | null {
            const targetId =
                String(id || "").trim();

            if (!targetId) return null;

            for (let index = 0; index < items.length; index++) {
                const item = items[index];

                if (
                    String(item?.id || "") === targetId
                ) {
                    return item;
                }

                const children =
                    Array.isArray(item?.items)
                        ? item.items
                        : [];

                const found =
                    findNavigationItemRecursive(
                        children,
                        targetId
                    );

                if (found) return found;
            }

            return null;
        }

        function appendNavigationItemToParent(
            stagedNavigationItems: AnyDoc[],
            item: AnyDoc,
            parentId: string | null
        ): void {
            const resolvedParentId =
                String(parentId || "").trim();

            if (!resolvedParentId) {
                stagedNavigationItems.push(item);
                return;
            }

            const parent =
                findNavigationItemRecursive(
                    stagedNavigationItems,
                    resolvedParentId
                );

            if (!parent) {
                throw new Error(
                    `Navigation parent "${resolvedParentId}" was not found. The item "${item?.Caption || item?.Name || item?.id || "NavigationItem"}" was not added to the root as a fallback.`
                );
            }

            parent.items =
                Array.isArray(parent.items)
                    ? parent.items
                    : [];

            item.ParentId =
                resolvedParentId;

            parent.items.push(item);
        }


        function detachNavigationItemRecursive(
            items: AnyDoc[],
            id: string
        ): AnyDoc | null {
            const targetId = String(id || "").trim();
            if (!targetId) return null;

            for (let index = 0; index < items.length; index++) {
                const item = items[index];

                if (String(item?.id || "") === targetId) {
                    return items.splice(index, 1)[0] || null;
                }

                const children =
                    Array.isArray(item?.items)
                        ? item.items
                        : [];

                const found =
                    detachNavigationItemRecursive(
                        children,
                        targetId
                    );

                if (found) return found;
            }

            return null;
        }

        function navigationItemContainsId(
            item: AnyDoc,
            id: string
        ): boolean {
            const targetId = String(id || "").trim();
            if (!item || !targetId) return false;

            if (String(item?.id || "") === targetId) {
                return true;
            }

            const children =
                Array.isArray(item?.items)
                    ? item.items
                    : [];

            return children.some(
                (child: AnyDoc) =>
                    navigationItemContainsId(
                        child,
                        targetId
                    )
            );
        }


        interface GenericObjectLocation {
            object: AnyDoc;
            parent: AnyDoc | null;
            collectionName: string | null;
            array: AnyDoc[] | null;
            index: number;
        }

        interface GenericModelContext {
            application: AnyDoc;
            objects: AnyDoc[];
            enums: AnyDoc[];
            navigationItems: AnyDoc[];
        }

        function getGenericMetamodelCollection(
            parent: AnyDoc,
            collectionName: string
        ): AnyDoc | null {
            const schema =
                getSchemaForObject(parent);

            const schemaCollections: AnyDoc[] =
                Array.isArray(schema?.Collections)
                    ? schema.Collections
                    : [];

            const ownCollections: AnyDoc[] =
                Array.isArray(parent?.Collections)
                    ? parent.Collections
                    : [];

            return (
                schemaCollections
                    .concat(ownCollections)
                    .find(
                        (collection: AnyDoc) =>
                            String(collection?.Name || "") ===
                            String(collectionName || "")
                    ) ||
                null
            );
        }

        function getGenericCollectionArray(
            parent: AnyDoc,
            collectionName: string,
            createIfMissing: boolean,
            context?: GenericModelContext
        ): AnyDoc[] {
            const name =
                String(collectionName || "").trim();

            if (!parent || !name) return [];

            if (
                context &&
                parent === context.application
            ) {
                if (
                    name === "Types" ||
                    name === "Entities"
                ) {
                    return context.objects;
                }

                if (name === "Enums") {
                    return context.enums;
                }

                if (
                    name === "NavigationItems" ||
                    name === "Navigation"
                ) {
                    return context.navigationItems;
                }
            }

            const storageName =
                name === "Items"
                    ? "items"
                    : name;

            if (
                Array.isArray(parent[storageName])
            ) {
                return parent[storageName];
            }

            if (
                storageName !== name &&
                Array.isArray(parent[name])
            ) {
                return parent[name];
            }

            if (!createIfMissing) return [];

            parent[storageName] = [];
            return parent[storageName];
        }

        function findGenericObjectInArray(
            items: AnyDoc[],
            objectId: string,
            parent: AnyDoc | null,
            collectionName: string | null,
            visited: WeakSet<object>
        ): GenericObjectLocation | null {
            for (
                let index = 0;
                index < items.length;
                index++
            ) {
                const item = items[index];

                if (
                    !item ||
                    typeof item !== "object"
                ) {
                    continue;
                }

                if (
                    String(item.id || "") ===
                    objectId
                ) {
                    return {
                        object: item,
                        parent,
                        collectionName,
                        array: items,
                        index
                    };
                }

                const nested =
                    findGenericObjectRecursive(
                        item,
                        objectId,
                        visited
                    );

                if (nested) return nested;
            }

            return null;
        }

        function findGenericObjectRecursive(
            owner: AnyDoc,
            objectId: string,
            visited: WeakSet<object>
        ): GenericObjectLocation | null {
            if (
                !owner ||
                typeof owner !== "object" ||
                visited.has(owner)
            ) {
                return null;
            }

            visited.add(owner);

            if (
                String(owner.id || "") ===
                objectId
            ) {
                return {
                    object: owner,
                    parent: null,
                    collectionName: null,
                    array: null,
                    index: -1
                };
            }

            const keys =
                Object.keys(owner);

            for (
                let keyIndex = 0;
                keyIndex < keys.length;
                keyIndex++
            ) {
                const key =
                    keys[keyIndex];

                if (key.startsWith("__")) {
                    continue;
                }

                const value =
                    owner[key];

                if (!Array.isArray(value)) {
                    continue;
                }

                const nested =
                    findGenericObjectInArray(
                        value,
                        objectId,
                        owner,
                        key === "items"
                            ? "Items"
                            : key,
                        visited
                    );

                if (nested) return nested;
            }

            return null;
        }

        function findGenericObject(
            context: GenericModelContext,
            objectId: string
        ): GenericObjectLocation | null {
            const id =
                String(objectId || "").trim();

            if (!id) return null;

            if (
                String(context.application?.id || "") === id ||
                String(runtime?.id || "") === id
            ) {
                return {
                    object: context.application,
                    parent: null,
                    collectionName: null,
                    array: null,
                    index: -1
                };
            }

            const visited =
                new WeakSet<object>();

            const roots = [
                {
                    items:
                        context.objects,
                    collection:
                        "Types"
                },
                {
                    items:
                        context.enums,
                    collection:
                        "Enums"
                },
                {
                    items:
                        context.navigationItems,
                    collection:
                        "NavigationItems"
                }
            ];

            for (
                let index = 0;
                index < roots.length;
                index++
            ) {
                const found =
                    findGenericObjectInArray(
                        roots[index].items,
                        id,
                        context.application,
                        roots[index].collection,
                        visited
                    );

                if (found) return found;
            }

            return null;
        }

        function resolveGenericOperationParent(
            operation: AnyDoc,
            context: GenericModelContext,
            temporaryObjects: Record<string, AnyDoc>
        ): AnyDoc {
            if (operation?.ParentId) {
                const location =
                    findGenericObject(
                        context,
                        String(operation.ParentId)
                    );

                if (!location) {
                    throw new Error(
                        `ParentId "${operation.ParentId}" was not found.`
                    );
                }

                return location.object;
            }

            const temporaryId =
                String(
                    operation?.ParentRef
                        ?.TemporaryId ||
                    ""
                ).trim();

            if (temporaryId) {
                const parent =
                    temporaryObjects[
                        temporaryId
                    ];

                if (!parent) {
                    throw new Error(
                        `ParentRef "${temporaryId}" was not resolved.`
                    );
                }

                return parent;
            }

            throw new Error(
                "ParentId or ParentRef is required."
            );
        }

        function prepareGenericAddedObject(
            parent: AnyDoc,
            collectionName: string,
            source: AnyDoc
        ): AnyDoc {
            const value =
                cloneData(source || {});

            if (!value.id) {
                value.id =
                    new DevExpress
                        .data
                        .Guid()
                        .toString();
            }

            const collection =
                getGenericMetamodelCollection(
                    parent,
                    collectionName
                );

            if (
                collection &&
                !value._type
            ) {
                const concreteType =
                    getConcreteTypeForItemEntity(
                        collection.ItemEntity
                    );

                if (concreteType) {
                    value._type =
                        concreteType;
                }
            }

            if (
                runtime.id &&
                !value._partitionId
            ) {
                value._partitionId =
                    runtime.id;
            }

            return value;
        }

        function objectExistsInGenericArrayTree(
            items: AnyDoc[],
            target: AnyDoc,
            visited?: WeakSet<object>
        ): boolean {
            const seen =
                visited ||
                new WeakSet<object>();

            for (
                let index = 0;
                index < items.length;
                index++
            ) {
                const item =
                    items[index];

                if (
                    !item ||
                    typeof item !== "object"
                ) {
                    continue;
                }

                if (
                    item === target ||
                    (
                        target?.id &&
                        item?.id &&
                        String(item.id) ===
                        String(target.id)
                    )
                ) {
                    return true;
                }

                if (seen.has(item)) {
                    continue;
                }

                seen.add(item);

                const children =
                    Array.isArray(item.items)
                        ? item.items
                        : [];

                if (
                    objectExistsInGenericArrayTree(
                        children,
                        target,
                        seen
                    )
                ) {
                    return true;
                }
            }

            return false;
        }

        function isGenericNavigationObject(
            parent: AnyDoc,
            context: GenericModelContext
        ): boolean {
            return !!(
                parent &&
                objectExistsInGenericArrayTree(
                    context.navigationItems,
                    parent
                )
            );
        }

        function validateGenericCollectionExists(
            parent: AnyDoc,
            collectionName: string,
            context: GenericModelContext
        ): void {
            const name =
                String(
                    collectionName ||
                    ""
                ).trim();

            if (
                parent === context.application &&
                (
                    name === "Types" ||
                    name === "Entities" ||
                    name === "Enums" ||
                    name === "NavigationItems" ||
                    name === "Navigation"
                )
            ) {
                return;
            }

            // Legacy runtime Menu objects do not necessarily carry enough
            // type metadata for getSchemaForObject() to resolve MetaEntity=Menu.
            // Their position inside Application.NavigationItems is authoritative:
            // every navigation object may own Menu.Items.
            if (
                name === "Items" &&
                isGenericNavigationObject(
                    parent,
                    context
                )
            ) {
                return;
            }

            if (
                !getGenericMetamodelCollection(
                    parent,
                    name
                )
            ) {
                throw new Error(
                    `Collection "${name}" is not available on ${nameOf(parent)}.`
                );
            }
        }

        function applyGenericOperation(
            operation: AnyDoc,
            context: GenericModelContext,
            temporaryObjects: Record<string, AnyDoc>,
            operationIndex: number
        ): boolean {
            const kind =
                String(operation?.Type || "");

            if (
                kind !== "AddObject" &&
                kind !== "UpdateObject" &&
                kind !== "MoveObject" &&
                kind !== "DeleteObject"
            ) {
                return false;
            }

            if (kind === "AddObject") {
                const parent =
                    resolveGenericOperationParent(
                        operation,
                        context,
                        temporaryObjects
                    );
                const collectionName =
                    String(
                        operation?.Collection ||
                        ""
                    ).trim();

                if (!collectionName) {
                    throw new Error(
                        `Operation ${operationIndex + 1}: AddObject requires Collection.`
                    );
                }

                validateGenericCollectionExists(
                    parent,
                    collectionName,
                    context
                );

                const value =
                    prepareGenericAddedObject(
                        parent,
                        collectionName,
                        operation?.Object
                    );

                getGenericCollectionArray(
                    parent,
                    collectionName,
                    true,
                    context
                ).push(value);

                const temporaryId =
                    String(
                        operation?.TemporaryId ||
                        ""
                    ).trim();

                if (temporaryId) {
                    temporaryObjects[
                        temporaryId
                    ] = value;
                }

                return true;
            }

            const objectId =
                String(
                    operation?.ObjectId ||
                    ""
                ).trim();

            if (!objectId) {
                throw new Error(
                    `Operation ${operationIndex + 1}: ${kind} requires ObjectId.`
                );
            }

            const location =
                findGenericObject(
                    context,
                    objectId
                );

            if (!location) {
                throw new Error(
                    `Operation ${operationIndex + 1}: object "${objectId}" was not found.`
                );
            }

            if (kind === "UpdateObject") {
                const changes =
                    cloneData(
                        operation?.Changes ||
                        {}
                    );

                delete changes.id;

                Object.keys(changes)
                    .forEach(
                        (key: string) => {
                            location.object[key] =
                                changes[key];
                        }
                    );

                return true;
            }

            if (kind === "DeleteObject") {
                if (
                    !location.array ||
                    location.index < 0
                ) {
                    throw new Error(
                        `Operation ${operationIndex + 1}: object "${objectId}" cannot be deleted from its current location.`
                    );
                }

                location.array.splice(
                    location.index,
                    1
                );

                return true;
            }

            const parent =
                resolveGenericOperationParent(
                    operation,
                    context,
                    temporaryObjects
                );
            const collectionName =
                String(
                    operation?.Collection ||
                    ""
                ).trim();

            if (!collectionName) {
                throw new Error(
                    `Operation ${operationIndex + 1}: MoveObject requires Collection.`
                );
            }

            if (
                location.object === parent
            ) {
                throw new Error(
                    `Operation ${operationIndex + 1}: object cannot be moved into itself.`
                );
            }

            validateGenericCollectionExists(
                parent,
                collectionName,
                context
            );

            if (
                !location.array ||
                location.index < 0
            ) {
                throw new Error(
                    `Operation ${operationIndex + 1}: object "${objectId}" cannot be detached.`
                );
            }

            const moved =
                location.array.splice(
                    location.index,
                    1
                )[0];

            getGenericCollectionArray(
                parent,
                collectionName,
                true,
                context
            ).push(moved);

            return true;
        }

        function applyAIPlanInMemory(plan: AnyDoc): void {
            console.warn("[DesignerAI BUILD 20261029-PIPELINE-TRACE-1] applying", (plan?.Operations || []).length, "operations before normalization");
            // Last line of defense for plans generated before normalization,
            // and for reverse collections synthesized after the initial LLM response.
            removeDuplicateGeneratedCollections(plan);
            console.warn("[DesignerAI BUILD 20261029-SCRIPT-NAVIGATION-1] normalized", (plan?.Operations || []).length,
                "operations; remaining AddCollection:", (plan?.Operations || []).filter((x: AnyDoc) => x?.Type === "AddCollection").length);
            const validation = validateAIPlanReferences(plan);

            if (!validation.IsValid) {
                throw new Error(formatAIPlanValidationIssues(validation));
            }

            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];

            // Work only with detached staged copies. runtime is changed only after every
            // operation has completed successfully, so a failure leaves the model intact.
            const stagedObjects = cloneData(getRuntimeObjectsArray(false));
            const stagedEnums = cloneData(getRuntimeEnumsArray(false));
            const stagedNavigationItems = cloneData(
                getRuntimeNavigationItemsArray(false)
            );

            const typeTemporaryIds: Record<string, string> = {};
            const enumTemporaryIds: Record<string, string> = {};
            const navigationTemporaryIds: Record<string, string> = {};
            const genericTemporaryObjects: Record<string, AnyDoc> = {};
            // Track only members created by this plan. An existing model member
            // must never be silently treated as a duplicate generated operation.
            const generatedMemberKinds = new Map<string, string>();
            const memberKey = (ownerId: string, name: string): string =>
                JSON.stringify([ownerId, String(name || "").toLowerCase()]);
            const equivalentGeneratedCollection = (
                ownerId: string, existing: AnyDoc, incoming: AnyDoc,
                incomingKind: string
            ): boolean => {
                const priorKind = generatedMemberKinds.get(memberKey(ownerId, existing?.Name));
                return !!priorKind && priorKind !== incomingKind &&
                    ((priorKind === "AddProperty" && incomingKind === "AddCollection") ||
                     (priorKind === "AddCollection" && incomingKind === "AddProperty")) &&
                    existing?.Many === true && incoming?.Many === true &&
                    String(existing?.Aggregation || "").toLowerCase() ===
                        String(incoming?.Aggregation || "").toLowerCase() &&
                    String(existing?.Type || "") === String(incoming?.Type || "");
            };
            const stagedApplication =
                cloneData(
                    applicationDoc ||
                    {}
                );


            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type === "AddType") {
                    const newType = createRuntimeTypeFromAIOperation(operation);
                    const temporaryId = String(operation.TemporaryId || "");

                    if (!temporaryId) throw new Error("AddType.TemporaryId is required.");
                    if (typeTemporaryIds[temporaryId]) throw new Error(`Duplicate AddType TemporaryId "${temporaryId}".`);
                    if (stagedObjects.some((x: AnyDoc) => x?.Name === newType.Name)) {
                        throw new Error(`Type "${newType.Name}" already exists.`);
                    }

                    typeTemporaryIds[temporaryId] = newType.id;
                    stagedObjects.push(newType);
                }

                if (operation?.Type === "AddNavigationGroup") {
                    const definition = cloneData(
                        operation?.NavigationItem || {}
                    );
                    const temporaryId = String(
                        operation?.TemporaryId || ""
                    );
                    const name = String(
                        definition?.Name || ""
                    ).trim();

                    if (!temporaryId || !name) {
                        throw new Error(
                            "AddNavigationGroup requires TemporaryId and NavigationItem.Name."
                        );
                    }

                    const existingGroup = stagedNavigationItems.find(
                        (item: AnyDoc) =>
                            item?.IsGroup === true &&
                            (
                                String(item?.Name || "")
                                    .toLowerCase() ===
                                name.toLowerCase() ||
                                (
                                    definition.Caption &&
                                    String(item?.Caption || "")
                                        .toLowerCase() ===
                                    String(definition.Caption)
                                        .toLowerCase()
                                )
                            )
                    );

                    if (existingGroup) {
                        navigationTemporaryIds[temporaryId] =
                            String(existingGroup.id);
                    } else {
                        const newGroup = {
                            id: new DevExpress.data.Guid().toString(),
                            Name: name,
                            Caption:
                                definition.Caption || name,
                            Description:
                                definition.Description || "",
                            Index:
                                definition.Index ?? null,
                            Icon:
                                definition.Icon || null,
                            Folder:
                                definition.Folder || null,
                            IsGroup: true,
                            items: []
                        };

                        navigationTemporaryIds[temporaryId] =
                            newGroup.id;
                        stagedNavigationItems.push(newGroup);
                    }
                }

                if (operation?.Type === "AddEnum") {
                    const newEnum = createRuntimeEnumFromAIOperation(operation);
                    const temporaryId = String(operation.TemporaryId || "");

                    if (!temporaryId) throw new Error("AddEnum.TemporaryId is required.");
                    if (enumTemporaryIds[temporaryId]) throw new Error(`Duplicate AddEnum TemporaryId "${temporaryId}".`);
                    if (stagedEnums.some((x: AnyDoc) => x?.Name === newEnum.Name)) {
                        throw new Error(`Enum "${newEnum.Name}" already exists.`);
                    }

                    enumTemporaryIds[temporaryId] = newEnum.id;
                    stagedEnums.push(newEnum);
                }
            });

            operations.forEach((operation: AnyDoc, index: number) => {
                if (operation?.Type !== "AddType") return;

                const temporaryId =
                    String(operation?.TemporaryId || "");
                const newTypeId =
                    typeTemporaryIds[temporaryId];
                const newType =
                    stagedObjects.find(
                        (typeDoc: AnyDoc) =>
                            String(typeDoc?.id || "") ===
                            String(newTypeId || "")
                    );

                if (!newType) return;

                const rawBaseType =
                    operation?.Entity?.BaseType ||
                    operation?.BaseType ||
                    null;

                if (!rawBaseType) return;

                if (typeof rawBaseType === "object") {
                    newType.BaseType =
                        resolveAIApplyReferenceId(
                            rawBaseType,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.Entity.BaseType`
                        );
                } else {
                    const baseValue =
                        String(rawBaseType);

                    const existingBase =
                        stagedObjects.find(
                            (typeDoc: AnyDoc) =>
                                String(typeDoc?.id || "") ===
                                baseValue ||
                                String(typeDoc?.Name || "") ===
                                baseValue
                        );

                    newType.BaseType =
                        existingBase?.id ||
                        baseValue;
                }
            });

            operations.forEach((operation: AnyDoc, index: number) => {
                const kind = String(operation?.Type || "");

                if (
                    kind === "AddType" ||
                    kind === "AddEnum" ||
                    kind === "AddNavigationGroup"
                ) return;

                if (kind === "AddNavigationItem") {
                    const definition = cloneData(
                        operation?.NavigationItem || {}
                    );
                    const target =
                        getAINavigationTarget(operation);
                    const scriptMode =
                        isAIScriptNavigationItem(operation);
                    const navigationScript =
                        getAINavigationScript(operation);

                    let targetTypeId: string | null = null;
                    let targetViewId: string | null = null;

                    if (!scriptMode && target.EntityId) {
                        targetTypeId = String(target.EntityId);
                    } else if (!scriptMode && target.EntityRef) {
                        const rawTemporaryId = String(
                            target.EntityRef?.TemporaryId || ""
                        );
                        let normalizedRef = target.EntityRef;

                        if (
                            rawTemporaryId &&
                            !typeTemporaryIds[rawTemporaryId]
                        ) {
                            const matchingTypeOperation =
                                operations.find(
                                    (candidate: AnyDoc) =>
                                        candidate?.Type ===
                                        "AddType" &&
                                        String(
                                            candidate?.Entity
                                                ?.Name || ""
                                        ) === rawTemporaryId
                                );

                            if (matchingTypeOperation) {
                                normalizedRef = {
                                    TemporaryId:
                                        String(
                                            matchingTypeOperation
                                                .TemporaryId
                                        )
                                };
                            }
                        }

                        targetTypeId = resolveAIApplyReferenceId(
                            normalizedRef,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.EntityRef`
                        );
                    } else if (!scriptMode && target.ViewId) {
                        targetViewId = String(target.ViewId);
                    } else if (!scriptMode && target.ViewRef?.TemporaryId) {
                        targetViewId = String(
                            target.ViewRef.TemporaryId
                        );
                    }

                    const parentId =
                        operation?.ParentId
                            ? String(operation.ParentId)
                            : (
                                operation?.ParentRef?.TemporaryId
                                    ? navigationTemporaryIds[
                                    String(
                                        operation.ParentRef.TemporaryId
                                    )
                                    ]
                                    : null
                            );

                    const targetTypeDoc = targetTypeId
                        ? stagedObjects.find(
                            (typeDoc: AnyDoc) =>
                                String(typeDoc?.id || "") ===
                                String(targetTypeId)
                        ) || null
                        : null;

                    const targetTypeName = String(
                        targetTypeDoc?.Name || ""
                    ).trim();
                    const targetTypeCaption = String(
                        targetTypeDoc?.Caption ||
                        targetTypeDoc?.Name ||
                        ""
                    ).trim();

                    const generatedName = String(
                        definition.Name || ""
                    ).trim();
                    const isGenericNavigationName =
                        !generatedName ||
                        /^Navigation\d+$/i.test(generatedName);

                    const navigationName =
                        isGenericNavigationName &&
                            targetTypeName
                            ? targetTypeName
                            : (
                                generatedName ||
                                `Navigation${index + 1}`
                            );

                    const navigationCaption =
                        String(
                            definition.Caption || ""
                        ).trim() ||
                        targetTypeCaption ||
                        navigationName;

                    const newItem = {
                        id: new DevExpress.data.Guid().toString(),

                        // Runtime NavigationItem contract:
                        // Type is the technical name of the type whose
                        // ListView must be opened. TargetType / EntityId are
                        // retained only as designer-side compatibility data.
                        Name: navigationName,
                        Caption: navigationCaption,
                        Type:
                            scriptMode
                                ? "<js>"
                                : (
                                    targetTypeName ||
                                    definition.Type ||
                                    null
                                ),
                        js:
                            scriptMode
                                ? navigationScript
                                : undefined,

                        Description:
                            definition.Description || "",
                        Index:
                            definition.Index ?? null,
                        Icon:
                            definition.Icon || null,
                        Folder:
                            definition.Folder || null,
                        ParentId:
                            parentId || null,
                        BeginGroup:
                            definition.BeginGroup === true,
                        Permission:
                            definition.Permission || "Default",

                        TargetType:
                            scriptMode
                                ? null
                                : (targetTypeId || null),
                        EntityId:
                            scriptMode
                                ? null
                                : (targetTypeId || null),
                        ViewId:
                            scriptMode
                                ? null
                                : (targetViewId || null),
                        ViewType:
                            scriptMode
                                ? null
                                : "ListView",
                        IncludeDerivedTypes:
                            scriptMode
                                ? false
                                : definition.IncludeDerivedTypes === true
                    };

                    navigationTemporaryIds[
                        String(operation?.TemporaryId || "")
                    ] = newItem.id;

                    appendNavigationItemToParent(
                        stagedNavigationItems,
                        newItem,
                        parentId
                    );
                    return;
                }


                if (
                    applyGenericOperation(
                        operation,
                        {
                            application:
                                stagedApplication,
                            objects:
                                stagedObjects,
                            enums:
                                stagedEnums,
                            navigationItems:
                                stagedNavigationItems
                        },
                        genericTemporaryObjects,
                        index
                    )
                ) {
                    return;
                }

                if (kind === "MoveNavigationItem") {
                    const navigationItemId =
                        String(operation?.NavigationItemId || "").trim();

                    const currentItem =
                        findNavigationItemRecursive(
                            stagedNavigationItems,
                            navigationItemId
                        );

                    if (!currentItem) {
                        throw new Error(
                            `Operation ${index + 1}: navigation item "${navigationItemId}" was not found.`
                        );
                    }

                    const parentId =
                        operation?.ParentId
                            ? String(operation.ParentId)
                            : (
                                operation?.ParentRef?.TemporaryId
                                    ? navigationTemporaryIds[
                                        String(operation.ParentRef.TemporaryId)
                                    ]
                                    : null
                            );

                    if (!parentId) {
                        throw new Error(
                            `Operation ${index + 1}: MoveNavigationItem destination was not resolved.`
                        );
                    }

                    const parent =
                        findNavigationItemRecursive(
                            stagedNavigationItems,
                            parentId
                        );

                    if (!parent) {
                        throw new Error(
                            `Operation ${index + 1}: navigation parent "${parentId}" was not found.`
                        );
                    }

                    if (
                        navigationItemContainsId(
                            currentItem,
                            parentId
                        )
                    ) {
                        throw new Error(
                            `Operation ${index + 1}: navigation item cannot be moved into itself or its descendant.`
                        );
                    }

                    const detached =
                        detachNavigationItemRecursive(
                            stagedNavigationItems,
                            navigationItemId
                        );

                    if (!detached) {
                        throw new Error(
                            `Operation ${index + 1}: navigation item "${navigationItemId}" could not be detached.`
                        );
                    }

                    appendNavigationItemToParent(
                        stagedNavigationItems,
                        detached,
                        parentId
                    );

                    return;
                }

                if (kind === "UpdateType") {
                    const owner = findStagedTypeById(
                        stagedObjects,
                        String(operation.EntityId || ""),
                        `Operation ${index + 1}`
                    );
                    const changes = cloneData(operation.Changes || {});

                    if (
                        changes.BaseType &&
                        typeof changes.BaseType === "object"
                    ) {
                        changes.BaseType = resolveAIApplyReferenceId(
                            changes.BaseType,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.Changes.BaseType`
                        );
                    }

                    Object.assign(owner, changes);
                    return;
                }

                if (kind === "AddProperty") {
                    const ownerId = operation.EntityId
                        ? String(operation.EntityId)
                        : resolveAIApplyReferenceId(
                            operation.EntityRef,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.EntityRef`
                        );

                    const owner = findStagedTypeById(stagedObjects, ownerId, `Operation ${index + 1}`);
                    const property = normalizeAIPropertyForRuntime(
                        operation.Property,
                        typeTemporaryIds,
                        enumTemporaryIds,
                        stagedEnums
                    );

                    owner.Properties = Array.isArray(owner.Properties) ? owner.Properties : [];

                    const existing = owner.Properties.find((x: AnyDoc) =>
                        String(x?.Name || "") === String(property.Name));
                    if (existing) {
                        if (equivalentGeneratedCollection(ownerId, existing, property, kind)) {
                            // AddProperty is the canonical, richer definition.
                            // Replace an earlier legacy AddCollection in-place.
                            if (generatedMemberKinds.get(memberKey(ownerId, property.Name)) === "AddCollection") {
                                owner.Properties[owner.Properties.indexOf(existing)] = property;
                                generatedMemberKinds.set(memberKey(ownerId, property.Name), kind);
                            }
                            console.info("[DesignerAI] Skipped equivalent duplicate member:", owner.Name, property.Name);
                            return;
                        }
                        throw new Error(`Operation ${index + 1}: property ${owner.Name}.${property.Name} already exists.`);
                    }

                    owner.Properties.push(property);
                    generatedMemberKinds.set(memberKey(ownerId, property.Name), kind);
                    return;
                }

                if (kind === "AddCollection") {
                    const ownerId = operation.EntityId
                        ? String(operation.EntityId)
                        : resolveAIApplyReferenceId(
                            operation.EntityRef,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.EntityRef`
                        );

                    const owner = findStagedTypeById(
                        stagedObjects,
                        ownerId,
                        `Operation ${index + 1}`
                    );
                    const property = normalizeAICollectionForRuntime(
                        operation.Collection,
                        typeTemporaryIds,
                        enumTemporaryIds
                    );

                    owner.Properties = Array.isArray(owner.Properties)
                        ? owner.Properties
                        : [];

                    const existing = owner.Properties.find((x: AnyDoc) =>
                        String(x?.Name || "") === String(property.Name));
                    if (existing) {
                        if (equivalentGeneratedCollection(ownerId, existing, property, kind)) {
                            console.info("[DesignerAI] Skipped equivalent duplicate member:", owner.Name, property.Name);
                            return;
                        }
                        throw new Error(
                            `Operation ${index + 1}: property ${owner.Name}.${property.Name} already exists.`
                        );
                    }

                    owner.Properties.push(property);
                    generatedMemberKinds.set(memberKey(ownerId, property.Name), kind);
                    return;
                }

                if (kind === "UpdateProperty") {
                    const owner = findStagedTypeById(
                        stagedObjects,
                        String(operation.EntityId || ""),
                        `Operation ${index + 1}`
                    );
                    const properties = Array.isArray(owner.Properties) ? owner.Properties : [];
                    const property = properties.find((x: AnyDoc) =>
                        String(x?.id || "") === String(operation.PropertyId || "")
                    );

                    if (!property) {
                        throw new Error(`Operation ${index + 1}: property "${operation.PropertyId}" was not found in ${owner.Name}.`);
                    }

                    Object.assign(property, cloneData(operation.Changes || {}));
                    return;
                }

                if (kind === "UpdateCollection") {
                    const owner = findStagedTypeById(
                        stagedObjects,
                        String(operation.EntityId || ""),
                        `Operation ${index + 1}`
                    );
                    const properties = Array.isArray(owner.Properties)
                        ? owner.Properties
                        : [];
                    const property = properties.find((x: AnyDoc) =>
                        String(x?.id || "") === String(operation.CollectionId || "") &&
                        x?.Many === true
                    );

                    if (!property) {
                        throw new Error(
                            `Operation ${index + 1}: collection property "${operation.CollectionId}" was not found in ${owner.Name}.`
                        );
                    }

                    const changes = cloneData(operation.Changes || {});

                    if (changes.ItemEntity && !changes.Type) {
                        changes.Type = changes.ItemEntity;
                    }
                    delete changes.ItemEntity;

                    if (changes.Type && typeof changes.Type === "object") {
                        changes.Type = resolveAIApplyReferenceId(
                            changes.Type,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.Changes.Type`
                        );
                    }

                    changes.Many = true;
                    Object.assign(property, changes);
                    return;
                }

                if (
                    kind === "AddRule" ||
                    kind === "AddAction" ||
                    kind === "AddEvent"
                ) {
                    const suffix =
                        kind.substring(3) as
                            "Rule" | "Action" | "Event";
                    const owner =
                        findAIBehaviorOwner(
                            stagedObjects,
                            operation,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}`
                        );

                    if (
                        suffix === "Action" &&
                        owner.Container !== owner.TypeDoc
                    ) {
                        throw new Error(
                            `Operation ${index + 1}: actions are supported only on Type.Actions in the legacy runtime format.`
                        );
                    }

                    const collectionName =
                        getAIBehaviorCollectionName(kind);
                    const items =
                        Array.isArray(
                            owner.Container[collectionName]
                        )
                            ? owner.Container[collectionName]
                            : (
                                owner.Container[
                                    collectionName
                                ] = []
                            );

                    const definition =
                        normalizeAIBehaviorDefinition(
                            getAIBehaviorDefinition(
                                operation
                            ),
                            suffix
                        );

                    if (
                        items.some(
                            (item: AnyDoc) =>
                                String(
                                    item?.Name || ""
                                ).toLowerCase() ===
                                String(
                                    definition.Name
                                ).toLowerCase()
                        )
                    ) {
                        throw new Error(
                            `Operation ${index + 1}: ${suffix} "${definition.Name}" already exists on ${owner.TypeDoc.Name}.`
                        );
                    }

                    items.push(definition);
                    return;
                }

                if (
                    kind === "UpdateRule" ||
                    kind === "UpdateAction" ||
                    kind === "UpdateEvent"
                ) {
                    const suffix =
                        kind.substring(6) as
                            "Rule" | "Action" | "Event";
                    const owner =
                        findAIBehaviorOwner(
                            stagedObjects,
                            operation,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}`
                        );

                    if (
                        suffix === "Action" &&
                        owner.Container !== owner.TypeDoc
                    ) {
                        throw new Error(
                            `Operation ${index + 1}: actions are supported only on Type.Actions in the legacy runtime format.`
                        );
                    }

                    const collectionName =
                        getAIBehaviorCollectionName(kind);
                    const items =
                        Array.isArray(
                            owner.Container[collectionName]
                        )
                            ? owner.Container[collectionName]
                            : [];

                    const targetId =
                        String(
                            operation?.[`${suffix}Id`] ||
                            ""
                        ).trim();
                    const targetName =
                        String(
                            operation?.[`${suffix}Name`] ||
                            ""
                        ).trim();

                    const item =
                        items.find(
                            (candidate: AnyDoc) =>
                                (
                                    targetId &&
                                    String(
                                        candidate?.id || ""
                                    ) === targetId
                                ) ||
                                (
                                    targetName &&
                                    String(
                                        candidate?.Name || ""
                                    ) === targetName
                                )
                        );

                    if (!item) {
                        throw new Error(
                            `Operation ${index + 1}: ${suffix} "${targetName || targetId}" was not found on ${owner.TypeDoc.Name}.`
                        );
                    }

                    Object.assign(
                        item,
                        cloneData(
                            operation?.Changes || {}
                        )
                    );
                    return;
                }

                throw new Error(`Operation ${index + 1}: unsupported operation type "${kind}".`);
            });

            const requiredLineOwners = operations
                .filter((operation: AnyDoc) =>
                    operation?.Type === "AddCollection" &&
                    String(operation?.Collection?.Name || "") === "Lines"
                )
                .map((operation: AnyDoc) => {
                    const ownerId = operation.EntityId
                        ? String(operation.EntityId)
                        : resolveAIApplyReferenceId(
                            operation.EntityRef,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            "Lines owner"
                        );

                    const owner = findStagedTypeById(
                        stagedObjects,
                        ownerId,
                        "Lines owner"
                    );

                    return owner.Name;
                });

            if (requiredLineOwners.length) {
                const missingLines = requiredLineOwners.filter((ownerName: string) => {
                    const owner = stagedObjects.find((item: AnyDoc) =>
                        String(item?.Name || "") === ownerName
                    );

                    return !owner ||
                        !Array.isArray(owner.Properties) ||
                        !owner.Properties.some((property: AnyDoc) =>
                            String(property?.Name || "") === "Lines" &&
                            property?.Many === true
                        );
                });

                if (missingLines.length) {
                    throw new Error(
                        `The following document types lost their Lines collection during staging: ${missingLines.join(", ")}.`
                    );
                }
            }

            // Verify all generated structural members before committing.
            operations.forEach((operation: AnyDoc, index: number) => {
                if (operation?.Type === "AddType") {
                    const temporaryId = String(operation.TemporaryId || "");
                    const typeId = typeTemporaryIds[temporaryId];
                    const typeName = String(operation?.Entity?.Name || temporaryId);

                    if (
                        !typeId ||
                        !stagedObjects.some((item: AnyDoc) =>
                            String(item?.id || "") === typeId
                        )
                    ) {
                        throw new Error(
                            `Operation ${index + 1}: generated type "${typeName}" is missing after staging.`
                        );
                    }
                }

                if (operation?.Type === "AddCollection") {
                    const ownerId = operation.EntityId
                        ? String(operation.EntityId)
                        : resolveAIApplyReferenceId(
                            operation.EntityRef,
                            typeTemporaryIds,
                            enumTemporaryIds,
                            `Operation ${index + 1}.EntityRef`
                        );

                    const owner = findStagedTypeById(
                        stagedObjects,
                        ownerId,
                        `Operation ${index + 1}`
                    );
                    const propertyName = String(
                        operation?.Collection?.Name || ""
                    );
                    const property = (owner.Properties || []).find(
                        (item: AnyDoc) =>
                            String(item?.Name || "") === propertyName &&
                            item?.Many === true
                    );

                    if (!property) {
                        throw new Error(
                            `Operation ${index + 1}: collection property ${owner.Name}.${propertyName} is missing after staging.`
                        );
                    }

                    if (property._type !== PROPERTY_TYPE) {
                        throw new Error(
                            `Operation ${index + 1}: ${owner.Name}.${propertyName} is not a Property.`
                        );
                    }

                    if (!property.Type) {
                        throw new Error(
                            `Operation ${index + 1}: ${owner.Name}.${propertyName} has no item Type.`
                        );
                    }

                    if (typeof property.StorageKind !== "number") {
                        throw new Error(
                            `Operation ${index + 1}: ${owner.Name}.${propertyName} has invalid StorageKind.`
                        );
                    }
                }
            });

            // Atomic commit: only this block mutates the runtime model.
            runtime.objects = stagedObjects;
            runtime.enums = stagedEnums;
            runtime.navigationItems = stagedNavigationItems;
            runtimeObjects = cloneData(stagedObjects);
            runtimeEnums = cloneData(stagedEnums);
            runtimeNavigationItems =
                cloneData(stagedNavigationItems);

            // applicationDoc is a detached projection created when the designer
            // opens. Recreate it so the tree reads the newly committed runtime
            // types and their nested Collections instead of stale references.
            applicationDoc = findApplicationDoc();

            projectDeclarationBundlePromise = null;
            treeItems = buildTree();

            const previouslySelectedDocumentId =
                selectedNode?.kind ===
                    "document"
                    ? String(
                        selectedNode.doc?.id ||
                        ""
                    )
                    : "";

            selectedNode =
                selectedNode?.id
                    ? findTreeNodeById(
                        treeItems,
                        selectedNode.id
                    )
                    : null;

            if (
                !selectedNode &&
                previouslySelectedDocumentId
            ) {
                selectedNode =
                    findTreeNodeByDocId(
                        treeItems,
                        previouslySelectedDocumentId
                    );
            }

            if (!selectedNode) {
                selectedNode =
                    treeItems.find(x => x.kind === "document" && x.doc === applicationDoc) ||
                    treeItems[0] ||
                    null;
            }

            selectedPropertyRow = null;

            if (tree) {
                tree.option("items", treeItems);
                if (selectedNode) tree.option("selectedItemKeys", [selectedNode.id]);
            }

            renderPropertyGrid();

            aiInMemoryApplyState = {
                Applied: true,
                OperationCount: operations.length,
                AppliedAt: new Date(),
                Message: String(plan?.Message || "Changes applied to the in-memory model."),
                AppliedPlanJson: JSON.stringify(plan)
            };

            renderAssistant();
        }

        function showAIPlanJSON(plan: AnyDoc): void {
            const $popup = $("<div>").appendTo(document.body);
            const json = JSON.stringify(plan, null, 4);
            let popup: any = null;
            let monacoEditor: any = null;
            let monacoModel: any = null;
            let fallbackTextArea: any = null;
            let $editorHost: JQuery | null = null;

            ($popup as any).dxPopup({
                title: "AI plan JSON",
                width: () =>
                    Math.min(window.innerWidth - 80, 1120),
                height: () =>
                    Math.min(window.innerHeight - 80, 780),
                minWidth: 720,
                minHeight: 440,
                showCloseButton: true,
                dragEnabled: true,
                resizeEnabled: true,
                contentTemplate: (contentElement: any) => {
                    const $content = $(contentElement).css({
                        height: "100%",
                        minHeight: 0,
                        padding: "10px",
                        boxSizing: "border-box",
                        overflow: "hidden"
                    });

                    $editorHost = $("<div>")
                        .css({
                            height: "100%",
                            width: "100%",
                            minHeight: 0,
                            border:
                                "1px solid rgba(128,128,128,.35)",
                            boxSizing: "border-box"
                        })
                        .appendTo($content);

                    const $loading = $("<div>")
                        .text("Loading Monaco editor...")
                        .css({
                            padding: "12px",
                            opacity: .72
                        })
                        .appendTo($editorHost);

                    ensureMonacoLoaded()
                        .then((monaco: any) => {
                            if (
                                !$editorHost ||
                                !$editorHost.length
                            ) {
                                return;
                            }

                            $loading.remove();

                            const modelUri = monaco.Uri.parse(
                                `inmemory://cosmoapps/ai-plan-${Date.now()}.json`
                            );

                            monacoModel =
                                monaco.editor.createModel(
                                    json,
                                    "json",
                                    modelUri
                                );

                            monacoEditor =
                                monaco.editor.create(
                                    $editorHost[0],
                                    {
                                        model: monacoModel,
                                        readOnly: true,
                                        language: "json",
                                        theme:
                                            getMonacoThemeName(),
                                        automaticLayout: true,
                                        minimap: {
                                            enabled: true
                                        },
                                        folding: true,
                                        lineNumbers: "on",
                                        wordWrap: "off",
                                        scrollBeyondLastLine:
                                            false,
                                        renderWhitespace:
                                            "selection",
                                        tabSize: 4
                                    }
                                );

                            window.setTimeout(
                                () =>
                                    monacoEditor?.layout?.(),
                                0
                            );
                        })
                        .catch((error: any) => {
                            console.warn(
                                "Monaco AI plan viewer failed; dxTextArea fallback will be used.",
                                error
                            );

                            if (
                                !$editorHost ||
                                !$editorHost.length
                            ) {
                                return;
                            }

                            $editorHost.empty();

                            ($editorHost as any)
                                .dxTextArea({
                                    value: json,
                                    readOnly: true,
                                    height: "100%",
                                    width: "100%",
                                    autoResizeEnabled: false
                                } as any);

                            fallbackTextArea =
                                ($editorHost as any)
                                    .dxTextArea(
                                        "instance"
                                    );
                        });
                },
                toolbarItems: [
                    {
                        toolbar: "bottom",
                        location: "before",
                        widget: "dxButton",
                        options: {
                            text: "Диаграмма изменений",
                            icon: "chart",
                            stylingMode: "outlined",
                            hint:
                                "Visualize all types and fields affected by this AI plan. Changed classes and fields are bold.",
                            onClick: () =>
                                showAIChangeDiagram(plan)
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "before",
                        widget: "dxButton",
                        options: {
                            text: "Копировать JSON",
                            icon: "copy",
                            stylingMode: "outlined",
                            onClick: () => {
                                copyTextToClipboard(json)
                                    .then(() =>
                                        DevExpress.ui.notify(
                                            "JSON плана скопирован в буфер обмена.",
                                            "success",
                                            2200
                                        )
                                    )
                                    .catch(() =>
                                        DevExpress.ui.notify(
                                            "Не удалось скопировать JSON плана.",
                                            "error",
                                            2600
                                        )
                                    );
                            }
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Закрыть",
                            icon: "close",
                            onClick: () =>
                                popup?.hide()
                        }
                    }
                ],
                onShown: () => {
                    window.setTimeout(
                        () =>
                            monacoEditor?.layout?.(),
                        0
                    );
                },
                onResize: () => {
                    monacoEditor?.layout?.();
                },
                onHidden: () => {
                    try {
                        monacoEditor?.dispose?.();
                    } catch { /* ignore */ }
                    try {
                        monacoModel?.dispose?.();
                    } catch { /* ignore */ }
                    try {
                        fallbackTextArea?.dispose?.();
                    } catch { /* ignore */ }
                    try {
                        popup?.dispose?.();
                    } catch { /* ignore */ }

                    $popup.remove();
                }
            } as any);

            popup = ($popup as any)
                .dxPopup("instance");
            popup.show();
        }

        function showAIApplyPreview(): void {
            const plan = getLatestAIPlan();
            const validation = validateAIPlanReferences(plan);

            if (!plan || !validation.IsValid) {
                const message = validation.Issues.length
                    ? formatAIPlanValidationIssues(validation)
                    : "Нет полного плана изменений для применения";

                DevExpress.ui.dialog.alert(message, "Некорректный план изменений ИИ");
                return;
            }

            const operations = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const $popup = $("<div>").appendTo(document.body);

            ($popup as any).dxPopup({
                title: "Подтверждение изменений",
                width: Math.min(760, Math.max(520, window.innerWidth - 80)),
                height: Math.min(720, Math.max(420, window.innerHeight - 80)),
                showCloseButton: true,
                dragEnabled: true,
                resizeEnabled: true,
                contentTemplate: (content: any) => {
                    const $content = $(content).addClass("ca-md-ai-apply-preview");
                    $("<div>")
                        .addClass("ca-md-ai-apply-summary")
                        .text(`The following ${operations.length} planned change${operations.length === 1 ? "" : "s"} will be applied to the current in-memory model. Nothing will be saved to the database.`)
                        .appendTo($content);

                    const scenarios: AnyDoc[] = Array.isArray(plan?.Scenarios) ? plan.Scenarios : [];
                    const capabilities: AnyDoc[] = Array.isArray(plan?.Capabilities) ? plan.Capabilities : [];

                    if (scenarios.length || capabilities.length) {
                        const $coverage = $("<div>")
                            .css({
                                margin: "0 0 12px 0",
                                padding: "10px",
                                border: "1px solid rgba(128,128,128,.22)",
                                borderRadius: "8px"
                            })
                            .appendTo($content);

                        $("<div>")
                            .css({ fontWeight: 700, marginBottom: "6px" })
                            .text("Покрытие бизнес-сценариев")
                            .appendTo($coverage);

                        scenarios.forEach((scenario: AnyDoc) => {
                            const missing = Array.isArray(scenario?.Missing) ? scenario.Missing : [];
                            $("<div>")
                                .text(`${missing.length ? "△" : "✓"} ${scenario?.Description || scenario?.Name || "Scenario"}`)
                                .appendTo($coverage);
                        });

                        capabilities.forEach((capability: AnyDoc) => {
                            const status = String(capability?.Status || "");
                            const mark =
                                status === "Implemented" ? "✓" :
                                    status === "PartiallyImplemented" ? "△" :
                                        status === "NotImplemented" ? "✗" : "•";

                            $("<div>")
                                .css({ opacity: .82, marginLeft: "14px" })
                                .text(`${mark} ${capability?.Name || "Capability"} — ${status || "Unknown"}`)
                                .appendTo($coverage);
                        });
                    }

                    operations.forEach((operation: AnyDoc, index: number) => {
                        const description = describeAIOperation(operation, index, operations);
                        const $item = $("<div>").addClass("ca-md-ai-operation").appendTo($content);
                        $("<div>").addClass("ca-md-ai-operation-title").text(`${index + 1}. ${description.Title}`).appendTo($item);
                        if (description.Detail) {
                            $("<div>").addClass("ca-md-ai-operation-detail").text(description.Detail).appendTo($item);
                        }
                    });
                },
                toolbarItems: [
                    {
                        toolbar: "bottom",
                        location: "before",
                        widget: "dxButton",
                        options: {
                            text: "Диаграмма изменений",
                            icon: "chart",
                            stylingMode: "outlined",
                            hint:
                                "Показать типы, перечисления, поля и связи, которые затронет этот план, до его применения.",
                            onClick: () =>
                                showAIChangeDiagram(plan)
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "before",
                        widget: "dxButton",
                        options: {
                            text: "Копировать JSON",
                            icon: "copy",
                            stylingMode: "outlined",
                            onClick: () => {
                                const json = JSON.stringify(plan, null, 2);
                                copyTextToClipboard(json)
                                    .then(() => DevExpress.ui.notify("JSON плана скопирован в буфер обмена.", "success", 2200))
                                    .catch(() => DevExpress.ui.notify("Не удалось скопировать JSON плана.", "error", 2600));
                            }
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Отмена",
                            stylingMode: "outlined",
                            onClick: () => ($popup as any).dxPopup("instance")?.hide()
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Применить в памяти",
                            icon: "check",
                            type: "success",
                            stylingMode: "contained",
                            onClick: () => {
                                try {
                                    applyAIPlanInMemory(plan);
                                    ($popup as any).dxPopup("instance")?.hide();
                                    DevExpress.ui.notify(
                                        `${operations.length} change${operations.length === 1 ? "" : "s"} applied in memory. Database was not changed.`,
                                        "success",
                                        3600
                                    );
                                } catch (error: any) {
                                    DevExpress.ui.dialog.alert(
                                        "No changes were applied. The model remains exactly as it was before this request.\n\n" +
                                        (error?.message || String(error)) + "\n\nDesigner build: 20261029-SCRIPT-NAVIGATION-1",
                                        "In-memory apply failed"
                                    );
                                }
                            }
                        }
                    }
                ],
                onHidden: () => $popup.remove()
            } as any).dxPopup("instance").show();
        }

        function getAssistantConversation(): AnyDoc[] {
            return aiMessages
                .filter(x => !x.Error)
                .slice(-12)
                .map(x => ({
                    Role: x.Role,
                    Content: x.Content
                }));
        }

        function scrollAssistantToBottom(): void {
            const body = document.getElementById(`${POPUP_ID}-ai-body`);
            if (body) body.scrollTop = body.scrollHeight;
        }

        function renderAssistant(): void {
            const $body = $(`#${POPUP_ID}-ai-body`);
            const $context = $(`#${POPUP_ID}-ai-context`);
            const $applyState = $(`#${POPUP_ID}-ai-apply-state`);

            if (!$body.length) return;

            const doc = selectedNode?.doc;
            const schema = doc ? getSchemaForObject(doc, selectedNode?.collection) : null;

            if ($context.length) {
                const modeName =
                    aiThinkingMode === "creative"
                        ? "Творческий"
                        : "Строгий";
                const projectContext = buildProjectAIContext();
                const businessMarker = projectContext.HasExplicitProjectBrief
                    ? " · описание проекта задано"
                    : projectContext.BusinessDescription || projectContext.RequirementsText
                        ? " · контекст проекта определён"
                        : " · описание проекта не задано";

                const $briefState = $(`#${POPUP_ID}-ai-project-brief-state`);
                if ($briefState.length) {
                    $briefState.text(
                        projectContext.HasExplicitProjectBrief
                            ? "Описание проекта задано. Бизнес-вопросы оцениваются в его контексте."
                            : "Описание проекта не задано. Общие темы отклоняются, если их связь с текущей моделью не очевидна."
                    );
                }

                $context.text(
                    selectedNode
                        ? `Режим: ${modeName} · ${selectedNode.text} · ${selectedNode.kind} · ${schema?.Name || "без схемы"}${businessMarker}`
                        : `Режим: ${modeName} · приложение${businessMarker}`
                );
            }

            if ($applyState.length) {
                $applyState.empty();

                if (aiInMemoryApplyState.Applied) {
                    $applyState.addClass("ca-md-ai-apply-state-visible");

                    $("<div>")
                        .addClass("ca-md-ai-apply-state-title")
                        .text("Применено в памяти — не сохранено")
                        .appendTo($applyState);

                    const appliedTime = aiInMemoryApplyState.AppliedAt
                        ? aiInMemoryApplyState.AppliedAt.toLocaleTimeString()
                        : "";

                    $("<div>")
                        .addClass("ca-md-ai-apply-state-detail")
                        .text(
                            `${aiInMemoryApplyState.OperationCount} change${aiInMemoryApplyState.OperationCount === 1 ? "" : "s"} applied` +
                            (appliedTime ? ` at ${appliedTime}` : "") +
                            ". The AI now sees this updated model. Reloading metadata discards these in-memory changes."
                        )
                        .appendTo($applyState);
                } else {
                    $applyState.removeClass("ca-md-ai-apply-state-visible");
                }
            }

            $body.empty();

            if (!aiMessages.length) {
                $("<div>")
                    .addClass("ca-md-ai-msg ca-md-ai-msg-assistant")
                    .text(
                        "Discuss the selected model, requirements, business processes or implementation. " +
                        "The assistant may ask clarifying questions and will propose model changes only when explicitly requested."
                    )
                    .appendTo($body);
            }

            const latestAssistantPlanIndex = (() => {
                for (let index = aiMessages.length - 1; index >= 0; index--) {
                    if (
                        aiMessages[index]?.Role === "assistant" &&
                        (
                            aiMessages[index]?.InternalPlan ||
                            aiMessages[index]?.Plan
                        )
                    ) {
                        return index;
                    }
                }

                return -1;
            })();

            aiMessages.forEach((message, messageIndex) => {
                const $message = $("<div>")
                    .addClass(
                        "ca-md-ai-msg " +
                        (message.Role === "user"
                            ? "ca-md-ai-msg-user"
                            : "ca-md-ai-msg-assistant") +
                        (message.Error ? " ca-md-ai-msg-error" : "")
                    )
                    .appendTo($body);

                $("<div>").text(message.Content).appendTo($message);

                if (
                    message.Error &&
                    message.ErrorReport
                ) {
                    const $errorActions =
                        $("<div>")
                            .css({
                                marginTop:
                                    "8px",
                                display:
                                    "flex",
                                gap:
                                    "6px"
                            })
                            .appendTo(
                                $message
                            );

                    const $reportButton =
                        $("<div>")
                            .appendTo(
                                $errorActions
                            );

                    $reportButton.dxButton({
                        text:
                            "Отчёт об ошибке",
                        icon:
                            "info",
                        stylingMode:
                            "outlined",
                        onClick:
                            () =>
                                openDesignerAIErrorReport(
                                    message.ErrorReport
                                )
                    } as any);
                }

                const plan = message.InternalPlan || message.Plan;
                const planJson = plan ? JSON.stringify(plan) : "";
                const wasApplied =
                    !!planJson &&
                    aiInMemoryApplyState.AppliedPlanJson === planJson;
                const canApplyThisPlan =
                    messageIndex === latestAssistantPlanIndex &&
                    !!plan &&
                    Array.isArray(plan.Operations) &&
                    plan.Operations.length > 0 &&
                    !plan.NeedsMoreContext &&
                    validateAIPlanReferences(plan).IsValid &&
                    !wasApplied;

                if (canApplyThisPlan || wasApplied) {
                    const $actions = $("<div>")
                        .addClass("ca-md-ai-msg-actions")
                        .appendTo($message);

                    const $diagramButton =
                        $("<div>").appendTo($actions);

                    ($diagramButton as any).dxButton({
                        text: "Диаграмма изменений",
                        icon: "chart",
                        stylingMode: "outlined",
                        disabled: aiRequestInProgress,
                        hint:
                            "Visualize every class and field affected by this plan before applying it.",
                        onClick: () =>
                            showAIChangeDiagram(plan)
                    } as any);

                    const $button = $("<div>").appendTo($actions);

                    ($button as any).dxButton({
                        text: wasApplied ? "Get JSON" : "Apply",
                        icon: wasApplied ? "codeblock" : "check",
                        type: wasApplied ? "normal" : "success",
                        stylingMode: wasApplied ? "outlined" : "contained",
                        disabled: aiRequestInProgress,
                        hint: wasApplied
                            ? "View the JSON plan that was applied."
                            : "Review and apply this plan to the in-memory model.",
                        onClick: () => {
                            if (wasApplied) {
                                showAIPlanJSON(plan);
                            } else {
                                showAIApplyPreview();
                            }
                        }
                    } as any);
                }
            });

            if (aiRequestInProgress) {
                const $thinking = $("<div>")
                    .addClass("ca-md-ai-msg ca-md-ai-msg-assistant ca-md-ai-thinking")
                    .appendTo($body);

                $("<span>").addClass("ca-md-ai-thinking-dot").appendTo($thinking);
                $("<span>").addClass("ca-md-ai-thinking-dot").appendTo($thinking);
                $("<span>").addClass("ca-md-ai-thinking-dot").appendTo($thinking);
                $("<span>").text("Thinking…").appendTo($thinking);
            }

            setTimeout(scrollAssistantToBottom, 0);
        }


        function formatAIConsultingSummary(plan: AnyDoc): string {
            const scenarios: AnyDoc[] = Array.isArray(plan?.Scenarios) ? plan.Scenarios : [];
            const capabilities: AnyDoc[] = Array.isArray(plan?.Capabilities) ? plan.Capabilities : [];
            const businessAnalysis: AnyDoc =
                plan?.BusinessAnalysis &&
                    typeof plan.BusinessAnalysis === "object"
                    ? plan.BusinessAnalysis
                    : {};
            const lines: string[] = [];

            const appendBusinessSection = (
                title: string,
                value: any
            ): void => {
                const items =
                    Array.isArray(value)
                        ? value
                            .map((item: any) =>
                                String(item || "").trim()
                            )
                            .filter(Boolean)
                        : [];

                if (!items.length) return;

                if (lines.length) lines.push("");
                lines.push(title);
                items.forEach(
                    (item: string) =>
                        lines.push(`• ${item}`)
                );
            };

            const isCreativePlan =
                String(plan?.ThinkingMode || "") === "creative" ||
                (
                    !plan?.ThinkingMode &&
                    aiThinkingMode === "creative"
                );

            if (isCreativePlan) {
                appendBusinessSection(
                    "Standard core:",
                    businessAnalysis.StandardCore
                );
                appendBusinessSection(
                    "Intentionally kept simple:",
                    businessAnalysis
                        .IntentionalSimplifications
                );
                appendBusinessSection(
                    "Where your pain is addressed:",
                    businessAnalysis.UserPain
                );
                appendBusinessSection(
                    "Distinctive requirements:",
                    businessAnalysis
                        .DistinctiveRequirements
                );
            }

            if (scenarios.length) {
                if (lines.length) lines.push("");
                lines.push("Scenarios:");
                scenarios.slice(0, 12).forEach((scenario: AnyDoc) => {
                    const missing = Array.isArray(scenario?.Missing) ? scenario.Missing : [];
                    lines.push(`${missing.length ? "△" : "✓"} ${scenario?.Description || scenario?.Name || "Scenario"}`);
                });
            }

            if (capabilities.length) {
                if (lines.length) lines.push("");
                lines.push("Capability coverage:");
                capabilities.slice(0, 16).forEach((capability: AnyDoc) => {
                    const status = String(capability?.Status || "");
                    const mark =
                        status === "Implemented" ? "✓" :
                            status === "PartiallyImplemented" ? "△" :
                                status === "NotImplemented" ? "✗" : "•";
                    lines.push(`${mark} ${capability?.Name || "Capability"} — ${status || "Unknown"}`);
                });
            }

            return lines.join("\n");
        }


        function normalizeDesignerAIPlan(plan: AnyDoc): AnyDoc {
            if (!plan || typeof plan !== "object") return plan;

            plan.BusinessAnalysis = plan.BusinessAnalysis && typeof plan.BusinessAnalysis === "object"
                ? plan.BusinessAnalysis
                : {};

            [
                "Actors", "ReferenceData", "Documents", "Lifecycles",
                "QuantitiesAndBalances", "DerivedValues", "Assumptions",
                "StandardCore", "IntentionalSimplifications",
                "UserPain", "DistinctiveRequirements",
                "DeliveryActivities"
            ].forEach(field => {
                if (!Array.isArray(plan.BusinessAnalysis[field])) {
                    plan.BusinessAnalysis[field] = [];
                }
            });

            plan.Scenarios = Array.isArray(plan.Scenarios) ? plan.Scenarios : [];
            plan.Capabilities = Array.isArray(plan.Capabilities) ? plan.Capabilities : [];
            plan.Operations = Array.isArray(plan.Operations) ? plan.Operations : [];

            const operations: AnyDoc[] = plan.Operations;
            const existingTypes = getAIApplicationTypeDocs();

            const usedTemporaryIds: Record<string, boolean> = {};
            operations.forEach((operation: AnyDoc) => {
                const temporaryId = String(operation?.TemporaryId || "").trim();
                if (temporaryId) usedTemporaryIds[temporaryId] = true;
            });

            const makeTemporaryId = (base: string): string => {
                let candidate = base;
                let suffix = 2;

                while (usedTemporaryIds[candidate]) {
                    candidate = `${base}-${suffix++}`;
                }

                usedTemporaryIds[candidate] = true;
                return candidate;
            };

            const toKebab = (value: string): string =>
                String(value || "")
                    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .replace(/^-+|-+$/g, "")
                    .toLowerCase();

            const getDefaultClosedChoiceValues = (
                ownerName: string,
                propertyName: string
            ): AnyDoc[] => {
                const owner =
                    String(ownerName || "").toLowerCase();
                const property =
                    String(propertyName || "").toLowerCase();

                if (
                    property === "type" &&
                    (
                        owner.indexOf("contact") >= 0 ||
                        owner.indexOf("communication") >= 0
                    )
                ) {
                    return [
                        {
                            Name: "Phone",
                            Caption: "Телефон",
                            Value: 0
                        },
                        {
                            Name: "Email",
                            Caption: "Email",
                            Value: 1
                        },
                        {
                            Name: "Messenger",
                            Caption: "Мессенджер",
                            Value: 2
                        },
                        {
                            Name: "Other",
                            Caption: "Другое",
                            Value: 3
                        }
                    ];
                }

                if (
                    property === "type" ||
                    property === "kind"
                ) {
                    return [
                        {
                            Name: "Primary",
                            Caption: "Основной",
                            Value: 0
                        },
                        {
                            Name: "Secondary",
                            Caption: "Дополнительный",
                            Value: 1
                        },
                        {
                            Name: "Other",
                            Caption: "Другое",
                            Value: 2
                        }
                    ];
                }

                return [
                    {
                        Name: "Default",
                        Caption: "По умолчанию",
                        Value: 0
                    },
                    {
                        Name: "Alternative",
                        Caption: "Альтернативный",
                        Value: 1
                    }
                ];
            };

            const getDefaultStatusValues = (ownerName: string): AnyDoc[] => {
                const owner = String(ownerName || "").toLowerCase();

                if (owner.indexOf("waybill") >= 0 ||
                    owner.indexOf("shipment") >= 0 ||
                    owner.indexOf("receipt") >= 0 ||
                    owner.indexOf("transfer") >= 0) {
                    return [
                        { Name: "Draft", Caption: "Черновик", Value: 0 },
                        { Name: "Posted", Caption: "Проведена", Value: 1 },
                        { Name: "Cancelled", Caption: "Отменена", Value: 2 }
                    ];
                }

                if (owner.indexOf("order") >= 0) {
                    return [
                        { Name: "Draft", Caption: "Черновик", Value: 0 },
                        { Name: "Confirmed", Caption: "Подтверждён", Value: 1 },
                        { Name: "Completed", Caption: "Выполнен", Value: 2 },
                        { Name: "Cancelled", Caption: "Отменён", Value: 3 }
                    ];
                }

                return [
                    { Name: "Draft", Caption: "Черновик", Value: 0 },
                    { Name: "Active", Caption: "Активен", Value: 1 },
                    { Name: "Completed", Caption: "Завершён", Value: 2 },
                    { Name: "Cancelled", Caption: "Отменён", Value: 3 }
                ];
            };

            // Deterministic repair for the most common incomplete business plan:
            // a lifecycle property named Status returned as a plain string.
            const generatedEnumsByOwner: Record<string, string> = {};
            const repairedOperations: AnyDoc[] = [];

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type === "AddProperty") {
                    const property = operation.Property || {};
                    const propertyName = String(property.Name || "");
                    const ownerRef = operation.EntityRef || operation.EntityId;
                    const ownerName =
                        getAIPlanTypeNameByRef(ownerRef, operations, existingTypes) ||
                        "Document";

                    if (
                        propertyName.toLowerCase() === "status" &&
                        isScalarStringType(property.Type)
                    ) {
                        const ownerKey = String(ownerName).toLowerCase();
                        let enumTemporaryId = generatedEnumsByOwner[ownerKey];

                        if (!enumTemporaryId) {
                            enumTemporaryId = makeTemporaryId(`${toKebab(ownerName)}-status`);
                            generatedEnumsByOwner[ownerKey] = enumTemporaryId;

                            repairedOperations.push({
                                Type: "AddEnum",
                                TemporaryId: enumTemporaryId,
                                Enum: {
                                    Name: `${ownerName}Status`,
                                    Caption: `${ownerName} status`,
                                    Values: getDefaultStatusValues(ownerName)
                                }
                            });

                            (plan as AnyDoc).__GeneratedAssumptions =
                                Array.isArray((plan as AnyDoc).__GeneratedAssumptions)
                                    ? (plan as AnyDoc).__GeneratedAssumptions
                                    : [];

                            (plan as AnyDoc).__GeneratedAssumptions.push(
                                `${ownerName}.Status was returned as string and was converted to a conventional enum lifecycle automatically.`
                            );
                        }

                        property.Type = { TemporaryId: enumTemporaryId };
                        delete property.Aggregation;
                    }

                    if (
                        propertyName.toLowerCase() !== "status" &&
                        isScalarStringType(property.Type) &&
                        (
                            isClosedChoicePropertyName(
                                propertyName
                            ) ||
                            isBusinessTypeChoiceProperty(
                                ownerName,
                                propertyName
                            )
                        )
                    ) {
                        const enumKey =
                            `${String(ownerName).toLowerCase()}.` +
                            String(propertyName).toLowerCase();

                        let enumTemporaryId =
                            generatedEnumsByOwner[enumKey];

                        if (!enumTemporaryId) {
                            enumTemporaryId =
                                makeTemporaryId(
                                    `${toKebab(ownerName)}-${toKebab(propertyName)}`
                                );

                            generatedEnumsByOwner[enumKey] =
                                enumTemporaryId;

                            repairedOperations.push({
                                Type: "AddEnum",
                                TemporaryId:
                                    enumTemporaryId,
                                Enum: {
                                    Name:
                                        `${ownerName}${propertyName}`,
                                    Caption:
                                        `${ownerName} ${propertyName}`,
                                    Values:
                                        getDefaultClosedChoiceValues(
                                            ownerName,
                                            propertyName
                                        )
                                }
                            });

                            (plan as AnyDoc)
                                .__GeneratedAssumptions =
                                Array.isArray(
                                    (plan as AnyDoc)
                                        .__GeneratedAssumptions
                                )
                                    ? (plan as AnyDoc)
                                        .__GeneratedAssumptions
                                    : [];

                            (plan as AnyDoc)
                                .__GeneratedAssumptions
                                .push(
                                    `${ownerName}.${propertyName} was returned as string and was converted to an enum automatically.`
                                );
                        }

                        property.Type = {
                            TemporaryId:
                                enumTemporaryId
                        };
                        delete property.Aggregation;
                    }
                }

                repairedOperations.push(operation);
            });

            // Ensure ordinary document/entity references are navigable in both
            // directions. The runtime stores the forward relation on the referencing
            // document; the reverse side is a Deferred collection.
            const resolveTypeRefByName = (typeName: string): any => {
                const generated = repairedOperations.find(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddType" &&
                        String(operation?.Entity?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );

                if (generated?.TemporaryId) {
                    return {
                        TemporaryId:
                            String(generated.TemporaryId)
                    };
                }

                const existing = existingTypes.find(
                    (typeDoc: AnyDoc) =>
                        String(typeDoc?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );

                return existing?.id
                    ? String(existing.id)
                    : null;
            };

            const pluralizeTechnicalName = (
                value: string
            ): string => {
                const name = String(value || "").trim();
                if (!name) return "Items";

                if (
                    /[^aeiou]y$/i.test(name)
                ) {
                    return name.replace(/y$/i, "ies");
                }

                if (
                    /(s|x|z|ch|sh)$/i.test(name)
                ) {
                    return name + "es";
                }

                return name + "s";
            };

            const getTypeCaptionPlural = (
                typeName: string
            ): string => {
                const generated = repairedOperations.find(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddType" &&
                        String(operation?.Entity?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );

                if (generated) {
                    return String(
                        generated?.Entity?.CaptionPlural ||
                        generated?.Entity?.Caption ||
                        pluralizeTechnicalName(typeName)
                    ).trim();
                }

                const existing = existingTypes.find(
                    (typeDoc: AnyDoc) =>
                        String(typeDoc?.Name || "")
                            .toLowerCase() ===
                        String(typeName || "").toLowerCase()
                );

                return String(
                    existing?.CaptionPlural ||
                    existing?.Caption ||
                    pluralizeTechnicalName(typeName)
                ).trim();
            };

            const isAggregatedChildType = (
                typeName: string
            ): boolean => {
                const target =
                    String(typeName || "").toLowerCase();

                const generatedOwnership =
                    repairedOperations.some(
                        (operation: AnyDoc) => {
                            if (
                                operation?.Type !== "AddCollection" &&
                                operation?.Type !== "AddProperty"
                            ) {
                                return false;
                            }

                            const member =
                                operation?.Type === "AddCollection"
                                    ? operation?.Collection
                                    : operation?.Property;

                            if (
                                String(member?.Aggregation || "") !==
                                "Aggregated"
                            ) {
                                return false;
                            }

                            const itemName =
                                getAIPlanTypeNameByRef(
                                    operation?.Type === "AddCollection"
                                        ? member?.ItemEntity
                                        : member?.Type,
                                    repairedOperations,
                                    existingTypes
                                );

                            return (
                                String(
                                    itemName || ""
                                ).toLowerCase() ===
                                target
                            );
                        }
                    );

                if (generatedOwnership) {
                    return true;
                }

                return existingTypes.some(
                    (owner: AnyDoc) => {
                        const members = [
                            ...(Array.isArray(owner?.Properties)
                                ? owner.Properties
                                : []),
                            ...(Array.isArray(owner?.Collections)
                                ? owner.Collections
                                : [])
                        ];

                        return members.some(
                            (member: AnyDoc) => {
                                if (
                                    String(member?.Aggregation || "") !==
                                    "Aggregated"
                                ) {
                                    return false;
                                }

                                const itemName =
                                    getAIPlanTypeNameByRef(
                                        member?.ItemEntity || member?.Type,
                                        repairedOperations,
                                        existingTypes
                                    );

                                return (
                                    String(itemName || "").toLowerCase() ===
                                    target
                                );
                            }
                        );
                    }
                );
            };

            const hasReverseCollection = (
                targetTypeName: string,
                sourceTypeName: string
            ): boolean => {
                const targetLower =
                    targetTypeName.toLowerCase();
                const sourceLower =
                    sourceTypeName.toLowerCase();

                const generated =
                    repairedOperations.some(
                        (operation: AnyDoc) => {
                            if (
                                operation?.Type !==
                                "AddCollection"
                            ) {
                                return false;
                            }

                            const ownerName =
                                getAIPlanTypeNameByRef(
                                    operation.EntityRef ||
                                    operation.EntityId,
                                    repairedOperations,
                                    existingTypes
                                );
                            const itemName =
                                getAIPlanTypeNameByRef(
                                    operation
                                        ?.Collection
                                        ?.ItemEntity,
                                    repairedOperations,
                                    existingTypes
                                );

                            return (
                                String(
                                    ownerName || ""
                                ).toLowerCase() ===
                                    targetLower &&
                                String(
                                    itemName || ""
                                ).toLowerCase() ===
                                    sourceLower &&
                                String(
                                    operation
                                        ?.Collection
                                        ?.Aggregation ||
                                    ""
                                ) === "Deferred"
                            );
                        }
                    );

                if (generated) {
                    return true;
                }

                const existingTarget =
                    existingTypes.find(
                        (typeDoc: AnyDoc) =>
                            String(
                                typeDoc?.Name || ""
                            ).toLowerCase() ===
                            targetLower
                    );

                return (
                    Array.isArray(
                        existingTarget?.Collections
                    ) &&
                    existingTarget.Collections.some(
                        (collection: AnyDoc) => {
                            if (
                                String(
                                    collection
                                        ?.Aggregation ||
                                    ""
                                ) !== "Deferred"
                            ) {
                                return false;
                            }

                            const itemName =
                                getAIPlanTypeNameByRef(
                                    collection
                                        ?.ItemEntity,
                                    repairedOperations,
                                    existingTypes
                                );

                            return (
                                String(
                                    itemName || ""
                                ).toLowerCase() ===
                                sourceLower
                            );
                        }
                    )
                );
            };

            // Aggregated line/child types live inside their parent document and
            // must not acquire independent Deferred reverse navigation on referenced
            // master data such as Product.OrderLines or Product.WarehouseDocumentLines.
            // Remove such operations even when the LLM emitted them explicitly.
            for (let index = repairedOperations.length - 1; index >= 0; index--) {
                const operation = repairedOperations[index];
                const isDeferredCollection =
                    operation?.Type === "AddCollection" &&
                    String(operation?.Collection?.Aggregation || "") === "Deferred";
                const isDeferredManyProperty =
                    operation?.Type === "AddProperty" &&
                    operation?.Property?.Many === true &&
                    String(operation?.Property?.Aggregation || "") === "Deferred";

                if (!isDeferredCollection && !isDeferredManyProperty) {
                    continue;
                }

                const member =
                    isDeferredCollection
                        ? operation.Collection
                        : operation.Property;
                const itemName = getAIPlanTypeNameByRef(
                    isDeferredCollection
                        ? member?.ItemEntity
                        : member?.Type,
                    repairedOperations,
                    existingTypes
                );

                if (!itemName || !isAggregatedChildType(itemName)) {
                    continue;
                }

                const ownerName = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    repairedOperations,
                    existingTypes
                );
                const memberName = String(member?.Name || "Collection");

                repairedOperations.splice(index, 1);
                plan.Warnings = Array.isArray(plan.Warnings)
                    ? plan.Warnings
                    : [];
                plan.Warnings.push(
                    `${ownerName || "Type"}.${memberName} was omitted because ${itemName} is an Aggregated child type and does not have independent Deferred reverse navigation.`
                );
            }

            const referencePairs =
                new Map<
                    string,
                    {
                        SourceName: string;
                        TargetName: string;
                        Count: number;
                    }
                >();

            repairedOperations.forEach(
                (operation: AnyDoc) => {
                    if (
                        operation?.Type !==
                        "AddProperty"
                    ) {
                        return;
                    }

                    const property =
                        operation.Property || {};

                    if (
                        !isReferenceAggregation(
                            property.Aggregation
                        )
                    ) {
                        return;
                    }

                    const sourceName =
                        getAIPlanTypeNameByRef(
                            operation.EntityRef ||
                            operation.EntityId,
                            repairedOperations,
                            existingTypes
                        );
                    const targetName =
                        getAIPlanTypeNameByRef(
                            property.Type,
                            repairedOperations,
                            existingTypes
                        );

                    if (
                        !sourceName ||
                        !targetName ||
                        sourceName.toLowerCase() ===
                        targetName.toLowerCase() ||
                        isAggregatedChildType(
                            sourceName
                        )
                    ) {
                        return;
                    }

                    const key =
                        sourceName.toLowerCase() +
                        "->" +
                        targetName.toLowerCase();

                    const current =
                        referencePairs.get(key);

                    if (current) {
                        current.Count++;
                    } else {
                        referencePairs.set(
                            key,
                            {
                                SourceName:
                                    sourceName,
                                TargetName:
                                    targetName,
                                Count: 1
                            }
                        );
                    }
                }
            );

            referencePairs.forEach(
                (pair: {
                    SourceName: string;
                    TargetName: string;
                    Count: number;
                }) => {
                    // Multiple forward references between the same two types
                    // need business-specific reverse names; do not invent them.
                    if (pair.Count !== 1) {
                        return;
                    }

                    if (
                        hasReverseCollection(
                            pair.TargetName,
                            pair.SourceName
                        )
                    ) {
                        return;
                    }

                    const targetRef =
                        resolveTypeRefByName(
                            pair.TargetName
                        );
                    const sourceRef =
                        resolveTypeRefByName(
                            pair.SourceName
                        );

                    if (
                        !targetRef ||
                        !sourceRef
                    ) {
                        return;
                    }

                    const collectionName =
                        pluralizeTechnicalName(
                            pair.SourceName
                        );

                    // AddProperty(Many) is the canonical runtime representation
                    // of a collection. Never synthesize a reverse AddCollection
                    // if the owner already has a member with the same name.
                    // This also handles relations supplied by AI as AddProperty,
                    // which hasReverseCollection (historically) did not inspect.
                    const hasNamedMemberInPlan = repairedOperations.some(
                        (candidate: AnyDoc) => {
                            if (candidate?.Type !== "AddProperty" &&
                                candidate?.Type !== "AddCollection") return false;
                            const candidateOwner = getAIPlanTypeNameByRef(
                                candidate.EntityRef || candidate.EntityId,
                                repairedOperations,
                                existingTypes
                            );
                            const candidateName = candidate.Type === "AddProperty"
                                ? candidate.Property?.Name
                                : candidate.Collection?.Name;
                            return String(candidateOwner || "").toLowerCase() ===
                                    pair.TargetName.toLowerCase() &&
                                String(candidateName || "").toLowerCase() ===
                                    collectionName.toLowerCase();
                        }
                    );
                    const existingOwner = existingTypes.find(
                        (item: AnyDoc) => String(item?.Name || "").toLowerCase() ===
                            pair.TargetName.toLowerCase()
                    );
                    const hasNamedMemberInExisting = !!existingOwner &&
                        [
                            ...(Array.isArray(existingOwner.Properties) ? existingOwner.Properties : []),
                            ...(Array.isArray(existingOwner.Collections) ? existingOwner.Collections : [])
                        ].some((member: AnyDoc) =>
                            String(member?.Name || "").toLowerCase() ===
                            collectionName.toLowerCase()
                        );
                    if (hasNamedMemberInPlan || hasNamedMemberInExisting) {
                        return;
                    }

                    const reverseOperation: AnyDoc = {
                        Type:
                            "AddCollection",
                        Collection: {
                            Name:
                                collectionName,
                            Caption:
                                getTypeCaptionPlural(
                                    pair.SourceName
                                ),
                            ItemEntity:
                                cloneData(sourceRef),
                            Aggregation:
                                "Deferred",
                            StorageKind: 0,
                            Index: null,
                            Global: false
                        }
                    };

                    if (
                        typeof targetRef ===
                        "object"
                    ) {
                        reverseOperation.EntityRef =
                            cloneData(targetRef);
                    } else {
                        reverseOperation.EntityId =
                            String(targetRef);
                    }

                    repairedOperations.push(
                        reverseOperation
                    );

                    (plan as AnyDoc)
                        .__GeneratedAssumptions =
                        Array.isArray(
                            (plan as AnyDoc)
                                .__GeneratedAssumptions
                        )
                            ? (plan as AnyDoc)
                                .__GeneratedAssumptions
                            : [];

                    (plan as AnyDoc)
                        .__GeneratedAssumptions
                        .push(
                            `${pair.TargetName}.${collectionName} was added as the Deferred reverse side of ${pair.SourceName} -> ${pair.TargetName}.`
                        );
                }
            );

            // No hard-coded business-party canonicalization here.
            // Generic reuse analysis decides reuse/extend/create for every type.

            const existingProduct = existingTypes.find(
                (item: AnyDoc) =>
                    String(item?.Name || "").toLowerCase() === "product"
            );
            let generatedProduct = repairedOperations.find(
                (operation: AnyDoc) =>
                    operation?.Type === "AddType" &&
                    String(operation?.Entity?.Name || "")
                        .toLowerCase() === "product"
            );

            const primitiveTypeNames = [
                "string", "text", "boolean", "integer", "int",
                "float", "double", "decimal", "money",
                "date", "datetime"
            ];

            const hasPrimitiveProductReference =
                repairedOperations.some((operation: AnyDoc) => {
                    if (operation?.Type !== "AddProperty") return false;

                    const property = operation.Property || {};
                    return (
                        String(property.Name || "").toLowerCase() === "product" &&
                        ["Hybrid", "Value"].indexOf(
                            String(property.Aggregation || "")
                        ) >= 0 &&
                        typeof property.Type === "string" &&
                        primitiveTypeNames.indexOf(
                            String(property.Type).toLowerCase()
                        ) >= 0
                    );
                });

            if (
                !existingProduct &&
                !generatedProduct &&
                hasPrimitiveProductReference
            ) {
                generatedProduct = {
                    Type: "AddType",
                    TemporaryId: "auto-product",
                    Entity: {
                        Name: "Product",
                        Caption: "Товар",
                        CaptionPlural: "Товары",
                        Browsable: true,
                        Cacheable: true
                    }
                };

                repairedOperations.unshift(
                    {
                        Type: "AddProperty",
                        EntityRef: {
                            TemporaryId: "auto-product"
                        },
                        Property: {
                            Name: "Price",
                            Caption: "Цена",
                            Type: "money",
                            Required: false
                        }
                    }
                );
                repairedOperations.unshift(
                    {
                        Type: "AddProperty",
                        EntityRef: {
                            TemporaryId: "auto-product"
                        },
                        Property: {
                            Name: "Name",
                            Caption: "Наименование",
                            Type: "string",
                            Required: true
                        }
                    }
                );
                repairedOperations.unshift(generatedProduct);
            }

            repairedOperations.forEach((operation: AnyDoc) => {
                if (operation?.Type !== "AddProperty") return;

                const property = operation.Property || {};
                const isProductProperty =
                    String(property.Name || "").toLowerCase() === "product";
                const isReference =
                    ["Hybrid", "Value"].indexOf(
                        String(property.Aggregation || "")
                    ) >= 0;
                const isPrimitive =
                    typeof property.Type === "string" &&
                    primitiveTypeNames.indexOf(
                        String(property.Type).toLowerCase()
                    ) >= 0;

                if (!isProductProperty || !isReference || !isPrimitive) {
                    return;
                }

                const previousType = String(property.Type);
                property.Type = existingProduct
                    ? String(existingProduct.id)
                    : {
                        TemporaryId: String(
                            generatedProduct?.TemporaryId || "auto-product"
                        )
                    };
                property.Aggregation = "Hybrid";

                plan.Warnings = Array.isArray(plan.Warnings)
                    ? plan.Warnings
                    : [];

                plan.Warnings.push(
                    `${getAIPlanTypeNameByRef(
                        operation.EntityRef || operation.EntityId,
                        repairedOperations,
                        existingTypes
                    ) || "Document"}.${property.Name} was redirected from primitive ${previousType} to Product.`
                );
            });

            const skippedExistingPropertyNames: string[] = [];

            for (
                let index = repairedOperations.length - 1;
                index >= 0;
                index--
            ) {
                const operation = repairedOperations[index];

                if (operation?.Type !== "AddProperty") {
                    continue;
                }

                const ownerName = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    repairedOperations,
                    existingTypes
                );
                const propertyName = String(
                    operation?.Property?.Name || ""
                );

                const existingOwner = existingTypes.find(
                    (typeDoc: AnyDoc) =>
                        String(typeDoc?.Name || "") === ownerName
                );
                const propertyAlreadyExists =
                    Array.isArray(existingOwner?.Properties) &&
                    existingOwner.Properties.some(
                        (property: AnyDoc) =>
                            String(property?.Name || "") ===
                            propertyName
                    );

                if (propertyAlreadyExists) {
                    skippedExistingPropertyNames.push(propertyName);
                    repairedOperations.splice(index, 1);
                }
            }

            // No document-specific cleanup based on a hard-coded Company type.

            // Helpers used by the Deferred-collection normalization below.
            // They must live in this scope because they depend on repairedOperations
            // and the current application's existingTypes.
            const resolveOperationOwnerName = (
                operation: AnyDoc
            ): string | null =>
                getAIPlanTypeNameByRef(
                    operation?.EntityRef ||
                    operation?.EntityId,
                    repairedOperations,
                    existingTypes
                );

            const resolveCollectionItemName = (
                operation: AnyDoc
            ): string | null =>
                getAIPlanTypeNameByRef(
                    operation?.Collection?.ItemEntity ||
                    operation?.Collection?.Type,
                    repairedOperations,
                    existingTypes
                );

            const hasDirectForwardReference = (
                itemTypeName: string,
                ownerTypeName: string
            ): boolean => {
                const itemName =
                    String(itemTypeName || "").toLowerCase();
                const ownerName =
                    String(ownerTypeName || "").toLowerCase();

                if (!itemName || !ownerName) {
                    return false;
                }

                const generatedForwardReference =
                    repairedOperations.some(
                        (candidate: AnyDoc) => {
                            if (
                                candidate?.Type !==
                                "AddProperty"
                            ) {
                                return false;
                            }

                            const candidateOwner =
                                getAIPlanTypeNameByRef(
                                    candidate.EntityRef ||
                                    candidate.EntityId,
                                    repairedOperations,
                                    existingTypes
                                );

                            if (
                                String(
                                    candidateOwner ||
                                    ""
                                ).toLowerCase() !==
                                itemName
                            ) {
                                return false;
                            }

                            const property =
                                candidate.Property ||
                                {};

                            if (
                                !isReferenceAggregation(
                                    property.Aggregation
                                )
                            ) {
                                return false;
                            }

                            const targetName =
                                getAIPlanTypeNameByRef(
                                    property.Type,
                                    repairedOperations,
                                    existingTypes
                                );

                            return (
                                String(
                                    targetName ||
                                    ""
                                ).toLowerCase() ===
                                ownerName
                            );
                        }
                    );

                if (generatedForwardReference) {
                    return true;
                }

                const existingItem =
                    existingTypes.find(
                        (typeDoc: AnyDoc) =>
                            String(
                                typeDoc?.Name ||
                                ""
                            ).toLowerCase() ===
                            itemName
                    );

                return (
                    Array.isArray(
                        existingItem?.Properties
                    ) &&
                    existingItem.Properties.some(
                        (property: AnyDoc) => {
                            if (
                                !isReferenceAggregation(
                                    property?.Aggregation
                                )
                            ) {
                                return false;
                            }

                            const targetName =
                                getAIPlanTypeNameByRef(
                                    property?.Type,
                                    repairedOperations,
                                    existingTypes
                                );

                            return (
                                String(
                                    targetName ||
                                    ""
                                ).toLowerCase() ===
                                ownerName
                            );
                        }
                    )
                );
            };

            const normalizedOperations: AnyDoc[] = [];

            repairedOperations.forEach((operation: AnyDoc) => {
                if (operation?.Type === "AddCollection" && operation.Collection) {
                    const rawStorageKind = operation.Collection.StorageKind;

                    if (
                        rawStorageKind === undefined ||
                        rawStorageKind === null ||
                        String(rawStorageKind).trim().toLowerCase() === "structured" ||
                        String(rawStorageKind).trim().toLowerCase() === "embedded" ||
                        String(rawStorageKind).trim() === "0"
                    ) {
                        operation.Collection.StorageKind = 0;
                    }
                }

                const deferredMember =
                    operation?.Type === "AddCollection"
                        ? operation?.Collection
                        : (
                            operation?.Type === "AddProperty" &&
                                operation?.Property?.Many === true
                                ? operation?.Property
                                : null
                        );

                if (
                    deferredMember &&
                    String(deferredMember.Aggregation || "") === "Deferred"
                ) {
                    const ownerName = resolveOperationOwnerName(operation);
                    const itemName =
                        operation?.Type === "AddCollection"
                            ? resolveCollectionItemName(operation)
                            : getAIPlanTypeNameByRef(
                                deferredMember.Type,
                                repairedOperations,
                                existingTypes
                            );

                    if (
                        ownerName &&
                        itemName &&
                        !hasDirectForwardReference(itemName, ownerName)
                    ) {
                        const collectionName = String(
                            deferredMember.Name || "Collection"
                        );

                        plan.Warnings = Array.isArray(plan.Warnings)
                            ? plan.Warnings
                            : [];

                        plan.Warnings.push(
                            `${ownerName}.${collectionName} was removed because ${itemName} has no direct Hybrid or Value reference to ${ownerName}.`
                        );

                        (plan as AnyDoc).__GeneratedAssumptions =
                            Array.isArray((plan as AnyDoc).__GeneratedAssumptions)
                                ? (plan as AnyDoc).__GeneratedAssumptions
                                : [];

                        (plan as AnyDoc).__GeneratedAssumptions.push(
                            `${ownerName}.${collectionName} requires an explicit query or a direct reference from ${itemName} to ${ownerName}; the invalid Deferred collection was omitted.`
                        );

                        return;
                    }
                }

                normalizedOperations.push(operation);
            });

            plan.Operations = normalizedOperations;

            if (
                skippedExistingPropertyNames.length > 0 &&
                typeof plan.Message === "string" &&
                /^Добавлены поля\b/i.test(plan.Message)
            ) {
                const addedPropertyNames = normalizedOperations
                    .filter(
                        (operation: AnyDoc) =>
                            operation?.Type === "AddProperty"
                    )
                    .map(
                        (operation: AnyDoc) =>
                            String(
                                operation?.Property?.Name || ""
                            ).trim()
                    )
                    .filter(
                        (name: string, index: number, items: string[]) =>
                            !!name && items.indexOf(name) === index
                    );

                const remainingSentences = plan.Message
                    .replace(/^[^.]*\.?\s*/i, "")
                    .trim();

                if (addedPropertyNames.length > 0) {
                    plan.Message =
                        `Добавлены поля ${addedPropertyNames.join(", ")}.` +
                        (
                            remainingSentences
                                ? ` ${remainingSentences}`
                                : ""
                        );
                }
            }

            const productIsAvailable =
                existingTypes.some((item: AnyDoc) =>
                    String(item?.Name || "").toLowerCase() === "product"
                ) ||
                normalizedOperations.some((operation: AnyDoc) =>
                    operation?.Type === "AddType" &&
                    String(operation?.Entity?.Name || "")
                        .toLowerCase() === "product"
                );

            if (productIsAvailable) {
                plan.Questions = (Array.isArray(plan.Questions)
                    ? plan.Questions
                    : []
                ).filter((item: any) =>
                    !/Product|товар/i.test(String(item || ""))
                );

                plan.Warnings = (Array.isArray(plan.Warnings)
                    ? plan.Warnings
                    : []
                ).filter((item: any) =>
                    !/Product не создан|Тип Product не создан|требуется уточнение/i
                        .test(String(item || ""))
                );

                if (typeof plan.Message === "string") {
                    plan.Message = plan.Message
                        .replace(
                            /\s*Товар \(Product\)[^.]*требуется уточнение\.?/gi,
                            " Product создан с полями Name и Price."
                        )
                        .replace(/\s{2,}/g, " ")
                        .trim();
                }
            }

            const evidencePaths: string[] = [];
            const addEvidence = (path: any): void => {
                const value = String(path || "").trim();
                if (value && evidencePaths.indexOf(value) < 0) evidencePaths.push(value);
            };

            normalizedOperations.forEach((operation: AnyDoc) => {
                const operationType = String(operation?.Type || "");

                if (operationType === "AddType") {
                    addEvidence(operation?.Entity?.Name);
                    return;
                }

                if (operationType === "AddEnum") {
                    addEvidence(operation?.Enum?.Name || operation?.Entity?.Name);
                    return;
                }

                if (operationType === "AddProperty" || operationType === "AddCollection") {
                    const ownerRef = operation.EntityRef || operation.EntityId;
                    const ownerName =
                        getAIPlanTypeNameByRef(ownerRef, normalizedOperations, existingTypes);
                    const member =
                        operationType === "AddProperty"
                            ? operation?.Property?.Name
                            : operation?.Collection?.Name;

                    if (ownerName && member) addEvidence(`${ownerName}.${member}`);
                    return;
                }

                if (operationType === "AddNavigationGroup") {
                    const item = operation?.NavigationItem || {};
                    addEvidence(
                        `Navigation.${String(item.Caption || item.Name || operation.TemporaryId || "Group")}`
                    );
                    return;
                }

                if (
                    operationType === "AddObject" ||
                    operationType === "UpdateObject" ||
                    operationType === "MoveObject" ||
                    operationType === "DeleteObject"
                ) {
                    addEvidence(
                        `${operationType}:${String(operation?.Collection || operation?.ObjectId || operation?.TemporaryId || "Object")}`
                    );
                    return;
                }

                if (operationType === "MoveNavigationItem") {
                    const item =
                        findNavigationItemRecursive(
                            getRuntimeNavigationItemsArray(false),
                            String(operation?.NavigationItemId || "")
                        );
                    addEvidence(
                        `Navigation.${String(item?.Caption || item?.Name || operation?.NavigationItemId || "Item")}`
                    );
                    return;
                }

                if (operationType === "AddNavigationItem") {
                    const item = operation?.NavigationItem || {};
                    const target = getAINavigationTarget(operation);
                    const targetName = target?.EntityId
                        ? getAIPlanTypeNameByRef(
                            target.EntityId,
                            normalizedOperations,
                            existingTypes
                        )
                        : getAIPlanTypeNameByRef(
                            target?.EntityRef,
                            normalizedOperations,
                            existingTypes
                        );
                    addEvidence(
                        `Navigation.${String(item.Caption || item.Name || targetName || operation.TemporaryId || "Item")}`
                    );
                    return;
                }

                if (
                    operationType === "AddRule" ||
                    operationType === "AddAction" ||
                    operationType === "AddEvent"
                ) {
                    const ownerRef =
                        operation.EntityRef ||
                        operation.EntityId;
                    const ownerName =
                        getAIPlanTypeNameByRef(
                            ownerRef,
                            normalizedOperations,
                            existingTypes
                        );
                    const behavior =
                        operationType === "AddRule"
                            ? operation?.Rule
                            : (
                                operationType === "AddAction"
                                    ? operation?.Action
                                    : operation?.Event
                            );
                    const behaviorName =
                        String(
                            behavior?.Name ||
                            behavior?.Caption ||
                            ""
                        ).trim();

                    if (
                        ownerName &&
                        behaviorName
                    ) {
                        addEvidence(
                            `${ownerName}.${operationType.substring(3)}s.${behaviorName}`
                        );
                    }
                    return;
                }
            });

            const behaviorOperations =
                normalizedOperations.filter(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddRule" ||
                        operation?.Type === "AddAction" ||
                        operation?.Type === "AddEvent"
                );

            const behaviorMatchesText = (
                operation: AnyDoc,
                value: any
            ): boolean => {
                const text =
                    String(value || "")
                        .toLowerCase();

                if (!text) return false;

                const definition =
                    operation?.Type === "AddRule"
                        ? operation?.Rule
                        : (
                            operation?.Type === "AddAction"
                                ? operation?.Action
                                : operation?.Event
                        );

                const candidates = [
                    definition?.Name,
                    definition?.Caption
                ]
                    .map((item: any) =>
                        String(item || "")
                            .trim()
                            .toLowerCase()
                    )
                    .filter(
                        (item: string) =>
                            item.length >= 3
                    );

                if (
                    candidates.some(
                        (candidate: string) =>
                            text.indexOf(
                                candidate
                            ) >= 0
                    )
                ) {
                    return true;
                }

                if (
                    operation?.Type === "AddAction" &&
                    /(кнопк|действи|action|button)/i.test(text)
                ) {
                    return (
                        behaviorOperations.filter(
                            (item: AnyDoc) =>
                                item?.Type === "AddAction"
                        ).length === 1
                    );
                }

                if (
                    operation?.Type === "AddRule" &&
                    /(правил|провер|валидац|rule|validation)/i.test(text)
                ) {
                    return (
                        behaviorOperations.filter(
                            (item: AnyDoc) =>
                                item?.Type === "AddRule"
                        ).length === 1
                    );
                }

                if (
                    operation?.Type === "AddEvent" &&
                    /(событ|event|при измен|при откры|при сохран)/i.test(text)
                ) {
                    return (
                        behaviorOperations.filter(
                            (item: AnyDoc) =>
                                item?.Type === "AddEvent"
                        ).length === 1
                    );
                }

                return false;
            };

            const reconcileBehaviorCoverage = (
                item: AnyDoc,
                isCapability: boolean
            ): void => {
                const originalMissing =
                    Array.isArray(item?.Missing)
                        ? item.Missing
                        : [];

                const remainingMissing =
                    originalMissing.filter(
                        (missing: any) =>
                            !behaviorOperations.some(
                                (operation: AnyDoc) =>
                                    behaviorMatchesText(
                                        operation,
                                        missing
                                    )
                            )
                    );

                const itemText = [
                    item?.Name,
                    item?.Description,
                    ...originalMissing
                ].join(" ");

                const matchedOperations =
                    behaviorOperations.filter(
                        (operation: AnyDoc) =>
                            behaviorMatchesText(
                                operation,
                                itemText
                            )
                    );

                item.Missing =
                    remainingMissing;

                if (
                    matchedOperations.length > 0
                ) {
                    item.Evidence =
                        Array.isArray(item.Evidence)
                            ? item.Evidence
                            : [];

                    matchedOperations.forEach(
                        (operation: AnyDoc) => {
                            const ownerName =
                                getAIPlanTypeNameByRef(
                                    operation.EntityRef ||
                                    operation.EntityId,
                                    normalizedOperations,
                                    existingTypes
                                );
                            const definition =
                                operation?.Type === "AddRule"
                                    ? operation?.Rule
                                    : (
                                        operation?.Type === "AddAction"
                                            ? operation?.Action
                                            : operation?.Event
                                    );
                            const behaviorName =
                                String(
                                    definition?.Name ||
                                    definition?.Caption ||
                                    ""
                                ).trim();

                            if (
                                ownerName &&
                                behaviorName
                            ) {
                                const path =
                                    `${ownerName}.${operation.Type.substring(3)}s.${behaviorName}`;

                                if (
                                    item.Evidence.indexOf(
                                        path
                                    ) < 0
                                ) {
                                    item.Evidence.push(
                                        path
                                    );
                                }
                            }
                        }
                    );

                    if (
                        isCapability &&
                        item.Missing.length === 0
                    ) {
                        item.Status =
                            "Implemented";
                    }
                }
            };

            plan.Scenarios.forEach((scenario: AnyDoc) => {
                scenario.Evidence = Array.isArray(scenario.Evidence)
                    ? scenario.Evidence.filter(Boolean)
                    : [];
                scenario.Missing = Array.isArray(scenario.Missing)
                    ? scenario.Missing.filter(Boolean)
                    : [];
                reconcileBehaviorCoverage(
                    scenario,
                    false
                );
            });

            plan.Capabilities.forEach((capability: AnyDoc) => {
                capability.Evidence = Array.isArray(capability.Evidence)
                    ? capability.Evidence.filter(Boolean)
                    : [];
                capability.Missing = Array.isArray(capability.Missing)
                    ? capability.Missing.filter(Boolean)
                    : [];
                reconcileBehaviorCoverage(
                    capability,
                    true
                );
            });

            removeDuplicateGeneratedCollections(plan);
            return plan;
        }

        function parseDesignerAIContent(
            content: any,
            finishReason?: string,
            phase: "BusinessAnalysis" | "BusinessAnalysisAudit" | "ModelGeneration" = "ModelGeneration"
        ): any {
            if (content === undefined || content === null) {
                throw new Error("Designer AI returned empty content.");
            }

            if (typeof content === "object") return content;

            const text = String(content).trim();
            if (!text) throw new Error("Designer AI returned empty content.");

            try {
                return JSON.parse(text);
            } catch (err: any) {
                if (String(finishReason || "").toLowerCase() === "length") {
                    throw new Error(
                        `The ${phase} response was cut off because the completion token limit was reached. ` +
                        `Increase the server-side token limit for ${phase}.`
                    );
                }

                throw new Error(
                    "The model returned invalid JSON: " +
                    (err?.message || String(err))
                );
            }
        }


        interface DesignerAIBusinessBlueprint {
            Intent: string;
            Summary: string;
            ApplicationName?: string;
            BusinessAnalysis: AnyDoc;
            Scenarios: AnyDoc[];
            Capabilities: AnyDoc[];
            Questions: string[];
            Assumptions: string[];
            ExistingModelReuseAnalysis: AnyDoc[];
            NeedsClarification: boolean;
        }

        function buildDesignerAIAnalysisContext(): AnyDoc {
            const context = buildDesignerAIContext();

            // The first pass is intentionally small and has no metamodel operation
            // contract. Its only job is to understand the business system.
            delete context.MetamodelEditingContract;
            delete context.OperationContract;
            delete context.ValueKinds;
            delete context.StorageKinds;
            delete context.Aggregations;

            context.Workflow = {
                Phase: "BusinessAnalysis",
                Objective: "Understand the requested application before generating model operations.",
                MustNotGenerateOperations: true,
                Output: {
                    Required: [
                        "Intent", "Summary", "ApplicationName", "BusinessAnalysis", "Scenarios",
                        "Capabilities", "Questions", "Assumptions",
                        "ExistingModelReuseAnalysis", "NeedsClarification"
                    ],
                    IntentValues: ["Analyze", "Clarify", "ReadyToModel"],
                    BusinessAnalysisRequired: [
                        "Actors", "ReferenceData", "Documents", "Lifecycles",
                        "QuantitiesAndBalances", "DerivedValues", "Assumptions",
                        "StandardCore", "IntentionalSimplifications",
                        "UserPain", "DistinctiveRequirements",
                        "DeliveryActivities"
                    ],
                    ScenarioRequired: [
                        "Id", "Name", "Description", "Importance",
                        "Trigger", "Data", "Lifecycle", "BusinessEffect",
                        "RequiredModelElements", "Requirements"
                    ],
                    CapabilityRequired: [
                        "Id", "Name", "Importance", "RequiredModelElements",
                        "AcceptanceCriteria", "Requirements"
                    ],
                    ExistingModelReuseAnalysisRequired: [
                        "RequestedType", "Decision", "Confidence", "Reason"
                    ],
                    ExistingModelReuseDecisionValues: [
                        "ReuseExisting", "ExtendExisting",
                        "CreateDerived", "CreateNew", "Ambiguous"
                    ],
                    RequirementKinds: [
                        "TypeExists", "PropertyExists", "Crud",
                        "ReferenceSelection", "EmbeddedObject",
                        "EmbeddedCollection", "ReverseCollection",
                        "Formula", "DefaultValue",
                        "Validation", "Action", "UpdateOnAction",
                        "StatusTransition", "ReadOnlyWhen", "Inherits",
                        "ListViewExists", "NavigationAccess",
                        "IntegrationBehavior", "ScheduledBehavior",
                        "SecurityBehavior", "ViewBehavior",
                        "ExecutableBehavior"
                    ]
                },
                Rules: [
                    "Return JSON only",
                    "ApplicationName is a concise human project title, normally 2-6 words, not a sentence and never a comma-separated list of features, entities or capabilities. Use the user's language. Examples: Складской учёт, CRM агентства недвижимости, Управление сервисным центром.",
                    "Context.ModelSummary.ApplicationModel is the complete authoritative model of the project being edited. Never reuse types from the metamodel, another project, prior conversation context or remembered examples.",
                    "If Context.ModelSummary.ApplicationModel.IsStructurallyEmpty is true, ExistingModelReuseAnalysis may contain only CreateNew decisions.",
                    "Assign stable ids S1, S2, ... to Scenarios and C1, C2, ... to Capabilities",
                    "RequiredModelElements must use English technical model identifiers or paths such as CustomerOrder, CustomerOrder.Lines and CustomerOrderLine.Price; descriptions remain in the conversation language",
                    "Every Scenario and Capability must contain a typed Requirements array. Coverage is computed only from Requirements, never from prose.",
                    "Every factual clause in Scenario.Description, Trigger, Lifecycle, BusinessEffect and every AcceptanceCriteria item must be represented by at least one typed Requirement. If a clause has no Requirement, either add the Requirement or remove the clause.",
                    "Do not say that a total, balance, status, default, validation, posting effect or automatic update exists unless a matching Formula, DefaultValue, Validation, Action, UpdateOnAction or StatusTransition Requirement is present.",
                    "BusinessAnalysis arrays must be populated when the request describes actors, documents, lifecycle, quantities, balances or derived values; do not return empty arrays for information that is present in the request.",
                    "Keep application capabilities separate from project delivery activities. Discovery, choosing a platform, implementation/testing work, documentation, training and team instructions belong in BusinessAnalysis.DeliveryActivities, not Capabilities.",
                    "In Creative mode populate StandardCore with the compact conventional foundation you recommend, IntentionalSimplifications with complexity deliberately excluded, UserPain with the user's expressed or strongly implied problem, and DistinctiveRequirements with requirements that make this custom system different from a generic product.",
                    "Do not invent a distinctive requirement merely to fill the field. When no special process is visible yet, state that the request currently looks like a simplified standard system and use the single clarification question to ask what standard products get wrong for this user.",
                    "Use TypeExists for a type, PropertyExists for a field, Crud for ordinary model-driven create/edit/delete, ReferenceSelection for selecting a referenced object, EmbeddedObject for a single Aggregated child object (Many=false), EmbeddedCollection for Aggregated child collections/lines (Many=true), ReverseCollection for Deferred navigation, Formula for derived values, DefaultValue for defaults, Validation for restrictions, Action for explicit commands, UpdateOnAction for data changes caused by an action, StatusTransition for lifecycle changes, ReadOnlyWhen for conditional edit restrictions, and Inherits for a required base-type relationship.",
                    "Use Formula only for values computable from the current object and its already-available scalar/Aggregated/current-data values. Never traverse Hybrid or Deferred references inside Formula (for example Specification.Lines when Specification is Hybrid); use Validation/Action/ExecutableBehavior or a stored field updated by an action instead. Cross-document balances such as stock, debt and account balances that change when other documents are posted must be represented by UpdateOnAction/ExecutableBehavior, not Formula through Deferred/query data.",
                    "Use IntegrationBehavior for external-system/email/webhook/form/API integration, ScheduledBehavior for reminders or time-triggered processing, SecurityBehavior for role/data-visibility/access rules, ViewBehavior for reporting/analytics/specialized presentation behavior, and ExecutableBehavior for requested executable behavior that is not more specifically represented by Formula, Validation, Action, StatusTransition, IntegrationBehavior or ScheduledBehavior.",
                    "A structural field that supports a behavior does not satisfy the behavior itself. For example, storing EmailRecord does not implement email integration, DueDate does not implement scheduled reminders, and list fields do not implement analytics/reporting.",
                    "Any statement that one type inherits from another must include an Inherits Requirement with Target equal to the derived type and ReferenceType equal to the base type.",
                    "Use ListViewExists when users must browse a concrete type or an abstract hierarchy.",
                    "Use NavigationAccess when that ListView must be reachable from runtime navigation.",
                    "For an initial application model, every top-level business document/reference-data type that actors must open, browse or maintain from the application shell must have both ListViewExists and NavigationAccess Requirements. Do not leave runtime navigation implicit.",
                    "When the request describes an explicit user command/button such as post, cancel, approve, close, recalculate or perform payment, represent it with an Action Requirement; represent its data/status side effects additionally with UpdateOnAction or StatusTransition as appropriate.",
                    "Abstract types can satisfy ListViewExists and NavigationAccess because their lists may include derived objects.",
                    "A Requirement object uses Kind and Target, with optional Source, Action, Condition, ReferenceType and Values. Use English technical identifiers in these fields.",
                    "Do not describe automatic updates, validations, posting, conditional read-only behavior or status transitions as PropertyExists. Give them their specific behavioral Requirement kind.",
                    "Do not generate Operations, TemporaryId values or metamodel changes",
                    "Before proposing new business types, compare every requested conceptual type with all existing application types in ModelSummary.ApplicationModel.Types. Do not use hard-coded aliases such as Customer→Company; infer reuse from the actual model.",
                    "Return ExistingModelReuseAnalysis for requested conceptual types. Use ReuseExisting when an existing type already represents the same concept, ExtendExisting when it is the same concept but needs additional fields, CreateDerived when the requested concept is a specialization of an existing base type, CreateNew when it is genuinely different, and Ambiguous only when the evidence is insufficient and the distinction materially changes the model.",
                    "For ReuseExisting, ExtendExisting or CreateDerived include ExistingType and ExistingTypeId copied exactly from ModelSummary.ApplicationModel.Types. Never invent an existing id.",
                    "Base matching on semantic purpose, Description, Caption, existing properties, references and role in scenarios; name similarity alone is not sufficient.",
                    "If ModelSummary.ApplicationModel.TypeCount is 0, there are no reusable application types. Return CreateNew for every required conceptual type and never reference ids from templates, other projects or prior conversations.",
                    "Do not treat metamodel schema types such as Type, Property, Action or View as reusable business-domain types.",
                    "Derive end-to-end scenarios, including ordinary implied scenarios that a competent business analyst would identify",
                    "For documents with products, inspect lines, quantities, editable prices, totals and partial execution",
                    "For inventory, inspect posting, on-hand quantity, reservations, release rules and warehouse-specific availability",
                    "For companies in multiple roles, inspect role-specific references and navigation",
                    "Ask questions only when different answers materially change the business model",
                    "In Creative mode ask no more than one question. Prefer presenting a proposed concept plus one decisive question over conducting a multi-turn questionnaire.",
                    "For routine omissions use conventional minimal assumptions and list them explicitly",
                    "Do not claim implementation; this phase describes what the application must support"
                ]
            };

            return context;
        }

        function getDesignerAIReuseMap(
            blueprint: DesignerAIBusinessBlueprint
        ): Map<string, AnyDoc> {
            const result = new Map<string, AnyDoc>();
            const existingTypes = getAIApplicationTypeDocs();
            const byId = new Map<string, AnyDoc>();
            const byName = new Map<string, AnyDoc>();

            existingTypes.forEach((typeDoc: AnyDoc) => {
                const id = String(typeDoc?.id || typeDoc?.Id || "").trim();
                const name = String(typeDoc?.Name || "").trim();
                if (id) byId.set(id, typeDoc);
                if (name) byName.set(name.toLowerCase(), typeDoc);
            });

            const decisions = Array.isArray(
                blueprint?.ExistingModelReuseAnalysis
            ) ? blueprint.ExistingModelReuseAnalysis : [];

            decisions.forEach((decision: AnyDoc) => {
                const requestedType = String(
                    decision?.RequestedType || ""
                ).trim();
                if (!requestedType) return;

                const action = String(
                    decision?.Decision || "CreateNew"
                ).trim();
                const existingId = String(
                    decision?.ExistingTypeId || ""
                ).trim();
                const existingName = String(
                    decision?.ExistingType || ""
                ).trim();

                let existing: AnyDoc | null = null;
                if (existingId) existing = byId.get(existingId) || null;
                if (!existing && existingName) {
                    existing = byName.get(existingName.toLowerCase()) || null;
                }

                if (
                    ["ReuseExisting", "ExtendExisting", "CreateDerived"]
                        .indexOf(action) >= 0 &&
                    !existing
                ) {
                    result.set(requestedType.toLowerCase(), {
                        ...cloneData(decision),
                        Decision: "CreateNew",
                        ExistingType: null,
                        ExistingTypeId: null,
                        Reason:
                            `${decision?.Reason || ""} ` +
                            "The proposed existing type is absent from the current project; CreateNew is enforced."
                    });
                    return;
                }

                result.set(requestedType.toLowerCase(), {
                    ...cloneData(decision),
                    ExistingType: existing?.Name || existingName || null,
                    ExistingTypeId:
                        existing?.id || existing?.Id || existingId || null
                });
            });

            return result;
        }

        function applyDesignerAIReuseAnalysisToBlueprint(
            blueprint: DesignerAIBusinessBlueprint
        ): DesignerAIBusinessBlueprint {
            const reuseMap = getDesignerAIReuseMap(blueprint);
            const typeNameMap = new Map<string, string>();

            reuseMap.forEach((decision: AnyDoc, key: string) => {
                if (
                    ["ReuseExisting", "ExtendExisting"].indexOf(
                        String(decision?.Decision || "")
                    ) >= 0 && decision?.ExistingType
                ) {
                    typeNameMap.set(key, String(decision.ExistingType));
                }
            });

            if (!typeNameMap.size) return blueprint;

            const rewritePath = (value: any): any => {
                if (typeof value !== "string") return value;
                const dot = value.indexOf(".");
                const head = dot >= 0 ? value.slice(0, dot) : value;
                const tail = dot >= 0 ? value.slice(dot) : "";
                const replacement = typeNameMap.get(head.toLowerCase());
                return replacement ? replacement + tail : value;
            };

            const rewriteRequirement = (requirement: AnyDoc): AnyDoc => {
                if (!requirement || typeof requirement !== "object") {
                    return requirement;
                }
                if (typeof requirement.Target === "string") {
                    requirement.Target = rewritePath(requirement.Target);
                }
                if (typeof requirement.Source === "string") {
                    requirement.Source = rewritePath(requirement.Source);
                }
                if (typeof requirement.ReferenceType === "string") {
                    requirement.ReferenceType = rewritePath(
                        requirement.ReferenceType
                    );
                }
                return requirement;
            };

            [blueprint.Scenarios, blueprint.Capabilities].forEach(
                (items: AnyDoc[]) => {
                    (Array.isArray(items) ? items : []).forEach(
                        (item: AnyDoc) => {
                            if (Array.isArray(item.RequiredModelElements)) {
                                item.RequiredModelElements =
                                    item.RequiredModelElements.map(rewritePath);
                            }
                            if (Array.isArray(item.Requirements)) {
                                item.Requirements =
                                    item.Requirements.map(rewriteRequirement);
                            }
                        }
                    );
                }
            );
            return blueprint;
        }

        function applyDesignerAIReuseAnalysisToPlan(
            plan: AnyDoc,
            blueprint: DesignerAIBusinessBlueprint
        ): void {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];
            const existingTypes = getAIApplicationTypeDocs();
            const reuseMap = getDesignerAIReuseMap(blueprint);

            const replaceTemporaryRef = (
                value: any,
                temporaryId: string,
                existingId: string
            ): any => {
                if (!value) return value;
                if (Array.isArray(value)) {
                    return value.map((item: any) =>
                        replaceTemporaryRef(item, temporaryId, existingId)
                    );
                }
                if (typeof value !== "object") return value;
                if (String(value.TemporaryId || "") === temporaryId) {
                    return existingId;
                }
                Object.keys(value).forEach((key: string) => {
                    value[key] = replaceTemporaryRef(
                        value[key], temporaryId, existingId
                    );
                });
                return value;
            };

            reuseMap.forEach((decision: AnyDoc, requestedKey: string) => {
                const action = String(decision?.Decision || "CreateNew");
                const existingId = String(
                    decision?.ExistingTypeId || ""
                ).trim();
                if (
                    ["ReuseExisting", "ExtendExisting", "CreateDerived"]
                        .indexOf(action) < 0 || !existingId
                ) return;

                const addType = operations.find((operation: AnyDoc) =>
                    operation?.Type === "AddType" &&
                    String(operation?.Entity?.Name || "").toLowerCase() ===
                    requestedKey
                );

                if (action === "CreateDerived") {
                    if (addType?.Entity) addType.Entity.BaseType = existingId;
                    return;
                }

                if (!addType?.TemporaryId) return;
                const temporaryId = String(addType.TemporaryId);

                operations.forEach((operation: AnyDoc) => {
                    if (
                        operation?.Type === "AddProperty" &&
                        String(operation?.EntityRef?.TemporaryId || "") ===
                        temporaryId
                    ) {
                        operation.EntityId = existingId;
                        delete operation.EntityRef;
                    } else {
                        replaceTemporaryRef(
                            operation, temporaryId, existingId
                        );
                    }
                });

                const existingType = existingTypes.find((typeDoc: AnyDoc) =>
                    String(typeDoc?.id || typeDoc?.Id || "") === existingId
                );
                const existingPropertyNames = new Set(
                    (Array.isArray(existingType?.Properties)
                        ? existingType.Properties : []
                    ).map((property: AnyDoc) =>
                        String(property?.Name || "").toLowerCase()
                    )
                );

                for (let i = operations.length - 1; i >= 0; i--) {
                    const operation = operations[i];
                    if (operation === addType) {
                        operations.splice(i, 1);
                        continue;
                    }
                    if (
                        operation?.Type === "AddProperty" &&
                        String(operation?.EntityId || "") === existingId &&
                        existingPropertyNames.has(
                            String(operation?.Property?.Name || "")
                                .toLowerCase()
                        )
                    ) {
                        operations.splice(i, 1);
                    }
                }

                plan.Warnings = Array.isArray(plan.Warnings)
                    ? plan.Warnings : [];
                plan.Warnings.push(
                    `${decision?.RequestedType || requestedKey} was resolved to existing ${decision?.ExistingType || existingId} by generic semantic reuse analysis (${action}).`
                );
            });
        }

        function blueprintNeedsCodeKnowledge(
            blueprint: DesignerAIBusinessBlueprint
        ): boolean {
            const codeKinds = new Set([
                "Formula", "Validation", "Action", "UpdateOnAction",
                "StatusTransition", "ReadOnlyWhen", "IntegrationBehavior",
                "ScheduledBehavior", "SecurityBehavior", "ViewBehavior",
                "ExecutableBehavior"
            ]);

            const containsCodeRequirement = (items: AnyDoc[]): boolean =>
                (Array.isArray(items) ? items : []).some((item: AnyDoc) =>
                    (Array.isArray(item?.Requirements) ? item.Requirements : [])
                        .some((requirement: AnyDoc) =>
                            codeKinds.has(String(requirement?.Kind || requirement?.Type || ""))
                        )
                );

            return containsCodeRequirement(blueprint?.Scenarios || []) ||
                containsCodeRequirement(blueprint?.Capabilities || []);
        }

        function buildDesignerAICodeKnowledge(): AnyDoc {
            const projectModel = buildProjectModelDeclaration();
            const platformApi = buildRuntimeDeclaration();

            return {
                SourcePolicy: {
                    PlatformApiIsAuthoritative: true,
                    ProjectTypeScriptModelIsAuthoritative: true,
                    NeverInventUndeclaredRuntimeApi: true,
                    NeverInferEnumMeaningFromCaptionOrOrdinal: true,
                    NeverUseUndeclaredHybridFields: true
                },
                PlatformApiDts: platformApi,
                ProjectTypeScriptModel: projectModel,
                Rules: [
                    "Use exact type, property and enum member names from ProjectTypeScriptModel.",
                    "Enum properties store enum Value; Caption is display text and must never be used as the stored value.",
                    "Value entity relations store ids.",
                    "Hybrid relations are partial embedded references; only fields declared by the Hybrid reference type are safe without resolving the full object.",
                    "Aggregated relations contain owned embedded objects.",
                    "Deferred relations are query-backed reverse relations.",
                    "Use only runtime APIs declared in PlatformApiDts.",
                    "Do not invent e.context, repositories, services, load/save helpers or refresh methods.",
                    "e.refresh is a boolean flag when available, not a function.",
                    "Declare local variables and loop variables with const or let.",
                    "Action handlers are synchronous in the current runtime. Never generate async functions or await.",
                    "Do not use app.objects; it is not part of the declared runtime API. Use app.query(...) or app.getLookupObject(...) as appropriate.",
                    "app.query(...) is synchronous in the legacy runtime and returns an array directly. Never await it and never treat it as a Promise.",
                    "Legacy app.query(...) accepts native Cosmos/runtime SQL with FROM {s}; semantic DataAPI syntax such as FROM Client or FROM Module.Type is not available in this runtime.",
                    "When querying a business type, resolve its runtime type id (for example through app.getType(typeName)) and filter s._type; do not put the type name after FROM.",
                    "Rule.Condition and Rule.PreCondition are JavaScript expressions, not function bodies. Runtime evaluates them as return <expression>.",
                    "Simple rules should use logical/ternary expressions. Complex rules may use an immediately-invoked function expression (IIFE), for example (() => { const x = ...; if (...) return true; return false; })(). Declarations, if and return are allowed only inside that nested function; the Rule value itself must still be one expression.",
                    "Action.Script must be one handler function such as (e) => { ... }, not an immediately-invoked wrapper.",
                    "In Action and Event scripts, never call .Save(), .Load() or .Clone() on e.data, e.parent, e.params or other runtime data objects. Treat them as plain data objects and persist changes only through app.upsertDocument(...). ProjectTypeScriptModel describes data shape, not runtime instance methods inside handlers.",
                    "Format Action.Script, Event.Script and complex Rule expressions as readable multiline JavaScript with indentation and line breaks. Preserve those line breaks in the JSON string; do not collapse executable code to one line.",
                    "The legacy runtime does not implement scalar type html. When html or text is requested/generated, use string instead.",
                    "Aggregation and multiplicity are independent. Aggregation=Aggregated means the child is embedded/owned by the parent; it does not imply a collection.",
                    "Use Many=true only when the user explicitly describes multiple child items, a list, lines, addresses, contacts, etc. For one embedded child object, use Aggregation=Aggregated with Many=false. Example: Counterparty.Address -> Address is Aggregated + Many=false; Order.Lines -> OrderLine is Aggregated + Many=true.",
                    "When creating a new persisted document, use the declared document creation API (app.createDocument(...)) before app.upsertDocument(...); do not invent a fresh untyped object literal and assume upsert assigns its type.",
                    "Runtime client UI currently uses jQuery and DevExtreme 22.2. For any generated Runtime client-side UI code — including Actions, Events and script NavigationItem.js — use the already-loaded jQuery/DevExtreme stack; do not introduce another UI library unless the user explicitly asks for one.",
                    "Instantiate DevExtreme widgets through the jQuery plugins used by CosmoApps, e.g. $(\"<div>\").dxPopup(...), .dxPieChart(...), .dxChart(...), .dxDataGrid(...). Prefer these Runtime widgets over hand-built SVG/canvas/HTML controls when the requested UI is a popup, chart, grid, form or similar standard widget. Do not use direct constructors such as new DevExpress.ui.dxPopup(...) or new DevExpress.viz.dxPieChart(...) unless existing Runtime source explicitly uses that pattern.",
                    "A dynamically created popup/widget host must be appended to the live DOM first (normally document.body or another visible mounted container), and only then initialized and shown through the jQuery plugin.",
                    "Create charts/grids/forms inside the mounted popup content/container (for example from contentTemplate), not on detached elements.",
                    "When modifying an existing NavigationItem with Type=<js>, treat Changes.js exactly like other Runtime client UI code. Preserve the script-navigation shape and update the JavaScript itself; for standard UI such as popup, pie/line chart, data grid or form, prefer the corresponding DevExtreme jQuery widgets instead of rebuilding them manually with SVG, canvas or large inline-HTML templates.",
                    "Respect the active Runtime/DevExtreme theme. Unless the user explicitly requests a custom visual style, do not hard-code a separate light or dark palette for popup content (background, text, borders, widget surfaces). Let DevExtreme/theme CSS provide colors and typography; use custom CSS mainly for layout, spacing, sizing and responsive arrangement.",
                    "Avoid visually duplicating standard widget chrome. For example, when dxPopup already has a title, do not add a second large heading with the same title inside its content unless the design explicitly needs it.",
                    "Clean up temporary UI on close: dispose transient widgets when appropriate and remove temporary DOM containers."
                ]
            };
        }


        function getAIBehaviorOperationCode(operation: AnyDoc): string {
            const changes = operation?.Changes || {};
            const script =
                operation?.Action?.Script ||
                operation?.Event?.Script ||
                changes?.Script ||
                operation?.Script;
            if (typeof script === "string") return script;
            if (script && typeof script.Code === "string") return script.Code;
            if (typeof operation?.Action?.js === "string") return operation.Action.js;
            if (typeof operation?.Event?.js === "string") return operation.Event.js;
            if (typeof changes?.js === "string") return changes.js;

            const condition = operation?.Rule?.Condition !== undefined
                ? operation.Rule.Condition
                : changes?.Condition;
            if (typeof condition === "string") return condition;
            if (condition && typeof condition.Code === "string") return condition.Code;
            return "";
        }

        function isAIBehaviorCodePlaceholder(operation: AnyDoc, code: string): boolean {
            const compact = String(code || "")
                .replace(/\/\/[^\n\r]*/g, "")
                .replace(/\/\*[\s\S]*?\*\//g, "")
                .replace(/\s+/g, "")
                .toLowerCase();
            if (!compact) return true;
            if (operation?.Type === "AddRule" || operation?.Type === "UpdateRule") {
                return compact === "true" || compact === "false";
            }
            return compact === "returne;" || compact === "(e)=>{returne;}" || compact === "(e)=>{}";
        }

        function getAIBehaviorCodeValidationErrors(plan: AnyDoc): string[] {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const errors: string[] = [];
            const add = (message: string) => {
                if (errors.indexOf(message) < 0) errors.push(message);
            };

            operations.forEach((operation: AnyDoc) => {
                const type = String(operation?.Type || "");
                if (!["AddAction", "UpdateAction", "AddEvent", "UpdateEvent", "AddRule", "UpdateRule"].includes(type)) return;
                const code = getAIBehaviorOperationCode(operation);
                const owner = getAIPlanOperationOwnerName(operation, operations, getRuntimeObjectsArray(false));
                const name = String(
                    operation?.Action?.Name ||
                    operation?.Event?.Name ||
                    operation?.Rule?.Name ||
                    operation?.ActionName ||
                    operation?.EventName ||
                    operation?.RuleName ||
                    operation?.RuleId ||
                    operation?.ActionId ||
                    operation?.EventId ||
                    "behavior"
                );
                const label = `${type} ${owner ? owner + "." : ""}${name}`;

                if (isAIBehaviorCodePlaceholder(operation, code)) {
                    add(`${label}: executable code is empty or a placeholder`);
                    return;
                }

                if (/\basync\b|\bawait\b/.test(code)) {
                    add(`${label}: async/await is not supported by the current synchronous Action runtime contract`);
                }
                if (/\be\.context\b|\bcontext\.(?:load|save)\b/.test(code)) {
                    add(`${label}: invented e.context/context load-save API is forbidden`);
                }
                if (/\be\.refresh\s*\(/.test(code)) {
                    add(`${label}: e.refresh is a boolean flag, not a function`);
                }
                if (/\bapp\.objects\b/.test(code)) {
                    add(`${label}: app.objects is not declared runtime API; use app.query/getLookupObject`);
                }

                if (/\bfrom\s+(?!\{s\}\b)[A-Za-z_$][A-Za-z0-9_$.]*/i.test(code)) {
                    add(`${label}: semantic DataAPI query syntax (FROM Type) is unavailable in the legacy runtime; use native runtime SQL with FROM {s}`);
                }

                if (type === "AddRule" || type === "UpdateRule") {
                    const ruleExpression = String(code || "").trim();
                    try {
                        // Syntax-check the Rule exactly as the runtime conceptually uses it:
                        // return (<expression>). This rejects function-body fragments such as
                        // "const x = ...; return ...;" while allowing a genuine expression,
                        // including an IIFE: (() => { const x = ...; return true; })().
                        new Function("data", "app", "return (" + ruleExpression + ");");
                    } catch (ruleExpressionError) {
                        add(`${label}: Rule.Condition must be one valid JavaScript expression evaluated as return <expression>; for complex logic wrap statements in an IIFE such as (() => { ...; return true; })()`);
                    }
                }

                if (type === "AddAction" || type === "UpdateAction" || type === "AddEvent" || type === "UpdateEvent") {
                    if (/\.(?:Save|Load|Clone)\s*\(/.test(code)) {
                        add(`${label}: model/runtime object instance methods .Save()/.Load()/.Clone() are forbidden in Action/Event scripts; persist plain runtime data with app.upsertDocument(...)`);
                    }
                }

                if (type === "AddAction" || type === "UpdateAction") {
                    const trimmed = code.trim();
                    const isHandler =
                        /^\(?\s*e\s*\)?\s*=>/.test(trimmed) ||
                        /^function\s*\(\s*e\s*\)/.test(trimmed) ||
                        /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(trimmed);
                    if (!isHandler) {
                        add(`${label}: Action.Script must be one handler function (e) => { ... } or a declared external function name`);
                    }
                }
            });

            return errors;
        }

        function pruneAIGeneratedPlaceholderBehaviors(plan: AnyDoc): string[] {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const removed: string[] = [];

            plan.Operations = operations.filter((operation: AnyDoc) => {
                const type = String(operation?.Type || "");

                // In AI-first mode an unimplemented NEW behavior is safer to omit
                // than to persist a fake Rule/Action/Event that only looks implemented.
                // Never auto-drop Update* operations because those address existing model behavior.
                if (!["AddAction", "AddEvent", "AddRule"].includes(type)) return true;

                const code = getAIBehaviorOperationCode(operation);
                if (!isAIBehaviorCodePlaceholder(operation, code)) return true;

                const owner = getAIPlanOperationOwnerName(
                    operation,
                    operations,
                    getRuntimeObjectsArray(false)
                );
                const name = String(
                    operation?.Action?.Name ||
                    operation?.Event?.Name ||
                    operation?.Rule?.Name ||
                    "behavior"
                );

                removed.push(`${type} ${owner ? owner + "." : ""}${name}`);
                return false;
            });

            return removed;
        }

        function getAIMissingEditableRequirements(
            blueprint: DesignerAIBusinessBlueprint,
            plan: AnyDoc
        ): AnyDoc[] {
            const editableKinds = new Set([
                "TypeExists", "PropertyExists", "ReferenceSelection",
                "EmbeddedObject", "EmbeddedCollection",
                "ReverseCollection", "Formula",
                "DefaultValue", "Validation", "Action", "UpdateOnAction",
                "StatusTransition", "ReadOnlyWhen", "Inherits",
                "ListViewExists", "NavigationAccess"
            ]);
            const result: AnyDoc[] = [];
            const seen = new Set<string>();

            const inspect = (ownerKind: string, owner: AnyDoc): void => {
                if (String(owner?.Importance || "Core") !== "Core") return;

                const requirements = buildFallbackTypedRequirements(owner);
                requirements.forEach((requirement: AnyDoc) => {
                    const kind = String(requirement?.Kind || requirement?.Type || "");
                    if (!editableKinds.has(kind)) return;

                    const coverage = isAIRequirementImplemented(plan, requirement);
                    if (coverage.Implemented) return;

                    const key = JSON.stringify({
                        Kind: kind,
                        Target: requirement?.Target || null,
                        Source: requirement?.Source || null,
                        Action: requirement?.Action || null,
                        Condition: requirement?.Condition || null,
                        ReferenceType: requirement?.ReferenceType || null,
                        Values: requirement?.Values || null
                    });
                    if (seen.has(key)) return;
                    seen.add(key);

                    result.push({
                        OwnerKind: ownerKind,
                        OwnerId: owner?.Id || null,
                        OwnerName: owner?.Name || null,
                        Requirement: cloneData(requirement),
                        Missing: coverage.Missing
                    });
                });
            };

            (blueprint?.Scenarios || []).forEach((item: AnyDoc) =>
                inspect("Scenario", item)
            );
            (blueprint?.Capabilities || []).forEach((item: AnyDoc) =>
                inspect("Capability", item)
            );

            return result;
        }

        function buildDesignerAIPlanRepairPrompt(
            userPrompt: string,
            currentPlan: AnyDoc,
            missingRequirements: AnyDoc[],
            codeValidationErrors: string[] = []
        ): string {
            return [
                "Review the generated CosmoApps plan as a senior application designer.",
                "The plan is AI-first: semantic coverage diagnostics are advisory evidence, not commands and not a literal specification.",
                "Use your own judgment against ORIGINAL_REQUEST, BusinessBlueprint, CURRENT_PLAN_OPERATIONS, CodeKnowledge and the pending/project TypeScript models.",
                "If the business intent is already implemented coherently by different Actions/Rules/Events than a diagnostic expected, keep the existing architecture and do NOT create an artificial operation merely to satisfy the diagnostic name.",
                "Example: if PostReceipt, PostIssue, PostOutput, PostShipment and PostInventory already update StockBalance correctly, do not invent a generic PostDocument only because an advisory diagnostic mentions it.",
                "Return JSON with ONLY this shape: {\"Operations\":[...] }. Keep the JSON envelope concise, but keep executable JavaScript inside code strings readable and multiline with indentation and \n line breaks.",
                "Return only genuinely useful NEW or REPLACEMENT operations. If no semantic change is needed, return {\"Operations\":[]}.",
                "A replacement AddAction/AddRule/AddProperty with the same owner and Name replaces the earlier operation.",
                "CODE_VALIDATION_ERRORS are different: they are objective runtime/structure defects and MUST be corrected when present.",
                "Use CodeKnowledge, PendingPlanTypeScriptModel and ProjectTypeScriptModel as authoritative technical documentation.",
                "Action code is synchronous: no async and no await. Never use app.objects or invented APIs. Use only APIs declared in CodeKnowledge.PlatformApiDts.",
                "Rule.Condition and Rule.PreCondition must each be a single JavaScript expression because the runtime evaluates them as return <expression>. For complex logic, an IIFE such as (() => { const x = ...; if (...) return true; return false; })() is valid because the outer value is still one expression. Do not return a bare function-body fragment such as const x = ...; if (...) return ...;.",
                "Legacy app.query is synchronous and uses native runtime SQL with FROM {s}; never generate semantic DataAPI syntax such as FROM Client or FROM Module.Type.",
                "Action.Script must be a single (e) => { ... } handler (or a declared external function name), never an IIFE.",
                "In Action/Event scripts never call .Save(), .Load() or .Clone() on e.data/e.parent/e.params or other runtime objects. Persist with app.upsertDocument(...).",
                "Use string instead of unsupported html/text scalar types.",
                "Write Action/Event scripts and complex Rule IIFEs as formatted multiline JavaScript; do not collapse them to one line.",
                "For client UI in Actions/Events, use the current runtime stack (jQuery + DevExtreme 22.2). Mount temporary popup/widget containers into document.body or another live visible DOM container before initialization/show(), and remove them when closed.",
                "Do not create a Formula that references a property/collection absent from PendingPlanTypeScriptModel/ProjectTypeScriptModel. Formula may use only current scalar/Aggregated data; never traverse Hybrid/Deferred references such as Reference.Lines.",
                "Prefer a coherent domain implementation over mechanically matching advisory coverage labels.",
                "Keep output minimal: no prose outside JSON.",
                "",
                "ORIGINAL_REQUEST:",
                userPrompt,
                "",
                "ADVISORY_SEMANTIC_COVERAGE_DIAGNOSTICS:",
                JSON.stringify(missingRequirements),
                "",
                "CODE_VALIDATION_ERRORS:",
                JSON.stringify(codeValidationErrors || []),
                "",
                "CURRENT_PLAN_OPERATIONS:",
                JSON.stringify(Array.isArray(currentPlan?.Operations) ? currentPlan.Operations : [])
            ].join("\\n");
        }

        function getAIReservedCosmosIdentifierIssues(plan: AnyDoc): AIPlanValidationIssue[] {
            return validateAIPlanReferences(plan).Issues.filter(
                (issue: AIPlanValidationIssue) =>
                    issue.Code === "ReservedCosmosIdentifier" &&
                    (issue.Severity || "error") === "error"
            );
        }

        function getAIReservedIdentifierOperationName(operation: AnyDoc): string {
            const kind = String(operation?.Type || "");
            if (kind === "AddType") return String(operation?.Entity?.Name || "");
            if (kind === "AddEnum") return String(operation?.Enum?.Name || operation?.Entity?.Name || "");
            if (kind === "AddProperty") return String(operation?.Property?.Name || "");
            if (kind === "AddCollection") return String(operation?.Collection?.Name || "");
            if (kind === "AddObject") return String(operation?.Object?.Name || "");
            return "";
        }

        function buildDesignerAIReservedIdentifierRepairPrompt(
            userPrompt: string,
            currentPlan: AnyDoc,
            issues: AIPlanValidationIssue[]
        ): string {
            const operations: AnyDoc[] = Array.isArray(currentPlan?.Operations)
                ? currentPlan.Operations
                : [];
            const problemNames = new Set<string>();
            issues.forEach((issue: AIPlanValidationIssue) => {
                const op = operations[issue.OperationIndex];
                const name = getAIReservedIdentifierOperationName(op).trim();
                if (name) problemNames.add(name);
            });

            const relevantOperations = operations
                .map((operation: AnyDoc, index: number) => ({ OperationIndex: index, Operation: operation }))
                .filter((item: AnyDoc) => {
                    if (issues.some((issue: AIPlanValidationIssue) => issue.OperationIndex === item.OperationIndex)) {
                        return true;
                    }
                    const serialized = JSON.stringify(item.Operation || {});
                    for (const name of Array.from(problemNames)) {
                        if (serialized.indexOf(name) >= 0) return true;
                    }
                    return false;
                });

            return [
                "Repair ONLY Cosmos DB SQL reserved technical identifiers in the generated CosmoApps plan.",
                "This is an objective structural repair, not a redesign.",
                "Every exact technical Type.Name, Property.Name, Collection.Name or Enum.Name that is a Cosmos SQL reserved keyword must be renamed to a business-specific non-reserved English PascalCase identifier.",
                "Examples: Order -> CustomerOrder or OrderRecord; Group -> TenantGroup/WorkspaceGroup when it is a type, and GroupRef/TenantGroup when it is a reference property. Choose by the actual business meaning in ORIGINAL_REQUEST and the operation context.",
                "Do not escape or quote a reserved word. Do not change captions merely to hide the problem.",
                "Preserve TemporaryId, ids, references, aggregation, required flags and all unrelated fields.",
                "If executable code, Formula, DataSource, Rule, Action, Event, navigation metadata or another operation refers to the renamed technical identifier by name, return a replacement for that operation too so the plan remains internally consistent.",
                "Return ONLY valid JSON with this exact shape:",
                '{"Replacements":[{"OperationIndex":0,"Operation":{}}]}',
                "OperationIndex is zero-based and MUST refer to the original CURRENT_RELEVANT_OPERATIONS index shown below.",
                "Each Operation must be the complete replacement operation, not a patch.",
                "Return no replacement for an operation that does not need a change.",
                "Do not add or delete business features.",
                "Before sending, verify every repaired technical identifier is not a reserved Cosmos SQL keyword.",
                "",
                "ORIGINAL_REQUEST:",
                userPrompt,
                "",
                "VALIDATION_ISSUES:",
                JSON.stringify(issues),
                "",
                "CURRENT_RELEVANT_OPERATIONS:",
                JSON.stringify(relevantOperations)
            ].join("\\n");
        }

        function applyAIIndexedOperationReplacements(
            plan: AnyDoc,
            repairValue: AnyDoc
        ): { Plan: AnyDoc; Renames: { OldName: string; NewName: string }[] } {
            const result = cloneData(plan || {});
            const operations: AnyDoc[] = Array.isArray(result?.Operations)
                ? result.Operations
                : [];
            const replacements: AnyDoc[] = Array.isArray(repairValue?.Replacements)
                ? repairValue.Replacements
                : [];
            const renames: { OldName: string; NewName: string }[] = [];

            replacements.forEach((replacement: AnyDoc) => {
                const index = Number(replacement?.OperationIndex);
                if (!Number.isInteger(index) || index < 0 || index >= operations.length) return;
                const nextOperation = replacement?.Operation;
                if (!nextOperation || typeof nextOperation !== "object") return;

                const oldName = getAIReservedIdentifierOperationName(operations[index]).trim();
                const newName = getAIReservedIdentifierOperationName(nextOperation).trim();
                operations[index] = cloneData(nextOperation);

                if (oldName && newName && oldName !== newName) {
                    renames.push({ OldName: oldName, NewName: newName });
                }
            });

            result.Operations = operations;

            if (renames.length && typeof result.Message === "string") {
                let message = String(result.Message);
                renames.forEach((rename) => {
                    const escaped = rename.OldName.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&");
                    message = message.replace(
                        new RegExp("\\\\b" + escaped + "\\\\b", "g"),
                        rename.NewName
                    );
                });
                result.Message = message;
            }

            return { Plan: result, Renames: renames };
        }

        async function repairAIReservedCosmosIdentifiers(
            userPrompt: string,
            blueprint: DesignerAIBusinessBlueprint,
            sourcePlan: AnyDoc
        ): Promise<AnyDoc> {
            let plan = sourcePlan;

            for (let attempt = 0; attempt < 2; attempt++) {
                const issues = getAIReservedCosmosIdentifierIssues(plan);
                if (!issues.length) return plan;

                const repairResponse = await callDesignerAIService(
                    buildDesignerAIReservedIdentifierRepairPrompt(
                        userPrompt,
                        plan,
                        issues
                    ),
                    buildDesignerAIModelingContext(
                        blueprint,
                        plan
                    ),
                    [],
                    "ModelGeneration",
                    3000
                );

                const parsedRepair = tryParseDesignerAIContent(
                    repairResponse.Content,
                    repairResponse.FinishReason,
                    "ModelGeneration"
                );
                if (!parsedRepair.Success) return plan;

                const applied = applyAIIndexedOperationReplacements(
                    plan,
                    parsedRepair.Value
                );
                plan = normalizeDesignerAIPlan(applied.Plan);
                applyDesignerAIReuseAnalysisToPlan(plan, blueprint);
                (plan as AnyDoc).ConceptualTypes = cloneData(
                    (blueprint as AnyDoc).ConceptualTypes || []
                );
                (plan as AnyDoc).SemanticRelations = cloneData(
                    (blueprint as AnyDoc).SemanticRelations || []
                );
                normalizeAIConceptualGraphAgainstPlan(plan);
            }

            return plan;
        }

        function getAIRepairOperationIdentity(operation: AnyDoc): string {
            const kind = String(operation?.Type || "");
            const owner = String(operation?.EntityId || operation?.EntityRef?.TemporaryId || "");
            const property = String(operation?.PropertyId || operation?.PropertyName || "");
            if (kind === "AddAction") return `${kind}|${owner}|${String(operation?.Action?.Name || "")}`;
            if (kind === "AddRule") return `${kind}|${owner}|${property}|${String(operation?.Rule?.Name || "")}`;
            if (kind === "AddEvent") return `${kind}|${owner}|${property}|${String(operation?.Event?.Name || "")}`;
            if (kind === "AddProperty") return `${kind}|${owner}|${String(operation?.Property?.Name || "")}`;
            if (kind === "AddNavigationItem") return `${kind}|${owner}|${String(operation?.NavigationItem?.Name || "")}`;
            return "";
        }

        function mergeAIRepairOperations(plan: AnyDoc, repairValue: AnyDoc): AnyDoc {
            const result = cloneData(plan || {});
            const baseOps: AnyDoc[] = Array.isArray(result.Operations) ? result.Operations : [];
            const repairOps: AnyDoc[] = Array.isArray(repairValue?.Operations) ? repairValue.Operations : [];
            repairOps.forEach((operation: AnyDoc) => {
                const identity = getAIRepairOperationIdentity(operation);
                if (identity) {
                    const index = baseOps.findIndex((existing: AnyDoc) =>
                        getAIRepairOperationIdentity(existing) === identity
                    );
                    if (index >= 0) {
                        baseOps[index] = cloneData(operation);
                        return;
                    }
                }
                baseOps.push(cloneData(operation));
            });
            result.Operations = baseOps;
            return result;
        }

        function buildPendingPlanTypeScriptModel(plan: AnyDoc): string {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations) ? plan.Operations : [];
            const typeNames: Record<string, string> = {};
            const enumNames: Record<string, string> = {};
            operations.forEach((op: AnyDoc) => {
                if (op?.Type === "AddType" && op?.TemporaryId && op?.Entity?.Name) typeNames[String(op.TemporaryId)] = String(op.Entity.Name);
                if (op?.Type === "AddEnum" && op?.TemporaryId && op?.Enum?.Name) enumNames[String(op.TemporaryId)] = String(op.Enum.Name);
            });
            const lines: string[] = [
                "declare namespace PendingPlan {",
                "  export interface CosmoHybridRef<TTarget = unknown> { id: string; Name?: string; _type?: string; }"
            ];
            operations.filter((op: AnyDoc) => op?.Type === "AddEnum" && op?.Enum?.Name).forEach((op: AnyDoc) => {
                lines.push(`  export enum ${safeTsName(op.Enum.Name)} {`);
                (Array.isArray(op.Enum.Values) ? op.Enum.Values : []).forEach((v: AnyDoc) => {
                    lines.push(`    ${safeTsName(v.Name || v.Caption || "Value")} = ${JSON.stringify(v.Value)},`);
                });
                lines.push("  }");
            });
            Object.keys(typeNames).forEach((tmp: string) => {
                const name = safeTsName(typeNames[tmp]);
                lines.push(`  export interface ${name} {`);
                operations.filter((op: AnyDoc) => op?.Type === "AddProperty" && String(op?.EntityRef?.TemporaryId || "") === tmp).forEach((op: AnyDoc) => {
                    const p = op.Property || {};
                    if (!p.Name) return;
                    let t = "any";
                    if (typeof p.Type === "string") {
                        const map: AnyDoc = { string:"string", int:"number", float:"number", money:"number", boolean:"boolean", date:"Date", dateTime:"Date", time:"string" };
                        t = map[p.Type] || "any";
                    } else if (p.Type?.TemporaryId) {
                        const ref = String(p.Type.TemporaryId);
                        if (enumNames[ref]) t = safeTsName(enumNames[ref]);
                        else if (typeNames[ref]) {
                            const target = safeTsName(typeNames[ref]);
                            const aggregation = String(p.Aggregation || "");
                            if (aggregation === "Value") t = "string";
                            else if (aggregation === "Hybrid") t = "CosmoHybridRef<" + target + ">";
                            else t = target;
                        }
                    }
                    if (p.Many) t += "[]";
                    const optional = p.Required === false ? "?" : "";
                    if (p?.Type?.TemporaryId && typeNames[String(p.Type.TemporaryId)]) {
                        const aggregation = String(p.Aggregation || "");
                        const target = typeNames[String(p.Type.TemporaryId)];
                        lines.push(`    /** @relation ${aggregation || "Value"} @target ${target} */`);
                    }
                    lines.push(`    ${String(p.Name)}${optional}: ${t};`);
                });
                lines.push("  }");
            });
            lines.push("}");
            return lines.join("\n");
        }

        function buildDesignerAIModelingContext(
            blueprint: DesignerAIBusinessBlueprint,
            pendingPlan?: AnyDoc
        ): AnyDoc {
            const context = buildDesignerAIContext();

            if (blueprintNeedsCodeKnowledge(blueprint)) {
                context.CodeKnowledge = buildDesignerAICodeKnowledge();
                if (pendingPlan) {
                    context.CodeKnowledge.PendingPlanTypeScriptModel =
                        buildPendingPlanTypeScriptModel(pendingPlan);
                }
            }

            context.Workflow = {
                Phase: "ModelGeneration",
                Objective: "Compile the approved business blueprint into a complete CosmoApps model change plan.",
                BusinessBlueprint: cloneData(blueprint),
                ExistingModelReuseAnalysis: cloneData(
                    blueprint.ExistingModelReuseAnalysis || []
                ),
                Rules: [
                    "Return one complete Modify plan as JSON",
                    "ExistingModelReuseAnalysis in BusinessBlueprint is authoritative for reuse of current application types. Reuse is generic and must not depend on hard-coded business aliases.",
                    "BusinessBlueprint.ConceptualTypes is guidance about the main business concepts expected in the model; use model judgment if a different coherent structure better satisfies the scenarios.",
                    "BusinessBlueprint.SemanticRelations is guidance about intended business relationships; preserve it when it fits, but use model judgment when another coherent typed structure better satisfies the scenario.",
                    "Use a direct typed reference when the source record truly needs to store/select the target; otherwise a coherent typed path is acceptable.",
                    "Do not satisfy a direct SemanticRelation with string, text or an id surrogate.",
                    "Relation names describe business meaning and are not required property names.",
                    "For ReuseExisting, reference the exact ExistingTypeId and do not emit AddType or duplicate existing properties.",
                    "For ExtendExisting, reference the exact ExistingTypeId, add only missing required properties to that existing type, and do not emit AddType for RequestedType.",
                    "For CreateDerived, create the requested type and set its BaseType to the exact ExistingTypeId.",
                    "For CreateNew, create a new type even if its name resembles a type from another project or template.",
                    "Implement every Core scenario that does not require clarification",
                    "Do not omit ordinary supporting structures such as lines, lifecycle enums, totals, posting state, reservation data or reverse navigation when required by the blueprint",
                    "Return scenario coverage using the exact Scenario.Id values from BusinessBlueprint and capability coverage using the exact Capability.Id values",
                    "Do not translate, rename or reorder Scenario.Id or Capability.Id",
                    "Scenarios and Capabilities in the result contain only Id for scenarios and capabilities. Do not generate Evidence, Missing or Status; the designer computes coverage deterministically from typed Requirements and Operations.",
                    "Evidence must contain only exact model paths created by Operations or already present in ModelSummary",
                    "Never use unrelated fallback paths as Evidence",
                    "Treat BusinessBlueprint.Requirements as semantic guidance and review evidence, not as a literal low-level implementation script. The designer may report deterministic coverage diagnostics, but those diagnostics are advisory.",
                    "Do not invent runtime script APIs",
                    "Implement every Core scenario coherently. Prefer the simplest architecture that satisfies the business intent. A Requirement may be satisfied by an equivalent design even when operation names or decomposition differ from the blueprint wording.",
                    "When a user-facing root type needs to be reachable from the application, normally add navigation unless an equally clear access path already exists. Do not add duplicate navigation merely to satisfy a diagnostic.",
                    "Use Action/Rule/Event when executable behavior is genuinely required. For cross-document updates and lifecycle transitions, choose coherent executable behavior and meaningful action names; do not invent generic duplicate actions solely to mirror a blueprint label.",
                    "Use Formula, Rule and read-only metadata when those are the natural platform mechanisms. Do not force a Formula or Rule when the same business intent is more correctly implemented by another supported mechanism.",
                    "Collections are ordinary properties: use AddProperty with Property.Type set to the item type, Property.Many=true, and Property.Aggregation set explicitly",
                    "AddCollection remains accepted only as a compatibility alias and will be converted to an ordinary Many property",
                    "TemporaryId declaration order is irrelevant, but every referenced TemporaryId must be declared in the same plan"
                ]
            };

            return context;
        }

        function normalizeDesignerAIQuestion(
            value: any
        ): string {
            if (value === undefined || value === null) {
                return "";
            }

            if (typeof value === "string") {
                return value.trim();
            }

            if (typeof value !== "object") {
                return String(value).trim();
            }

            const directText =
                value.Question ||
                value.Text ||
                value.Message ||
                value.Prompt ||
                value.Description ||
                value.Caption ||
                value.Name;

            if (directText) {
                return String(directText).trim();
            }

            const choices = Array.isArray(value.Options)
                ? value.Options
                : (
                    Array.isArray(value.Choices)
                        ? value.Choices
                        : []
                );

            if (choices.length > 0) {
                return choices
                    .map((choice: any) =>
                        normalizeDesignerAIQuestion(choice)
                    )
                    .filter((choice: string) => !!choice)
                    .join(" / ");
            }

            try {
                return JSON.stringify(value);
            } catch {
                return String(value).trim();
            }
        }

        function parseDesignerAIBusinessBlueprint(content: any): DesignerAIBusinessBlueprint {
            const result = parseDesignerAIContent(content);

            result.ApplicationName = trimProjectText(
                String(result.ApplicationName || "")
                    .replace(/\s+/g, " ")
                    .trim(),
                100
            );

            if (
                result.ApplicationName &&
                getAIApplicationTypeDocs().length === 0 &&
                getAIApplicationEnumDocs().length === 0
            ) {
                aiSuggestedApplicationName = result.ApplicationName;
            }

            result.BusinessAnalysis =
                result.BusinessAnalysis && typeof result.BusinessAnalysis === "object"
                    ? result.BusinessAnalysis
                    : {};

            [
                "Actors", "ReferenceData", "Documents", "Lifecycles",
                "QuantitiesAndBalances", "DerivedValues", "Assumptions",
                "StandardCore", "IntentionalSimplifications",
                "UserPain", "DistinctiveRequirements"
            ].forEach(field => {
                if (!Array.isArray(result.BusinessAnalysis[field])) {
                    result.BusinessAnalysis[field] = [];
                }
            });

            // Some models nest these arrays inside BusinessAnalysis despite the
            // requested top-level schema. Accept both shapes.
            const nestedScenarios = result.BusinessAnalysis.Scenarios;
            const nestedCapabilities = result.BusinessAnalysis.Capabilities;
            const nestedQuestions = result.BusinessAnalysis.Questions;

            result.Scenarios = Array.isArray(result.Scenarios)
                ? result.Scenarios
                : (Array.isArray(nestedScenarios) ? nestedScenarios : []);

            result.Scenarios.forEach((scenario: AnyDoc, index: number) => {
                scenario.Id = String(scenario?.Id || `S${index + 1}`);
                scenario.Importance = normalizeScenarioImportance(
                    scenario?.Importance,
                    scenario
                );
            });

            result.Capabilities = Array.isArray(result.Capabilities)
                ? result.Capabilities
                : (Array.isArray(nestedCapabilities) ? nestedCapabilities : []);

            result.Scenarios.forEach((scenario: AnyDoc) => {
                scenario.Requirements = Array.isArray(scenario.Requirements)
                    ? scenario.Requirements
                    : [];
            });

            result.Capabilities.forEach((capability: AnyDoc) => {
                capability.Requirements = Array.isArray(capability.Requirements)
                    ? capability.Requirements
                    : [];

                capability.AcceptanceCriteria =
                    Array.isArray(capability.AcceptanceCriteria)
                        ? capability.AcceptanceCriteria
                        : (
                            capability.AcceptanceCriteria
                                ? [String(capability.AcceptanceCriteria)]
                                : []
                        );
            });

            result.Capabilities.forEach((capability: AnyDoc, index: number) => {
                capability.Id = String(capability?.Id || `C${index + 1}`);
            });

            result.Questions = (
                Array.isArray(result.Questions)
                    ? result.Questions
                    : (
                        Array.isArray(nestedQuestions)
                            ? nestedQuestions
                            : []
                    )
            )
                .map((question: any) =>
                    normalizeDesignerAIQuestion(question)
                )
                .filter((question: string) => !!question)
                .slice(0, 1);

            result.Assumptions = Array.isArray(result.Assumptions)
                ? result.Assumptions
                : [];

            result.ConceptualTypes =
                Array.isArray(result.ConceptualTypes)
                    ? result.ConceptualTypes
                        .map((item: any) =>
                            String(
                                typeof item === "string"
                                    ? item
                                    : (item?.Name || item?.Type || "")
                            ).trim()
                        )
                        .filter(Boolean)
                    : [];

            result.SemanticRelations =
                Array.isArray(result.SemanticRelations)
                    ? result.SemanticRelations
                        .map((item: AnyDoc) => ({
                            From: String(item?.From || item?.Source || "").trim(),
                            Relation: String(item?.Relation || item?.Verb || item?.Kind || "references").trim(),
                            To: String(item?.To || item?.Target || "").trim(),
                            Required: item?.Required !== false,
                            Direct: item?.Direct === true,
                            Reason: String(item?.Reason || "").trim(),
                            ScenarioIds: Array.isArray(item?.ScenarioIds)
                                ? item.ScenarioIds.map((x: any) => String(x || "").trim()).filter(Boolean)
                                : [],
                            CapabilityIds: Array.isArray(item?.CapabilityIds)
                                ? item.CapabilityIds.map((x: any) => String(x || "").trim()).filter(Boolean)
                                : []
                        }))
                        .filter((item: AnyDoc) => !!item.From && !!item.To && item.From !== item.To)
                    : [];

            const conceptualTypeSet =
                new Set<string>(
                    result.ConceptualTypes.map(
                        (name: string) =>
                            String(name).toLowerCase()
                    )
                );

            result.SemanticRelations =
                result.SemanticRelations.filter(
                    (relation: AnyDoc) =>
                        conceptualTypeSet.has(
                            String(
                                relation.From || ""
                            ).toLowerCase()
                        ) &&
                        conceptualTypeSet.has(
                            String(
                                relation.To || ""
                            ).toLowerCase()
                        )
                );

            result.ExistingModelReuseAnalysis =
                Array.isArray(result.ExistingModelReuseAnalysis)
                    ? result.ExistingModelReuseAnalysis
                        .map((item: AnyDoc) => ({
                            RequestedType: String(item?.RequestedType || "").trim(),
                            ExistingType: item?.ExistingType
                                ? String(item.ExistingType).trim()
                                : null,
                            ExistingTypeId: item?.ExistingTypeId
                                ? String(item.ExistingTypeId).trim()
                                : null,
                            Decision: String(item?.Decision || "CreateNew").trim(),
                            Confidence: Number.isFinite(Number(item?.Confidence))
                                ? Number(item.Confidence)
                                : null,
                            Reason: String(item?.Reason || "").trim(),
                            RequiredNewProperties: Array.isArray(item?.RequiredNewProperties)
                                ? item.RequiredNewProperties
                                    .map((x: any) => String(x || "").trim())
                                    .filter(Boolean)
                                : []
                        }))
                        .filter((item: AnyDoc) => !!item.RequestedType)
                    : [];

            const addSemanticEndpointRequirement = (
                item: AnyDoc,
                typeName: string
            ): void => {
                item.Requirements = Array.isArray(item.Requirements)
                    ? item.Requirements
                    : [];

                const exists = item.Requirements.some(
                    (requirement: AnyDoc) =>
                        normalizeAIRequirementKind(requirement?.Kind) ===
                        "TypeExists" &&
                        String(requirement?.Target || "") === typeName
                );

                if (!exists) {
                    item.Requirements.push({
                        Kind: "TypeExists",
                        Target: typeName
                    });
                }
            };

            (result.SemanticRelations || [])
                .filter((relation: AnyDoc) => relation?.Required !== false)
                .forEach((relation: AnyDoc) => {
                    const endpoints = [
                        String(relation.From || ""),
                        String(relation.To || "")
                    ].filter(Boolean);
                    const scenarioIds = Array.isArray(relation.ScenarioIds)
                        ? relation.ScenarioIds
                        : [];
                    const capabilityIds = Array.isArray(relation.CapabilityIds)
                        ? relation.CapabilityIds
                        : [];

                    endpoints.forEach((typeName: string) => {
                        let attached = false;

                        result.Scenarios.forEach((scenario: AnyDoc) => {
                            if (
                                scenarioIds.indexOf(String(scenario.Id || "")) >= 0
                            ) {
                                addSemanticEndpointRequirement(
                                    scenario,
                                    typeName
                                );
                                attached = true;
                            }
                        });

                        result.Capabilities.forEach((capability: AnyDoc) => {
                            if (
                                capabilityIds.indexOf(
                                    String(capability.Id || "")
                                ) >= 0
                            ) {
                                addSemanticEndpointRequirement(
                                    capability,
                                    typeName
                                );
                                attached = true;
                            }
                        });

                        if (!attached && result.Scenarios.length) {
                            addSemanticEndpointRequirement(
                                result.Scenarios[0],
                                typeName
                            );
                        }
                    });
                });

            if (aiThinkingMode === "strict") {
                result.Questions = [];
                result.NeedsClarification = false;
            } else {
                result.NeedsClarification =
                    result.NeedsClarification === true &&
                    result.Questions.length > 0;
            }

            return applyDesignerAIReuseAnalysisToBlueprint(
                result as DesignerAIBusinessBlueprint
            );
        }

        function ensureCreativeBusinessFraming(
            blueprint: DesignerAIBusinessBlueprint,
            request: string
        ): DesignerAIBusinessBlueprint {
            if (aiThinkingMode !== "creative") {
                return blueprint;
            }

            const analysis =
                blueprint.BusinessAnalysis || {};

            const asStrings = (value: any): string[] =>
                Array.isArray(value)
                    ? value
                        .map((item: any) =>
                            String(item || "").trim()
                        )
                        .filter(Boolean)
                    : [];

            const requestText =
                String(request || "").toLowerCase();

            let standardCore =
                asStrings(analysis.StandardCore);

            if (!standardCore.length) {
                const references =
                    asStrings(analysis.ReferenceData);
                const documents =
                    asStrings(analysis.Documents);

                standardCore = [
                    ...(
                        references.length
                            ? [
                                `Reference data: ${references.join(", ")}.`
                            ]
                            : []
                    ),
                    ...(
                        documents.length
                            ? [
                                `Operational documents: ${documents.join(", ")}.`
                            ]
                            : []
                    )
                ];

                if (!standardCore.length) {
                    standardCore = [
                        "A compact conventional model covering the explicitly requested business processes."
                    ];
                }
            }

            let simplifications =
                asStrings(
                    analysis.IntentionalSimplifications
                );

            if (!simplifications.length) {
                simplifications = [
                    "No approvals, reservations, batches, serial numbers, accounting integration or complex role model unless explicitly requested."
                ];

                if (
                    /не\s+хочу\s+сложн|прост(ая|ую|ой)|simple|not\s+complex/i
                        .test(requestText)
                ) {
                    simplifications.unshift(
                        "The solution is intentionally kept smaller than a typical ERP."
                    );
                }
            }

            let userPain =
                asStrings(analysis.UserPain);

            if (!userPain.length) {
                if (
                    /не\s+хочу\s+сложн|прост(ая|ую|ой)|simple|not\s+complex/i
                        .test(requestText)
                ) {
                    userPain = [
                        "The user wants the useful core of the business system without the complexity and overhead of a full ERP."
                    ];
                } else {
                    userPain = [
                        "The requested workflows should be available without forcing the user into unrelated enterprise features."
                    ];
                }
            }

            let distinctive =
                asStrings(
                    analysis.DistinctiveRequirements
                );

            if (!distinctive.length) {
                distinctive = [
                    "No distinctive process has been identified yet; the current request looks like a simplified standard solution."
                ];
            }

            analysis.StandardCore = standardCore;
            analysis.IntentionalSimplifications =
                simplifications;
            analysis.UserPain = userPain;
            analysis.DistinctiveRequirements =
                distinctive;

            const explicitlyRequestsBalances =
                /остат|balance|stock\s+level|inventory\s+balance/i
                    .test(requestText);

            if (!explicitlyRequestsBalances) {
                const hasBalanceImplementation = (
                    requirements: any
                ): boolean =>
                    Array.isArray(requirements) &&
                    requirements.some(
                        (requirement: AnyDoc) =>
                            [
                                "Formula",
                                "Action",
                                "UpdateOnAction",
                                "PropertyExists",
                                "TypeExists"
                            ].includes(
                                String(
                                    requirement?.Kind || ""
                                )
                            ) &&
                            /остат|balance|stock/i.test(
                                String(
                                    requirement?.Target || ""
                                )
                            )
                    );

                blueprint.Scenarios =
                    (blueprint.Scenarios || [])
                        .filter(
                            (scenario: AnyDoc) => {
                                const textValue = [
                                    scenario?.Name,
                                    scenario?.Description,
                                    scenario?.BusinessEffect,
                                    scenario?.Data
                                ]
                                    .map(value =>
                                        String(value || "")
                                    )
                                    .join(" ");

                                if (
                                    !/остат|balance|stock\s+level/i
                                        .test(textValue)
                                ) {
                                    return true;
                                }

                                return hasBalanceImplementation(
                                    scenario?.Requirements
                                );
                            }
                        );

                analysis.QuantitiesAndBalances =
                    asStrings(
                        analysis.QuantitiesAndBalances
                    ).filter(
                        item =>
                            !/остат|balance|stock\s+level/i
                                .test(item)
                    );
            }

            blueprint.BusinessAnalysis = analysis;
            return blueprint;
        }

        function isUsableBusinessBlueprint(
            blueprint: DesignerAIBusinessBlueprint
        ): boolean {
            return !!blueprint &&
                Array.isArray(blueprint.Scenarios) &&
                blueprint.Scenarios.length > 0 &&
                Array.isArray(blueprint.Capabilities) &&
                blueprint.Capabilities.length > 0;
        }

        function buildCompactBusinessAnalysisRetryPrompt(userPrompt: string): string {
            return [
                "Return a MINIMAL valid business blueprint as compact JSON only.",
                "This is a recovery retry after a response exceeded the completion limit.",
                "Do not explain. Do not generate Operations. Minimize prose aggressively.",
                "Preserve every explicit business process, but remove duplicated wording between Scenarios and Capabilities.",
                "Use short names and one short sentence at most for Description and AcceptanceCriteria.",
                "Scenario Trigger, Data, Lifecycle and BusinessEffect may be empty strings/arrays when the same fact is already represented by typed Requirements.",
                "Requirements are authoritative; keep them compact and typed.",
                "Explicit integrations, scheduled reminders, security/permissions, analytics/reporting and automation must use IntegrationBehavior, ScheduledBehavior, SecurityBehavior, ViewBehavior or ExecutableBehavior Requirements respectively; supporting fields alone do not implement behavior.",
                "Capabilities are resulting-application features only. Process discovery, platform selection, implementation/testing, documentation, training and team instructions are delivery activities, not Capabilities.",
                "ConceptualTypes is a compact hint list of main entity/document/reference-data concepts. Never include enums, statuses, scalar value lists, reports or UI concepts.",
                "Actors and access roles are not ConceptualTypes unless business records must persistently reference them as data.",
                "ExistingModelReuseAnalysis must analyze only types actually present in Context.ModelSummary.ApplicationModel.Types.",
                "ExistingModelReuseAnalysis is SPARSE: omit CreateNew decisions. Missing entry means CreateNew. Return only ReuseExisting, ExtendExisting, CreateDerived or Ambiguous decisions.",
                "If the current application has no types, ExistingModelReuseAnalysis must be [].",
                "SemanticRelations is a compact directed graph of required type-to-type business relationships.",
                "Each SemanticRelations item has From, Relation, To, Required, Reason, ScenarioIds and CapabilityIds. From and To are technical business type identifiers, not fields or prose concepts.",
                "Strict mode: include only relations explicit in the request or structurally necessary for an explicit scenario. Creative mode may add a small conventional supporting graph when it materially improves coherence; every inferred relation needs a short Reason.",
                "If Context.ModelSummary.ApplicationModel.IsStructurallyEmpty=true, every requested business type must use Decision=CreateNew; never invent an existing type or id.",
                "Every AddEnum decision is deferred to model generation; this phase only describes conceptual types and requirements.",
                "",
                "Request:",
                userPrompt,
                "",
                "Required shape:",
                "{",
                '"Intent":"ReadyToModel",',
                '"Summary":"...",',
                '"ConceptualTypes":["TypeA","TypeB"],',
                '"Scenarios":[{"Id":"S1","Name":"...","Importance":"Core","Requirements":[{"Kind":"TypeExists","Target":"TypeA"}]}],',
                '"Capabilities":[{"Id":"C1","Name":"...","Requirements":[{"Kind":"Crud","Target":"TypeA"}]}],',
                '"Questions":[],',
                '"Assumptions":[],',
                '"ExistingModelReuseAnalysis":[],',
                '"SemanticRelations":[{"From":"TypeA","Relation":"references","To":"TypeB","Required":true,"Direct":true,"Reason":"...","ScenarioIds":["S1"],"CapabilityIds":[]}],',
                '"NeedsClarification":false',
                "}",
                "",
                "HARD LIMIT: complete JSON under about 1800 output tokens.",
                "Maximum 8 scenarios, 12 compact capabilities, 5 requirements per item, 12 SemanticRelations. Never omit an explicit requested capability merely because it is unsupported by Operations.",
                "Questions: normally []. Ask at most one only for architecture-changing ambiguity that cannot be safely represented with a reversible assumption.",
                "Use English technical identifiers in ConceptualTypes, Requirement targets and SemanticRelations endpoints.",
                "SemanticRelations endpoints must be ConceptualTypes only; never enums/statuses.",
                "Close every quote, bracket and brace."].join("\n");
        }

        function getDesignerAIThinkingModeInstruction(): string {
            if (aiThinkingMode === "creative") {
                return [
                    "THINKING MODE: CREATIVE.",
                    "Treat the user's request as a business goal, not only as a literal field list.",
                    "Act as an experienced business analyst and solution architect.",
                    "First decide whether the user mainly needs a simpler version of a standard CRM/ERP pattern or has a distinctive business process that standard products handle poorly.",
                    "For a mostly standard request, confidently propose a minimal conventional core instead of asking the user to design it.",
                    "Keep that core deliberately small: do not add enterprise complexity such as approvals, reservations, batches, serial numbers, accounting integration or complex roles unless the request requires it.",
                    "Actively look for the user's specific pain, exception or unusual workflow. Preserve it as a first-class requirement rather than flattening it into the standard template.",
                    "Show the user exactly where the proposed model addresses that pain.",
                    "Clearly separate explicit requirements, proposed standard core, intentional simplifications, detected user pain, distinctive requirements and assumptions.",
                    "Ask at most one clarification question, and only when its answer materially changes the architecture or may reveal why the user needs a custom system.",
                    "In Creative mode, do not block model generation for ordinary missing details. Make safe conventional assumptions, generate a useful first concept immediately, and present the single question as an optional refinement after the proposal.",
                    "Every explicit process named by the user must remain visible in Scenarios and Capabilities; do not silently omit purchases, sales, transfers, warehouses, counterparties, prices, totals or other requested business functions.",
                    "Whenever a safe, reversible conventional assumption exists, state it and continue instead of asking.",
                    "You may propose domain concepts, workflows, reference data, document structure and relationships that materially improve the solution.",
                    "For SemanticRelations, infer a small coherent supporting graph when a conventional relationship is materially necessary for the proposed workflow; state the business reason instead of silently assuming it.",
                    "Prefer a coherent useful concept over the narrowest possible interpretation.",
                    "Do not invent arbitrary complexity. Every proposed addition must have a clear business reason.",
                    "When generating Operations, implement the coherent concept described in the plan, including reasonable supporting structure, while keeping assumptions and the user's pain visible in the response."
                ].join("\n");
            }

            return [
                "THINKING MODE: STRICT.",
                "Follow the user's explicit requirements literally.",
                "Add only structural elements strictly required to represent the request.",
                "Do not introduce conventional fields, workflows, statuses, totals, reports, validations or navigation unless explicitly requested or technically unavoidable.",
                "Do not omit a type-to-type relation that is structurally necessary to represent an explicit process merely because the user did not name the field. Record that relation in SemanticRelations; omit optional conventional relations.",
                "STRICT IS GENERATION-FIRST. Do not stop to ask clarification questions during model creation.",
                "Use Questions: [] in Strict mode. When details are ambiguous, choose the smallest reversible interpretation, record it in Assumptions, and continue.",
                "Never ask for enum values, optional fields, labels, UI details, document totals, reminder wording, attachment targets or similar reversible details.",
                "If architecture itself is ambiguous, choose the narrower coherent structure and state the alternative in Assumptions/Recommendations instead of blocking generation."
            ].join("\n");
        }

        function splitDesignerAIContextForProvider(context: AnyDoc): { StaticContext: AnyDoc; DynamicContext: AnyDoc } {
            const source = cloneData(context || {});
            const staticContext: AnyDoc = {};
            const dynamicContext: AnyDoc = cloneData(source);

            const moveStatic = (name: string) => {
                if (source[name] === undefined) return;
                staticContext[name] = cloneData(source[name]);
                delete dynamicContext[name];
            };

            // DeepSeek caches a common prompt prefix. Keep platform-level contracts
            // byte-stable and ahead of task/application data so unrelated projects can
            // reuse the same cache prefix.
            [
                "AssistantScope",
                "SemanticRules",
                "ValueKinds",
                "StorageKinds",
                "Aggregations",
                "PlatformCapabilities",
                "OperationContract",
                "Capabilities"
            ].forEach(moveStatic);

            if (source.MetamodelEditingContract) {
                const staticMeta = cloneData(source.MetamodelEditingContract);
                const dynamicExamples: AnyDoc = {};
                ["ExistingTypeExamples", "ExistingPropertyExamples"].forEach((name: string) => {
                    if (staticMeta[name] !== undefined) {
                        dynamicExamples[name] = cloneData(staticMeta[name]);
                        delete staticMeta[name];
                    }
                });
                staticContext.MetamodelEditingContract = staticMeta;
                delete dynamicContext.MetamodelEditingContract;
                if (Object.keys(dynamicExamples).length) {
                    dynamicContext.MetamodelEditingRuntimeExamples = dynamicExamples;
                }
            }

            if (source.CodeKnowledge) {
                const staticCode = cloneData(source.CodeKnowledge);
                const dynamicCode: AnyDoc = {};
                ["ProjectTypeScriptModel", "PendingPlanTypeScriptModel"].forEach((name: string) => {
                    if (staticCode[name] !== undefined) {
                        dynamicCode[name] = cloneData(staticCode[name]);
                        delete staticCode[name];
                    }
                });
                staticContext.CodeKnowledge = staticCode;
                delete dynamicContext.CodeKnowledge;
                if (Object.keys(dynamicCode).length) {
                    dynamicContext.CodeKnowledge = dynamicCode;
                }
            }

            if (source.ModelSummary?.MetaModel) {
                staticContext.ModelSummary = {
                    MetaModel: cloneData(source.ModelSummary.MetaModel)
                };
                if (dynamicContext.ModelSummary) {
                    delete dynamicContext.ModelSummary.MetaModel;
                    if (!Object.keys(dynamicContext.ModelSummary).length) {
                        delete dynamicContext.ModelSummary;
                    }
                }
            }

            return {
                StaticContext: staticContext,
                DynamicContext: dynamicContext
            };
        }

        async function callDesignerAIService(
            prompt: string,
            context: AnyDoc,
            conversation: AnyDoc[],
            phase: "BusinessAnalysis" | "BusinessAnalysisAudit" | "ModelGeneration",
            networkRetry: boolean = false
        ): Promise<any> {
            const serviceCall = ++designerAIPipelineServiceSequence;
            const callKind = classifyDesignerAIServiceCall(prompt, phase, networkRetry);
            traceDesignerAIPipeline("AI.Call.Start", {
                Call: serviceCall, Kind: callKind, Phase: phase, NetworkRetry: networkRetry === true
            });

            const startedAt =
                Date.now();
            const startedAtUtc =
                new Date(
                    startedAt
                ).toISOString();

            const providerContext =
                splitDesignerAIContextForProvider(context);

            const requestPayload = {
                TaskId:
                    aiTaskId,
                Phase:
                    phase,
                Prompt: [
                    getDesignerAIThinkingModeInstruction(),
                    "",
                    prompt
                ].join("\n"),
                StaticContext:
                    providerContext.StaticContext,
                Context:
                    providerContext.DynamicContext,
                Conversation:
                    conversation,
                MaxTokens:
                    phase ===
                    "BusinessAnalysis"
                        ? 6000
                        : (networkRetry ? 6000 : 8000),
                NetworkRetry:
                    networkRetry
            };

            const trace: AnyDoc = {
                ReportId:
                    new DevExpress
                        .data
                        .Guid()
                        .toString(),
                Url:
                    "DesignerAI.ashx",
                Phase:
                    phase,
                StartedAtUtc:
                    startedAtUtc,
                CompletedAtUtc:
                    null,
                DurationMs:
                    null,
                HttpStatus:
                    null,
                HttpStatusText:
                    null,
                Request:
                    requestPayload,
                Response:
                    null,
                ParsedResponse:
                    null
            };

            lastDesignerAITrace =
                trace;

            try {
                const response =
                    await fetch(
                        "DesignerAI.ashx",
                        {
                            method:
                                "POST",
                            credentials:
                                "same-origin",
                            headers: {
                                "Content-Type":
                                    "application/json"
                            },
                            body:
                                JSON.stringify(
                                    requestPayload
                                )
                        }
                    );

                const responseText =
                    await response.text();

                trace.CompletedAtUtc =
                    new Date()
                        .toISOString();
                trace.DurationMs =
                    Date.now() -
                    startedAt;
                trace.HttpStatus =
                    response.status;
                trace.HttpStatusText =
                    response.statusText ||
                    null;
                trace.Response =
                    responseText;

                let serviceResponse: any =
                    null;

                try {
                    serviceResponse =
                        responseText
                            ? JSON.parse(
                                responseText
                            )
                            : null;
                    trace.ParsedResponse =
                        serviceResponse;
                } catch (
                    parseError: any
                ) {
                    const error: any =
                        new Error(
                            `Designer AI returned invalid service JSON during ${phase} (HTTP ${response.status}).`
                        );

                    error.DesignerAIReport =
                        trace;
                    error.cause =
                        parseError;

                    throw error;
                }

                traceDesignerAIPipeline("AI.Call.Done", {
                    Call: serviceCall, Kind: callKind, Phase: phase,
                    DurationMs: trace.DurationMs, HttpStatus: response.status,
                    FinishReason: serviceResponse?.FinishReason || null,
                    ContentChars: String(serviceResponse?.Content || "").length
                });

                if (
                    !response.ok ||
                    !serviceResponse?.Success
                ) {
                    const error: any =
                        new Error(
                            serviceResponse?.Error ||
                            `Designer AI ${phase} request failed with HTTP ${response.status}.`
                        );

                    error.DesignerAIReport =
                        trace;

                    throw error;
                }

                return serviceResponse;
            } catch (
                serviceError: any
            ) {
                if (
                    trace.CompletedAtUtc ===
                    null
                ) {
                    trace.CompletedAtUtc =
                        new Date()
                            .toISOString();
                    trace.DurationMs =
                        Date.now() -
                        startedAt;
                }

                if (
                    !serviceError
                        ?.DesignerAIReport
                ) {
                    serviceError.DesignerAIReport =
                        trace;
                }

                lastDesignerAITrace =
                    trace;

                const fetchFailedBeforeHttpResponse =
                    phase === "ModelGeneration" &&
                    !networkRetry &&
                    trace.HttpStatus === null &&
                    /failed\s+to\s+fetch|networkerror|network\s+request\s+failed/i.test(
                        String(serviceError?.message || serviceError || "")
                    );

                if (fetchFailedBeforeHttpResponse) {
                    return await callDesignerAIService(
                        prompt,
                        context,
                        conversation,
                        phase,
                        true
                    );
                }

                throw serviceError;
            }
        }



        function normalizeScenarioImportance(
            value: any,
            scenario: AnyDoc
        ): "Core" | "Supporting" {
            const raw = String(value || "").trim().toLowerCase();

            if (
                raw === "core" ||
                raw === "основной" ||
                raw === "основная" ||
                raw === "ключевой" ||
                raw === "ключевая" ||
                raw === "critical"
            ) {
                return "Core";
            }

            if (
                raw === "supporting" ||
                raw === "support" ||
                raw === "поддерживающий" ||
                raw === "поддерживающая" ||
                raw === "вспомогательный" ||
                raw === "вспомогательная" ||
                raw === "secondary"
            ) {
                return "Supporting";
            }

            const text = [
                scenario?.Name,
                scenario?.Description
            ].filter(Boolean).join(" ").toLowerCase();

            if (
                text.indexOf("просмотр") >= 0 ||
                text.indexOf("view") >= 0 ||
                text.indexOf("отч") >= 0 ||
                text.indexOf("report") >= 0 ||
                text.indexOf("справочник") >= 0 ||
                text.indexOf("catalog") >= 0
            ) {
                return "Supporting";
            }

            return "Core";
        }

        function normalizeMatchingKey(value: any): string {
            return String(value || "")
                .trim()
                .toLowerCase()
                .replace(/[^a-zа-яё0-9]+/gi, "");
        }

        function normalizeAIRequiredModelElement(value: any): string {
            let result = String(value || "").trim();

            result = result.replace(/\s*\([^)]*\)\s*$/g, "").trim();
            result = result.replace(/^(property|field|collection)\s*:\s*/i, "").trim();

            return result;
        }

        function isAIBehavioralRequirement(value: any): boolean {
            const original = String(value || "").trim();
            const normalized = normalizeAIRequiredModelElement(original);

            if (!normalized) return false;

            if (/^[A-Za-z_][A-Za-z0-9_]*(\.[A-Za-z_][A-Za-z0-9_]*)?$/.test(normalized)) {
                return false;
            }

            const behavioralMarkers = [
                "rule", "action", "validation", "restriction", "prohibition",
                "automatic", "automatically", "calculate", "update", "post",
                "create", "edit", "delete", "select", "change", "set", "block",
                "prevent", "allow", "recalculate", "decrease", "increase",
                "провер", "правил", "действ", "запрет", "автомат",
                "проведен", "обнов", "расчет", "расчёт", "нельзя",
                "создан", "созда", "редакт", "удален", "удал",
                "выбор", "выбира", "измен", "установ", "блокир",
                "разреш", "пересчет", "пересчёт", "уменьш", "увелич",
                "списан", "списыв", "контрол", "подтвержд",
                "провод", "фиксир",
                "закрыва", "отмен", "переходит", "становится",
                "обновляется", "уменьшается", "увеличивается",
                "остаётся", "остается", "остаток", "отгружено",
                "не превышает", "недоступ", "после отгрузки",
                "когда ", "после ", "при ",
                "просмотр списка", "история", "отображение заказанного",
                "отображение остатка", "видит список накладных",
                "view list", "history", "display remaining",
                "must not exceed", "becomes", "when ", "after ", "if "
            ];

            const lower = original.toLowerCase();

            return behavioralMarkers.some(marker => lower.indexOf(marker) >= 0);
        }

        function getAIMissingBehaviorRequirements(
            plan: AnyDoc,
            values: any[]
        ): string[] {
            return (Array.isArray(values) ? values : [])
                .filter((value: any) =>
                    isAIBehavioralRequirement(value) &&
                    !hasAIBehaviorImplementation(plan, value)
                )
                .map((value: any) => `Behavior: ${String(value).trim()}`);
        }

        function getAIPlanEnumValueNames(plan: AnyDoc): string[] {
            const values: string[] = [];
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type !== "AddEnum") return;

                (Array.isArray(operation?.Enum?.Values)
                    ? operation.Enum.Values
                    : []
                ).forEach((item: AnyDoc) => {
                    const name = String(item?.Name || "").trim();
                    const caption = String(item?.Caption || "").trim();

                    if (name) values.push(name.toLowerCase());
                    if (caption) values.push(caption.toLowerCase());
                });
            });

            return values;
        }

        function isAIStatusDeclarationImplemented(
            plan: AnyDoc,
            requirement: any
        ): boolean {
            const lower = String(requirement || "").toLowerCase();
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];

            const hasStatusProperty = operations.some((operation: AnyDoc) =>
                operation?.Type === "AddProperty" &&
                String(operation?.Property?.Name || "").toLowerCase() === "status"
            );

            if (!hasStatusProperty) return false;

            const declarationMarkers = [
                "имеет статус",
                "статус (",
                "status values",
                "has status"
            ];

            if (!declarationMarkers.some(marker => lower.indexOf(marker) >= 0)) {
                return false;
            }

            const enumValues = getAIPlanEnumValueNames(plan);

            // If the criterion lists concrete values, require all mentioned values
            // to be present in a generated enum. Otherwise the Status field is enough.
            const quotedValues = Array.from(
                lower.matchAll(/['«"]([^'»"]+)['»"]/g)
            ).map(match => String(match[1] || "").trim());

            if (!quotedValues.length) {
                return true;
            }

            return quotedValues.every(value =>
                enumValues.indexOf(value.toLowerCase()) >= 0
            );
        }

        function hasAIBehaviorImplementation(plan: AnyDoc, requirement: any): boolean {
            const lower = String(requirement || "").toLowerCase();
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];

            const hasExecutableOperation = operations.some((operation: AnyDoc) => {
                const kind = String(operation?.Type || "").toLowerCase();

                if (
                    kind.indexOf("action") < 0 &&
                    kind.indexOf("rule") < 0 &&
                    kind.indexOf("validation") < 0 &&
                    kind.indexOf("constraint") < 0
                ) {
                    return false;
                }

                const serialized = JSON.stringify(operation).toLowerCase();

                return lower
                    .split(/[^a-zа-яё0-9_]+/i)
                    .filter((token: string) => token.length >= 5)
                    .some((token: string) => serialized.indexOf(token) >= 0);
            });

            if (hasExecutableOperation) {
                return true;
            }

            if (isAIStatusDeclarationImplemented(plan, requirement)) {
                return true;
            }

            const addedTypes = operations.filter(
                (operation: AnyDoc) => operation?.Type === "AddType"
            );
            const addedProperties = operations
                .filter((operation: AnyDoc) => operation?.Type === "AddProperty")
                .map((operation: AnyDoc) => operation?.Property || {});
            const addedCollections = operations.filter(
                (operation: AnyDoc) =>
                    operation?.Type === "AddCollection" ||
                    (
                        operation?.Type === "AddProperty" &&
                        operation?.Property?.Many === true
                    )
            );

            const hardBehaviorMarkers = [
                "автомат", "при проведен", "проводит", "проведение",
                "обновляет", "обновление", "уменьшает", "увеличивает",
                "списывает", "списание", "не превышает", "контроль превышения",
                "блокировка", "запрещ", "после подтверждения",
                "только до", "невозможна", "проверяет",
                "automatically", "on posting", "post ", "update",
                "decrease", "increase", "write off", "must not exceed",
                "validation", "block", "prevent", "only before"
            ];

            const describesShipmentBalance =
                /остаток|отгружен|remaining|shipped/i.test(lower);

            if (describesShipmentBalance) {
                const balanceFormulaExists = addedProperties.some(
                    (property: AnyDoc) => {
                        const name = String(
                            property?.Name || ""
                        ).toLowerCase();

                        return (
                            name === "remainingquantity" ||
                            name === "shippedquantity"
                        ) &&
                            !!property?.Formula?.Code;
                    }
                );

                if (!balanceFormulaExists) {
                    return false;
                }
            }

            const describesCalculation =
                /вычисл|пересчит|рассчит|расч[её]т|сумм[аы]\s+(строк|заказ|наклад)|итог/i
                    .test(lower) ||
                /обновля.*(?:строк|позиц)|изменени.*(?:строк|позиц)/i
                    .test(lower) ||
                /calculat|recalculat|total\s+amount|line\s+amount/i
                    .test(lower) ||
                /update.*(?:line|item)|change.*(?:line|item)/i
                    .test(lower);

            if (
                describesCalculation &&
                addedProperties.some((property: AnyDoc) =>
                    !!property?.Formula?.Code
                )
            ) {
                return true;
            }

            if (hardBehaviorMarkers.some(marker => lower.indexOf(marker) >= 0)) {
                return false;
            }

            // Standard model-driven CRUD is provided by the runtime for browsable types.
            const crudMarkers = [
                "созда", "создание",
                "редакт", "изменя", "изменение",
                "удаля", "удаление",
                "create", "creation", "edit", "editing", "delete", "deletion"
            ];

            if (
                crudMarkers.some(marker => lower.indexOf(marker) >= 0) &&
                addedTypes.length > 0
            ) {
                return true;
            }

            // Selecting a referenced object is native for Hybrid/Value references.
            if (
                (
                    lower.indexOf("выбор клиента") >= 0 ||
                    lower.indexOf("выбрать клиента") >= 0 ||
                    lower.indexOf("выбирает клиента") >= 0 ||
                    lower.indexOf("выбор товара") >= 0 ||
                    lower.indexOf("выбрать товар") >= 0 ||
                    lower.indexOf("выбирает товар") >= 0 ||
                    lower.indexOf("выбор заказа") >= 0 ||
                    lower.indexOf("выбрать заказ") >= 0 ||
                    lower.indexOf("выбирает заказ") >= 0 ||
                    lower.indexOf("select customer") >= 0 ||
                    lower.indexOf("select product") >= 0 ||
                    lower.indexOf("select order") >= 0
                ) &&
                addedProperties.some((property: AnyDoc) =>
                    ["Hybrid", "Value"].indexOf(
                        String(property?.Aggregation || "")
                    ) >= 0
                )
            ) {
                return true;
            }

            // Editing ordinary scalar fields is native when they are not read-only.
            if (
                (
                    lower.indexOf("редактируема") >= 0 ||
                    lower.indexOf("редактируемы") >= 0 ||
                    lower.indexOf("изменить цену") >= 0 ||
                    lower.indexOf("указывает количество") >= 0 ||
                    lower.indexOf("указывает отгружаемое количество") >= 0 ||
                    lower.indexOf("editable") >= 0
                ) &&
                addedProperties.some((property: AnyDoc) => {
                    const name = String(property?.Name || "").toLowerCase();

                    return (
                        name === "price" ||
                        name === "quantity"
                    ) &&
                        property?.ReadOnly !== true;
                })
            ) {
                return true;
            }

            // Adding and editing embedded lines is native for Aggregated Many properties.
            if (
                (
                    lower.indexOf("добавить строки") >= 0 ||
                    lower.indexOf("добавляет строки") >= 0 ||
                    lower.indexOf("add lines") >= 0
                ) &&
                addedCollections.some((operation: AnyDoc) => {
                    const member =
                        operation?.Collection || operation?.Property || {};
                    return (
                        member?.Many === true ||
                        operation?.Type === "AddCollection"
                    ) &&
                        String(member?.Aggregation || "") === "Aggregated";
                })
            ) {
                return true;
            }

            // A related-document list is native only when the model contains
            // an explicit collection or a direct reference that the runtime can expose.
            if (
                (
                    lower.indexOf("просмотр списка") >= 0 ||
                    lower.indexOf("история") >= 0 ||
                    lower.indexOf("видит список накладных") >= 0 ||
                    lower.indexOf("view list") >= 0 ||
                    lower.indexOf("history") >= 0
                ) &&
                addedCollections.some((operation: AnyDoc) => {
                    const member =
                        operation?.Collection || operation?.Property || {};
                    return (
                        member?.Many === true ||
                        operation?.Type === "AddCollection"
                    );
                })
            ) {
                return true;
            }

            // Displaying ordered/shipped/remaining quantities requires an actual
            // derived balance or executable update. A standalone ShippedQuantity
            // field with default 0 is not evidence that shipment posting updates it.
            if (
                lower.indexOf("отображение заказанного") >= 0 ||
                lower.indexOf("отображение остатка") >= 0 ||
                lower.indexOf("показывает остаток") >= 0 ||
                lower.indexOf("виден остаток") >= 0 ||
                lower.indexOf("сколько ещё не отгружено") >= 0 ||
                lower.indexOf("сколько еще не отгружено") >= 0 ||
                lower.indexOf("display remaining") >= 0
            ) {
                const remainingProperty = addedProperties.find(
                    (property: AnyDoc) =>
                        String(property?.Name || "").toLowerCase() ===
                        "remainingquantity"
                );
                const shippedProperty = addedProperties.find(
                    (property: AnyDoc) =>
                        String(property?.Name || "").toLowerCase() ===
                        "shippedquantity"
                );

                const hasRemainingFormula =
                    !!remainingProperty?.Formula?.Code;
                const hasShippedFormula =
                    !!shippedProperty?.Formula?.Code;

                return hasRemainingFormula || hasShippedFormula;
            }

            // Manual status selection is supported by an enum-valued Status property.
            if (
                (
                    lower.indexOf("перевести в статус") >= 0 ||
                    lower.indexOf("изменение статуса") >= 0 ||
                    lower.indexOf("set status") >= 0 ||
                    lower.indexOf("change status") >= 0
                ) &&
                addedProperties.some((property: AnyDoc) =>
                    String(property?.Name || "").toLowerCase() === "status"
                )
            ) {
                return true;
            }

            return false;
        }

        function buildAIPlanStructuralEvidence(plan: AnyDoc): Set<string> {
            const evidence = new Set<string>();
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];
            const existingTypes = getRuntimeObjectsArray(false);

            existingTypes.forEach((typeDoc: AnyDoc) => {
                const typeName = String(typeDoc?.Name || "").trim();
                if (!typeName) return;

                evidence.add(typeName);

                (Array.isArray(typeDoc?.Properties) ? typeDoc.Properties : [])
                    .forEach((property: AnyDoc) => {
                        const propertyName = String(property?.Name || "").trim();
                        if (propertyName) {
                            evidence.add(`${typeName}.${propertyName}`);
                        }
                    });
            });

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type === "AddType") {
                    const typeName = String(operation?.Entity?.Name || "").trim();
                    if (typeName) evidence.add(typeName);
                }
            });

            operations.forEach((operation: AnyDoc) => {
                if (operation?.Type !== "AddProperty") return;

                const ownerName = getAIPlanTypeNameByRef(
                    operation.EntityRef || operation.EntityId,
                    operations,
                    existingTypes
                );
                const propertyName = String(operation?.Property?.Name || "").trim();

                if (ownerName) evidence.add(ownerName);
                if (ownerName && propertyName) {
                    evidence.add(`${ownerName}.${propertyName}`);
                }
            });

            return evidence;
        }


        function normalizeAIRequirementKind(value: any): string {
            const raw = String(value || "").trim().toLowerCase();
            const aliases: Record<string, string> = {
                "typeexists": "TypeExists",
                "type": "TypeExists",
                "propertyexists": "PropertyExists",
                "property": "PropertyExists",
                "field": "PropertyExists",
                "crud": "Crud",
                "referenceselection": "ReferenceSelection",
                "reference": "ReferenceSelection",
                "embeddedobject": "EmbeddedObject",
                "aggregatedobject": "EmbeddedObject",
                "ownedobject": "EmbeddedObject",
                "embeddedcollection": "EmbeddedCollection",
                "aggregatedcollection": "EmbeddedCollection",
                "reversecollection": "ReverseCollection",
                "deferredcollection": "ReverseCollection",
                "formula": "Formula",
                "defaultvalue": "DefaultValue",
                "validation": "Validation",
                "constraint": "Validation",
                "action": "Action",
                "updateonaction": "UpdateOnAction",
                "statustransition": "StatusTransition",
                "readonlywhen": "ReadOnlyWhen",
                "inherits": "Inherits",
                "inheritance": "Inherits",
                "basetype": "Inherits",
                "listviewexists": "ListViewExists",
                "listview": "ListViewExists",
                "navigationaccess": "NavigationAccess",
                "navigation": "NavigationAccess",
                "integrationbehavior": "IntegrationBehavior",
                "integration": "IntegrationBehavior",
                "externalintegration": "IntegrationBehavior",
                "scheduledbehavior": "ScheduledBehavior",
                "scheduled": "ScheduledBehavior",
                "reminderbehavior": "ScheduledBehavior",
                "scheduler": "ScheduledBehavior",
                "securitybehavior": "SecurityBehavior",
                "security": "SecurityBehavior",
                "permissions": "SecurityBehavior",
                "accesscontrol": "SecurityBehavior",
                "viewbehavior": "ViewBehavior",
                "reportingbehavior": "ViewBehavior",
                "analyticsbehavior": "ViewBehavior",
                "reporting": "ViewBehavior",
                "analytics": "ViewBehavior",
                "executablebehavior": "ExecutableBehavior",
                "automationbehavior": "ExecutableBehavior",
                "automation": "ExecutableBehavior"
            };

            return aliases[raw] || String(value || "").trim();
        }

        function buildFallbackTypedRequirements(
            item: AnyDoc
        ): AnyDoc[] {
            const explicit = Array.isArray(item?.Requirements)
                ? item.Requirements.filter(Boolean)
                : [];

            if (explicit.length) {
                return explicit.map((requirement: AnyDoc) => ({
                    ...cloneData(requirement),
                    Kind: normalizeAIRequirementKind(requirement?.Kind),
                    Target: normalizeAIRequiredModelElement(
                        requirement?.Target
                    )
                }));
            }

            // Backward compatibility only: old blueprints become structural
            // requirements. Prose is intentionally ignored.
            return (Array.isArray(item?.RequiredModelElements)
                ? item.RequiredModelElements
                : []
            ).filter(Boolean).map((target: any) => {
                const normalized = normalizeAIRequiredModelElement(target);

                return {
                    Kind: normalized.indexOf(".") >= 0
                        ? "PropertyExists"
                        : "TypeExists",
                    Target: normalized
                };
            });
        }

        function getAIPlanOperationOwnerName(
            operation: AnyDoc,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): string {
            return String(
                getAIPlanTypeNameByRef(
                    operation?.EntityRef || operation?.EntityId,
                    operations,
                    existingTypes
                ) || ""
            );
        }

        function getAIPlanOperationTargetPath(
            operation: AnyDoc,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): string {
            const owner = getAIPlanOperationOwnerName(
                operation,
                operations,
                existingTypes
            );
            const member =
                operation?.Property ||
                operation?.Collection ||
                operation?.Action ||
                operation?.Rule ||
                operation?.Event ||
                operation?.Validation ||
                operation?.Constraint ||
                {};
            const name = String(member?.Name || operation?.Name || "").trim();

            return owner && name ? `${owner}.${name}` : owner;
        }

        function resolveAIModelPropertyPath(
            target: string,
            operations: AnyDoc[],
            existingTypes: AnyDoc[]
        ): { path: string; canonicalPath: string; ownerTypeName: string; property: AnyDoc } | null {
            const parts = String(target || "")
                .split(".")
                .map((x: string) => x.trim())
                .filter(Boolean);

            if (parts.length < 2) return null;

            let currentTypeName = parts[0];
            let resolvedPath = currentTypeName;
            let resolvedProperty: AnyDoc = null;

            for (let index = 1; index < parts.length; index++) {
                const memberName = parts[index];
                const currentExistingType = existingTypes.find(
                    (typeDoc: AnyDoc) =>
                        String(typeDoc?.Name || "") === currentTypeName
                );

                let propertyOperation = operations.find(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddProperty" &&
                        getAIPlanOperationOwnerName(
                            operation,
                            operations,
                            existingTypes
                        ) === currentTypeName &&
                        String(operation?.Property?.Name || "") === memberName
                );

                if (!propertyOperation) {
                    propertyOperation = operations.find(
                        (operation: AnyDoc) => {
                            if (operation?.Type !== "UpdateProperty") return false;
                            const owner = getAIPlanOperationOwnerName(
                                operation,
                                operations,
                                existingTypes
                            );
                            const existingProperty = (
                                Array.isArray(currentExistingType?.Properties)
                                    ? currentExistingType.Properties
                                    : []
                            ).find((property: AnyDoc) =>
                                String(property?.id || property?.Id || "") ===
                                String(operation?.PropertyId || operation?.ObjectId || "")
                            );
                            return owner === currentTypeName &&
                                String(existingProperty?.Name || "") === memberName;
                        }
                    );
                }

                const existingProperty = (
                    Array.isArray(currentExistingType?.Properties)
                        ? currentExistingType.Properties
                        : []
                ).find(
                    (property: AnyDoc) =>
                        String(property?.Name || "") === memberName
                );

                resolvedProperty =
                    propertyOperation?.Property ||
                    (
                        propertyOperation?.Changes
                            ? { ...existingProperty, ...propertyOperation.Changes }
                            : existingProperty
                    );

                if (!resolvedProperty) return null;

                resolvedPath += `.${memberName}`;

                if (index < parts.length - 1) {
                    const nextTypeName = getAIPlanTypeNameByRef(
                        resolvedProperty?.Type,
                        operations,
                        existingTypes
                    );

                    if (!nextTypeName) return null;
                    currentTypeName = String(nextTypeName);
                }
            }

            return {
                path: resolvedPath,
                canonicalPath: `${currentTypeName}.${String(resolvedProperty?.Name || parts[parts.length - 1])}`,
                ownerTypeName: currentTypeName,
                property: resolvedProperty
            };
        }

        function getAIRequirementExpressionTokens(value: any): string[] {
            const ignored = new Set<string>([
                "sum", "if", "true", "false", "null", "undefined",
                "and", "or", "not", "for", "all", "of",
                "reduce", "line", "lines"
            ]);
            const withoutQualifiers = String(value || "")
                .replace(
                    /\b[A-Za-z_][A-Za-z0-9_]*\.(?=[A-Za-z_][A-Za-z0-9_]*)/g,
                    ""
                );

            return Array.from(
                new Set(
                    withoutQualifiers
                        .match(/[A-Za-z_][A-Za-z0-9_]*/g) || []
                )
            ).filter((token: string) =>
                !ignored.has(token.toLowerCase())
            );
        }

        function doesAIExpressionMatch(
            actualExpression: any,
            expectedExpression: any
        ): boolean {
            const actual = String(actualExpression || "").trim();
            const expected = String(expectedExpression || "").trim();

            if (!actual || !expected) return !!actual;

            const actualLower = actual
                .replace(/\s+/g, "")
                .toLowerCase();
            const expectedLower = expected
                .replace(/\s+/g, "")
                .toLowerCase();

            if (
                actualLower === expectedLower ||
                actualLower.indexOf(expectedLower) >= 0
            ) {
                return true;
            }

            const expectedTokens =
                getAIRequirementExpressionTokens(expected);

            const actualTokenSource = actual.toLowerCase();

            return expectedTokens.every((token: string) =>
                actualTokenSource.indexOf(
                    token.toLowerCase()
                ) >= 0
            );
        }

        function getAIBehaviorRequirementCapability(
            kind: string
        ): { CapabilityName: string; Classification: string; Evidence: string[] } | null {
            const mapping: Record<string, string> = {
                IntegrationBehavior: "ExternalIntegrations",
                ScheduledBehavior: "ScheduledReminders",
                SecurityBehavior: "RoleAwareActions",
                ViewBehavior: "Views",
                ExecutableBehavior: "CrossDocumentBehavior"
            };

            const capabilityName = mapping[kind];
            if (!capabilityName) return null;

            const platform =
                buildDesignerAIPlatformCapabilityContext();
            const capability =
                platform?.DerivedCapabilities?.[
                capabilityName
                ] || {};

            return {
                CapabilityName: capabilityName,
                Classification: String(
                    capability?.Classification ||
                    "Unsupported"
                ),
                Evidence: Array.isArray(
                    capability?.Evidence
                )
                    ? capability.Evidence
                        .map((x: any) =>
                            String(x || "").trim()
                        )
                        .filter(Boolean)
                    : []
            };
        }

        function isAIRequirementImplemented(
            plan: AnyDoc,
            requirement: AnyDoc
        ): { Implemented: boolean; Evidence: string[]; Missing: string } {
            const operations: AnyDoc[] = Array.isArray(plan?.Operations)
                ? plan.Operations
                : [];
            const existingTypes: AnyDoc[] =
                getRuntimeObjectsArray(false);
            const structuralEvidence = buildAIPlanStructuralEvidence(plan);
            const kind = normalizeAIRequirementKind(requirement?.Kind);
            const target = normalizeAIRequiredModelElement(
                requirement?.Target
            );
            const source = normalizeAIRequiredModelElement(
                requirement?.Source
            );
            const actionName = String(requirement?.Action || "").trim();
            const condition = String(requirement?.Condition || "").trim();
            const referenceType = normalizeAIRequiredModelElement(
                requirement?.ReferenceType || requirement?.Source
            );
            const expression = String(
                requirement?.Expression ||
                requirement?.Effect ||
                ""
            ).trim();
            const missing = `${kind}: ${target || "(unspecified target)"}`;

            const addPropertyOperations = operations.filter(
                (operation: AnyDoc) => operation?.Type === "AddProperty"
            );
            const addCollectionOperations = operations.filter(
                (operation: AnyDoc) => operation?.Type === "AddCollection"
            );
            const targetPropertyOperation = addPropertyOperations.find(
                (operation: AnyDoc) =>
                    getAIPlanOperationTargetPath(
                        operation,
                        operations,
                        existingTypes
                    ) === target
            );
            const targetCollectionOperation =
                addCollectionOperations.find(
                    (operation: AnyDoc) =>
                        getAIPlanOperationTargetPath(
                            operation,
                            operations,
                            existingTypes
                        ) === target
                );
            const targetParts = target.split(".");
            const targetOwnerName = targetParts[0] || "";
            const targetMemberName = targetParts[1] || "";
            const targetExistingType = existingTypes.find(
                (typeDoc: AnyDoc) =>
                    String(typeDoc?.Name || "") === targetOwnerName
            );
            const targetExistingProperty =
                (
                    Array.isArray(targetExistingType?.Properties)
                        ? targetExistingType.Properties
                        : []
                ).find(
                    (property: AnyDoc) =>
                        String(property?.Name || "") ===
                        targetMemberName
                );

            const resolvedTargetProperty = resolveAIModelPropertyPath(
                target,
                operations,
                existingTypes
            );
            const targetProperty =
                targetPropertyOperation?.Property ||
                targetExistingProperty ||
                resolvedTargetProperty?.property;
            const targetCollection =
                targetCollectionOperation?.Collection ||
                (
                    targetExistingProperty?.Many === true
                        ? targetExistingProperty
                        : undefined
                );

            if (kind === "TypeExists") {
                return {
                    Implemented: structuralEvidence.has(target),
                    Evidence: structuralEvidence.has(target) ? [target] : [],
                    Missing: missing
                };
            }

            if (kind === "PropertyExists") {
                const aliases = [target];

                if (/\.CustomerName$/i.test(target)) {
                    aliases.push(
                        target.replace(
                            /\.CustomerName$/i,
                            ".Customer"
                        )
                    );
                    aliases.push(
                        target.replace(
                            /\.CustomerName$/i,
                            ".Company"
                        )
                    );
                }

                if (/\.ClientName$/i.test(target)) {
                    aliases.push(
                        target.replace(
                            /\.ClientName$/i,
                            ".Client"
                        )
                    );
                    aliases.push(
                        target.replace(
                            /\.ClientName$/i,
                            ".Company"
                        )
                    );
                }

                let implementedTarget = aliases.find(
                    (candidate: string) =>
                        structuralEvidence.has(candidate)
                );

                if (!implementedTarget) {
                    const resolvedAlias = aliases.find((candidate: string) =>
                        !!resolveAIModelPropertyPath(
                            candidate,
                            operations,
                            existingTypes
                        )
                    );
                    implementedTarget = resolvedAlias;
                }

                return {
                    Implemented: !!implementedTarget,
                    Evidence: implementedTarget
                        ? [implementedTarget]
                        : [],
                    Missing: missing
                };
            }

            if (kind === "Inherits") {
                const expectedBaseType =
                    normalizeAIRequiredModelElement(
                        requirement?.ReferenceType ||
                        requirement?.BaseType ||
                        requirement?.Source
                    );
                const derivedType = existingTypes.find(
                    (item: AnyDoc) =>
                        String(item?.Name || "") === target
                );
                const updateTypeOperation = operations.find(
                    (operation: AnyDoc) =>
                        operation?.Type === "UpdateType" &&
                        String(operation?.EntityId || "") ===
                        String(
                            derivedType?.id ||
                            derivedType?.Id ||
                            ""
                        )
                );
                const actualBaseRef =
                    updateTypeOperation?.Changes?.BaseType ||
                    derivedType?.BaseType;
                const actualBaseType =
                    normalizeAIRequiredModelElement(
                        getAIPlanTypeNameByRef(
                            actualBaseRef,
                            operations,
                            existingTypes
                        )
                    );
                const implemented =
                    !!actualBaseType &&
                    (
                        !expectedBaseType ||
                        actualBaseType === expectedBaseType
                    );

                return {
                    Implemented: implemented,
                    Evidence: implemented ? [target] : [],
                    Missing: missing
                };
            }

            if (
                kind === "ListViewExists" ||
                kind === "NavigationAccess"
            ) {
                const navigationOperations = operations.filter(
                    (operation: AnyDoc) =>
                        operation?.Type ===
                        "AddNavigationItem"
                );

                const matchingNavigation =
                    navigationOperations.find(
                        (operation: AnyDoc) => {
                            const navigationTarget =
                                getAINavigationTarget(
                                    operation
                                );

                            let actualTypeName = "";

                            if (navigationTarget.EntityId) {
                                const existingType =
                                    existingTypes.find(
                                        (typeDoc: AnyDoc) =>
                                            String(
                                                typeDoc?.id ||
                                                ""
                                            ) ===
                                            String(
                                                navigationTarget
                                                    .EntityId
                                            )
                                    );

                                actualTypeName = String(
                                    existingType?.Name || ""
                                );
                            } else if (
                                navigationTarget.EntityRef
                            ) {
                                actualTypeName =
                                    getAIPlanTypeNameByRef(
                                        navigationTarget.EntityRef,
                                        operations,
                                        existingTypes
                                    );
                            }

                            return (
                                normalizeAIRequiredModelElement(
                                    actualTypeName
                                ) === target
                            );
                        }
                    );

                return {
                    Implemented: !!matchingNavigation,
                    Evidence: matchingNavigation
                        ? [target]
                        : [],
                    Missing: missing
                };
            }

            if (kind === "Crud") {
                const typeOperation = operations.find(
                    (operation: AnyDoc) =>
                        operation?.Type === "AddType" &&
                        String(operation?.Entity?.Name || "") === target
                );
                const existingType = existingTypes.find(
                    (item: AnyDoc) => String(item?.Name || "") === target
                );
                const browsable =
                    typeOperation?.Entity?.Browsable !== false &&
                    existingType?.Browsable !== false;

                return {
                    Implemented:
                        structuralEvidence.has(target) && browsable,
                    Evidence:
                        structuralEvidence.has(target) && browsable
                            ? [target]
                            : [],
                    Missing: missing
                };
            }

            if (kind === "ReferenceSelection") {
                const candidateProperties: { path: string; property: AnyDoc }[] = [];

                if (targetProperty) {
                    candidateProperties.push({
                        path: target,
                        property: targetProperty
                    });
                } else if (targetOwnerName && !targetMemberName) {
                    addPropertyOperations.forEach((operation: AnyDoc) => {
                        const path = getAIPlanOperationTargetPath(
                            operation,
                            operations,
                            existingTypes
                        );
                        if (path.indexOf(targetOwnerName + ".") !== 0) return;
                        candidateProperties.push({
                            path: path,
                            property: operation?.Property
                        });
                    });

                    (Array.isArray(targetExistingType?.Properties)
                        ? targetExistingType.Properties
                        : []
                    ).forEach((property: AnyDoc) => {
                        candidateProperties.push({
                            path: `${targetOwnerName}.${String(property?.Name || "")}`,
                            property: property
                        });
                    });
                }

                const matchingReference = candidateProperties.find((candidate) => {
                    const property = candidate.property;
                    const aggregation = String(property?.Aggregation || "");
                    if (["Hybrid", "Value"].indexOf(aggregation) < 0) return false;
                    const actualType = normalizeAIRequiredModelElement(
                        getAIPlanTypeNameByRef(
                            property?.Type,
                            operations,
                            existingTypes
                        )
                    );
                    return !referenceType || actualType === referenceType;
                });

                return {
                    Implemented: !!matchingReference,
                    Evidence: matchingReference ? [matchingReference.path] : [],
                    Missing: missing
                };
            }

            if (kind === "EmbeddedObject") {
                const propertyImplemented =
                    !!targetProperty &&
                    targetProperty.Many !== true &&
                    String(targetProperty.Aggregation || "") ===
                    "Aggregated";

                const expectedItemType =
                    normalizeAIRequiredModelElement(
                        requirement?.ItemType ||
                        requirement?.ReferenceType ||
                        requirement?.Source
                    );

                const actualItemType =
                    targetProperty
                        ? normalizeAIRequiredModelElement(
                            getAIPlanTypeNameByRef(
                                targetProperty.Type,
                                operations,
                                existingTypes
                            )
                        )
                        : "";

                const implemented =
                    propertyImplemented &&
                    (
                        !expectedItemType ||
                        !actualItemType ||
                        actualItemType === expectedItemType
                    );

                return {
                    Implemented: implemented,
                    Evidence:
                        implemented && targetProperty
                            ? [target]
                            : [],
                    Missing:
                        implemented
                            ? []
                            : [missing]
                };
            }

            if (kind === "EmbeddedCollection") {
                const propertyImplemented =
                    !!targetProperty &&
                    targetProperty.Many === true &&
                    String(targetProperty.Aggregation || "") ===
                    "Aggregated";
                const collectionImplemented =
                    !!targetCollection &&
                    String(targetCollection.Aggregation || "") ===
                    "Aggregated";
                const expectedItemType =
                    normalizeAIRequiredModelElement(
                        requirement?.ItemType ||
                        requirement?.ReferenceType ||
                        requirement?.Source
                    );
                const actualItemType =
                    targetProperty
                        ? normalizeAIRequiredModelElement(
                            getAIPlanTypeNameByRef(
                                targetProperty.Type,
                                operations,
                                existingTypes
                            )
                        )
                        : normalizeAIRequiredModelElement(
                            getAIPlanTypeNameByRef(
                                targetCollection?.ItemEntity,
                                operations,
                                existingTypes
                            )
                        );
                const implemented =
                    (propertyImplemented || collectionImplemented) &&
                    (
                        !expectedItemType ||
                        actualItemType === expectedItemType
                    );

                return {
                    Implemented: implemented,
                    Evidence: implemented ? [target] : [],
                    Missing: missing
                };
            }

            if (kind === "ReverseCollection") {
                const propertyImplemented =
                    !!targetProperty &&
                    targetProperty.Many === true &&
                    String(targetProperty.Aggregation || "") ===
                    "Deferred";
                const collectionImplemented =
                    !!targetCollection &&
                    String(targetCollection.Aggregation || "") ===
                    "Deferred";
                const implemented =
                    propertyImplemented || collectionImplemented;

                return {
                    Implemented: implemented,
                    Evidence: implemented ? [target] : [],
                    Missing: missing
                };
            }

            if (kind === "Formula") {
                const expectedExpression = expression || source || condition;
                const candidates: { path: string; property: AnyDoc }[] = [];

                if (targetProperty) {
                    candidates.push({ path: target, property: targetProperty });
                } else if (targetOwnerName && !targetMemberName) {
                    addPropertyOperations.forEach((operation: AnyDoc) => {
                        const path = getAIPlanOperationTargetPath(
                            operation,
                            operations,
                            existingTypes
                        );
                        if (path.indexOf(targetOwnerName + ".") !== 0) return;
                        candidates.push({ path: path, property: operation?.Property });
                    });

                    (Array.isArray(targetExistingType?.Properties)
                        ? targetExistingType.Properties
                        : []
                    ).forEach((property: AnyDoc) => {
                        candidates.push({
                            path: `${targetOwnerName}.${String(property?.Name || "")}`,
                            property: property
                        });
                    });
                }

                const matchingFormula = candidates.find((candidate) => {
                    const formulaCode = getAIFormulaCode(candidate.property);
                    if (!formulaCode || isAITrivialConstantFormula(formulaCode)) return false;
                    const formulaFindingTargets = [candidate.path];
                    if (resolvedTargetProperty?.canonicalPath &&
                        formulaFindingTargets.indexOf(resolvedTargetProperty.canonicalPath) < 0) {
                        formulaFindingTargets.push(resolvedTargetProperty.canonicalPath);
                    }
                    const formulaFindings = formulaFindingTargets.reduce(
                        (all: AIFormulaDependencyFinding[], formulaTarget: string) =>
                            all.concat(getAIFormulaFindingsForTarget(plan, formulaTarget)),
                        []
                    );
                    if (formulaFindings.some((finding: AIFormulaDependencyFinding) => finding.Blocking)) return false;
                    return !expectedExpression || doesAIExpressionMatch(formulaCode, expectedExpression);
                });

                return {
                    Implemented: !!matchingFormula,
                    Evidence: matchingFormula ? [matchingFormula.path] : [],
                    Missing: missing
                };
            }

            if (kind === "DefaultValue") {
                const defaultValue = targetProperty?.DefaultValue;
                const serializedDefault =
                    defaultValue === undefined
                        ? ""
                        : JSON.stringify(defaultValue);
                const expectedDefault = expression || source;
                const implemented =
                    defaultValue !== undefined &&
                    (
                        !expectedDefault ||
                        doesAIExpressionMatch(
                            serializedDefault,
                            expectedDefault
                        )
                    );

                return {
                    Implemented: implemented,
                    Evidence: implemented ? [target] : [],
                    Missing: missing
                };
            }

            if (kind === "ReadOnlyWhen") {
                const always =
                    !condition ||
                    condition.toLowerCase() === "always";
                const implemented =
                    always && targetProperty?.ReadOnly === true;

                return {
                    Implemented: implemented,
                    Evidence: implemented ? [target] : [],
                    Missing: missing
                };
            }

            if (kind === "Validation") {
                const validationOwner = targetOwnerName || target;
                const matchingRule = operations.find((operation: AnyDoc) => {
                    if (operation?.Type !== "AddRule" && operation?.Type !== "UpdateRule") return false;
                    const owner = getAIPlanOperationOwnerName(operation, operations, existingTypes);
                    if (
                        validationOwner &&
                        String(owner || "").toLowerCase() !== String(validationOwner).toLowerCase()
                    ) return false;
                    const code = getAIBehaviorOperationCode(operation);
                    return !!code && !isAIBehaviorCodePlaceholder(operation, code);
                });

                return {
                    Implemented: !!matchingRule,
                    Evidence: matchingRule ? [getAIPlanOperationTargetPath(matchingRule, operations, existingTypes) || target] : [],
                    Missing: missing
                };
            }

            if (kind === "UpdateOnAction") {
                const targetTypeName = targetOwnerName || target;
                const targetPropertyName = targetMemberName;
                const expectedAction = actionName.toLowerCase();
                const escapedProperty = targetPropertyName
                    ? targetPropertyName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
                    : "";
                const propertyAssignmentRegex = targetPropertyName
                    ? new RegExp("\\.\\s*" + escapedProperty + "\\s*=(?!=)", "i")
                    : null;

                const matchingUpdate = operations.find((operation: AnyDoc) => {
                    if (operation?.Type !== "AddAction" && operation?.Type !== "UpdateAction") return false;
                    const opActionName = String(operation?.Action?.Name || operation?.Name || "").trim().toLowerCase();
                    if (expectedAction && opActionName !== expectedAction) return false;
                    const code = getAIBehaviorOperationCode(operation);
                    if (!code || isAIBehaviorCodePlaceholder(operation, code)) return false;
                    const lowerCode = code.toLowerCase();
                    const typeMentioned = !targetTypeName || lowerCode.indexOf(String(targetTypeName).toLowerCase()) >= 0;
                    if (targetPropertyName) {
                        return !!propertyAssignmentRegex && propertyAssignmentRegex.test(code) && typeMentioned;
                    }
                    if (!targetTypeName) return true;
                    return typeMentioned;
                });

                return {
                    Implemented: !!matchingUpdate,
                    Evidence: matchingUpdate
                        ? [getAIPlanOperationTargetPath(matchingUpdate, operations, existingTypes) || target]
                        : [],
                    Missing: missing
                };
            }

            if (kind === "StatusTransition") {
                const memberName = targetMemberName || "Status";
                const ownerName = targetOwnerName || target;
                const escapedMember = memberName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                const assignmentRegex = new RegExp(
                    "(?:\\bdoc|\\be\\.data|\\bdata|\\bthis|\\b[a-zA-Z_$][a-zA-Z0-9_$]*)\\s*\\.\\s*" +
                    escapedMember +
                    "\\s*=(?!=)",
                    "i"
                );

                const matchingTransition = operations.find((operation: AnyDoc) => {
                    if (![
                        "AddAction", "UpdateAction",
                        "AddRule", "UpdateRule",
                        "AddEvent", "UpdateEvent"
                    ].includes(String(operation?.Type || ""))) return false;

                    const owner = getAIPlanOperationOwnerName(operation, operations, existingTypes);
                    if (ownerName && String(owner || "").toLowerCase() !== ownerName.toLowerCase()) return false;
                    const code = getAIBehaviorOperationCode(operation);
                    return !!code && !isAIBehaviorCodePlaceholder(operation, code) && assignmentRegex.test(code);
                });

                return {
                    Implemented: !!matchingTransition,
                    Evidence: matchingTransition
                        ? [getAIPlanOperationTargetPath(matchingTransition, operations, existingTypes) || target]
                        : [],
                    Missing: missing
                };
            }

            if (kind === "Action") {
                const ownerName = targetOwnerName || target;
                const expectedAction = actionName.toLowerCase();
                const matchingAction = operations.find((operation: AnyDoc) => {
                    if (operation?.Type !== "AddAction" && operation?.Type !== "UpdateAction") return false;
                    const owner = getAIPlanOperationOwnerName(operation, operations, existingTypes);
                    if (ownerName && String(owner || "").toLowerCase() !== ownerName.toLowerCase()) return false;
                    const opActionName = String(operation?.Action?.Name || operation?.Name || "").trim().toLowerCase();
                    if (expectedAction && opActionName !== expectedAction) return false;
                    const code = getAIBehaviorOperationCode(operation);
                    return !!code && !isAIBehaviorCodePlaceholder(operation, code);
                });

                return {
                    Implemented: !!matchingAction,
                    Evidence: matchingAction
                        ? [getAIPlanOperationTargetPath(matchingAction, operations, existingTypes) || target]
                        : [],
                    Missing: missing
                };
            }

            const behaviorCapability =
                getAIBehaviorRequirementCapability(
                    kind
                );

            if (behaviorCapability) {
                const classification =
                    behaviorCapability.Classification;
                const behaviorTarget =
                    target ||
                    actionName ||
                    "(unspecified target)";

                const behaviorOperations = operations.filter((operation: AnyDoc) =>
                    [
                        "AddRule", "UpdateRule",
                        "AddAction", "UpdateAction",
                        "AddEvent", "UpdateEvent"
                    ].includes(String(operation?.Type || ""))
                );

                const matchingBehavior =
                    classification === "NativeEditable"
                        ? behaviorOperations.find((operation: AnyDoc) => {
                            const serialized = JSON.stringify(operation).toLowerCase();
                            const targetMatches = !target || serialized.indexOf(String(target).toLowerCase()) >= 0;
                            const actionMatches = !actionName || serialized.indexOf(actionName.toLowerCase()) >= 0;
                            const conditionMatches = !condition || serialized.indexOf(condition.toLowerCase()) >= 0;

                            if (behaviorCapability.CapabilityName === "RoleAwareActions") {
                                return (
                                    (operation?.Type === "AddAction" || operation?.Type === "UpdateAction") &&
                                    (serialized.indexOf("enableroles") >= 0 || serialized.indexOf("disableroles") >= 0) &&
                                    targetMatches && actionMatches
                                );
                            }

                            return targetMatches && actionMatches && conditionMatches;
                        })
                        : null;

                if (matchingBehavior) {
                    return {
                        Implemented: true,
                        Evidence: [
                            getAIPlanOperationTargetPath(
                                matchingBehavior,
                                operations,
                                existingTypes
                            ) || behaviorTarget
                        ],
                        Missing: missing
                    };
                }

                // Supporting fields/types alone are not evidence that behavior itself is implemented.
                const classificationText: Record<string, string> = {
                    NativeEditable:
                        "the platform and current AI editor can generate this behavior, but no matching generated operation was found",
                    PlatformSupportedDesignerManual:
                        "supported by the CosmoApps metamodel but requires manual designer configuration with the current AI OperationContract",
                    ModelComposableDesignerPartial:
                        "partially expressible from platform primitives, but the current AI OperationContract does not generate the complete behavior",
                    RequiresCustomCode:
                        "requires custom code or an external service",
                    Unsupported:
                        "not exposed by the currently loaded platform metamodel"
                };

                return {
                    Implemented: false,
                    Evidence: [],
                    Missing:
                        `${kind}: ${behaviorTarget} — ` +
                        (
                            classificationText[
                            classification
                            ] ||
                            classification
                        )
                };
            }

            return {
                Implemented: false,
                Evidence: [],
                Missing: missing
            };
        }

        function evaluateAITypedRequirements(
            plan: AnyDoc,
            item: AnyDoc
        ): { Evidence: string[]; Missing: string[] } {
            const requirements = buildFallbackTypedRequirements(item);
            const evidence: string[] = [];
            const missing: string[] = [];

            requirements.forEach((requirement: AnyDoc) => {
                const result = isAIRequirementImplemented(
                    plan,
                    requirement
                );

                result.Evidence.forEach((value: string) => {
                    if (value && evidence.indexOf(value) < 0) {
                        evidence.push(value);
                    }
                });

                if (!result.Implemented && missing.indexOf(result.Missing) < 0) {
                    missing.push(result.Missing);
                }
            });

            // Coverage is based on typed Requirements only.
            // Prose is explanatory context for the model, not a deterministic source of Missing items.
            return { Evidence: evidence, Missing: missing };
        }

        function mergeBlueprintScenarios(
            blueprintScenarios: AnyDoc[],
            generatedScenarios: AnyDoc[],
            structuralEvidence: Set<string>,
            plan: AnyDoc
        ): AnyDoc[] {
            return (blueprintScenarios || []).map(
                (blueprintScenario: AnyDoc, index: number) => {
                    const id = String(
                        blueprintScenario?.Id || `S${index + 1}`
                    );
                    const explicitRequirements =
                        buildFallbackTypedRequirements(
                            blueprintScenario
                        );
                    const isSimpleStructuralScenario =
                        String(blueprintScenario?.Name || "") ===
                        "Requested structural model change" &&
                        explicitRequirements.length === 0;
                    const coverage =
                        isSimpleStructuralScenario
                            ? {
                                Evidence: Array.from(
                                    structuralEvidence
                                ),
                                Missing: []
                            }
                            : evaluateAITypedRequirements(
                                plan,
                                blueprintScenario
                            );

                    return {
                        ...cloneData(blueprintScenario),
                        Id: id,
                        Importance: normalizeScenarioImportance(
                            blueprintScenario?.Importance,
                            blueprintScenario
                        ),
                        Evidence: coverage.Evidence,
                        Missing: coverage.Missing
                    };
                }
            );
        }

        function mergeBlueprintCapabilities(
            blueprintCapabilities: AnyDoc[],
            generatedCapabilities: AnyDoc[],
            structuralEvidence: Set<string>,
            plan: AnyDoc
        ): AnyDoc[] {
            return (blueprintCapabilities || []).map(
                (blueprintCapability: AnyDoc, index: number) => {
                    const id = String(
                        blueprintCapability?.Id || `C${index + 1}`
                    );
                    const requirements =
                        buildFallbackTypedRequirements(
                            blueprintCapability
                        );
                    const isSimpleStructuralCapability =
                        String(blueprintCapability?.Name || "") ===
                        "Requested structural model change" &&
                        requirements.length === 0;
                    const coverage =
                        isSimpleStructuralCapability
                            ? {
                                Evidence: Array.from(
                                    structuralEvidence
                                ),
                                Missing: []
                            }
                            : evaluateAITypedRequirements(
                                plan,
                                blueprintCapability
                            );
                    let status = "NotImplemented";
                    const missing =
                        coverage.Missing.slice();

                    if (
                        (
                            requirements.length > 0 ||
                            isSimpleStructuralCapability
                        ) &&
                        coverage.Evidence.length > 0 &&
                        missing.length === 0
                    ) {
                        status = "Implemented";
                    } else if (coverage.Evidence.length > 0) {
                        status = "PartiallyImplemented";
                    }

                    if (
                        status === "NotImplemented" &&
                        missing.length === 0
                    ) {
                        missing.push(
                            "No current model operation implements the typed requirements of this capability."
                        );
                    }

                    return {
                        ...cloneData(blueprintCapability),
                        Id: id,
                        Status: status,
                        Evidence: coverage.Evidence,
                        Missing: missing
                    };
                }
            );
        }

        function repairDesignerAIRepairOperationsJson(content: any): any {
            if (typeof content !== "string") return content;
            const source = String(content);
            if (!source.trim()) return content;

            // Repair only one conservative structural error seen in compact repair responses:
            // an Operations item with nested Action.Script may omit the operation's final `}`
            // before the next top-level {"Type":...} item.  We never alter quoted code/text.
            let result = "";
            let inString = false;
            let escaped = false;
            let curlyDepth = 0;
            let squareDepth = 0;

            for (let i = 0; i < source.length; i++) {
                const ch = source[i];

                if (inString) {
                    result += ch;
                    if (escaped) {
                        escaped = false;
                    } else if (ch === "\\") {
                        escaped = true;
                    } else if (ch === '"') {
                        inString = false;
                    }
                    continue;
                }

                if (ch === '"') {
                    inString = true;
                    result += ch;
                    continue;
                }

                if (ch === "{") curlyDepth++;
                else if (ch === "}") curlyDepth = Math.max(0, curlyDepth - 1);
                else if (ch === "[") squareDepth++;
                else if (ch === "]") squareDepth = Math.max(0, squareDepth - 1);

                if (ch === "," && squareDepth === 1 && curlyDepth > 1) {
                    let j = i + 1;
                    while (j < source.length && /\s/.test(source[j])) j++;
                    if (source.substr(j, 7) === '{"Type"') {
                        // At a valid Operations item boundary only the root JSON object remains open.
                        // Close any accidentally unclosed operation-level objects before the comma.
                        while (curlyDepth > 1) {
                            result += "}";
                            curlyDepth--;
                        }
                    }
                }

                result += ch;
            }

            return result;
        }


        function extractDesignerAICompleteOperationsPrefix(content: any): AnyDoc[] {
            if (typeof content !== "string") return [];
            const source = String(content);
            const marker = '"Operations"';
            const markerIndex = source.indexOf(marker);
            if (markerIndex < 0) return [];

            const colonIndex = source.indexOf(":", markerIndex + marker.length);
            if (colonIndex < 0) return [];
            let arrayStart = colonIndex + 1;
            while (arrayStart < source.length && /\s/.test(source[arrayStart])) arrayStart++;
            if (source[arrayStart] !== "[") return [];

            const operations: AnyDoc[] = [];
            let inString = false;
            let escaped = false;
            let curlyDepth = 0;
            let opStart = -1;

            for (let i = arrayStart + 1; i < source.length; i++) {
                const ch = source[i];
                if (inString) {
                    if (escaped) escaped = false;
                    else if (ch === "\\") escaped = true;
                    else if (ch === '"') inString = false;
                    continue;
                }
                if (ch === '"') {
                    inString = true;
                    continue;
                }
                if (ch === "{") {
                    if (curlyDepth === 0) opStart = i;
                    curlyDepth++;
                } else if (ch === "}") {
                    if (curlyDepth > 0) curlyDepth--;
                    if (curlyDepth === 0 && opStart >= 0) {
                        try {
                            const op = JSON.parse(source.substring(opStart, i + 1));
                            if (op && typeof op === "object") operations.push(op);
                        } catch (_) {
                            break;
                        }
                        opStart = -1;
                    }
                } else if (ch === "]" && curlyDepth === 0) {
                    break;
                }
            }

            return operations;
        }

        function buildDesignerAIContinuationPlan(
            blueprint: DesignerAIBusinessBlueprint,
            operations: AnyDoc[],
            message?: string
        ): AnyDoc {
            return {
                Intent: "Modify",
                Message: message || "Large model plan generated in multiple AI response chunks.",
                Scenarios: (blueprint?.Scenarios || []).map((item: AnyDoc) => ({ Id: String(item?.Id || "") })).filter((item: AnyDoc) => !!item.Id),
                Capabilities: (blueprint?.Capabilities || []).map((item: AnyDoc) => ({ Id: String(item?.Id || "") })).filter((item: AnyDoc) => !!item.Id),
                Operations: (operations || []).map((item: AnyDoc) => cloneData(item))
            };
        }

        function buildDesignerAICompletedOperationIndex(operations: AnyDoc[]): string[] {
            const refText = (value: any): string => {
                if (!value) return "?";
                if (typeof value === "string") return value;
                if (value.TemporaryId) return String(value.TemporaryId);
                if (value.id) return String(value.id);
                return "?";
            };

            return (operations || []).map((operation: AnyDoc, index: number) => {
                const type = String(operation?.Type || "Operation");
                if (type === "AddType") {
                    return `${index}: AddType ${String(operation?.TemporaryId || "?")} ${String(operation?.Entity?.Name || "?")}`;
                }
                if (type === "AddEnum") {
                    return `${index}: AddEnum ${String(operation?.TemporaryId || "?")} ${String(operation?.Enum?.Name || "?")}`;
                }
                if (type === "AddProperty" || type === "AddCollection") {
                    const owner = refText(operation?.EntityRef || operation?.EntityId);
                    const item = operation?.Property || operation?.Collection || {};
                    const target = refText(item?.Type || item?.ItemEntity);
                    return `${index}: ${type} ${owner}.${String(item?.Name || "?")} -> ${target} ${String(item?.Aggregation || "")}${item?.Many ? " Many" : ""}`.trim();
                }
                if (type === "AddRule" || type === "AddAction" || type === "AddEvent") {
                    const owner = refText(operation?.EntityRef || operation?.EntityId);
                    const def = operation?.Rule || operation?.Action || operation?.Event || {};
                    return `${index}: ${type} ${owner}.${String(def?.Name || "?")}`;
                }
                if (type === "AddNavigationGroup" || type === "AddNavigationItem") {
                    const item = operation?.NavigationItem || {};
                    return `${index}: ${type} ${String(operation?.TemporaryId || "?")} ${String(item?.Name || item?.Caption || "?")}`;
                }
                return `${index}: ${type} ${String(operation?.TemporaryId || operation?.ObjectId || operation?.EntityId || "")}`.trim();
            });
        }

        function buildDesignerAIModelContinuationPrompt(
            currentOperations: AnyDoc[]
        ): string {
            return [
                "Continue the SAME CosmoApps model plan using the BusinessBlueprint and current application in Context.",
                "Do NOT restart the plan and do NOT repeat operations already listed in CURRENT_COMPLETE_OPERATION_INDEX.",
                "You may reference TemporaryId values declared in that index.",
                "Reference objects MUST always use the full exact shape {\"TemporaryId\":\"...\"}. Never shorten EntityRef, ParentRef, Property.Type, ItemEntity or any other reference to {\"id\"}, {\"name\"}, {\"t-x\"} or another shorthand form.",
                "For example EntityRef must be {\"TemporaryId\":\"t-order\"}, never {\"t-order\"}.",
                "Return at most 30 additional Operations in this response so the JSON remains syntactically reliable and closes well before the provider completion limit.",
                "If more required work remains after this chunk, return Complete:false. If the whole plan is finished, return Complete:true.",
                "Return exactly {\"Operations\":[...],\"Complete\":true|false} and no other fields or prose.",
                "Before returning, verify that every operation in this chunk is new and that all braces, brackets and quotes are closed.",
                "Keep descriptions concise; executable code must remain correct and readable.",
                "",
                "CURRENT_COMPLETE_OPERATION_INDEX:",
                buildDesignerAICompletedOperationIndex(currentOperations).join("\n")
            ].join("\n");
        }

        function recoverDesignerAIPlanOperations(content: any): AnyDoc | null {
            if (typeof content !== "string") return null;
            const source = String(content);
            const marker = '"Operations"';
            const markerIndex = source.indexOf(marker);
            if (markerIndex < 0) return null;

            let colonIndex = source.indexOf(":", markerIndex + marker.length);
            if (colonIndex < 0) return null;
            let arrayStart = colonIndex + 1;
            while (arrayStart < source.length && /\s/.test(source[arrayStart])) arrayStart++;
            if (source[arrayStart] !== "[") return null;

            let inString = false;
            let escaped = false;
            let squareDepth = 0;
            let arrayEnd = -1;
            for (let i = arrayStart; i < source.length; i++) {
                const ch = source[i];
                if (inString) {
                    if (escaped) escaped = false;
                    else if (ch === "\\") escaped = true;
                    else if (ch === '"') inString = false;
                    continue;
                }
                if (ch === '"') { inString = true; continue; }
                if (ch === "[") squareDepth++;
                else if (ch === "]") {
                    squareDepth--;
                    if (squareDepth === 0) { arrayEnd = i; break; }
                }
            }
            if (arrayEnd < 0) return null;

            // Parse the top-level plan independently from Operations. This lets us
            // preserve Intent/Message/Scenario ids even if one operation object is bad.
            let base: AnyDoc;
            try {
                base = JSON.parse(source.substring(0, arrayStart) + "[]" + source.substring(arrayEnd + 1));
            } catch (_) {
                return null;
            }

            const body = source.substring(arrayStart + 1, arrayEnd);
            const operations: AnyDoc[] = [];
            let invalidCount = 0;
            inString = false;
            escaped = false;
            let curlyDepth = 0;
            let opStart = -1;

            const acceptChunk = (chunk: string) => {
                const text = chunk.trim();
                if (!text) return;
                try {
                    const op = JSON.parse(text);
                    if (op && typeof op === "object") operations.push(op);
                    else invalidCount++;
                } catch (_) {
                    invalidCount++;
                }
            };

            for (let i = 0; i < body.length; i++) {
                const ch = body[i];
                if (inString) {
                    if (escaped) escaped = false;
                    else if (ch === "\\") escaped = true;
                    else if (ch === '"') inString = false;
                    continue;
                }
                if (ch === '"') { inString = true; continue; }
                if (ch === "{") {
                    if (curlyDepth === 0) opStart = i;
                    curlyDepth++;
                } else if (ch === "}") {
                    if (curlyDepth > 0) curlyDepth--;
                    if (curlyDepth === 0 && opStart >= 0) {
                        acceptChunk(body.substring(opStart, i + 1));
                        opStart = -1;
                    }
                }
            }
            if (opStart >= 0) invalidCount++;

            // Recovery is deliberately conservative: accept a nearly-complete plan
            // only when malformed items are a tiny minority. Semantic review and the
            // normal structural/code validators will then inspect the recovered plan.
            const total = operations.length + invalidCount;
            if (!operations.length || invalidCount > 3 || (total > 20 && invalidCount / total > 0.05)) {
                return null;
            }

            base.Operations = operations;
            const warnings = Array.isArray(base.Warnings) ? base.Warnings.slice() : [];
            if (invalidCount > 0) {
                warnings.push(
                    "AI-first recovered the model plan by omitting " +
                    invalidCount +
                    " malformed Operations item(s); semantic review will reassess the result."
                );
            }
            base.Warnings = warnings;
            return base;
        }

        function tryParseDesignerAIModelContent(
            content: any,
            finishReason?: string
        ): { Success: boolean; Value?: AnyDoc; Error?: string } {
            const first = tryParseDesignerAIContent(content, finishReason, "ModelGeneration");
            if (first.Success || typeof content !== "string") return first;

            // First use the narrow brace-boundary repair already proven on repair-pass
            // responses. It does not touch quoted strings or executable code.
            const structurallyRepaired = repairDesignerAIRepairOperationsJson(content);
            if (structurallyRepaired !== content) {
                const second = tryParseDesignerAIContent(
                    structurallyRepaired,
                    finishReason,
                    "ModelGeneration"
                );
                if (second.Success) return second;
            }

            // If a single operation contains a local JSON typo, keep every other valid
            // operation instead of throwing away/regenerating the complete large plan.
            const recovered = recoverDesignerAIPlanOperations(structurallyRepaired);
            if (recovered) {
                return { Success: true, Value: recovered };
            }

            return first;
        }

        function tryParseDesignerAIRepairContent(
            content: any,
            finishReason?: string
        ): { Success: boolean; Value?: AnyDoc; Error?: string } {
            const first = tryParseDesignerAIContent(
                content,
                finishReason,
                "ModelGeneration"
            );
            if (first.Success || typeof content !== "string") return first;

            const repaired = repairDesignerAIRepairOperationsJson(content);
            if (repaired === content) return first;

            const second = tryParseDesignerAIContent(
                repaired,
                finishReason,
                "ModelGeneration"
            );
            if (second.Success) return second;

            return first;
        }

        function tryParseDesignerAIContent(
            content: any,
            finishReason?: string,
            phase: "BusinessAnalysis" | "BusinessAnalysisAudit" | "ModelGeneration" = "ModelGeneration"
        ): { Success: boolean; Value?: AnyDoc; Error?: string } {
            try {
                return {
                    Success: true,
                    Value: parseDesignerAIContent(
                        content,
                        finishReason,
                        phase
                    )
                };
            } catch (error: any) {
                return {
                    Success: false,
                    Error: error?.message || String(error)
                };
            }
        }

        function wasDesignerAIResponseCutOff(serviceResponse: any): boolean {
            return String(serviceResponse?.FinishReason || "").toLowerCase() === "length";
        }

        function buildCompactRetryPrompt(
            userPrompt: string,
            blueprint: DesignerAIBusinessBlueprint
        ): string {
            return [
                "Retry the CosmoApps model plan from scratch because the previous response was truncated or invalid JSON.",
                "Return the smallest syntactically valid JSON possible.",
                "",
                "Original request:",
                userPrompt,
                "",
                "The BusinessBlueprint in Context is authoritative.",
                "BusinessBlueprint.BusinessAnalysis.DeliveryActivities are project work, not application model features. Do not create types, fields, navigation or capability evidence merely to represent them.",
                "Create or reuse every BusinessBlueprint.ConceptualTypes item. ConceptualTypes contains business entity/document/reference-data types only, never enums.",
                "For each Core scenario involving multiple ConceptualTypes, keep those types connected by real typed references/collections or short typed paths. A derived/summary type must not be isolated from the records it summarizes.",
                "If the same actor/person is persistently referenced by multiple business records or is the grouping key of a cross-record calculation, model that actor as a ConceptualType and typed reference, not repeated string fields.",
                "Do not create extra standalone actor/access-role types absent from ConceptualTypes. Access roles are not business entities unless business records persistently reference them.",
                "Implement every Required BusinessBlueprint.SemanticRelations relation. Ensure both endpoint types exist or are reused. Direct=true requires a real typed field/collection on From resolving to To; Direct=false may be represented by a short coherent typed path. Never use a scalar surrogate for a direct relation.",
                "Use BusinessBlueprint.ExistingModelReuseAnalysis for every existing-type reuse decision. Never substitute a hard-coded canonical type name.",
                "Only types actually present in Context.ModelSummary.ApplicationModel.Types may be reused. If no matching existing type is present, create the required type.",
                "Context.ModelSummary.ApplicationModel is the complete authoritative application model for reuse decisions. Do not use ids, type names or assumptions from another project, a template, the metamodel, prior conversation context or training knowledge.",
                "If Context.ModelSummary.ApplicationModel.IsStructurallyEmpty is true, every required business entity must be created in Operations. ExistingModelReuseAnalysis must contain no ReuseExisting, ExtendExisting or CreateDerived decisions.",
                "Every AddEnum must be referenced by at least one generated property unless the user explicitly requested a standalone enum artifact. Never create orphan enums.",
                "Create an enum only when it has at least two meaningful alternatives; one-value enums are invalid.",
                "Do not implement cross-record aggregate formulas through Deferred collections in CurrentData.",
                "Create an enum only when it has at least two meaningful alternatives. A period/frequency with only one current value is not an enum; use string/date/value fields instead.",
                "Do not implement a cross-record aggregate Formula through Deferred collections in CurrentData. If the required aggregate depends on records loaded by query/Deferred navigation, keep a stored snapshot/result field and mark the automatic calculation as missing/manual unless the runtime explicitly provides that data.",
                "Before returning, verify every identifier and nested member used by every Formula exists in the generated/current model.",
                "Never use Formula 0, false, true, null, an empty string, or another literal constant as a placeholder for a promised business calculation. Use DefaultValue for a genuine constant; otherwise leave the calculation missing.",
                "Do not claim a bonus, debt, overdue amount, document total, price calculation or other derived business value is implemented unless its Formula actually depends on the model data required by that business rule.",
                "Message counts and named created types/enums must exactly match Operations. Never mention a created type that has no AddType operation.",
                "Structural fields such as Manager, Role, IsOverdue or PriceOverridden do not by themselves implement permissions, reminders, highlighting, logging, validation or automatic actions.",
                "For cross-record calculations and summaries, choose a coherent model yourself. Do not claim behavior is implemented unless the generated structure or formula really supports it.",
                "JavaScript Array methods such as reduce, map and filter are valid on Many collections.",
                "Never use Formula 0, false, true, null, an empty string, or another literal constant as a placeholder for a promised business calculation. Use DefaultValue for a genuine constant; otherwise leave the calculation missing.",
                "Do not claim a bonus, debt, overdue amount, document total, price calculation or other derived business value is implemented unless its Formula actually depends on the model data required by that business rule.",
                "Message counts and named created types/enums must exactly match Operations. Never mention a created type that has no AddType operation.",
                "Structural fields such as Manager, Role, IsOverdue or PriceOverridden do not by themselves implement permissions, reminders, highlighting, logging, validation or automatic actions.",
                "If a formula needs a reverse related-document collection and the related type has a direct Hybrid/Value reference back to the owner, generate that reverse collection as Deferred. Example pattern only: PriceRule.Product -> Product.PriceRules.",
                "Never invent a reverse collection when no direct forward reference defines it; instead leave that behavior missing.",
                "Do not contradict explicit user answers from the conversation.",
                "Never assume Company, Product, User, Employee or any other business type exists unless it is present in Context.Model. In an empty project, create the required business types instead of referencing known IDs from another project or template.",
                "Never assume Company, Product, User, Employee or any other business type exists unless it is present in Context.Model. In an empty project, create the required business types instead of referencing known IDs from another project or template.",
                "Do not mark behavior as implemented merely because supporting fields exist. Actions, validation, automatic status changes, posting, balance updates and edit restrictions require explicit executable model elements.",
                "Likewise, IntegrationBehavior, ScheduledBehavior, SecurityBehavior, ViewBehavior and ExecutableBehavior are not satisfied by supporting types, fields, navigation or ListViews alone. Preserve the supporting structure, but let coverage report the behavior as missing when the current OperationContract cannot generate it.",
                "In this metamodel scalar properties may use Aggregation: Value. Preserve this convention for primitive and enum properties.",
                "Aggregation and multiplicity are independent. Aggregated means the child object is embedded/owned by the parent; it does not mean Many=true.",
                "Use Many=true only when the user explicitly asks for multiple child objects, a list/collection, lines/items, or otherwise clearly plural data. For one embedded child object use AddProperty with Aggregation=Aggregated and Many=false. Example: Counterparty.Address -> Address is Aggregated + Many=false; Order.Lines -> OrderLine is Aggregated + Many=true.",
                "Preserve the user's document terminology. If the user uses Invoice or накладная as the document that records shipment, do not invent a separate Shipment document unless the user explicitly distinguishes invoice issuance from a separate physical shipment event.",
                "Do not add capabilities for unrelated existing model elements merely because they are present in context. Reused types may appear only when they directly support the requested scenarios.",
                "Explicit answers given after clarification override assumptions from the initial business analysis.",
                "Do not introduce warehouse stock, StockQuantity, inventory write-off, warehouse balances or stock validations unless the user explicitly requests warehouse accounting. Tracking shipment against customer orders is not warehouse accounting.",
                "If a requested referenced type such as Product does not exist, create it in the same plan with minimal useful fields instead of leaving a primitive placeholder or asking for clarification.",
                "A Hybrid or Value reference must point to a real existing type id or to a TemporaryId created by AddType. Never use a primitive type such as string for a reference.",
                "Use the exact Scenario.Id and Capability.Id values from that blueprint.",
                "",
                "Return only:",
                "{",
                '  "Intent": "Modify",',
                '  "Message": "...",',
                '  "Scenarios": [{"Id":"S1"}],',
                '  "Capabilities": [{"Id":"C1"}],',
                '  "Operations": [...]',
                "}",
                "",
                "Do not return BusinessAnalysis, Questions, Recommendations, Warnings, NeedsMoreContext or ContextRequests.",
                "Use no markdown, comments, trailing commas or text outside the JSON object.",
                "Escape every string correctly.",
                "Use no whitespace formatting beyond what JSON requires.",
                "Keep every required Operation; shorten only explanatory text.",
                "Before sending, verify that the JSON parses and that all braces, brackets and quotes are closed."
            ].join("\\n");
        }


        function buildModelGenerationPrompt(
            userPrompt: string,
            blueprint: DesignerAIBusinessBlueprint
        ): string {
            return [
                "Create the CosmoApps model changes requested by the user.",
                "",
                "Original user request:",
                userPrompt,
                "",
                "The BusinessBlueprint in Context is authoritative.",
                "BusinessBlueprint.BusinessAnalysis.DeliveryActivities are project work, not application model features. Do not create types, fields, navigation or capability evidence merely to represent them.",
                "Create or reuse every BusinessBlueprint.ConceptualTypes item. ConceptualTypes contains business entity/document/reference-data types only, never enums.",
                "For each Core scenario involving multiple ConceptualTypes, keep those types connected by real typed references/collections or short typed paths. A derived/summary type must not be isolated from the records it summarizes.",
                "If the same actor/person is persistently referenced by multiple business records or is the grouping key of a cross-record calculation, model that actor as a ConceptualType and typed reference, not repeated string fields.",
                "Do not create extra standalone actor/access-role types absent from ConceptualTypes. Access roles are not business entities unless business records persistently reference them.",
                "Implement every Required BusinessBlueprint.SemanticRelations relation. Ensure both endpoint types exist or are reused. Direct=true requires a real typed field/collection on From resolving to To; Direct=false may be represented by a short coherent typed path. Never use a scalar surrogate for a direct relation.",
                "Use BusinessBlueprint.ExistingModelReuseAnalysis for every existing-type reuse decision. Never substitute a hard-coded canonical type name.",
                "Only types actually present in Context.ModelSummary.ApplicationModel.Types may be reused. If no matching existing type is present, create the required type.",
                "Context.ModelSummary.ApplicationModel is the complete authoritative application model for reuse decisions. Do not use ids, type names or assumptions from another project, a template, the metamodel, prior conversation context or training knowledge.",
                "If Context.ModelSummary.ApplicationModel.IsStructurallyEmpty is true, every required business entity must be created in Operations. ExistingModelReuseAnalysis must contain no ReuseExisting, ExtendExisting or CreateDerived decisions.",
                "Every AddEnum must be referenced by at least one generated property unless the user explicitly requested a standalone enum artifact. Never create orphan enums.",
                "Context.PlatformCapabilities is authoritative for what the platform can express and what the current AI OperationContract can actually generate.",
                "Generate Rule, Action and Event operations when required and present in OperationContract. Never fabricate operation types absent from OperationContract; View behavior remains manual until View operations are added.",
                "Do not contradict explicit user answers from the conversation.",
                "Do not mark behavior as implemented merely because supporting fields exist. Actions, validation, automatic status changes, posting, balance updates and edit restrictions require explicit executable model elements.",
                "Likewise, IntegrationBehavior, ScheduledBehavior, SecurityBehavior, ViewBehavior and ExecutableBehavior are not satisfied by supporting types, fields, navigation or ListViews alone. Preserve the supporting structure, but let coverage report the behavior as missing when the current OperationContract cannot generate it.",
                "In this metamodel scalar properties may use Aggregation: Value. Preserve this convention for primitive and enum properties.",
                "Aggregation and multiplicity are independent. Aggregation=Aggregated means owned/embedded storage and does NOT imply Many=true.",
                "For typed semantic Requirements, use EmbeddedObject for a single Aggregated child (Many=false) and EmbeddedCollection only for an Aggregated collection (Many=true).",
                "For a single embedded/owned child described in singular form, emit AddProperty with Aggregation=Aggregated and Many=false (or omit Many). Keep the owner property singular.",
                "Use Many=true / AddCollection only when the user explicitly asks for multiple items, a list/collection, repeated lines/rows/addresses/contacts, or when plural multiplicity is otherwise explicit in the authoritative BusinessBlueprint.",
                "Never pluralize a singular user concept merely because it is an Aggregated child.",
                "Before returning Operations, verify every Aggregated relation against the user's requested cardinality: singular owned object => one property; plural owned children => collection.",
                "Preserve the user's document terminology. If the user uses Invoice or накладная as the document that records shipment, do not invent a separate Shipment document unless the user explicitly distinguishes invoice issuance from a separate physical shipment event.",
                "Do not add capabilities for unrelated existing model elements merely because they are present in context. Reused types may appear only when they directly support the requested scenarios.",
                "Explicit answers given after clarification override assumptions from the initial business analysis.",
                "Generate a complete plan that implements its Core scenarios.",
                "Do not add model elements that are absent from the authoritative BusinessBlueprint, even when they are common for this document type.",
                "When an Inherits Requirement targets an existing derived type and a base type created in this plan, emit UpdateType with EntityId of the derived type and Changes.BaseType referencing the base type TemporaryId.",
                "Navigation is built around ListViews, not direct entity-instance opening.",
                "A ListView of abstract Document may expose all derived documents.",
                "Concrete document views may be placed in process-specific Folder groups.",
                "Folder is a preferred classification hint; explicit user intent and existing navigation have priority.",
                "Do not create navigation for Aggregated line types or technical child types.",
                "Do not rebuild existing navigation unless explicitly requested.",
                "When existing objects must be regrouped or reparented, use MoveObject rather than recreating them.",
                "For AddNavigationItem always emit exactly one direct EntityId or EntityRef on the operation. For a type created in the same plan use EntityRef: { TemporaryId: '<exact AddType TemporaryId>' }. Never emit a navigation item without a target. Do not set NavigationItem.Type: the designer maps the resolved target to runtime NavigationItem.Type using the target type technical Name. Do not invent a separate ListView operation; AddNavigationItem targeting a type represents its runtime ListView.",
                "Message must describe only operations actually present in the returned plan. Do not claim that scenarios or capabilities were implemented by id.",
                "FINAL IDENTIFIER CHECK: before returning, inspect every generated Type.Name, Property.Name, Collection.Name and Enum.Name. None may exactly equal a Cosmos DB SQL reserved keyword (case-insensitive), especially Group or Order. If business terminology uses a reserved word, choose a specific technical identifier such as TenderGroup, CustomerOrder, OrderRecord or GroupRef while preserving the requested Caption.",
                "",
                "OUTPUT CHUNK RULES:",
                "- Return at most 50 Operations in this response.",
                "- Add top-level Complete:true when all required Operations are included; use Complete:false when more Operations remain. The designer will request the next chunk.",
                "- Never intentionally run into the token limit. Prefer a smaller valid JSON chunk with Complete:false.",
                "OUTPUT SIZE RULES:",
                "- Return compact JSON only, with no markdown.",
                "- Do not repeat BusinessAnalysis; the client already has it.",
                "- Scenarios: return only Name, Evidence and Missing.",
                "- Capabilities: return only Name, Status, Evidence and Missing.",
                "- Omit empty Questions, Recommendations, Warnings and ContextRequests when possible.",
                "- Do not add prose outside Message.",
                "- Use concise captions and descriptions.",
                "- Operations must remain complete; never omit model changes merely to shorten the response."
            ].join("\n");
        }


        function isSimpleDesignerAIStructuralEdit(prompt: string): boolean {
            const value = String(prompt || "").trim().toLowerCase();

            if (!value || value.length > 500) {
                return false;
            }

            const complexMarkers = [
                "система", "приложение", "учет", "процесс", "сценар",
                "заказ", "накладн", "остат", "склад", "workflow",
                "system", "application", "business process", "scenario",
                "order", "invoice", "balance", "warehouse",
                "несколько", "все поля", "полную модель", "создай тип",
                "multiple", "complete model", "create type"
            ];

            if (complexMarkers.some(marker => value.indexOf(marker) >= 0)) {
                return false;
            }

            const explicitFieldAction =
                /(добав(ь|ить|ьте)|созда(й|ть|йте)|переимену(й|йте|ть)|измени(ть|те)?|удали(ть|те)?|сделай)\s+.*(поле|свойств)/i.test(value) ||
                /(add|create|rename|change|update|remove|delete)\s+.*(field|property)/i.test(value);

            const changesEntityStructure =
                /(тип|сущност|класс|entity|type|class)/i.test(value) &&
                /(добав|созда|сделай|измени|удали|убери|замени|встро|влож|add|create|make|change|update|remove|delete|replace|embed|nest)/i.test(value);

            const changesOwnedObjectStructure =
                /(встроенн|вложенн|агрегир|частью\s+[^,.]+|находящ|embedded|nested|aggregated|owned\s+by|part\s+of)/i.test(value) &&
                /(поле|свойств|ссылк|тип|сущност|объект|field|property|reference|type|entity|object)/i.test(value);

            // The simple-edit path is intentionally limited to local field/property edits.
            // Creating/restructuring an entity or an owned embedded object usually requires
            // several coordinated operations (type, child fields, owner property, removals).
            // Route such requests through full ModelGeneration even if they also contain
            // the words "field/property".
            if (changesEntityStructure || changesOwnedObjectStructure) {
                return false;
            }

            const explicitNavigationAction =
                /(добав(ь|ить|ьте)|созда(й|ть|йте)|измени(ть|те)?|удали(ть|те)?|перенеси(ть|те)?|сгруппируй|размести(ть|те)?|переделай|реорганизу(й|йте|ть)|распредели(ть|те)?|разложи(ть|те)?|помести(ть|те)?)\s+.*(навигац|меню|раздел)/i.test(value) ||
                /(add|create|change|update|remove|delete|move|group|place|reorganize|restructure|redistribute)\s+.*(navigation|menu|section)/i.test(value);

            if (explicitNavigationAction) {
                const alsoChangesModelStructure =
                    /(тип|сущност|класс|поле|свойств|ссылк|отношен|связ|reference|entity|type|field|property|relation)/i.test(value) &&
                    /(добав|созда|измени|удали|сделай|add|create|change|update|remove|delete|make)/i.test(value);

                const alsoDefinesNavigationBehavior =
                    /(скрипт|код|действ|поведен|выполня|открыва|показыва|отобража|окн|диалог|popup|script|code|action|behavior|execute|open|show|display)/i.test(value) ||
                    /(отч[её]т|таблиц|график|диаграмм|дашборд|форм[ау]|grid|chart|diagram|report|dashboard|form)/i.test(value);

                // The lightweight navigation path is only for menu structure:
                // add/move/group/rename menu sections or items.
                // If the same request also changes model structure or describes
                // executable/UI behavior of a navigation item, use full
                // ModelGeneration so the behavior and navigation are planned together.
                if (
                    alsoChangesModelStructure ||
                    alsoDefinesNavigationBehavior
                ) {
                    return false;
                }

                return true;
            }

            // Natural requests often omit the word "field":
            // "добавь в компанию юридический адрес".
            const implicitFieldAction =
                /^(добав(ь|ить|ьте)|созда(й|ть|йте))\s+(в|для)\s+[\p{L}\d_ -]+\s+[\p{L}\d_ -]+$/iu.test(value) ||
                /^(add|create)\s+[\p{L}\d_ -]+\s+(to|for|in)\s+[\p{L}\d_ -]+$/iu.test(value);

            if (!explicitFieldAction && !implicitFieldAction) {
                return false;
            }

            const separators = (value.match(/[,;]|\sи\s|\sand\s/g) || []).length;
            const complexClauses = [
                "котор", "чтобы", "при этом", "на основании", "автоматически",
                "where", "which", "when", "based on", "automatically"
            ];

            return (
                separators <= 2 &&
                !complexClauses.some(marker => value.indexOf(marker) >= 0)
            );
        }

        function buildSimpleDesignerAIBlueprint(
            prompt: string
        ): DesignerAIBusinessBlueprint {
            return {
                Intent: "ReadyToModel",
                Summary: prompt,
                BusinessAnalysis: {
                    Actors: [],
                    ReferenceData: [],
                    Documents: [],
                    Lifecycles: [],
                    QuantitiesAndBalances: [],
                    DerivedValues: [],
                    Assumptions: []
                },
                ExistingModelReuseAnalysis: [],
                Scenarios: [
                    {
                        Id: "S1",
                        Name: "Requested structural model change",
                        Description: prompt,
                        Importance: "Core",
                        RequiredModelElements: [],
                        Requirements: []
                    }
                ],
                Capabilities: [
                    {
                        Id: "C1",
                        Name: "Requested structural model change",
                        Importance: "Core",
                        RequiredModelElements: [],
                        Requirements: [],
                        AcceptanceCriteria: [
                            "The explicitly requested model change is present."
                        ]
                    }
                ],
                Questions: [],
                Assumptions: [],
                NeedsClarification: false
            };
        }

        function buildSimpleDesignerAIModificationPrompt(
            userPrompt: string,
            blueprint: DesignerAIBusinessBlueprint
        ): string {
            return [
                "Apply one simple structural modification to the existing CosmoApps model.",
                "Return valid compact JSON only.",
                "Do not perform a separate business analysis.",
                "Do not invent additional scenarios, search behavior, forms, actions or capabilities.",
                "Do not invent navigation unless the user explicitly requested navigation/menu changes.",
                "Generate only the minimum Operations explicitly required by the request.",
                "For an explicit navigation request, inspect Context.ModelSummary.ApplicationModel.NavigationItems. It is a FLAT authoritative list of all existing groups and items. ParentId identifies the containing group and Path shows the hierarchy.",
                "For every missing type explicitly required in navigation, emit AddNavigationItem. Use ParentId with the exact id of an existing destination group; use ParentRef only for a group created in the same plan.",
                "Never say that a navigation item was added unless a corresponding AddNavigationItem operation is present.",
                "If the user asks to add all missing navigation items, compare ApplicationModel.Types against NavigationItems and add only types that do not already have a navigation item.",
                "Reuse existing types when the requested field clearly refers to one.",
                "For a reference field use the existing type id and the appropriate Aggregation.",
                "Aggregation and multiplicity are independent. Aggregated means one child may be embedded in the owner; it does not imply a collection.",
                "Use Many=true only when the user explicitly asks for multiple/list/collection child objects. For a single embedded object use AddProperty with Aggregation=Aggregated and Many=false (for example Counterparty.Address).",
                "Collections are ordinary AddProperty operations with Many=true.",
                "",
                "User request:",
                userPrompt,
                "",
                "Use exactly Scenario Id S1 and Capability Id C1.",
                "Return the standard Modify-plan shape required by the supplied context."
            ].join("\n");
        }


        
        function isDesignerAINavigationReorganizationRequest(
            prompt: string
        ): boolean {
            const value =
                String(prompt || "")
                    .trim()
                    .toLowerCase();

            if (!value) return false;

            if (
                /(недостающ|отсутствующ|missing|not\s+present)/i.test(value)
            ) {
                return false;
            }

            const mentionsNavigation =
                /(навигац|меню|раздел)/i.test(value) ||
                /(navigation|menu|section)/i.test(value);

            const reorganizationVerb =
                /(передел|реорганиз|сгруппир|распредел|разлож|помест|перенес|перемест|размест)/i.test(value) ||
                /(reorganize|restructure|group|redistribute|move|place)/i.test(value);

            const groupingMeaning =
                /(тематичес|соответствующ|по\s+раздел|в\s+раздел|по\s+тем|групп)/i.test(value) ||
                /(thematic|appropriate\s+section|into\s+section|by\s+theme|group)/i.test(value);

            return (
                mentionsNavigation &&
                reorganizationVerb &&
                groupingMeaning
            );
        }

        function getDesignerAINavigationReorganizationItems(): AnyDoc[] {
            const types = getAIApplicationTypeDocs();
            const navigation = getAIApplicationNavigationItems();

            const resolveType =
                (item: AnyDoc): AnyDoc | null => {
                    const candidates = [
                        item?.EntityId,
                        item?.TargetType,
                        item?.Type
                    ]
                        .filter(Boolean)
                        .map((value: any) => String(value));

                    for (let index = 0; index < candidates.length; index++) {
                        const candidate = candidates[index];
                        const found =
                            types.find(
                                (typeDoc: AnyDoc) =>
                                    String(typeDoc?.id || "") === candidate ||
                                    String(typeDoc?.Name || "") === candidate ||
                                    String(typeDoc?.TypeName || "") === candidate
                            );

                        if (found) return found;
                    }

                    return null;
                };

            return navigation
                .filter(
                    (item: AnyDoc) =>
                        item?.IsGroup !== true
                )
                .map(
                    (item: AnyDoc) => {
                        const typeDoc = resolveType(item);

                        return {
                            NavigationItemId:
                                item?.id || null,
                            Caption:
                                item?.Caption ||
                                item?.Name ||
                                null,
                            CurrentParentId:
                                item?.ParentId ||
                                null,
                            CurrentPath:
                                item?.Path ||
                                null,
                            TypeId:
                                typeDoc?.id ||
                                null,
                            TypeName:
                                typeDoc?.Name ||
                                item?.Type ||
                                null,
                            TypeCaption:
                                typeDoc?.Caption ||
                                null,
                            TypeDescription:
                                typeDoc?.Description ||
                                null
                        };
                    }
                )
                .filter(
                    (item: AnyDoc) =>
                        !!item.NavigationItemId &&
                        !!item.TypeName
                );
        }

        function buildDesignerAINavigationReorganizationPrompt(
            userPrompt: string,
            retryReason?: string
        ): string {
            const items =
                getDesignerAINavigationReorganizationItems();
            const groups =
                getDesignerAINavigationGroups();

            return [
                "Reorganize existing CosmoApps navigation by assigning existing typed menu items to thematic groups.",
                "Return JSON only.",
                "Do NOT generate CosmoApps Operations. The Designer compiles the assignments deterministically.",
                "",
                "RULES:",
                "1. Every CURRENT_ITEM must appear exactly once in Assignments.",
                "2. Reuse an EXISTING_GROUP when semantically appropriate.",
                "3. Add an entry to Groups only when no suitable existing group exists.",
                "4. Never create or duplicate a menu item. Existing items will be moved.",
                "5. Do not change types, captions, ids, views or business model.",
                "6. For an existing group use ParentId.",
                "7. For a proposed new group use ParentRef: { TemporaryId: <Groups.TemporaryId> }.",
                "8. Keep groups few and thematic.",
                "",
                "OUTPUT SHAPE:",
                '{"Intent":"Modify","Message":"short factual summary","Groups":[{"TemporaryId":"nav-group-x","Name":"TechnicalName","Caption":"User caption"}],"Assignments":[{"NavigationItemId":"<existing-item-id>","ParentId":"<existing-group-id>"},{"NavigationItemId":"<existing-item-id>","ParentRef":{"TemporaryId":"nav-group-x"}}]}',
                "",
                retryReason
                    ? "PREVIOUS RESULT WAS INVALID: " + retryReason
                    : "",
                "",
                "USER REQUEST:",
                userPrompt,
                "",
                "EXISTING_GROUPS:",
                JSON.stringify(groups),
                "",
                "CURRENT_ITEMS:",
                JSON.stringify(items)
            ]
                .filter((line: string) => line !== "")
                .join("\\n");
        }

        function compileDesignerAINavigationReorganization(
            rawPlan: AnyDoc
        ): AnyDoc {
            const currentItems =
                getDesignerAINavigationReorganizationItems();
            const existingGroups =
                getDesignerAINavigationGroups();

            const assignments =
                Array.isArray(rawPlan?.Assignments)
                    ? rawPlan.Assignments
                    : [];

            const rawGroups =
                Array.isArray(rawPlan?.Groups)
                    ? rawPlan.Groups
                    : [];

            const itemById =
                new Map<string, AnyDoc>();
            currentItems.forEach(
                (item: AnyDoc) =>
                    itemById.set(
                        String(item.NavigationItemId),
                        item
                    )
            );

            const existingGroupById =
                new Map<string, AnyDoc>();
            const existingGroupByCaption =
                new Map<string, AnyDoc>();

            existingGroups.forEach(
                (group: AnyDoc) => {
                    existingGroupById.set(
                        String(group.id),
                        group
                    );

                    existingGroupByCaption.set(
                        String(
                            group.Caption ||
                            group.Name ||
                            ""
                        )
                            .trim()
                            .toLowerCase(),
                        group
                    );
                }
            );

            const newGroupsByTemporaryId =
                new Map<string, AnyDoc>();
            const groupOperations: AnyDoc[] = [];

            rawGroups.forEach(
                (group: AnyDoc, index: number) => {
                    const temporaryId =
                        String(
                            group?.TemporaryId ||
                            `nav-group-${index + 1}`
                        ).trim();
                    const caption =
                        String(
                            group?.Caption ||
                            group?.Name ||
                            ""
                        ).trim();
                    const name =
                        String(
                            group?.Name ||
                            (
                                caption
                                    ? makeDesignerAINavigationGroupTechnicalName(
                                        caption
                                    )
                                    : ""
                            )
                        ).trim();

                    if (!temporaryId || !caption || !name) {
                        return;
                    }

                    const existing =
                        existingGroupByCaption.get(
                            caption.toLowerCase()
                        );

                    if (existing) {
                        newGroupsByTemporaryId.set(
                            temporaryId,
                            {
                                ExistingId:
                                    String(existing.id),
                                Caption:
                                    caption
                            }
                        );
                        return;
                    }

                    if (
                        newGroupsByTemporaryId.has(
                            temporaryId
                        )
                    ) {
                        return;
                    }

                    newGroupsByTemporaryId.set(
                        temporaryId,
                        {
                            TemporaryId:
                                temporaryId,
                            Name:
                                name,
                            Caption:
                                caption
                        }
                    );

                    groupOperations.push({
                        Type:
                            "AddNavigationGroup",
                        TemporaryId:
                            temporaryId,
                        NavigationItem: {
                            Name:
                                name,
                            Caption:
                                caption
                        }
                    });
                }
            );

            const seenAssignments =
                new Set<string>();
            const moveOperations: AnyDoc[] = [];

            assignments.forEach(
                (assignment: AnyDoc) => {
                    const navigationItemId =
                        String(
                            assignment?.NavigationItemId ||
                            ""
                        ).trim();

                    if (
                        !itemById.has(navigationItemId) ||
                        seenAssignments.has(navigationItemId)
                    ) {
                        return;
                    }

                    let parentId =
                        String(
                            assignment?.ParentId ||
                            ""
                        ).trim();
                    let parentRef =
                        String(
                            assignment?.ParentRef?.TemporaryId ||
                            ""
                        ).trim();

                    if (
                        parentId &&
                        !existingGroupById.has(parentId)
                    ) {
                        parentId = "";
                    }

                    if (parentRef) {
                        const group =
                            newGroupsByTemporaryId.get(
                                parentRef
                            );

                        if (!group) {
                            parentRef = "";
                        } else if (group.ExistingId) {
                            parentId =
                                String(group.ExistingId);
                            parentRef = "";
                        }
                    }

                    if (
                        Number(!!parentId) +
                        Number(!!parentRef) !==
                        1
                    ) {
                        return;
                    }

                    seenAssignments.add(
                        navigationItemId
                    );

                    const current =
                        itemById.get(
                            navigationItemId
                        );

                    if (
                        parentId &&
                        String(
                            current?.CurrentParentId ||
                            ""
                        ) === parentId
                    ) {
                        return;
                    }

                    const operation: AnyDoc = {
                        Type:
                            "MoveObject",
                        ObjectId:
                            navigationItemId,
                        Collection:
                            "Items"
                    };

                    if (parentId) {
                        operation.ParentId =
                            parentId;
                    } else {
                        operation.ParentRef = {
                            TemporaryId:
                                parentRef
                        };
                    }

                    moveOperations.push(
                        operation
                    );
                }
            );

            const unassigned =
                currentItems.filter(
                    (item: AnyDoc) =>
                        !seenAssignments.has(
                            String(
                                item.NavigationItemId
                            )
                        )
                );

            if (unassigned.length > 0) {
                throw new Error(
                    "ИИ не распределил пункты меню: " +
                    unassigned
                        .map(
                            (item: AnyDoc) =>
                                String(
                                    item.Caption ||
                                    item.TypeName ||
                                    item.NavigationItemId
                                )
                        )
                        .join(", ")
                );
            }

            return {
                Intent: "Modify",
                Message:
                    String(
                        rawPlan?.Message ||
                        "Навигация реорганизована по тематическим разделам."
                    ),
                BusinessAnalysis: {},
                Scenarios: [],
                Capabilities: [],
                Questions: [],
                Recommendations: [],
                Operations: [
                    ...groupOperations,
                    ...moveOperations
                ],
                Warnings: [],
                NeedsMoreContext: false,
                ContextRequests: []
            };
        }

        function isDesignerAIFillMissingNavigationRequest(
            prompt: string
        ): boolean {
            const value =
                String(prompt || "")
                    .trim()
                    .toLowerCase();

            if (!value) return false;

            const mentionsNavigation =
                /(навигац|меню|раздел)/i.test(value) ||
                /(navigation|menu|section)/i.test(value);

            const mentionsMissing =
                /(недостающ|отсутствующ|которых\s+нет|не\s+добавлен|не\s+представлен)/i.test(value) ||
                /(missing|not\s+present|not\s+represented|not\s+added)/i.test(value);

            const mentionsTypes =
                /(тип|сущност|объект)/i.test(value) ||
                /(type|entity|object)/i.test(value);

            return (
                mentionsNavigation &&
                mentionsMissing &&
                mentionsTypes
            );
        }

        function isDesignerAIExplicitNavigationGroupRequest(
            prompt: string
        ): boolean {
            const value =
                String(prompt || "")
                    .trim();

            if (!value) return false;

            const lower =
                value.toLowerCase();

            const mentionsNavigation =
                /(навигац|меню|раздел)/i.test(lower) ||
                /(navigation|menu|section)/i.test(lower);

            const addVerb =
                /(добав|созда|сделай|встав)/i.test(lower) ||
                /(add|create|make|insert)/i.test(lower);

            const hasQuotedCaption =
                /["«„][^"»“]+["»“]/.test(value) ||
                /'[^']+'/.test(value);

            const explicitlyGroupLike =
                /(раздел|групп|заголов)/i.test(lower) ||
                /(section|group|header)/i.test(lower);

            // "Добавь пункт меню 'Справочники'" without an entity/type target
            // is a group/header request in the legacy runtime navigation format.
            const hasTypeTarget =
                /(для\s+тип|для\s+сущност|открыва|listview|entityid|тип\s+[A-ZА-Я])/i.test(value);

            return (
                mentionsNavigation &&
                addVerb &&
                (
                    explicitlyGroupLike ||
                    (
                        hasQuotedCaption &&
                        !hasTypeTarget
                    )
                )
            );
        }

        function extractDesignerAINavigationCaption(
            prompt: string
        ): string | null {
            const value =
                String(prompt || "")
                    .trim();

            const quoted =
                value.match(
                    /["«„]([^"»“]+)["»“]/
                ) ||
                value.match(
                    /'([^']+)'/
                );

            if (
                quoted &&
                quoted[1]
            ) {
                return String(
                    quoted[1]
                ).trim();
            }

            const afterKeyword =
                value.match(
                    /(?:раздел|групп[ау]?|пункт\s+меню|section|group|menu\s+item)\s+(.+)$/i
                );

            if (
                afterKeyword &&
                afterKeyword[1]
            ) {
                return String(
                    afterKeyword[1]
                )
                    .replace(
                        /^[\s:—–-]+/,
                        ""
                    )
                    .replace(
                        /[.!?]+$/,
                        ""
                    )
                    .trim();
            }

            return null;
        }

        function makeDesignerAINavigationGroupTechnicalName(
            caption: string
        ): string {
            const source =
                transliterateProjectName(
                    caption
                )
                    .replace(
                        /[^A-Za-z0-9]+/g,
                        " "
                    )
                    .trim();

            const words =
                source
                    .split(/\s+/)
                    .filter(Boolean);

            let result =
                words
                    .map(
                        (word: string) =>
                            word.charAt(0)
                                .toUpperCase() +
                            word.slice(1)
                    )
                    .join("");

            if (!result) {
                result =
                    "NavigationGroup";
            }

            if (/^\d/.test(result)) {
                result =
                    "Group" + result;
            }

            return result.substring(
                0,
                64
            );
        }

        function buildDesignerAIExplicitNavigationGroupPlan(
            prompt: string
        ): AnyDoc | null {
            if (
                !isDesignerAIExplicitNavigationGroupRequest(
                    prompt
                )
            ) {
                return null;
            }

            const caption =
                extractDesignerAINavigationCaption(
                    prompt
                );

            if (!caption) {
                return null;
            }

            const existing =
                getAIApplicationNavigationItems()
                    .find(
                        (item: AnyDoc) =>
                            item?.IsGroup === true &&
                            String(
                                item?.Caption ||
                                item?.Name ||
                                ""
                            )
                                .trim()
                                .toLowerCase() ===
                            caption
                                .toLowerCase()
                    );

            if (existing) {
                return {
                    Intent:
                        "Modify",
                    Message:
                        `Раздел «${caption}» уже существует в навигации.`,
                    BusinessAnalysis: {},
                    Scenarios: [],
                    Capabilities: [],
                    Questions: [],
                    Recommendations: [],
                    Operations: [],
                    Warnings: [],
                    NeedsMoreContext:
                        false,
                    ContextRequests: []
                };
            }

            const technicalName =
                makeDesignerAINavigationGroupTechnicalName(
                    caption
                );

            return {
                Intent: "Modify",
                Message:
                    `Добавлен раздел навигации «${caption}».`,
                BusinessAnalysis: {},
                Scenarios: [],
                Capabilities: [],
                Questions: [],
                Recommendations: [],
                Operations: [
                    {
                        Type:
                            "AddNavigationGroup",
                        TemporaryId:
                            "nav-group-" +
                            technicalName
                                .replace(
                                    /([a-z0-9])([A-Z])/g,
                                    "$1-$2"
                                )
                                .toLowerCase(),
                        NavigationItem: {
                            Name:
                                technicalName,
                            Caption:
                                caption
                        }
                    }
                ],
                Warnings: [],
                NeedsMoreContext:
                    false,
                ContextRequests: []
            };
        }


function isDesignerAINavigationModificationRequest(
            prompt: string
        ): boolean {
            const value =
                String(prompt || "")
                    .trim()
                    .toLowerCase();

            if (!value) return false;

            return (
                /(навигац|меню|раздел)/i.test(value) ||
                /(navigation|menu|section)/i.test(value)
            );
        }

        function getDesignerAINavigationRepresentedTypeIds(): Set<string> {
            const represented =
                new Set<string>();
            const types =
                getAIApplicationTypeDocs();
            const navigation =
                getAIApplicationNavigationItems();

            const resolveTypeId = (
                item: AnyDoc
            ): string | null => {
                const direct = String(
                    item?.EntityId ||
                    item?.TargetType ||
                    ""
                ).trim();

                if (
                    direct &&
                    types.some(
                        (typeDoc: AnyDoc) =>
                            String(
                                typeDoc?.id || ""
                            ) === direct
                    )
                ) {
                    return direct;
                }

                const rawType =
                    String(
                        item?.Type || ""
                    ).trim();

                if (!rawType) {
                    return null;
                }

                const typeDoc =
                    types.find(
                        (candidate: AnyDoc) =>
                            String(
                                candidate?.id || ""
                            ) === rawType ||
                            String(
                                candidate?.Name || ""
                            ) === rawType ||
                            String(
                                candidate?.TypeName || ""
                            ) === rawType
                    );

                return typeDoc?.id
                    ? String(typeDoc.id)
                    : null;
            };

            navigation.forEach(
                (item: AnyDoc) => {
                    if (item?.IsGroup === true) {
                        return;
                    }

                    const hasTarget =
                        !!String(
                            item?.EntityId ||
                            item?.TargetType ||
                            item?.Type ||
                            ""
                        ).trim();

                    if (!hasTarget) {
                        return;
                    }

                    const id =
                        resolveTypeId(item);

                    if (id) {
                        represented.add(id);
                    }
                }
            );

            return represented;
        }

        function getDesignerAIAggregatedChildTypeIds(): Set<string> {
            const result =
                new Set<string>();
            const types =
                getAIApplicationTypeDocs();

            types.forEach(
                (owner: AnyDoc) => {
                    const members = [
                        ...(Array.isArray(owner?.Properties)
                            ? owner.Properties
                            : []),
                        ...(Array.isArray(owner?.Collections)
                            ? owner.Collections
                            : [])
                    ];

                    members.forEach(
                        (member: AnyDoc) => {
                            if (
                                String(
                                    member?.Aggregation || ""
                                ) !== "Aggregated"
                            ) {
                                return;
                            }

                            const raw =
                                member?.ItemEntity ??
                                member?.Type ??
                                null;

                            const typeDoc =
                                typeof raw === "string"
                                    ? types.find(
                                        (candidate: AnyDoc) =>
                                            String(
                                                candidate?.id || ""
                                            ) === raw ||
                                            String(
                                                candidate?.Name || ""
                                            ) === raw ||
                                            String(
                                                candidate?.TypeName || ""
                                            ) === raw
                                    )
                                    : null;

                            if (typeDoc?.id) {
                                result.add(
                                    String(typeDoc.id)
                                );
                            }
                        }
                    );
                }
            );

            return result;
        }

        function getDesignerAIMissingNavigationTypes(): AnyDoc[] {
            const represented =
                getDesignerAINavigationRepresentedTypeIds();
            const aggregatedChildren =
                getDesignerAIAggregatedChildTypeIds();

            return getAIApplicationTypeDocs()
                .filter(
                    (typeDoc: AnyDoc) =>
                        !!typeDoc?.id &&
                        !!typeDoc?.Name &&
                        typeDoc?.Browsable !== false &&
                        !represented.has(
                            String(typeDoc.id)
                        ) &&
                        !aggregatedChildren.has(
                            String(typeDoc.id)
                        )
                )
                .map(
                    (typeDoc: AnyDoc) => ({
                        id:
                            String(typeDoc.id),
                        Name:
                            String(
                                typeDoc.Name
                            ),
                        Caption:
                            typeDoc?.Caption ||
                            null,
                        CaptionPlural:
                            typeDoc?.CaptionPlural ||
                            null,
                        Description:
                            typeDoc?.Description ||
                            null,
                        BaseType:
                            typeDoc?.BaseType ||
                            null,
                        IsRoot:
                            typeDoc?.IsRoot === true
                    })
                );
        }

        function getDesignerAINavigationGroups(): AnyDoc[] {
            return getAIApplicationNavigationItems()
                .filter(
                    (item: AnyDoc) =>
                        item?.IsGroup === true &&
                        !!String(
                            item?.id || ""
                        ).trim()
                )
                .map(
                    (item: AnyDoc) => ({
                        id:
                            String(item.id),
                        Name:
                            item?.Name || null,
                        Caption:
                            item?.Caption || null,
                        Path:
                            item?.Path || null,
                        Depth:
                            item?.Depth ?? 0
                    })
                );
        }

        function buildDesignerAINavigationCompilerPrompt(
            userPrompt: string,
            retryReason?: string
        ): string {
            const missingTypes =
                getDesignerAIMissingNavigationTypes();
            const groups =
                getDesignerAINavigationGroups();

            return [
                "You are classifying missing CosmoApps navigation types into existing navigation groups.",
                "Do NOT generate CosmoApps operations. The Designer will generate them deterministically.",
                "Return JSON only.",
                "",
                "TASK:",
                "For every item in MISSING_TYPES choose exactly one semantically appropriate group from EXISTING_GROUPS.",
                "Use only ids supplied below. Do not invent ids.",
                "Do not omit a missing type.",
                "Do not create new groups unless there are no existing groups at all.",
                "",
                "OUTPUT SHAPE:",
                '{"Intent":"Modify","Message":"short factual result","Assignments":[{"EntityId":"<type-id>","ParentId":"<group-id>"}]}',
                "",
                retryReason
                    ? "PREVIOUS RESULT WAS INVALID: " + retryReason
                    : "",
                "",
                "USER REQUEST:",
                userPrompt,
                "",
                "MISSING_TYPES:",
                JSON.stringify(missingTypes),
                "",
                "EXISTING_GROUPS:",
                JSON.stringify(groups)
            ]
                .filter(
                    (line: string) =>
                        line !== ""
                )
                .join("\\n");
        }

        function compileDesignerAINavigationAssignments(
            rawPlan: AnyDoc
        ): AnyDoc {
            const missingTypes =
                getDesignerAIMissingNavigationTypes();
            const groups =
                getDesignerAINavigationGroups();

            if (missingTypes.length === 0) {
                const representedCount =
                    getDesignerAINavigationRepresentedTypeIds().size;
                const typeCount =
                    getAIApplicationTypeDocs()
                        .filter(
                            (typeDoc: AnyDoc) =>
                                typeDoc?.Browsable !== false
                        ).length;

                return {
                    Intent: "Modify",
                    Message:
                        `Все подходящие типы уже присутствуют в навигации (${representedCount} из ${typeCount}).`,
                    BusinessAnalysis: {},
                    Scenarios: [],
                    Capabilities: [],
                    Questions: [],
                    Recommendations: [],
                    Operations: [],
                    Warnings: [],
                    NeedsMoreContext: false,
                    ContextRequests: []
                };
            }

            if (groups.length === 0) {
                throw new Error(
                    "В навигации нет существующих разделов, в которые можно распределить недостающие типы."
                );
            }

            const assignments =
                Array.isArray(
                    rawPlan?.Assignments
                )
                    ? rawPlan.Assignments
                    : [];

            const groupIds =
                new Set<string>(
                    groups.map(
                        (group: AnyDoc) =>
                            String(group.id)
                    )
                );

            const missingById =
                new Map<string, AnyDoc>();

            missingTypes.forEach(
                (typeDoc: AnyDoc) =>
                    missingById.set(
                        String(typeDoc.id),
                        typeDoc
                    )
            );

            const assigned =
                new Map<string, string>();

            assignments.forEach(
                (assignment: AnyDoc) => {
                    const entityId =
                        String(
                            assignment?.EntityId ||
                            ""
                        ).trim();
                    const parentId =
                        String(
                            assignment?.ParentId ||
                            ""
                        ).trim();

                    if (
                        !missingById.has(entityId)
                    ) {
                        return;
                    }

                    if (
                        !groupIds.has(parentId)
                    ) {
                        return;
                    }

                    assigned.set(
                        entityId,
                        parentId
                    );
                }
            );

            const unassigned =
                missingTypes.filter(
                    (typeDoc: AnyDoc) =>
                        !assigned.has(
                            String(typeDoc.id)
                        )
                );

            if (unassigned.length > 0) {
                throw new Error(
                    "ИИ не распределил по разделам типы: " +
                    unassigned
                        .map(
                            (typeDoc: AnyDoc) =>
                                String(
                                    typeDoc?.CaptionPlural ||
                                    typeDoc?.Caption ||
                                    typeDoc?.Name ||
                                    typeDoc?.id
                                )
                        )
                        .join(", ")
                );
            }

            const operations =
                missingTypes.map(
                    (
                        typeDoc: AnyDoc,
                        index: number
                    ) => {
                        const technicalName =
                            String(
                                typeDoc.Name
                            );
                        const caption =
                            String(
                                typeDoc.CaptionPlural ||
                                typeDoc.Caption ||
                                technicalName
                            );

                        return {
                            Type:
                                "AddNavigationItem",
                            TemporaryId:
                                "nav-" +
                                technicalName
                                    .replace(
                                        /([a-z0-9])([A-Z])/g,
                                        "$1-$2"
                                    )
                                    .replace(
                                        /[^A-Za-z0-9]+/g,
                                        "-"
                                    )
                                    .replace(
                                        /^-+|-+$/g,
                                        ""
                                    )
                                    .toLowerCase() +
                                "-" +
                                String(
                                    index + 1
                                ),
                            ParentId:
                                assigned.get(
                                    String(typeDoc.id)
                                ),
                            EntityId:
                                String(typeDoc.id),
                            NavigationItem: {
                                Name:
                                    (
                                        typeDoc.CaptionPlural
                                            ? technicalName + "s"
                                            : technicalName + "s"
                                    ),
                                Caption:
                                    caption
                            }
                        };
                    }
                );

            return {
                Intent: "Modify",
                Message:
                    String(
                        rawPlan?.Message ||
                        "Добавлены недостающие элементы навигации в соответствующие разделы."
                    ),
                BusinessAnalysis:
                    rawPlan?.BusinessAnalysis ||
                    {},
                Scenarios:
                    Array.isArray(
                        rawPlan?.Scenarios
                    )
                        ? rawPlan.Scenarios
                        : [],
                Capabilities:
                    Array.isArray(
                        rawPlan?.Capabilities
                    )
                        ? rawPlan.Capabilities
                        : [],
                Questions: [],
                Recommendations: [],
                Operations:
                    operations,
                Warnings: [],
                NeedsMoreContext: false,
                ContextRequests: []
            };
        }

        function isDesignerAINavigationModificationRequest(
            prompt: string
        ): boolean {
            const value =
                String(prompt || "")
                    .trim()
                    .toLowerCase();

            if (!value) return false;

            return (
                /(навигац|меню|раздел)/i.test(value) ||
                /(navigation|menu|section)/i.test(value)
            );
        }


        let aiPromptEditorOpening = false;

        function openDesignerAIPromptEditor(): void {
            try {
                const activeElement = document.activeElement as HTMLElement;
                activeElement?.blur?.();
            } catch { /* ignore */ }

            if (
                aiPromptEditorOpening ||
                aiRequestInProgress ||
                !aiPromptBox
            ) {
                return;
            }

            aiPromptEditorOpening = true;

            const initialValue = String(
                aiPromptBox.option("value") || ""
            );
            const $popupHost = $("<div>").appendTo(document.body);
            let popup: any = null;
            let editor: any = null;

            const transferEditorValue = (): string => {
                const value = String(
                    editor?.option("value") || ""
                );
                aiPromptBox?.option("value", value);
                return value;
            };

            const closeWithoutSending = (): void => {
                transferEditorValue();
                popup?.hide();
            };

            const applyAndSend = (): void => {
                const value = transferEditorValue().trim();

                if (!value) {
                    DevExpress.ui.notify(
                        "Введите запрос для ИИ-ассистента",
                        "warning",
                        1800
                    );
                    return;
                }

                popup?.hide();

                window.setTimeout(() => {
                    sendDesignerAIRequest();
                }, 0);
            };

            ($popupHost as any).dxPopup({
                title: "Запрос к ИИ",
                width: () =>
                    Math.min(
                        Math.max(760, window.innerWidth - 180),
                        1280
                    ),
                height: () =>
                    Math.min(
                        Math.max(520, window.innerHeight - 160),
                        860
                    ),
                minWidth: 680,
                minHeight: 420,
                showCloseButton: false,
                dragEnabled: true,
                resizeEnabled: true,
                contentTemplate: (contentElement: any) => {
                    const $content = $(contentElement).css({
                        height: "100%",
                        minHeight: 0,
                        padding: "12px",
                        boxSizing: "border-box"
                    });

                    const $editorHost = $("<div>")
                        .css({
                            width: "100%",
                            height: "100%"
                        })
                        .appendTo($content);

                    ($editorHost as any).dxTextArea({
                        value: initialValue,
                        height: "100%",
                        width: "100%",
                        autoResizeEnabled: false,
                        valueChangeEvent: "input",
                        placeholder:
                            "Опишите модель, требования, бизнес-процесс или нужное изменение...",
                        onInitialized: (args: any) => {
                            editor = args.component;
                        },
                        onContentReady: (args: any) => {
                            window.setTimeout(
                                () => args.component.focus(),
                                0
                            );
                        },
                        onKeyDown: (args: any) => {
                            const event = args.event;

                            if (
                                event?.key === "Enter" &&
                                (event.ctrlKey || event.metaKey)
                            ) {
                                event.preventDefault?.();
                                applyAndSend();
                            }

                            if (event?.key === "Escape") {
                                event.preventDefault?.();
                                closeWithoutSending();
                            }
                        }
                    } as any);
                },
                toolbarItems: [
                    {
                        toolbar: "bottom",
                        location: "before",
                        widget: "dxButton",
                        options: {
                            text: "Закрыть",
                            icon: "close",
                            stylingMode: "outlined",
                            hint:
                                "Сохранить отредактированный текст в поле запроса, не отправляя его",
                            onClick: closeWithoutSending
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Применить",
                            icon: "runner",
                            type: "default",
                            stylingMode: "contained",
                            hint:
                                "Перенести отредактированный текст в поле запроса и отправить ИИ-ассистенту",
                            onClick: applyAndSend
                        }
                    }
                ],
                onShown: () => {
                    aiPromptEditorOpening = false;
                },
                onHidden: () => {
                    aiPromptEditorOpening = false;
                    try { editor?.dispose?.(); } catch { /* ignore */ }
                    try { popup?.dispose?.(); } catch { /* ignore */ }
                    $popupHost.remove();
                }
            } as any);

            popup = ($popupHost as any).dxPopup("instance");
            popup.show();
        }

        async function sendDesignerAIRequest(): Promise<void> {
            if (aiRequestInProgress) return;

            const prompt = String(aiPromptBox?.option("value") || "").trim();
            if (!prompt) {
                DevExpress.ui.notify("Введите запрос для ИИ-ассистента", "warning", 1800);
                return;
            }

            const designerAIUserEmail =
                String((window as any).cosmoDesignerUserEmail || "").trim();

            // Keep the short-message anti-spam limit for anonymous sessions,
            // but do not block authenticated users from sending a complete
            // specification or other long-form requirement text.
            if (!designerAIUserEmail && prompt.length > 8000) {
                DevExpress.ui.notify(
                    "The request is too long for an anonymous session. Sign in to send longer requirements.",
                    "warning",
                    3200
                );
                return;
            }

            const requestThinkingMode =
                aiThinkingMode;

            designerAIPipelineRequestSequence++;
            designerAIPipelineServiceSequence = 0;
            designerAIPipelineTrace = [];
            (window as any).cosmoDesignerAITrace = [];
            traceDesignerAIPipeline("Request.Start", {
                Prompt: prompt.length > 500 ? prompt.substring(0,500) + "…" : prompt,
                ThinkingMode: requestThinkingMode
            });

            aiMessages.push({
                Role: "user",
                Content: prompt
            });

            aiPromptBox?.option("value", "");
            aiRequestInProgress = true;
            aiPromptBox?.option("disabled", true);
            aiSendButton?.option("disabled", true);
            renderAssistant();

            // Rebuilding the AI panel can initialize the Mode editor again.
            // Keep the mode that belonged to this request stable for the
            // complete analysis/generation/rendering pipeline.
            aiThinkingMode =
                requestThinkingMode;

            try {
                const conversation = getAssistantConversation().slice(0, -1);

                if (
                    isDesignerAICasualOrMetaRequest(
                        prompt
                    )
                ) {
                    const casualAnswered =
                        await answerDesignerAICasualOrMetaRequest(
                            prompt,
                            conversation
                        );

                    if (casualAnswered) {
                        return;
                    }
                }

                let effectiveBusinessRequest = prompt;
                const applyPreviousRecommendation =
                    isDesignerAIApplyPreviousRecommendation(prompt);

                if (applyPreviousRecommendation) {
                    const previousRecommendation =
                        getPreviousAssistantRecommendation();

                    if (previousRecommendation) {
                        effectiveBusinessRequest = [
                            "Apply the following previously proposed model changes now.",
                            "Generate a Modify plan with concrete Operations.",
                            "Do not merely repeat or acknowledge the recommendation.",
                            "",
                            "Previously proposed changes:",
                            previousRecommendation,
                            "",
                            "User confirmation:",
                            prompt
                        ].join("\n");
                    }
                }

                let previousClarificationIndex = -1;
                let clarificationOriginalRequest = "";

                for (
                    let index = aiMessages.length - 2;
                    index >= 0;
                    index--
                ) {
                    const message = aiMessages[index];

                    if (
                        message?.Role === "assistant" &&
                        message?.Plan?.Intent === "Clarify"
                    ) {
                        previousClarificationIndex = index;
                        break;
                    }

                    if (message?.Role === "assistant") {
                        break;
                    }
                }

                if (previousClarificationIndex >= 0) {
                    let originalRequest = "";

                    for (
                        let index = previousClarificationIndex - 1;
                        index >= 0;
                        index--
                    ) {
                        const message = aiMessages[index];

                        if (message?.Role === "user") {
                            originalRequest =
                                String(message.Content || "").trim();
                            break;
                        }
                    }

                    if (originalRequest) {
                        clarificationOriginalRequest = originalRequest;
                        effectiveBusinessRequest = [
                            "Original request:",
                            originalRequest,
                            "",
                            "User clarification answers:",
                            prompt,
                            "",
                            "Treat the clarification answers as authoritative.",
                            "Do not ask again about choices explicitly answered above."
                        ].join("\\n");
                    }
                }

                const simpleStructuralEdit =
                    isSimpleDesignerAIStructuralEdit(
                        applyPreviousRecommendation
                            ? effectiveBusinessRequest
                            : prompt
                    );
                traceDesignerAIPipeline("Route.Initial", {
                    SimpleStructuralEdit: simpleStructuralEdit,
                    ApplyPreviousRecommendation: applyPreviousRecommendation,
                    EffectiveRequestChars: effectiveBusinessRequest.length
                });

                const explanationRequest =
                    !applyPreviousRecommendation &&
                    (
                        isDesignerAIExplanationRequest(prompt) ||
                        isDesignerAIExplanationFollowUp(prompt) ||
                        (
                            !!clarificationOriginalRequest &&
                            isDesignerAIExplanationRequest(
                                clarificationOriginalRequest
                            )
                        )
                    );

                if (
                    explanationRequest &&
                    !simpleStructuralEdit
                ) {
                    const explanationAnswered =
                        await answerDesignerAIExplanation(
                            effectiveBusinessRequest,
                            conversation
                        );

                    if (explanationAnswered) {
                        return;
                    }
                }

                let blueprint: DesignerAIBusinessBlueprint;

                if (simpleStructuralEdit) {
                    blueprint = buildSimpleDesignerAIBlueprint(prompt);
                } else {
                    let analysisResponse = await callDesignerAIService(
                        [
                            "Analyze this application request as a business-system consultant.",
                            "Use Context.PlatformCapabilities as the authoritative capability contract for the current CosmoApps platform and AI editor.",
                            "Distinguish native editable structure, platform-supported mechanisms that require manual designer work, model-composable behavior that the current AI editor only partially supports, and behavior that requires custom code or an external service.",
                            "Do not describe the platform itself as incapable when the metamodel contains the required Rule, Action, Event, View, Code or Script mechanism.",
                            "Identify the complete minimum set of end-to-end scenarios and capabilities.",
                            "Minimum means literal scope: include only what the user explicitly requested plus structural elements strictly required to represent it.",
                            "Do not add prices, totals, default values, statuses, lifecycle restrictions, reverse navigation, reports, validations or automatic behavior unless the user explicitly requested them.",
                            "Do not turn a plausible convenience into a requirement. In particular, a product reference does not imply copying Product.Price, and an order does not imply statuses or totals.",
                            "Do not generate model operations.",
                            "When you create an AddNavigationGroup, every AddNavigationItem intended to appear inside that group MUST set ParentRef: { TemporaryId: <the group's TemporaryId> }. Creating a group and separate root items is not grouped navigation.",
                            "Do not repeat a clarification question already answered in the conversation.",
                            "Return compact JSON. Keep descriptions to one short sentence. Avoid repeating the same fact in BusinessAnalysis, Scenarios and Capabilities.",
                            "HARD SIZE LIMIT: keep the entire JSON under about 2600 output tokens.",
                            "Use at most 8 Scenarios and 12 Capabilities. Group closely related functions when useful, but never omit an explicit requested process merely because the current OperationContract cannot implement it.",
                            "Explicit analytics/reporting, automation, reminders, email/website integrations, permissions and other unsupported/manual behaviors must remain visible as Capabilities so coverage can mark them Partial or NotImplemented.",
                            "For every explicit analytics/reporting, automation, reminder/scheduling, security/permission or integration capability, include the matching typed behavior Requirement (ViewBehavior, ExecutableBehavior, ScheduledBehavior, SecurityBehavior or IntegrationBehavior). Do not represent these behaviors only with TypeExists/PropertyExists/ListViewExists.",
                            "Capabilities describe behavior/data/features of the resulting application only. Project delivery work such as process discovery, choosing a platform, implementation itself, implementation testing, documentation, training or preparing team instructions is NOT an application Capability.",
                            "Put delivery/engagement work into BusinessAnalysis.DeliveryActivities and exclude it from application capability coverage and model validation.",
                            "Use at most 5 typed Requirements per Scenario or Capability.",
                            "BusinessAnalysis arrays must contain short phrases only, never paragraphs.",
                            "Return ConceptualTypes as a compact hint list of the main entity/document/reference-data concepts you expect the model to need. It is not an exhaustive schema contract. Never include enums, statuses, scalar value lists, reports or UI concepts.",
                            "Actors and user roles are NOT ConceptualTypes by default. Create an actor as a business type only when business records must persistently reference that person/party as data. A permission role such as SalesHead, Manager or Administrator must not become a standalone entity merely because it appears in access rules.",
                            "ExistingModelReuseAnalysis is sparse: omit CreateNew decisions. Missing entry means CreateNew. If the current project has no types, return ExistingModelReuseAnalysis: [].",
                            "ExistingModelReuseAnalysis Reason must be one short sentence.",
                            "Also return SemanticRelations as a compact hint graph between the main ConceptualTypes with From, Relation, To, Required, Direct, Reason, ScenarioIds and CapabilityIds.",
                            "SemanticRelations records business meaning, not database convention. From and To must exactly match ConceptualTypes. Never use enums/statuses such as DealStage as relation endpoints.",
                            "For every Core scenario that involves two or more ConceptualTypes, the scenario's participating business types should form a connected typed graph unless the scenario explicitly describes an independent cross-record report. Add the necessary SemanticRelations; do not leave a derived/calculated document isolated from the source records it depends on.",
                            "If the same human/actor is persistently referenced by multiple business records or is the grouping key for a cross-record calculation, represent that actor as a ConceptualType and typed reference rather than repeating a free-text name.",
                            "Set Direct=true only when the source record itself must store/select the target. Use Direct=false when the relationship may be represented by a short coherent typed path.",
                            "Do not hard-code domains or aliases. Infer the graph from this request. Use at most 16 SemanticRelations.",
                            "Strict mode includes only explicit or structurally necessary relations. Creative mode may infer a small conventional supporting graph, but every inferred relation must have a business Reason.",
                            "Questions should normally be empty. In Strict mode, do not ask for status values, enum choices, ordinary fields, line-item details, reminder wording or other reversible details; make the smallest reasonable assumption and continue.",
                            "Context.ModelSummary.ApplicationModel is the complete authoritative current project model. Never reuse a type that is absent from it.",
                            "If ApplicationModel.IsStructurallyEmpty is true, every requested business type must be CreateNew.",
                            "",
                            effectiveBusinessRequest
                        ].join("\n"),
                        buildDesignerAIAnalysisContext(),
                        [],
                        "BusinessAnalysis"
                    );

                    let parsedAnalysisResponse = tryParseDesignerAIContent(
                        analysisResponse.Content,
                        analysisResponse.FinishReason,
                        "BusinessAnalysis"
                    );

                    let parsedBlueprint: DesignerAIBusinessBlueprint | null =
                        parsedAnalysisResponse.Success
                            ? parseDesignerAIBusinessBlueprint(
                                parsedAnalysisResponse.Value
                            )
                            : null;

                    if (
                        !parsedAnalysisResponse.Success ||
                        !parsedBlueprint ||
                        !isUsableBusinessBlueprint(parsedBlueprint)
                    ) {
                        analysisResponse = await callDesignerAIService(
                            buildCompactBusinessAnalysisRetryPrompt(
                                effectiveBusinessRequest
                            ),
                            buildDesignerAIAnalysisContext(),
                            [],
                            "BusinessAnalysis"
                        );

                        parsedAnalysisResponse = tryParseDesignerAIContent(
                            analysisResponse.Content,
                            analysisResponse.FinishReason,
                            "BusinessAnalysis"
                        );

                        parsedBlueprint = parsedAnalysisResponse.Success
                            ? parseDesignerAIBusinessBlueprint(
                                parsedAnalysisResponse.Value
                            )
                            : null;
                    }

                    if (!parsedAnalysisResponse.Success) {
                        throw new Error(
                            "Business analysis returned invalid JSON, including the compact retry: " +
                            String(parsedAnalysisResponse.Error || "Unknown JSON error")
                        );
                    }

                    if (
                        !parsedBlueprint ||
                        !isUsableBusinessBlueprint(parsedBlueprint)
                    ) {
                        throw new Error(
                            "Business analysis did not return Scenarios and Capabilities, including the compact retry. Model generation was not started."
                        );
                    }

                    blueprint = parsedBlueprint;

                    // Deliberately no separate AI audit pass here.
                    // BusinessAnalysis + ModelGeneration are sufficient; deterministic
                    // validators audit the generated plan. This removes one long,
                    // expensive model call from every non-trivial request.

                    blueprint =
                        ensureCreativeBusinessFraming(
                            blueprint,
                            effectiveBusinessRequest
                        );

                    traceDesignerAIPipeline("BusinessAnalysis.Blueprint", {
                        Scenarios: blueprint.Scenarios.length,
                        Capabilities: blueprint.Capabilities.length,
                        Questions: blueprint.Questions.length,
                        ConceptualTypes: Array.isArray((blueprint as AnyDoc).ConceptualTypes)
                            ? (blueprint as AnyDoc).ConceptualTypes : []
                    });

                    const strictQuestionIsArchitectural =
                        blueprint.Questions.some(
                            (question: string) =>
                                /different\s+(?:top-level\s+)?types?|different\s+entities|different\s+relationships?|architecture|отдельн(?:ая|ый|ое)\s+(?:сущност|тип|документ)|разн(?:ые|ая)\s+схем/i
                                    .test(
                                        String(
                                            question || ""
                                        )
                                    )
                        );

                    if (
                        false &&
                        requestThinkingMode !== "creative" &&
                        blueprint.NeedsClarification &&
                        blueprint.Questions.length &&
                        strictQuestionIsArchitectural
                    ) {
                        const businessAnalysis =
                            blueprint.BusinessAnalysis || {};

                        const section = (
                            title: string,
                            items: any
                        ): string[] => {
                            const values =
                                Array.isArray(items)
                                    ? items
                                        .map((item: any) =>
                                            String(item || "").trim()
                                        )
                                        .filter(Boolean)
                                    : [];

                            return values.length
                                ? [
                                    "",
                                    title,
                                    ...values.map(
                                        (item: string) =>
                                            `• ${item}`
                                    )
                                ]
                                : [];
                        };

                        // This block is reached only in Strict mode:
                        // Creative mode no longer blocks generation for
                        // ordinary clarification questions.
                        const questions =
                            blueprint.Questions;

                        const analysisSummary = [
                            String(
                                blueprint.Summary ||
                                "The business requirements need clarification."
                            ),
                            ...section(
                                "Proposed standard core:",
                                businessAnalysis.StandardCore
                            ),
                            ...section(
                                "Intentionally kept simple:",
                                businessAnalysis
                                    .IntentionalSimplifications
                            ),
                            ...section(
                                "Where I heard your pain:",
                                businessAnalysis.UserPain
                            ),
                            ...section(
                                "What may be unique in your process:",
                                businessAnalysis
                                    .DistinctiveRequirements
                            ),
                            ...section(
                                "Project delivery activities:",
                                businessAnalysis
                                    .DeliveryActivities
                            ),
                            "",
                            ...questions.map(
                                (question: string) =>
                                    `• ${question}`
                            )
                        ].join("\n");

                        const clarificationPlan = {
                            Intent: "Clarify",
                            Message: analysisSummary,
                            BusinessAnalysis:
                                blueprint.BusinessAnalysis,
                            Scenarios: blueprint.Scenarios,
                            Capabilities: blueprint.Capabilities,
                            Questions: blueprint.Questions,
                            Recommendations: [],
                            Operations: [],
                            Warnings: [],
                            NeedsMoreContext: true,
                            ContextRequests:
                                blueprint.Questions
                        };

                        aiMessages.push({
                            Role: "assistant",
                            Content: analysisSummary,
                            Plan: clarificationPlan,
                            InternalPlan: cloneData(
                                clarificationPlan
                            )
                        });

                        return;
                    }
                }

                const navigationRequestText =
                    applyPreviousRecommendation
                        ? effectiveBusinessRequest
                        : prompt;

                const explicitNavigationGroupPlan =
                    simpleStructuralEdit
                        ? buildDesignerAIExplicitNavigationGroupPlan(
                            navigationRequestText
                        )
                        : null;

                const navigationReorganization =
                    simpleStructuralEdit &&
                    !explicitNavigationGroupPlan &&
                    isDesignerAINavigationReorganizationRequest(
                        navigationRequestText
                    );

                const navigationStructuralEdit =
                    simpleStructuralEdit &&
                    !explicitNavigationGroupPlan &&
                    !navigationReorganization &&
                    isDesignerAIFillMissingNavigationRequest(
                        navigationRequestText
                    );

                traceDesignerAIPipeline("Route.ModelGeneration", {
                    ExplicitNavigationGroupPlan: !!explicitNavigationGroupPlan,
                    NavigationReorganization: navigationReorganization,
                    NavigationStructuralEdit: navigationStructuralEdit,
                    SimpleStructuralEdit: simpleStructuralEdit,
                    Route: explicitNavigationGroupPlan ? "DeterministicNavigationGroup"
                        : (navigationReorganization ? "NavigationReorganization"
                        : (navigationStructuralEdit ? "NavigationCompiler"
                        : (simpleStructuralEdit ? "SimpleStructuralEdit" : "FullModelGeneration")))
                });

                let modelingResponse: any = null;

                if (!explicitNavigationGroupPlan) {
                    modelingResponse = await callDesignerAIService(
                        navigationReorganization
                            ? buildDesignerAINavigationReorganizationPrompt(
                                effectiveBusinessRequest
                            )
                            : (
                                navigationStructuralEdit
                                    ? buildDesignerAINavigationCompilerPrompt(
                                        effectiveBusinessRequest
                                    )
                                    : (
                                        simpleStructuralEdit
                                            ? buildSimpleDesignerAIModificationPrompt(
                                                effectiveBusinessRequest,
                                                blueprint
                                            )
                                            : buildModelGenerationPrompt(
                                                effectiveBusinessRequest,
                                                blueprint
                                            )
                                    )
                            ),
                        buildDesignerAIModelingContext(blueprint),
                        conversation,
                        "ModelGeneration"
                    );
                }

                let parsedModelingResponse =
                    explicitNavigationGroupPlan
                        ? {
                            Success: true,
                            Value:
                                explicitNavigationGroupPlan
                        }
                        : tryParseDesignerAIModelContent(
                    modelingResponse.Content,
                    modelingResponse.FinishReason
                );

                // Large plans use an explicit chunk protocol. A valid response may
                // intentionally return Complete:false before reaching the provider cap;
                // a legacy/truncated response is recovered from its complete Operations prefix.
                let chunkedGenerationStarted = false;
                if (
                    !explicitNavigationGroupPlan &&
                    !navigationReorganization &&
                    !navigationStructuralEdit &&
                    !simpleStructuralEdit
                ) {
                    let accumulatedOperations: AnyDoc[] = [];
                    let needsContinuation = false;

                    if (parsedModelingResponse.Success) {
                        const initialValue = parsedModelingResponse.Value || {};
                        if (Array.isArray(initialValue.Operations)) {
                            accumulatedOperations = initialValue.Operations.map((item: AnyDoc) => cloneData(item));
                        }
                        needsContinuation = initialValue.Complete === false;
                    } else if (wasDesignerAIResponseCutOff(modelingResponse)) {
                        accumulatedOperations =
                            extractDesignerAICompleteOperationsPrefix(modelingResponse.Content);
                        needsContinuation = accumulatedOperations.length > 0;
                    }

                    if (needsContinuation) {
                        chunkedGenerationStarted = true;
                        traceDesignerAIPipeline("ModelGeneration.Chunking", { InitialOperations: accumulatedOperations.length });
                        let continuationComplete = false;

                        for (let continuationAttempt = 0; continuationAttempt < 12 && !continuationComplete; continuationAttempt++) {
                            modelingResponse = await callDesignerAIService(
                                buildDesignerAIModelContinuationPrompt(accumulatedOperations),
                                buildDesignerAIModelingContext(blueprint),
                                [],
                                "ModelGeneration"
                            );

                            if (wasDesignerAIResponseCutOff(modelingResponse)) {
                                const continuedPrefix =
                                    extractDesignerAICompleteOperationsPrefix(modelingResponse.Content);
                                if (!continuedPrefix.length) {
                                    throw new Error(
                                        "ModelGeneration continuation reached the token limit before completing even one Operation. " +
                                        "The continuation chunk must be smaller."
                                    );
                                }
                                accumulatedOperations = accumulatedOperations.concat(
                                    continuedPrefix.map((item: AnyDoc) => cloneData(item))
                                );
                                continue;
                            }

                            const continuationParsed =
                                tryParseDesignerAIContent(
                                    modelingResponse.Content,
                                    modelingResponse.FinishReason,
                                    "ModelGeneration"
                                );

                            if (!continuationParsed.Success) {
                                // A continuation can occasionally contain many valid operations
                                // followed by one malformed operation. Preserve the valid prefix
                                // and ask for the remainder instead of discarding the whole chunk.
                                const recoveredPrefix =
                                    extractDesignerAICompleteOperationsPrefix(modelingResponse.Content);
                                if (recoveredPrefix.length) {
                                    accumulatedOperations = accumulatedOperations.concat(
                                        recoveredPrefix.map((item: AnyDoc) => cloneData(item))
                                    );
                                    continue;
                                }

                                throw new Error(
                                    "ModelGeneration continuation returned invalid JSON and no complete Operation could be recovered: " +
                                    String(continuationParsed.Error || "Unknown JSON error")
                                );
                            }

                            const continuationValue = continuationParsed.Value || {};
                            const continuationOperations =
                                Array.isArray(continuationValue.Operations)
                                    ? continuationValue.Operations
                                    : [];
                            traceDesignerAIPipeline("ModelGeneration.Continuation", {
                                Attempt: continuationAttempt + 1,
                                Added: summarizeDesignerAIOperations(continuationOperations),
                                Complete: continuationValue.Complete !== false
                            });
                            accumulatedOperations = accumulatedOperations.concat(
                                continuationOperations.map((item: AnyDoc) => cloneData(item))
                            );
                            continuationComplete = continuationValue.Complete !== false;
                        }

                        if (!continuationComplete) {
                            throw new Error(
                                "ModelGeneration remained incomplete after 12 continuation chunks. " +
                                "The plan was preserved but not applied."
                            );
                        }

                        parsedModelingResponse = {
                            Success: true,
                            Value: buildDesignerAIContinuationPlan(
                                blueprint,
                                accumulatedOperations,
                                "Large model plan generated in multiple AI response chunks."
                            )
                        };
                    }
                }

                // For ordinary malformed JSON, or if continuation recovery could not make
                // progress, retain the existing one-shot compact retry behavior.
                if (
                    !explicitNavigationGroupPlan &&
                    !parsedModelingResponse.Success &&
                    !chunkedGenerationStarted &&
                    !wasDesignerAIResponseCutOff(modelingResponse)
                ) {
                    modelingResponse = await callDesignerAIService(
                        navigationReorganization
                            ? buildDesignerAINavigationReorganizationPrompt(
                                effectiveBusinessRequest,
                                "The previous response was malformed or truncated. Return complete Groups and Assignments for every CURRENT_ITEMS item."
                            )
                            : (
                                navigationStructuralEdit
                                    ? buildDesignerAINavigationCompilerPrompt(
                                        effectiveBusinessRequest,
                                        "The previous response was malformed or truncated. Return a complete JSON object with Assignments for every MISSING_TYPES item."
                                    )
                                    : (
                                        simpleStructuralEdit
                                            ? buildSimpleDesignerAIModificationPrompt(
                                                effectiveBusinessRequest,
                                                blueprint
                                            )
                                            : buildCompactRetryPrompt(
                                                effectiveBusinessRequest,
                                                blueprint
                                            )
                                    )
                            ),
                        buildDesignerAIModelingContext(blueprint),
                        [],
                        "ModelGeneration"
                    );

                    parsedModelingResponse = tryParseDesignerAIModelContent(
                        modelingResponse.Content,
                        modelingResponse.FinishReason
                    );
                }

                if (!parsedModelingResponse.Success) {
                    if (wasDesignerAIResponseCutOff(modelingResponse)) {
                        throw new Error(
                            "ModelGeneration was truncated before a recoverable Operations chunk could be completed. " +
                            "The designer did not restart generation from scratch."
                        );
                    }
                    throw new Error(
                        "The model returned invalid JSON, including the compact retry: " +
                        String(parsedModelingResponse.Error || "Unknown JSON error")
                    );
                }

                let rawModelingPlan =
                    parsedModelingResponse.Value;

                if (
                    navigationReorganization
                ) {
                    try {
                        rawModelingPlan =
                            compileDesignerAINavigationReorganization(
                                rawModelingPlan
                            );
                    } catch (
                        navigationReorganizationError: any
                    ) {
                        const reorganizationRetry =
                            await callDesignerAIService(
                                buildDesignerAINavigationReorganizationPrompt(
                                    effectiveBusinessRequest,
                                    navigationReorganizationError?.message ||
                                    "The previous navigation assignment was incomplete."
                                ),
                                buildDesignerAIModelingContext(
                                    blueprint
                                ),
                                [],
                                "ModelGeneration"
                            );

                        const parsedReorganizationRetry =
                            tryParseDesignerAIContent(
                                reorganizationRetry.Content,
                                reorganizationRetry.FinishReason,
                                "ModelGeneration"
                            );

                        if (!parsedReorganizationRetry.Success) {
                            throw navigationReorganizationError;
                        }

                        rawModelingPlan =
                            compileDesignerAINavigationReorganization(
                                parsedReorganizationRetry.Value
                            );
                    }
                }

                if (
                    navigationStructuralEdit
                ) {
                    try {
                        rawModelingPlan =
                            compileDesignerAINavigationAssignments(
                                rawModelingPlan
                            );
                    } catch (
                        navigationCompileError: any
                    ) {
                        const assignmentRetry =
                            await callDesignerAIService(
                                buildDesignerAINavigationCompilerPrompt(
                                    effectiveBusinessRequest,
                                    navigationCompileError?.message ||
                                    "The previous assignment result was incomplete."
                                ),
                                buildDesignerAIModelingContext(
                                    blueprint
                                ),
                                [],
                                "ModelGeneration"
                            );

                        const parsedAssignmentRetry =
                            tryParseDesignerAIContent(
                                assignmentRetry.Content,
                                assignmentRetry.FinishReason,
                                "ModelGeneration"
                            );

                        if (
                            !parsedAssignmentRetry.Success
                        ) {
                            throw navigationCompileError;
                        }

                        rawModelingPlan =
                            compileDesignerAINavigationAssignments(
                                parsedAssignmentRetry.Value
                            );
                    }
                }

                let plan =
                    normalizeDesignerAIPlan(
                        rawModelingPlan
                    );

                traceDesignerAIPipeline("Plan.Generated", summarizeDesignerAIOperations(plan));

                if (
                    simpleStructuralEdit &&
                    !navigationStructuralEdit &&
                    !navigationReorganization &&
                    !explicitNavigationGroupPlan &&
                    String(plan?.Intent || "") === "Modify" &&
                    (
                        !Array.isArray(plan?.Operations) ||
                        plan.Operations.length === 0
                    )
                ) {
                    throw new Error(
                        "ИИ сообщил о структурном изменении, но не вернул ни одной операции. Изменения не применялись."
                    );
                }

                applyDesignerAIReuseAnalysisToPlan(
                    plan,
                    blueprint
                );

                (plan as AnyDoc).ConceptualTypes =
                    cloneData(
                        (blueprint as AnyDoc).ConceptualTypes || []
                    );
                (plan as AnyDoc).SemanticRelations =
                    cloneData(
                        (blueprint as AnyDoc).SemanticRelations || []
                    );

                normalizeAIConceptualGraphAgainstPlan(plan);

                if (!simpleStructuralEdit) {
                    // AI-first semantic review: deterministic coverage is advisory.
                    // Give the model one chance to improve the plan using the full
                    // business + runtime context, but do not force it to implement
                    // a diagnostic literally when the intent is already covered by
                    // another coherent design. Objective code errors remain strict.
                    const semanticCoverageDiagnostics =
                        getAIMissingEditableRequirements(
                            blueprint,
                            plan
                        );
                    const codeValidationErrors =
                        getAIBehaviorCodeValidationErrors(plan);

                    traceDesignerAIPipeline("SemanticReview.Check", {
                        MissingRequirements: semanticCoverageDiagnostics.map((item: AnyDoc) => ({
                            OwnerKind: item?.OwnerKind || null,
                            Kind: item?.Requirement?.Kind || null,
                            Target: item?.Requirement?.Target || item?.Missing || null
                        })),
                        CodeValidationErrors: codeValidationErrors
                    });

                    if (
                        semanticCoverageDiagnostics.length > 0 ||
                        codeValidationErrors.length > 0
                    ) {
                        const operationsBeforeReview = summarizeDesignerAIOperations(plan);
                        const reviewResponse =
                            await callDesignerAIService(
                                buildDesignerAIPlanRepairPrompt(
                                    effectiveBusinessRequest,
                                    plan,
                                    semanticCoverageDiagnostics,
                                    codeValidationErrors
                                ),
                                buildDesignerAIModelingContext(
                                    blueprint,
                                    plan
                                ),
                                [],
                                "ModelGeneration"
                            );

                        const parsedReview =
                            tryParseDesignerAIRepairContent(
                                reviewResponse.Content,
                                reviewResponse.FinishReason
                            );

                        if (parsedReview.Success) {
                            traceDesignerAIPipeline("SemanticReview.Response", {
                                ReviewOperations: summarizeDesignerAIOperations(parsedReview.Value?.Operations || []),
                                Before: operationsBeforeReview
                            });
                            plan = normalizeDesignerAIPlan(
                                mergeAIRepairOperations(
                                    plan,
                                    parsedReview.Value
                                )
                            );
                            applyDesignerAIReuseAnalysisToPlan(
                                plan,
                                blueprint
                            );
                            (plan as AnyDoc).ConceptualTypes =
                                cloneData(
                                    (blueprint as AnyDoc).ConceptualTypes || []
                                );
                            (plan as AnyDoc).SemanticRelations =
                                cloneData(
                                    (blueprint as AnyDoc).SemanticRelations || []
                                );
                            normalizeAIConceptualGraphAgainstPlan(plan);
                            traceDesignerAIPipeline("SemanticReview.Merged", summarizeDesignerAIOperations(plan));
                        }
                    }
                }

                let prunedPlaceholderBehaviors: string[] = [];
                if (!simpleStructuralEdit) {
                    prunedPlaceholderBehaviors =
                        pruneAIGeneratedPlaceholderBehaviors(plan);
                }

                // Do not auto-rewrite business architecture from heuristics.
                // Invalid enum shapes and missing formula dependencies remain validation findings.
                // Deferred dependencies remain warnings because runtime Expand/Include may make them valid.
                // Semantic relation directness remains the model's architectural decision.

                // The first pass is authoritative for business meaning.
                // The second pass may only add implementation coverage.
                plan.BusinessAnalysis = cloneData(blueprint.BusinessAnalysis);

                if (!blueprint.Scenarios.length || !blueprint.Capabilities.length) {
                    throw new Error(
                        "Business blueprint is incomplete. Model generation result was discarded."
                    );
                }

                const structuralEvidence =
                    buildAIPlanStructuralEvidence(plan);

                plan.Scenarios = mergeBlueprintScenarios(
                    blueprint.Scenarios,
                    Array.isArray(plan.Scenarios) ? plan.Scenarios : [],
                    structuralEvidence,
                    plan
                );
                plan.Capabilities = mergeBlueprintCapabilities(
                    blueprint.Capabilities,
                    Array.isArray(plan.Capabilities) ? plan.Capabilities : [],
                    structuralEvidence,
                    plan
                );

                // SemanticRelations are advisory guidance and diagnostics only.
                // They do not deterministically downgrade scenario/capability coverage.
                const operationEvidence =
                    buildAIPlanStructuralEvidence({
                        Operations: plan.Operations
                    });
                const scenarioRequired = new Set<string>();

                plan.Scenarios.forEach((scenario: AnyDoc) => {
                    (Array.isArray(scenario?.RequiredModelElements)
                        ? scenario.RequiredModelElements
                        : []
                    ).forEach((item: any) => {
                        scenarioRequired.add(
                            normalizeAIRequiredModelElement(item)
                        );
                    });
                });

                const currentUserRequest = [
                    prompt,
                    effectiveBusinessRequest,
                    loadAIProjectBrief()
                ]
                    .filter(Boolean)
                    .join("\n")
                    .toLowerCase();
                const warehouseExplicitlyRequested =
                    /склад|остатк[аи]?\s+на\s+склад|inventory|warehouse|stock\s+quantity/
                        .test(currentUserRequest);

                if (!warehouseExplicitlyRequested) {
                    const containsWarehouseScope = (
                        value: AnyDoc
                    ): boolean => {
                        const serialized = JSON.stringify(
                            value || {}
                        ).toLowerCase();

                        return (
                            serialized.indexOf("stockquantity") >= 0 ||
                            serialized.indexOf("onhand") >= 0 ||
                            serialized.indexOf("warehouse") >= 0 ||
                            serialized.indexOf("inventory") >= 0 ||
                            serialized.indexOf("остаток на складе") >= 0 ||
                            serialized.indexOf("количество на складе") >= 0 ||
                            serialized.indexOf("товар со склада") >= 0 ||
                            serialized.indexOf("доступное количество на складе") >= 0
                        );
                    };

                    plan.Scenarios = plan.Scenarios.filter(
                        (scenario: AnyDoc) =>
                            !containsWarehouseScope(scenario)
                    );

                    plan.Capabilities = plan.Capabilities.filter(
                        (capability: AnyDoc) =>
                            !containsWarehouseScope(capability)
                    );

                    // Do not remove executable operations merely because their code
                    // references existing warehouse/inventory types. A targeted action such
                    // as "show customers this product was shipped to" legitimately needs
                    // WarehouseDocument/StockDocument even when the user did not literally
                    // say "warehouse" in the request.
                    //
                    // This heuristic is allowed to remove only clearly hallucinated scalar
                    // stock fields that the AI tried to add to the model implicitly.
                    plan.Operations = plan.Operations.filter(
                        (operation: AnyDoc) => {
                            if (operation?.Type !== "AddProperty") {
                                return true;
                            }

                            const propertyName = String(
                                operation?.Property?.Name || ""
                            ).toLowerCase();

                            return (
                                propertyName !== "stockquantity" &&
                                propertyName !== "onhand"
                            );
                        }
                    );

                    if (typeof plan.Message === "string") {
                        plan.Message = plan.Message
                            .replace(
                                /\s*Товар \(Product\)[^.;]*(?:OnHand|StockQuantity)[^.;]*[.;]?/gi,
                                ""
                            )
                            .replace(
                                /\s*Добавлены[^.]*\bнавигац(?:ия|ионные элементы)\b[^.]*\.?/gi,
                                ""
                            )
                            .replace(/\s{2,}/g, " ")
                            .trim();
                    }

                    if (plan.BusinessAnalysis) {
                        const removeWarehouseItems = (items: any[]) =>
                            (Array.isArray(items) ? items : []).filter(
                                (item: any) =>
                                    !/склад|stockquantity|warehouse/i.test(
                                        String(item || "")
                                    )
                            );

                        plan.BusinessAnalysis.QuantitiesAndBalances =
                            removeWarehouseItems(
                                plan.BusinessAnalysis
                                    .QuantitiesAndBalances
                            );
                        plan.BusinessAnalysis.Assumptions =
                            removeWarehouseItems(
                                plan.BusinessAnalysis.Assumptions
                            );
                    }
                }

                plan.Capabilities = plan.Capabilities.filter(
                    (capability: AnyDoc) => {
                        const required = Array.isArray(
                            capability?.RequiredModelElements
                        )
                            ? capability.RequiredModelElements.map(
                                normalizeAIRequiredModelElement
                            )
                            : [];

                        if (!required.length) return true;

                        const usedByScenario = required.some(
                            (item: string) => scenarioRequired.has(item)
                        );
                        const touchedByOperations = required.some(
                            (item: string) => operationEvidence.has(item)
                        );

                        return usedByScenario || touchedByOperations;
                    }
                );


                if (!simpleStructuralEdit) {
                    const stillMissingEditableRequirements =
                        getAIMissingEditableRequirements(
                            blueprint,
                            plan
                        );

                    const finalCodeValidationErrors =
                        getAIBehaviorCodeValidationErrors(plan);

                    if (prunedPlaceholderBehaviors.length > 0) {
                        plan.Warnings = Array.isArray(plan.Warnings)
                            ? plan.Warnings
                            : [];
                        plan.Warnings.push(
                            "AI-first omitted unimplemented placeholder behavior (non-blocking): " +
                            prunedPlaceholderBehaviors.join(", ")
                        );
                    }

                    // Semantic coverage is diagnostic only in AI-first mode.
                    // Preserve it for inspection instead of blocking an otherwise
                    // coherent plan because a deterministic matcher could not prove
                    // equivalence between the blueprint wording and generated code.
                    if (stillMissingEditableRequirements.length > 0) {
                        plan.Warnings = Array.isArray(plan.Warnings)
                            ? plan.Warnings
                            : [];

                        const semanticSummary = stillMissingEditableRequirements
                            .slice(0, 12)
                            .map((item: AnyDoc) => {
                                const requirement = item.Requirement || {};
                                return `${requirement.Kind || "Requirement"}: ${requirement.Target || item.Missing || "unknown target"}`;
                            })
                            .join(", ");

                        plan.Warnings.push(
                            "AI-first semantic coverage diagnostic (non-blocking): " +
                            semanticSummary
                        );
                    }

                    // Runtime/code contract violations remain blocking because they
                    // are objective implementation defects, not semantic judgments.
                    if (finalCodeValidationErrors.length > 0) {
                        throw new Error(
                            "ИИ сформировал код, нарушающий runtime-контракт: " +
                            finalCodeValidationErrors
                                .slice(0, 8)
                                .join("; ")
                        );
                    }
                }

                const hasIncompleteCoverage =
                    plan.Scenarios.some((scenario: AnyDoc) =>
                        Array.isArray(scenario?.Missing) &&
                        scenario.Missing.length > 0
                    ) ||
                    plan.Capabilities.some((capability: AnyDoc) =>
                        String(capability?.Status || "") !== "Implemented"
                    );

                if (
                    hasIncompleteCoverage &&
                    typeof plan.Message === "string"
                ) {
                    plan.Message = plan.Message
                        .replace(
                            /\s*Реализованы все основные сценарии\.?/gi,
                            ""
                        )
                        .replace(
                            /\s*All core scenarios are implemented\.?/gi,
                            ""
                        )
                        .replace(/\s{2,}/g, " ")
                        .trim();
                }

                // Simple structural edits keep one synthetic scenario and
                // capability internally because plan validation requires them.
                // They are removed only from the user-facing copy after validation.
                if (simpleStructuralEdit) {
                    plan.BusinessAnalysis = {
                        Actors: [],
                        ReferenceData: [],
                        Documents: [],
                        Lifecycles: [],
                        QuantitiesAndBalances: [],
                        DerivedValues: [],
                        Assumptions: [],
                        StandardCore: [],
                        IntentionalSimplifications: [],
                        UserPain: [],
                        DistinctiveRequirements: []
                    };
                }

                plan.BusinessAnalysis.Assumptions =
                    Array.isArray(plan.BusinessAnalysis.Assumptions)
                        ? plan.BusinessAnalysis.Assumptions
                        : [];

                const generatedAssumptions = Array.isArray(
                    (plan as AnyDoc).__GeneratedAssumptions
                )
                    ? (plan as AnyDoc).__GeneratedAssumptions
                    : [];
                generatedAssumptions.forEach((assumption: string) => {
                    if (plan.BusinessAnalysis.Assumptions.indexOf(assumption) < 0) {
                        plan.BusinessAnalysis.Assumptions.push(assumption);
                    }
                });

                const currentAIApplicationTypes =
                    getAIApplicationTypeDocs();
                const companyId =
                    getExistingAITypeIdByName("Company");

                const blueprintText =
                    JSON.stringify(blueprint || {});

                const canonicalCompanyRequired =
                    !!companyId &&
                    /(?:^|[^A-Za-z])(Company)(?:[^A-Za-z]|$)/
                        .test(blueprintText);

                const partyAliasNames = new Set([
                    "client",
                    "customer",
                    "supplier",
                    "vendor",
                    "counterparty",
                    "carrier"
                ]);

                const partyTemporaryIds = new Set<string>();

                if (canonicalCompanyRequired) {
                    (plan.Operations || []).forEach(
                        (operation: AnyDoc) => {
                            if (
                                operation?.Type !== "AddType"
                            ) {
                                return;
                            }

                            const entityName =
                                String(
                                    operation?.Entity?.Name ||
                                    ""
                                ).toLowerCase();

                            if (
                                partyAliasNames.has(entityName)
                            ) {
                                const temporaryId =
                                    String(
                                        operation?.TemporaryId ||
                                        ""
                                    );

                                if (temporaryId) {
                                    partyTemporaryIds.add(
                                        temporaryId
                                    );
                                }
                            }
                        }
                    );

                    if (partyTemporaryIds.size) {
                        plan.Operations =
                            (plan.Operations || []).filter(
                                (operation: AnyDoc) =>
                                    !(
                                        operation?.Type ===
                                        "AddType" &&
                                        partyTemporaryIds.has(
                                            String(
                                                operation?.TemporaryId ||
                                                ""
                                            )
                                        )
                                    )
                            );

                        (plan.Operations || []).forEach(
                            (operation: AnyDoc) => {
                                const ownerTemporaryId =
                                    String(
                                        operation?.EntityRef
                                            ?.TemporaryId ||
                                        ""
                                    );

                                if (
                                    partyTemporaryIds.has(
                                        ownerTemporaryId
                                    )
                                ) {
                                    operation.EntityId =
                                        companyId;
                                    delete operation.EntityRef;
                                }

                                const navigationTemporaryId =
                                    String(
                                        operation?.EntityRef
                                            ?.TemporaryId ||
                                        operation?.TargetType
                                            ?.TemporaryId ||
                                        operation?.NavigationItem
                                            ?.EntityRef
                                            ?.TemporaryId ||
                                        ""
                                    );

                                if (
                                    operation?.Type ===
                                    "AddNavigationItem" &&
                                    partyTemporaryIds.has(
                                        navigationTemporaryId
                                    )
                                ) {
                                    operation.EntityId =
                                        companyId;
                                    delete operation.EntityRef;
                                    delete operation.TargetType;

                                    if (
                                        operation.NavigationItem
                                    ) {
                                        delete operation
                                            .NavigationItem
                                            .EntityRef;
                                    }
                                }

                                const propertyTypeTemporaryId =
                                    String(
                                        operation?.Property?.Type
                                            ?.TemporaryId ||
                                        ""
                                    );

                                if (
                                    partyTemporaryIds.has(
                                        propertyTypeTemporaryId
                                    )
                                ) {
                                    operation.Property.Type =
                                        companyId;
                                    operation.Property.Aggregation =
                                        operation.Property
                                            .Aggregation ||
                                        "Hybrid";
                                }

                                const collectionItemTemporaryId =
                                    String(
                                        operation?.Collection
                                            ?.ItemEntity
                                            ?.TemporaryId ||
                                        ""
                                    );

                                if (
                                    partyTemporaryIds.has(
                                        collectionItemTemporaryId
                                    )
                                ) {
                                    operation.Collection.ItemEntity =
                                        companyId;
                                }
                            }
                        );

                        if (
                            typeof plan.Message === "string"
                        ) {
                            plan.Message = plan.Message
                                .replace(
                                    /(?:созда(?:е|ё)тся|создать|добавляется|добавить)\s+тип\s+(?:Client|Customer|Supplier|Vendor|Counterparty|Carrier)[,.;]?\s*/gi,
                                    ""
                                )
                                .replace(
                                    /(?:creates?|adds?)\s+(?:a\s+)?(?:Client|Customer|Supplier|Vendor|Counterparty|Carrier)\s+type[,.;]?\s*/gi,
                                    ""
                                )
                                .replace(
                                    /\b(?:Client|Customer)\b/g,
                                    "Company"
                                )
                                .replace(/\s{2,}/g, " ")
                                .trim();
                        }
                    }
                }

                // Repair navigation references that use a guessed TemporaryId
                // instead of the exact TemporaryId emitted by AddType.
                const addTypeByTemporaryId =
                    new Map<string, AnyDoc>();
                const addTypeByName =
                    new Map<string, AnyDoc>();

                (plan.Operations || []).forEach(
                    (operation: AnyDoc) => {
                        if (
                            operation?.Type !== "AddType"
                        ) {
                            return;
                        }

                        const temporaryId =
                            String(
                                operation?.TemporaryId ||
                                ""
                            );
                        const entityName =
                            String(
                                operation?.Entity?.Name ||
                                ""
                            ).toLowerCase();

                        if (temporaryId) {
                            addTypeByTemporaryId.set(
                                temporaryId,
                                operation
                            );
                        }

                        if (entityName) {
                            addTypeByName.set(
                                entityName,
                                operation
                            );
                        }
                    }
                );

                (plan.Operations || []).forEach(
                    (operation: AnyDoc) => {
                        if (
                            operation?.Type !==
                            "AddNavigationItem"
                        ) {
                            return;
                        }

                        const reference =
                            operation?.EntityRef ||
                            operation?.TargetType ||
                            operation?.NavigationItem
                                ?.EntityRef;

                        const temporaryId =
                            String(
                                reference?.TemporaryId ||
                                ""
                            );

                        if (
                            !temporaryId ||
                            addTypeByTemporaryId.has(
                                temporaryId
                            )
                        ) {
                            return;
                        }

                        const candidateName =
                            temporaryId
                                .replace(/^new[-_]?/i, "")
                                .toLowerCase();

                        const matchingAddType =
                            addTypeByName.get(
                                candidateName
                            );

                        if (matchingAddType) {
                            operation.EntityRef = {
                                TemporaryId:
                                    matchingAddType
                                        .TemporaryId
                            };
                            delete operation.EntityId;
                            delete operation.TargetType;

                            if (
                                operation.NavigationItem
                            ) {
                                delete operation
                                    .NavigationItem
                                    .EntityRef;
                            }

                            return;
                        }

                        const canonicalName =
                            [
                                "client",
                                "customer",
                                "supplier",
                                "vendor",
                                "counterparty",
                                "carrier",
                                "company"
                            ].indexOf(candidateName) >= 0
                                ? "Company"
                                : upperFirst(
                                    candidateName
                                );

                        const existingTypeId =
                            getExistingAITypeIdByName(
                                canonicalName
                            );

                        if (existingTypeId) {
                            setAINavigationEntityId(
                                operation,
                                existingTypeId
                            );
                        }
                    }
                );

                (plan.Operations || []).forEach((operation: AnyDoc) => {
                    const ownerTemporaryId = String(
                        operation &&
                        operation.EntityRef &&
                        operation.EntityRef.TemporaryId ||
                        ""
                    ).toLowerCase();

                    if (
                        companyId &&
                        (
                            ownerTemporaryId === "new-company" ||
                            ownerTemporaryId === "company"
                        )
                    ) {
                        operation.EntityId = companyId;
                        delete operation.EntityRef;
                    }

                    if (
                        operation &&
                        operation.Property &&
                        operation.Property.Type &&
                        typeof operation.Property.Type === "object"
                    ) {
                        const propertyTypeTemporaryId = String(
                            operation.Property.Type.TemporaryId || ""
                        ).toLowerCase();

                        if (
                            companyId &&
                            (
                                propertyTypeTemporaryId === "new-company" ||
                                propertyTypeTemporaryId === "company"
                            )
                        ) {
                            operation.Property.Type = companyId;
                            operation.Property.Aggregation = "Hybrid";
                        }
                    }
                });

                if (simpleStructuralEdit) {
                    const structuralEvidence =
                        Array.from(
                            buildAIPlanStructuralEvidence(plan)
                        );

                    if (
                        !Array.isArray(plan.Scenarios) ||
                        !plan.Scenarios.length
                    ) {
                        plan.Scenarios = [
                            {
                                Id: "S1",
                                Name:
                                    "Requested structural model change",
                                Description:
                                    prompt,
                                Importance: "Core",
                                RequiredModelElements: [],
                                Requirements: [],
                                Evidence:
                                    structuralEvidence,
                                Missing: []
                            }
                        ];
                    }

                    if (
                        !Array.isArray(plan.Capabilities) ||
                        !plan.Capabilities.length
                    ) {
                        plan.Capabilities = [
                            {
                                Id: "C1",
                                Name:
                                    "Requested structural model change",
                                Importance: "Core",
                                RequiredModelElements: [],
                                Requirements: [],
                                AcceptanceCriteria: [
                                    "The explicitly requested model change is present."
                                ],
                                Status:
                                    structuralEvidence.length
                                        ? "Implemented"
                                        : "NotImplemented",
                                Evidence:
                                    structuralEvidence,
                                Missing:
                                    structuralEvidence.length
                                        ? []
                                        : [
                                            "No structural operation was generated."
                                        ]
                            }
                        ];
                    }
                }

                applyAIFormulaDependencyCoverageAudit(plan);

                // Full-model generation may include speculative, unused enums.
                // Keep explicit structural edits untouched.
                if (!simpleStructuralEdit) {
                    const beforeCanonicalization = summarizeDesignerAIOperations(plan);
                    removeUnusedGeneratedEnums(plan);
                    removeDuplicateGeneratedCollections(plan);
                    traceDesignerAIPipeline("Plan.Canonicalized", {
                        Before: beforeCanonicalization,
                        After: summarizeDesignerAIOperations(plan)
                    });
                }

                // Objective reserved-keyword failures must never be handed back to the
                // user as a plan-validation error. The main model can miss a naming
                // rule inside a large generation prompt, so run a narrow indexed
                // repair pass and validate the repaired plan again. Indexed replacement
                // is important here because renaming AddProperty/AddType changes the
                // operation identity and cannot be handled by the ordinary name-based
                // semantic repair merge.
                if (getAIReservedCosmosIdentifierIssues(plan).length) {
                    plan = await repairAIReservedCosmosIdentifiers(
                        effectiveBusinessRequest,
                        blueprint,
                        plan
                    );
                }

                const validation = validateAIPlanReferences(plan);

                traceDesignerAIPipeline("Validation.Final", {
                    IsValid: validation.IsValid,
                    Errors: validation.Issues.filter((item: AnyDoc) => (item?.Severity || "error") === "error")
                        .map((item: AnyDoc) => ({ Operation: item?.OperationIndex, Code: item?.Code, Message: item?.Message })),
                    Warnings: validation.Issues.filter((item: AnyDoc) => item?.Severity === "warning")
                        .map((item: AnyDoc) => ({ Operation: item?.OperationIndex, Code: item?.Code })),
                    FinalOperations: summarizeDesignerAIOperations(plan)
                });
                (plan as AnyDoc).__PipelineTrace = cloneData(designerAIPipelineTrace);

                plan.ThinkingMode =
                    requestThinkingMode;

                const userFacingPlan = cloneData(plan);
                userFacingPlan.ThinkingMode =
                    requestThinkingMode;

                if (simpleStructuralEdit) {
                    userFacingPlan.Scenarios = [];
                    userFacingPlan.Capabilities = [];
                }

                const baseMessageText =
                    String(userFacingPlan?.Message || "").trim() ||
                    "The assistant returned a model change plan.";
                const consultingSummary =
                    formatAIConsultingSummary(userFacingPlan);
                const messageText = consultingSummary
                    ? `${baseMessageText}\n\n${consultingSummary}`
                    : baseMessageText;

                if (!validation.IsValid) {
                    aiMessages.push({
                        Role: "assistant",
                        Content:
                            messageText +
                            "\n\nPlan validation failed:\n" +
                            formatAIPlanValidationIssues(validation),
                        Plan: userFacingPlan,
                        InternalPlan: plan,
                        Error: true
                    });
                } else {
                    aiMessages.push({
                        Role: "assistant",
                        Content: messageText,
                        Plan: userFacingPlan,
                        InternalPlan: plan
                    });
                }
            } catch (err: any) {
                traceDesignerAIPipeline("Request.Error", { Message: err?.message || String(err) });
                const errorReport =
                    buildDesignerAIErrorReport(
                        err,
                        prompt
                    );

                aiMessages.push({
                    Role: "assistant",
                    Content:
                        err?.message ||
                        String(err),
                    Error: true,
                    ErrorReport:
                        errorReport
                });
            } finally {
                aiRequestInProgress = false;
                aiPromptBox?.option("disabled", false);
                aiSendButton?.option("disabled", false);
                renderAssistant();
            }
        }

        function isDarkTheme(): boolean {
            const bodyClass = document.body.className || "";
            const htmlClass = document.documentElement.className || "";
            const allClasses = `${bodyClass} ${htmlClass}`.toLowerCase();

            if (
                allClasses.includes("dark") ||
                allClasses.includes("dark-theme") ||
                allClasses.includes("theme-dark") ||
                allClasses.includes("dx-theme-generic-dark") ||
                allClasses.includes("dx-theme-material-dark") ||
                allClasses.includes("dx-color-scheme-dark")
            ) {
                return true;
            }

            // DevExtreme часто кладёт тему в link href.
            const themeLinks = Array.from(document.querySelectorAll("link[href]")) as HTMLLinkElement[];

            if (themeLinks.some(l => String(l.href || "").toLowerCase().includes("dark"))) {
                return true;
            }

            // Последний fallback — системная тема.
            return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches === true;
        }

        function getMonacoThemeName(): string {
            return isDarkTheme() ? "vs-dark" : "vs";
        }

        function openCodeEditor(owner: AnyDoc, prop: AnyDoc): void {
            const typeEntity = resolveMetaEntityRef(prop.TypeEntity);
            if (!typeEntity) return;

            const typeName = String(typeEntity.Name || "");
            const codeValue = ensureCodeValue(owner, prop);

            const $host = $("<div>").appendTo(document.body);

            let textArea: any = null;
            let languageBox: any = null;
            let contextBox: any = null;

            let monacoEditor: any = null;
            let monaco: any = null;
            const $hostAny = $host as any;
            let popupInstance: any = null;

            $hostAny.dxPopup({
                title: `${prop.Name} — ${typeName}`,
                width: () => Math.min(window.innerWidth - 80, 1100),
                height: () => Math.min(window.innerHeight - 80, 760),
                showTitle: true,
                showCloseButton: true,
                resizeEnabled: true,
                dragEnabled: true,
                shading: true,

                toolbarItems: [
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "OK",
                            type: "default",
                            onClick: () => {
                                const codeText = monacoEditor
                                    ? monacoEditor.getValue()
                                    : textArea?.option("value") ?? "";

                                codeValue.Code = codeText;

                                if (typeName === "Code" && languageBox) {
                                    codeValue.Language = normalizeCodeLanguage(languageBox.option("value"));
                                }

                                if (typeName === "CodeExpression" && contextBox) {
                                    codeValue.WithContext = contextBox.option("value") || "None";
                                }

                                setObjectValue(owner, prop, codeValue);

                                renderPropertyGrid();
                                renderInfo();

                                popupInstance?.hide();;
                            }
                        }
                    },
                    {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: "Отмена",
                            onClick: () => popupInstance?.hide()
                        }
                    }
                ],

                contentTemplate: contentElement => {
                    const $root = $("<div>")
                        .css({
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            padding: "10px",
                            boxSizing: "border-box"
                        })
                        .appendTo(contentElement);

                    const $top = $("<div>")
                        .css({
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: "0 0 auto"
                        })
                        .appendTo($root);

                    if (typeName === "Code") {
                        $("<div>")
                            .css({ minWidth: "220px" })
                            .appendTo($top)
                            .dxSelectBox({
                                label: "Language",
                                labelMode: "floating",
                                dataSource: ["JS", "TS", "SQL"],
                                value: normalizeCodeLanguage(codeValue.Language),
                                onValueChanged: args => {
                                    codeValue.Language = normalizeCodeLanguage(args.value);

                                    if (monacoEditor && monaco?.editor) {
                                        const model = monacoEditor.getModel();
                                        if (model) {
                                            monaco.editor.setModelLanguage(
                                                model,
                                                getCodeEditorMode(codeValue, typeName)
                                            );
                                        }
                                    }
                                },
                                onInitialized: args => {
                                    languageBox = args.component;
                                }
                            } as any);
                    }

                    if (typeName === "CodeExpression") {
                        $("<div>")
                            .css({ minWidth: "260px" })
                            .appendTo($top)
                            .dxSelectBox({
                                label: "With context",
                                labelMode: "floating",
                                dataSource: ["None", "CurrentData"],
                                value: codeValue.WithContext || "None",
                                onInitialized: (args: any) => {
                                    contextBox = args.component;
                                },
                                onValueChanged: (args: any) => {
                                    codeValue.WithContext = args.value || "None";

                                    if (monaco?.editor) {
                                        const currentSchema = getCodeEditorContextSchema(owner, prop);
                                        const withCurrentDataContext = isCurrentDataContextEnabled(typeName, codeValue);

                                        loadProjectDeclarationBundle()
                                            .then(projectDts => {
                                                configureMonacoForCurrentData(
                                                    monaco,
                                                    currentSchema,
                                                    withCurrentDataContext,
                                                    projectDts
                                                );
                                            });
                                    }
                                }
                                //onValueChanged: async (args: any) => {
                                //    codeValue.WithContext = args.value || "None";

                                //    if (monaco?.editor) {
                                //        const currentSchema = getCodeEditorContextSchema(owner, prop);
                                //        const withCurrentDataContext = isCurrentDataContextEnabled(typeName, codeValue);
                                //        const projectDts = await loadProjectDeclarationBundle();

                                //        configureMonacoForCurrentData(
                                //            monaco,
                                //            currentSchema,
                                //            withCurrentDataContext,
                                //            projectDts
                                //        );
                                //    }
                                //}
                            } as any);
                    }

                    $("<div>")
                        .text(typeEntity.Description || prop.Description || "")
                        .css({
                            opacity: ".75",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: "1"
                        })
                        .appendTo($top);

                    const $editorHost = $("<div>")
                        .addClass("ca-md-code-editor-host")
                        .css({
                            flex: "1 1 auto",
                            minHeight: "0",
                            border: "1px solid rgba(128,128,128,.35)"
                        })
                        .appendTo($root);

                    $("<div>")
                        .text("Loading code editor...")
                        .css({
                            padding: "12px",
                            opacity: ".7"
                        })
                        .appendTo($editorHost);

                    ensureMonacoLoaded()
                        .then(async m => {
                            monaco = m;
                            $editorHost.empty();

                            const monacoTheme = getMonacoThemeName();

                            monaco.editor.setTheme(monacoTheme);

                            const editorLanguage = getCodeEditorMode(codeValue, typeName);

                            const modelUri = monaco.Uri.parse(
                                `inmemory://cosmoapps/code-editor-${Date.now()}.${editorLanguage === "typescript" ? "ts" : "js"}`
                            );

                            const model = monaco.editor.createModel(
                                String(codeValue.Code || ""),
                                editorLanguage,
                                modelUri
                            );

                            monacoEditor = monaco.editor.create($editorHost[0], {
                                model,
                                theme: monacoTheme,
                                automaticLayout: true,
                                minimap: { enabled: false },
                                scrollBeyondLastLine: false,
                                quickSuggestions: {
                                    other: true,
                                    comments: false,
                                    strings: false
                                },
                                suggestOnTriggerCharacters: true,
                                wordBasedSuggestions: "off" as any
                            });

                            const currentSchema = getCodeEditorContextSchema(owner, prop);
                            const withCurrentDataContext = isCurrentDataContextEnabled(typeName, codeValue);
                            const projectDts = await loadProjectDeclarationBundle();

                            configureMonacoForCurrentData(
                                monaco,
                                currentSchema,
                                withCurrentDataContext,
                                projectDts
                            );
                        })
                        .catch(err => {
                            console.warn("Monaco load failed, fallback to dxTextArea", err);

                            $editorHost.empty();

                            $editorHost.dxTextArea({
                                value: String(codeValue.Code || ""),
                                height: "100%",
                                stylingMode: "outlined",
                                autoResizeEnabled: false,
                                elementAttr: {
                                    class: "ca-md-code-textarea"
                                },
                                onInitialized: args => {
                                    textArea = args.component;
                                }
                            } as any);
                        });
                },

                onHidden: () => {
                    if (monacoEditor) {
                        const model = monacoEditor.getModel();

                        monacoEditor.dispose();
                        monacoEditor = null;

                        model?.dispose?.();
                    }

                    $host.remove();
                }
            } as any)

            popupInstance = $hostAny.dxPopup("instance");
            popupInstance.show();
        }

        function getCodeEditorContextSchema(owner: AnyDoc, prop: AnyDoc): AnyDoc | null {
            // Обычно owner — это текущий selectedNode.doc.
            let schema: AnyDoc | null = null;

            try {
                schema = getSchemaForObject(owner, selectedNode?.collection);
            } catch {
                schema = null;
            }

            if (schema && Array.isArray(schema.Properties) && schema.Properties.length) {
                return schema;
            }

            // Если открыли код из property typed-object / вложенного объекта.
            if (selectedNode?.doc === owner) {
                try {
                    schema = getSchemaForObject(selectedNode.doc, selectedNode.collection);
                } catch {
                    schema = null;
                }

                if (schema && Array.isArray(schema.Properties) && schema.Properties.length) {
                    return schema;
                }
            }

            // Если у объекта явно есть __typeEntity.
            if (owner?.__typeEntity) {
                schema = resolveMetaEntityRef(owner.__typeEntity);

                if (schema && Array.isArray(schema.Properties) && schema.Properties.length) {
                    return schema;
                }
            }

            // Если _type — это id MetaEntity.
            if (typeof owner?._type === "string") {
                schema = getMetaEntityById(owner._type);

                if (schema && Array.isArray(schema.Properties) && schema.Properties.length) {
                    return schema;
                }
            }

            return null;
        }

        function renderPropertyGrid(): void {
            if (!selectedNode) return;

            selectedPropertyRow = null;

            const $grid = $(`#${POPUP_ID}-property-grid`);
            if (!$grid.length) return;

            if (grid) {
                grid.dispose();
                grid = null;
                $grid.empty();
            }

            const rows = selectedNode.kind === "group" ? [] : buildPropertyRows(selectedNode);

            grid = $grid.dxDataGrid({
                dataSource: rows,
                keyExpr: "id",
                height: "100%",
                showBorders: true,
                showColumnLines: true,
                showRowLines: true,
                rowAlternationEnabled: false,
                hoverStateEnabled: true,
                focusedRowEnabled: true,
                paging: { enabled: false },
                pager: { visible: false },
                scrolling: { mode: "standard", showScrollbar: "always" },
                grouping: { autoExpandAll: true },
                groupPanel: { visible: false },
                editing: {
                    mode: "cell",
                    allowUpdating: selectedNode.kind !== "group",
                    startEditAction: "click",
                    selectTextOnEditStart: true
                },
                columns: [
                    {
                        dataField: "category",
                        groupIndex: 0,
                        visible: false,
                        sortOrder: "asc"
                    },
                    {
                        dataField: "name",
                        caption: "Свойство",
                        width: 240,
                        allowEditing: false,
                        cellTemplate: (container, options) => {
                            const row = options.data as PropertyGridRow;
                            const $wrap = $("<div>")
                                .addClass("ca-md-prop-name")
                                .attr("data-ai-property", row.name);

                            if (row.description) {
                                $wrap.attr("title", row.description).attr("data-ai-description", row.description);
                            }

                            $("<span>").text(row.name).appendTo($wrap);

                            if (row.meta?.Required) {
                                $("<span>").addClass("ca-md-required").text("*").appendTo($wrap);
                            }

                            container.append($wrap);
                        }
                    },
                    {
                        dataField: "value",
                        caption: "Значение",
                        minWidth: 320,
                        allowEditing: true,
                        cellTemplate: (container, options) => {
                            const row = options.data as PropertyGridRow;
                            const text = displayValue(row.name, row.value);
                            $("<span>").text(text).attr("title", text).appendTo(container);
                        },
                        editCellTemplate: (cellElement, cellInfo) => {
                            const row = cellInfo.data as PropertyGridRow;
                            const prop = row.meta || null;
                            const currentValue = selectedNode?.doc && prop ? getObjectValue(selectedNode.doc, prop) : row.value;

                            if (isCodeProperty(prop)) {
                                const codeValue = ensureCodeValue(selectedNode!.doc, prop);

                                const $wrap = $("<div>")
                                    .css({
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        width: "100%"
                                    })
                                    .appendTo(cellElement);

                                $("<div>")
                                    .css({
                                        flex: "1",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        opacity: codeValue.Code ? "1" : ".55"
                                    })
                                    .text(getCodeDisplayText(codeValue) || "<empty>")
                                    .appendTo($wrap);

                                $("<div>")
                                    .appendTo($wrap)
                                    .dxButton({
                                        icon: "edit",
                                        text: "Code",
                                        stylingMode: "outlined",
                                        onClick: () => {
                                            openCodeEditor(selectedNode!.doc, prop);
                                        }
                                    } as any);

                                return;
                            }

                            const applyValue = (value: any): void => {
                                const editedNodeId = selectedNode?.id || "";
                                const editedDocId = String(selectedNode?.doc?.id || "");
                                const renamedIdentityField = row.name === "Name";

                                row.value = value;
                                if (selectedNode?.doc && prop) setObjectValue(selectedNode.doc, prop, value);
                                cellInfo.setValue(value);

                                // Tree nodes are a snapshot of the current model. Name changes must
                                // rebuild that snapshot; otherwise the diagram/runtime model already
                                // sees the new name while dxTreeView keeps the stale item (and may
                                // lose it on a later repaint/search refresh). Re-select by stable id,
                                // never by Name.
                                if (renamedIdentityField && editedDocId) {
                                    window.setTimeout(() => {
                                        treeItems = buildTree();
                                        selectedNode =
                                            findTreeNodeByDocId(treeItems, editedDocId) ||
                                            findTreeNodeById(treeItems, editedNodeId) ||
                                            selectedNode;
                                        selectedPropertyRow = null;

                                        if (tree) {
                                            tree.option("items", treeItems);

                                            window.setTimeout(() => {
                                                try {
                                                    const nodeId = selectedNode?.id || editedNodeId;
                                                    if (nodeId) {
                                                        const parts = String(nodeId).split("/");
                                                        for (let i = 1; i < parts.length; i++) {
                                                            tree.expandItem(parts.slice(0, i).join("/"));
                                                        }
                                                        tree.selectItem(nodeId);
                                                        tree.scrollToItem(nodeId);
                                                    }
                                                } catch {
                                                    // ignore dxTreeView render timing issues
                                                }

                                                renderPropertyGrid();
                                                renderInfo();
                                                renderAssistant();
                                            }, 0);
                                        } else {
                                            renderPropertyGrid();
                                            renderInfo();
                                            renderAssistant();
                                        }
                                    }, 0);
                                    return;
                                }

                                renderInfo();
                                renderAssistant();
                            };

                            cellElement.empty();

                            if (row.name === "Category") {
                                const categories = getCategories();
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: categories,
                                        valueExpr: "id",
                                        displayExpr: "Name",
                                        searchEnabled: true,
                                        value: currentValue?.id || null,
                                        onValueChanged: args => applyValue(categories.find(c => c.id === args.value) || null)
                                    });
                                return;
                            }

                            if (row.name === "Icon") {
                                const icons = getIcons();
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: icons,
                                        valueExpr: "id",
                                        displayExpr: (item: AnyDoc) => item ? `${item.Content || ""} ${item.Name || item.id}` : "",
                                        searchEnabled: true,
                                        value: currentValue?.id || null,
                                        onValueChanged: args => applyValue(icons.find(i => i.id === args.value) || null)
                                    });
                                return;
                            }

                            if (row.name === "ItemEntity" || row.name === "TypeEntity" || prop?.Type === META_ENTITY_TYPE) {
                                const metaEntities = getModelTypes();
                                const currentEntity = resolveMetaEntityRef(currentValue);

                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: metaEntities,
                                        valueExpr: "id",
                                        displayExpr: "Name",
                                        searchEnabled: true,
                                        value: currentEntity?.id || null,
                                        onValueChanged: args => {
                                            const entity = metaEntities.find(m => m.id === args.value);
                                            applyValue(entity ? makeHybridMetaEntityRef(entity) : null);
                                        }
                                    });
                                return;
                            }

                            const selectedSchema = selectedNode?.doc
                                ? getSchemaForObject(selectedNode.doc, selectedNode.collection)
                                : null;

                            if (selectedSchema?.Name === "Type" && row.name === "BaseType") {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: getBaseTypes(selectedNode?.doc),
                                        displayExpr: "Name",
                                        valueExpr: "id",
                                        searchEnabled: true,
                                        value: currentValue || "object",
                                        dropDownOptions: {
                                            width: 500,
                                            maxWidth: window.innerWidth * 0.9
                                        },
                                        onValueChanged: args => applyValue(args.value)
                                    } as any);

                                return;
                            }

                            if (selectedSchema?.Name === "Property" && row.name === "Type") {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: getPropertyTypes(),
                                        displayExpr: "Name",
                                        valueExpr: "id",
                                        searchEnabled: true,
                                        value: currentValue || null,
                                        dropDownOptions: {
                                            width: 500,
                                            maxWidth: window.innerWidth * 0.9
                                        },
                                        onValueChanged: args => applyValue(args.value)
                                    } as any);

                                return;
                            }

                            if (enumMaps[row.name]) {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: enumMaps[row.name],
                                        valueExpr: "value",
                                        displayExpr: "name",
                                        searchEnabled: true,
                                        value: currentValue,
                                        onValueChanged: args => applyValue(args.value)
                                    });
                                return;
                            }

                            if (Array.isArray(prop?.Values) && prop.Values.length && !prop.Many) {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxSelectBox({
                                        dataSource: prop.Values,
                                        valueExpr: "Name",
                                        displayExpr: "Name",
                                        searchEnabled: true,
                                        value: currentValue,
                                        onValueChanged: args => applyValue(args.value)
                                    });
                                return;
                            }

                            if (prop?.ValueType === 4 || typeof currentValue === "boolean") {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxCheckBox({
                                        value: !!currentValue,
                                        text: currentValue ? "True" : "False",
                                        onValueChanged: args => {
                                            applyValue(args.value);
                                            args.component.option("text", args.value ? "True" : "False");
                                        }
                                    });
                                return;
                            }

                            if (
                                row.name === "Description" ||
                                row.name === "Note" ||
                                row.name === "Script" ||
                                row.name === "Condition" ||
                                row.name === "PreCondition" ||
                                row.name === "ErrorMessage" ||
                                Array.isArray(currentValue) ||
                                (currentValue && typeof currentValue === "object")
                            ) {
                                $("<div>")
                                    .appendTo(cellElement)
                                    .dxTextArea({
                                        value: Array.isArray(currentValue) || (currentValue && typeof currentValue === "object")
                                            ? JSON.stringify(currentValue, null, 2)
                                            : (currentValue || ""),
                                        minHeight: 70,
                                        autoResizeEnabled: true,
                                        valueChangeEvent: "input",
                                        onValueChanged: args => {
                                            let value: any = args.value;
                                            if (Array.isArray(currentValue) || (currentValue && typeof currentValue === "object")) {
                                                try {
                                                    value = value ? JSON.parse(value) : null;
                                                } catch {
                                                    value = args.value;
                                                }
                                            }
                                            applyValue(value);
                                        }
                                    });
                                return;
                            }

                            $("<div>")
                                .appendTo(cellElement)
                                .dxTextBox({
                                    value: currentValue ?? "",
                                    onValueChanged: args => applyValue(args.value)
                                });
                        }
                    }
                ],
                onFocusedRowChanged: args => {
                    selectedPropertyRow = args.row?.data || null;
                    renderInfo();
                },
                onRowClick: args => {
                    selectedPropertyRow = args.data || null;
                    renderInfo();
                }
            }).dxDataGrid("instance");

            if (propertySearchText) {
                grid.searchByText(propertySearchText);
            }

            renderInfo();
            renderAssistant();
        }

        function parseDefaultValue(raw: any, prop: AnyDoc, target: AnyDoc, parent: AnyDoc): any {
            if (raw === undefined || raw === null || raw === "") return undefined;
            if (typeof raw !== "string") return cloneData(raw);

            const trimmed = raw.trim();
            if (trimmed === "true") return true;
            if (trimmed === "false") return false;
            if (trimmed === "null") return null;
            if (trimmed === "undefined") return undefined;

            if (prop.ValueType === 2 || prop.ValueType === 3) {
                const n = Number(trimmed);
                if (!Number.isNaN(n)) return n;
            }

            if ((trimmed.startsWith("\"") && trimmed.endsWith("\"")) || (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
                try {
                    return JSON.parse(trimmed.replace(/^'/, "\"").replace(/'$/, "\""));
                } catch {
                    return trimmed.substring(1, trimmed.length - 1);
                }
            }

            try {
                if (typeof runtime.calc === "function") return runtime.calc(trimmed, target, parent);
            } catch {
                // default expression may be plain text or depend on missing context
            }

            return trimmed;
        }

        function applySchemaDefaults(target: AnyDoc, schema: AnyDoc, parent: AnyDoc): void {
            const props: AnyDoc[] = Array.isArray(schema?.Properties) ? schema.Properties : [];

            props.forEach(prop => {
                if (!prop?.Name) return;
                if (Object.prototype.hasOwnProperty.call(target, prop.Name)) return;

                const defaultValue = parseDefaultValue(prop.DefaultValue, prop, target, parent);
                if (defaultValue !== undefined) target[prop.Name] = defaultValue;
            });
        }

        function getConcreteTypeForItemEntity(itemEntity: any): string | null {
            const schema = resolveMetaEntityRef(itemEntity);
            if (!schema) return null;

            if (schema.Name === "Property") return PROPERTY_TYPE;
            if (schema.Name === "MetaCollection") return COLLECTION_TYPE;
            if (schema.Name === "MetaPropertyValue" || schema.Name === "EnumValue") return PROPERTY_VALUE_TYPE;
            if (schema.Name === "Icon") return ICON_TYPE;
            if (schema.Name === "MetaPropertyCategory" || schema.Name === "Category") return CATEGORY_TYPE;
            if (schema.Name === "Application") return APPLICATION_TYPE;

            return schema.id || null;
        }

        function getSuggestedNewName(collection: AnyDoc, items: AnyDoc[]): string {
            const schema = resolveMetaEntityRef(collection.ItemEntity);
            const base = `New${schema?.Name || collection.Name || "Item"}`;

            let index = items.length + 1;
            let candidate = `${base}${index}`;

            while (items.some(x => x?.Name === candidate)) {
                index++;
                candidate = `${base}${index}`;
            }

            return candidate;
        }

        function createNewCollectionItem(collection: AnyDoc, parent: AnyDoc): AnyDoc {
            const schema = resolveMetaEntityRef(collection.ItemEntity);
            const siblings = getCollectionArray(parent, collection, false);
            const isRootApplicationCollection = parent === applicationDoc;
            const isRuntimeTypeCollection = isRootApplicationCollection && (collection.Name === "Types" || collection.Name === "Entities");

            if (isRuntimeTypeCollection) {
                const name = getSuggestedNewName(collection, siblings);

                return {
                    id: new DevExpress.data.Guid().toString(),
                    projectId: runtime.id,
                    _partitionKey: runtime.id,
                    _type: "_Type",
                    _extern: false,
                    BaseType: "object",
                    Browsable: true,
                    Cacheable: false,
                    IsRoot: false,
                    Properties: [],
                    Collections: [],
                    Rules: [],
                    ApperanceRules: [],
                    Actions: [],
                    Events: [],
                    formLayout: { Width: "1200", Height: "800", items: [] },
                    Name: name,
                    TypeName: `${runtime.ModuleName || runtime.Name || "App"}.${name}`,
                    Widgets: [],
                    Advanced: []
                };
            }

            const itemType = getConcreteTypeForItemEntity(collection.ItemEntity);
            const item: AnyDoc = {
                id: new DevExpress.data.Guid().toString(),
                Name: getSuggestedNewName(collection, siblings)
            };

            if (itemType) item._type = itemType;
            if (runtime.id) item._partitionId = runtime.id;

            applySchemaDefaults(item, schema, parent);

            if (!item.Name) item.Name = getSuggestedNewName(collection, siblings);

            return item;
        }

        function findTreeNodeById(nodes: DesignerTreeNode[], id: string): DesignerTreeNode | null {
            for (const node of nodes) {
                if (node.id === id) return node;
                const found = node.items ? findTreeNodeById(node.items, id) : null;
                if (found) return found;
            }
            return null;
        }

        function rebuildTreeAndSelect(nodeId: string, parentNodeId?: string): void {
            treeItems = buildTree();
            selectedNode = findTreeNodeById(treeItems, nodeId) || selectedNode;
            selectedPropertyRow = null;

            if (!tree) {
                renderPropertyGrid();
                return;
            }

            tree.option("items", treeItems);

            setTimeout(() => {
                try {
                    if (parentNodeId) tree.expandItem(parentNodeId);

                    if (selectedNode?.id) {
                        tree.selectItem(selectedNode.id);
                        tree.scrollToItem(selectedNode.id);
                    }
                } catch {
                    // ignore dxTreeView render timing issues
                }

                renderPropertyGrid();
            }, 0);
        }

        function addItemToSelectedCollection(node?: DesignerTreeNode): void {
            const collectionNode = node || selectedNode;

            if (!collectionNode || collectionNode.kind !== "collection" || !collectionNode.collection) {
                DevExpress.ui.notify("Выбери коллекцию в дереве", "warning", 2200);
                return;
            }

            const collection = collectionNode.collection;
            const owner = collectionNode.containerDoc || collectionNode.ownerDoc;

            if (!owner) {
                DevExpress.ui.notify("Не найден объект-владелец коллекции", "warning", 2200);
                return;
            }

            const items = getCollectionArray(owner, collection, true);
            const newItem = createNewCollectionItem(collection, owner);
            items.push(newItem);

            const parentNodeId = collectionNode.id;
            const newNodeId = `${collectionNode.id}/${newItem.id || items.length - 1}`;
            rebuildTreeAndSelect(newNodeId, parentNodeId);

            DevExpress.ui.notify(`Добавлено: ${newItem.Name || "new item"}`, "success", 1600);
        }

        function runtimeSaveRef(value: any): string | null {
            if (value === undefined || value === null || value === "") return null;
            if (typeof value === "string" || typeof value === "number") return String(value);
            if (typeof value !== "object") return String(value);

            const direct = value.id || value.EntityId || value.TargetType || value.Type;
            if (direct && typeof direct !== "object") return String(direct);

            const name = String(value.Name || value.TypeName || "").trim();
            if (!name) return null;

            const typeDoc = getRuntimeTypeDocs().find((x: AnyDoc) =>
                String(x?.Name || "") === name || String(x?.TypeName || "") === name
            );
            if (typeDoc?.id) return String(typeDoc.id);

            const enumDoc = getRuntimeEnumDocs().find((x: AnyDoc) =>
                String(x?.Name || "") === name
            );
            return enumDoc?.id ? String(enumDoc.id) : null;
        }

        function runtimeAggregation(value: any): string {
            if (value === 0 || value === "0") return "Value";
            if (value === 1 || value === "1") return "Aggregated";
            if (value === 2 || value === "2") return "Hybrid";
            if (value === 3 || value === "3") return "Deferred";
            return String(value || "Value");
        }

        function runtimeCode(value: any): any {
            if (value === undefined || value === null || typeof value === "string") return value;
            if (typeof value !== "object") return value;

            const candidate =
                value.js ?? value.Code ?? value.Expression ?? value.Value ?? value.Text;

            if (typeof candidate === "string") return candidate;
            if (candidate && typeof candidate === "object") return runtimeCode(candidate);
            return value;
        }

        function compactRuntimeProperty(source: AnyDoc, index: number, forceMany: boolean): AnyDoc {
            const p = cloneData(source || {});
            p.id = p.id || new DevExpress.data.Guid().toString();

            const ref = p.Type ?? p.TypeEntity ?? p.ItemEntity ?? p.EntityRef ?? p.TypeRef;
            const resolved = runtimeSaveRef(ref);
            if (resolved) p.Type = resolved;
            else if (!p.Type && p.ValueType) p.Type = String(p.ValueType);

            if (String(p.Type || "").toLowerCase() === "text") {
                p.Type = "string";
            }

            p.RO = p.RO === true || p.Readonly === true;
            p.Browsable = p.Browsable !== false;
            p.Required = p.Required === true;
            p.Many = forceMany || p.Many === true;
            p.VisibleInList = p.VisibleInList !== false;
            p.VisibleInDetail = p.VisibleInDetail !== false;
            p.VisibleInLookup = p.VisibleInLookup === true;
            p.Aggregation = runtimeAggregation(p.Aggregation);
            p.Index = p.Index ?? (index + 1);

            p.Rules = Array.isArray(p.Rules) ? p.Rules.map((r: AnyDoc) => {
                const x = cloneData(r);
                if (x.Condition !== undefined) x.Condition = runtimeCode(x.Condition);
                if (x.PreCondition !== undefined) x.PreCondition = runtimeCode(x.PreCondition);
                return x;
            }) : [];

            p.Events = Array.isArray(p.Events) ? p.Events.map((e: AnyDoc) => {
                const x = cloneData(e);
                if (x.js !== undefined) x.js = runtimeCode(x.js);
                else if (x.Script !== undefined) {
                    const code = runtimeCode(x.Script);
                    if (typeof code === "string") x.js = code;
                }
                delete x.Script;
                return x;
            }) : [];

            if (p.Formula !== undefined) p.Formula = runtimeCode(p.Formula);

            if (p.IsEnum === undefined) {
                p.IsEnum = getRuntimeEnumDocs().some((e: AnyDoc) =>
                    String(e?.id || "") === String(p.Type || "")
                );
            }

            [
                "TypeEntity", "ItemEntity", "EntityRef", "TypeRef", "Readonly",
                "__typeEntity", "__parent", "__clone", "__new",
                "_type", "projectId", "_partitionId", "_partitionKey"
            ].forEach(key => delete p[key]);

            return p;
        }

        function compactRuntimeAction(
            source: AnyDoc
        ): AnyDoc {
            const x =
                cloneData(
                    source || {}
                );

            // Preserve the exact defaults used by the legacy constructor.
            // Older AI-created actions may not contain them at all.
            x.Mode =
                x.Mode || "Override";
            x.TargetView =
                x.TargetView || "Any";
            x.Permission =
                x.Permission || "Default";
            x.ViewNesting =
                x.ViewNesting || "Any";

            if (
                x.Independent === undefined ||
                x.Independent === null
            ) {
                x.Independent = false;
            }

            // Metamodel property Action.ActionType is the designer-facing name.
            // Legacy runtime Action expects the same value in Action.Type.
            if (
                x.ActionType !== undefined
            ) {
                x.Type =
                    x.ActionType;
            }

            x.Type =
                x.Type || "Simple";

            // TargetView is runtime-significant: without it the action may exist
            // in metadata but is not rendered in the intended view.
            // Keep it explicitly instead of relying on incidental clone shape.
            if (
                source &&
                Object.prototype.hasOwnProperty.call(
                    source,
                    "TargetView"
                )
            ) {
                x.TargetView =
                    cloneData(
                        source.TargetView
                    );
            }

            if (
                x.js !== undefined
            ) {
                x.js =
                    runtimeCode(
                        x.js
                    );
            } else if (
                x.Script !== undefined
            ) {
                const code =
                    runtimeCode(
                        x.Script
                    );

                if (
                    typeof code ===
                    "string"
                ) {
                    x.js =
                        code;
                }
            }

            delete x.Script;
            delete x.ActionType;

            // Designer-only metadata must not leak into the runtime document.
            [
                "__typeEntity",
                "__parent",
                "__clone",
                "__new"
            ].forEach(
                (key: string) =>
                    delete x[key]
            );

            return x;
        }

        function compactRuntimeType(source: AnyDoc, appId: string): AnyDoc {
            const t = cloneData(source || {});
            t.id = t.id || new DevExpress.data.Guid().toString();
            t.projectId = appId;
            t._partitionKey = appId;
            t._type = "_Type";
            t._extern = t._extern === true;
            t.BaseType = runtimeSaveRef(t.BaseType) || "object";
            t.Browsable = t.Browsable !== false;
            t.Cacheable = t.Cacheable === true;
            t.IsRoot = t.IsRoot === true;

            const result: AnyDoc[] = [];
            const ids: Record<string, boolean> = {};
            const names: Record<string, boolean> = {};

            const add = (item: AnyDoc, many: boolean) => {
                const p = compactRuntimeProperty(item, result.length, many);
                const id = String(p.id || "");
                const name = String(p.Name || "");
                if ((id && ids[id]) || (name && names[name])) return;
                if (id) ids[id] = true;
                if (name) names[name] = true;
                result.push(p);
            };

            (Array.isArray(source?.Properties) ? source.Properties : []).forEach(
                (p: AnyDoc) => add(p, p?.Many === true)
            );
            (Array.isArray(source?.Collections) ? source.Collections : []).forEach(
                (c: AnyDoc) => add(c, true)
            );

            t.Properties = result;
            delete t.Collections;
            delete t._partitionId;

            t.Rules = Array.isArray(t.Rules) ? t.Rules.map((r: AnyDoc) => {
                const x = cloneData(r);
                if (x.Condition !== undefined) x.Condition = runtimeCode(x.Condition);
                if (x.PreCondition !== undefined) x.PreCondition = runtimeCode(x.PreCondition);
                return x;
            }) : [];

            t.ApperanceRules = Array.isArray(t.ApperanceRules)
                ? cloneData(t.ApperanceRules)
                : (Array.isArray(t.AppearanceRules) ? cloneData(t.AppearanceRules) : []);
            delete t.AppearanceRules;

            t.Actions = Array.isArray(t.Actions)
                ? t.Actions.map(
                    (a: AnyDoc) =>
                        compactRuntimeAction(a)
                )
                : [];

            t.Events = Array.isArray(t.Events) ? t.Events.map((e: AnyDoc) => {
                const x = cloneData(e);
                if (x.js !== undefined) x.js = runtimeCode(x.js);
                else if (x.Script !== undefined) {
                    const code = runtimeCode(x.Script);
                    if (typeof code === "string") x.js = code;
                }
                delete x.Script;
                return x;
            }) : [];

            t.formLayout = t.formLayout || { Width: "1200", Height: "800", items: [] };
            t.TypeName = t.TypeName || `${runtime.ModuleName || runtime.Name || "App"}.${t.Name || "Type"}`;
            t.Widgets = Array.isArray(t.Widgets) ? t.Widgets : [];
            t.Advanced = Array.isArray(t.Advanced) ? t.Advanced : [];

            return t;
        }

        function compactRuntimeEnum(source: AnyDoc): AnyDoc {
            const e = cloneData(source || {});
            return {
                id: e.id || new DevExpress.data.Guid().toString(),
                Name: e.Name || "Enum",
                Caption: e.Caption,
                Description: e.Description,
                _extern: e._extern === true,
                Values: Array.isArray(e.Values) ? e.Values.map((v: AnyDoc, i: number) => ({
                    Value: v?.Value !== undefined ? v.Value : i,
                    Name: v?.Name || v?.Caption || `Value${i}`,
                    Caption: v?.Caption,
                    Description: v?.Description
                })) : []
            };
        }

        function runtimeNavigationTypeId(item: AnyDoc): string | null {
            const candidate = runtimeSaveRef(item?.EntityId || item?.TargetType || item?.Type);
            if (candidate && getRuntimeTypeDocs().some((t: AnyDoc) =>
                String(t?.id || "") === String(candidate)
            )) return candidate;

            const name = String(item?.Type || "").trim();
            const byName = getRuntimeTypeDocs().find((t: AnyDoc) =>
                String(t?.Name || "") === name || String(t?.TypeName || "") === name
            );
            return byName?.id ? String(byName.id) : null;
        }

        function buildRuntimeNavigationForSave(): AnyDoc[] {
            const source =
                cloneData(
                    getRuntimeNavigationItemsArray(false)
                ) || [];
            const byId: Record<string, AnyDoc> = {};
            const roots: AnyDoc[] = [];
            const sourceParent: Record<string, string | null> = {};
            let sequence = 0;

            const collect = (
                raw: AnyDoc,
                inheritedParentId: string | null,
                siblingIndex: number
            ): void => {
                if (!raw) return;

                const id = String(
                    raw?.id ||
                    new DevExpress.data.Guid().toString()
                );

                const explicitParentId =
                    raw?.ParentId ||
                    raw?.parentId ||
                    null;

                const parentId =
                    explicitParentId
                        ? String(explicitParentId)
                        : inheritedParentId;

                const item: AnyDoc = {
                    id,
                    Caption:
                        raw?.Caption ||
                        raw?.Name ||
                        `Item ${sequence + 1}`,
                    BeginGroup:
                        raw?.BeginGroup === true,
                    Permission:
                        raw?.Permission ||
                        "Default",
                    Icon: raw?.Icon,
                    ToolTip:
                        raw?.ToolTip ||
                        raw?.Description,
                    Template: raw?.Template,
                    js: raw?.js,
                    items: [],
                    __parentId:
                        parentId,
                    __index:
                        raw?.Index ??
                        siblingIndex,
                    __sequence:
                        sequence++
                };

                const typeId =
                    runtimeNavigationTypeId(raw);

                if (typeId) {
                    item.Type = typeId;
                } else if (
                    raw?.Type === "<js>"
                ) {
                    item.Type = "<js>";
                } else if (
                    raw?.Type === null ||
                    raw?.Type === undefined
                ) {
                    item.Type = null;
                }

                byId[id] = item;
                sourceParent[id] =
                    parentId || null;

                const children =
                    Array.isArray(raw?.items)
                        ? raw.items
                        : [];

                children.forEach(
                    (
                        child: AnyDoc,
                        childIndex: number
                    ) =>
                        collect(
                            child,
                            id,
                            childIndex
                        )
                );
            };

            source.forEach(
                (
                    raw: AnyDoc,
                    index: number
                ) =>
                    collect(
                        raw,
                        null,
                        index
                    )
            );

            Object.keys(byId).forEach(
                (id: string) => {
                    const item =
                        byId[id];
                    const parentId =
                        sourceParent[id]
                            ? String(
                                sourceParent[id]
                            )
                            : "";

                    if (
                        parentId &&
                        byId[parentId] &&
                        parentId !== id
                    ) {
                        byId[
                            parentId
                        ].items.push(item);
                    } else {
                        roots.push(item);
                    }
                }
            );

            const clean = (
                items: AnyDoc[]
            ): void => {
                items.sort(
                    (a: AnyDoc, b: AnyDoc) => {
                        const ai =
                            Number(
                                a.__index ?? 0
                            );
                        const bi =
                            Number(
                                b.__index ?? 0
                            );

                        if (ai !== bi) {
                            return ai - bi;
                        }

                        return (
                            Number(
                                a.__sequence ??
                                0
                            ) -
                            Number(
                                b.__sequence ??
                                0
                            )
                        );
                    }
                );

                items.forEach(
                    (item: AnyDoc) => {
                        clean(item.items);
                        delete item.__parentId;
                        delete item.__index;
                        delete item.__sequence;

                        Object.keys(
                            item
                        ).forEach(
                            (key: string) => {
                                if (
                                    item[key] ===
                                    undefined
                                ) {
                                    delete item[key];
                                }
                            }
                        );
                    }
                );
            };

            clean(roots);
            return roots;
        }

        const pendingDesignerSaveKey = "cosmoapps.designer.pendingSave";

        function transliterateProjectName(value: string): string {
            const map: Record<string, string> = {
                а:"a",б:"b",в:"v",г:"g",д:"d",е:"e",ё:"e",ж:"zh",з:"z",и:"i",й:"y",к:"k",л:"l",м:"m",н:"n",о:"o",п:"p",р:"r",с:"s",т:"t",у:"u",ф:"f",х:"h",ц:"c",ч:"ch",ш:"sh",щ:"sch",ъ:"",ы:"y",ь:"",э:"e",ю:"yu",я:"ya"
            };
            return String(value || "").split("").map(ch => {
                const low = ch.toLowerCase();
                const tr = map[low];
                if (tr === undefined) return ch;
                return ch === ch.toUpperCase() ? tr.charAt(0).toUpperCase() + tr.slice(1) : tr;
            }).join("");
        }

        function makeProjectModuleName(name: string): string {
            const latin = transliterateProjectName(name)
                .replace(/[^A-Za-z0-9]+/g, " ")
                .trim();
            const words = latin.split(/\s+/).filter(Boolean).slice(0, 8);
            let result = words.map(w => w.charAt(0).toUpperCase() + w.slice(1)).join("");
            if (!result) result = "NewProject";
            if (/^\d/.test(result)) result = "Project" + result;
            return result.substring(0, 64);
        }

        function trimProjectText(value: any, maxLength: number): string {
            let text = String(value || "")
                .replace(/\s+/g, " ")
                .trim();

            if (text.length <= maxLength) return text;

            text = text.substring(0, maxLength).trim();
            const lastSpace = text.lastIndexOf(" ");

            if (lastSpace >= Math.floor(maxLength * 0.65)) {
                text = text.substring(0, lastSpace).trim();
            }

            return text.replace(/[,:;\-–—]+$/, "").trim();
        }

        function getWorkingProjectBrief(): string {
            return String(
                loadAIProjectBrief() ||
                applicationDoc?.Description ||
                runtime?.Description ||
                ""
            ).trim();
        }

        function getModelCaptionCandidates(): string[] {
            const result: string[] = [];
            const seen: Record<string, boolean> = {};

            getRuntimeTypeDocs().forEach((typeDoc: AnyDoc) => {
                if (!typeDoc) return;

                const raw = String(
                    typeDoc.CaptionPlural ||
                    typeDoc.Caption ||
                    typeDoc.Name ||
                    ""
                ).trim();

                if (!raw) return;

                const value = trimProjectText(raw, 50);
                const key = value.toLowerCase();

                if (!value || seen[key]) return;
                seen[key] = true;
                result.push(value);
            });

            return result.slice(0, 4);
        }

        function inferWorkingProjectName(): string {
            const suggestedName =
                trimProjectText(
                    String(aiSuggestedApplicationName || "").trim(),
                    100
                );

            if (suggestedName) {
                return suggestedName;
            }

            const brief = getWorkingProjectBrief();

            if (brief) {
                let line = brief.split(/[\r\n.!?]/)[0].trim();

                line = line.replace(/^(хочу|нужно|необходимо|требуется|надо)\s+/i, "");
                line = line.replace(/^(создать|сделать|разработать|построить|реализовать)\s+/i, "");
                line = line.replace(
                    /^(приложение|систему|система|сервис|сайт|crm|erp)\s+(для|по)\s+/i,
                    ""
                );

                line = trimProjectText(line || brief, 100);

                if (line) return line;
            }

            const captions = getModelCaptionCandidates();

            if (captions.length) {
                return trimProjectText(captions.join(" · "), 100);
            }

            return "Новый проект";
        }

        function inferWorkingProjectDescription(): string {
            const brief = getWorkingProjectBrief();
            const captions = getModelCaptionCandidates();

            if (brief) {
                const looksLikeStructuredBlueprint =
                    brief.length > 700 ||
                    /(^|\n)\s*(#{1,6}\s+|[-*]\s+|\d+[.)]\s+)/m.test(brief) ||
                    /\b(BusinessAnalysis|Scenarios|Capabilities|ConceptualTypes|Operations)\b/i.test(brief) ||
                    /(^|\n)\s*(сценарии|возможности|сущности|модель|план решения|структура)\s*[:\-]/im.test(brief);

                if (looksLikeStructuredBlueprint) {
                    const projectName = inferWorkingProjectName();
                    const sections = captions.length
                        ? ` Основные разделы: ${captions.join(", ")}.`
                        : "";

                    return trimProjectText(
                        `${projectName}.${sections}`,
                        500
                    );
                }

                const normalized = brief
                    .replace(/\r/g, "")
                    .split(/\n\s*\n/)[0]
                    .replace(/^\s*(?:blueprint|план решения|описание проекта)\s*[:\-]\s*/i, "")
                    .replace(/^\s*#{1,6}\s*/g, "")
                    .replace(/\s+/g, " ")
                    .trim();

                const sentences =
                    normalized.match(/[^.!?]+[.!?]?/g) || [normalized];

                return trimProjectText(
                    sentences.slice(0, 2).join(" ").trim(),
                    500
                );
            }

            if (captions.length) {
                return trimProjectText(
                    "Основные разделы: " + captions.join(", ") + ".",
                    500
                );
            }

            return "";
        }

        function ensureWorkingProjectNames(project: AnyDoc): void {
            const genericName =
                !project.Name ||
                /^(новый проект|new project|application)$/i.test(
                    String(project.Name).trim()
                );

            const genericModule =
                !project.ModuleName ||
                /^(новый проект|newproject|new project|application)$/i.test(
                    String(project.ModuleName).trim()
                );

            if (genericName) {
                project.Name = inferWorkingProjectName();
            }

            project.Name = trimProjectText(project.Name || "Новый проект", 100);

            if (!project.Description) {
                const description = inferWorkingProjectDescription();
                if (description) project.Description = description;
            }

            if (genericModule) {
                project.ModuleName =
                    makeProjectModuleName(
                        String(project.Name || "Новый проект")
                    );
            }
        }

        function storePendingDesignerSave(project: AnyDoc): void {
            window.sessionStorage.setItem(pendingDesignerSaveKey, JSON.stringify({
                savedAt: new Date().toISOString(),
                project: project
            }));
        }

        function clearPendingDesignerSave(): void {
            try { window.sessionStorage.removeItem(pendingDesignerSaveKey); } catch { /* ignore */ }
        }

        function buildRuntimeProjectForSave(): AnyDoc {
            const appId = String(runtime?.id || applicationDoc?.id || "").trim();
            if (!appId) throw new Error("У проекта отсутствует id.");

            const project = cloneData(runtime || {});
            delete project.objects;
            delete project.types;

            // Persist Application properties from the metamodel instead of maintaining
            // a fragile hard-coded whitelist. Runtime names follow OldName when the
            // metamodel exposes a legacy storage name; otherwise the current Name is used.
            //
            // Structural collections are rebuilt explicitly below (types/enums/navigation),
            // so they are intentionally excluded from this property projection.
            const applicationSchema =
                applicationDoc
                    ? getSchemaForObject(applicationDoc)
                    : null;

            const structuralApplicationNames: Record<string, boolean> = {
                Types: true,
                Entities: true,
                Enums: true,
                NavigationItems: true,
                Navigation: true,
                ModuleReferences: true,
                Scripts: true,
                Themes: true,
                ManageAccess: true,
                Diagrams: true,
                objects: true,
                types: true,
                enums: true,
                navigationItems: true
            };

            const copiedApplicationSourceNames: Record<string, boolean> = {};
            const copiedRuntimeNames: Record<string, boolean> = {};

            const copyApplicationProperty = (
                prop: AnyDoc
            ): void => {
                const from = String(prop?.Name || "").trim();
                const to = String(prop?.OldName || from).trim();

                if (!from || !to || structuralApplicationNames[from]) return;

                // Read through the same metamodel-aware accessor used by the editor.
                // It already understands OldName and historical storage aliases.
                let value = getObjectValue(applicationDoc, prop);
                if (value === undefined || typeof value === "function") return;

                // Designer Code / CodeExpression values are typed objects, while the
                // legacy runtime expects the executable text itself.
                if (isCodeProperty(prop)) {
                    value = runtimeCode(value);
                } else {
                    value = cloneData(value);
                }

                project[to] = value;
                copiedApplicationSourceNames[from] = true;
                copiedRuntimeNames[to] = true;

                // OldName is the legacy runtime/storage name. Avoid carrying both
                // the designer name and OldName when project was cloned from runtime.
                if (to !== from && Object.prototype.hasOwnProperty.call(project, from)) {
                    delete project[from];
                }
            };

            const applicationProperties: AnyDoc[] =
                Array.isArray(applicationSchema?.Properties)
                    ? applicationSchema.Properties
                    : [];

            applicationProperties.forEach((prop: AnyDoc) => {
                copyApplicationProperty(prop);
            });

            // Preserve any additional top-level values already present on Application
            // even when the loaded metamodel does not know them yet. Unknown values are
            // harmless to an older runtime and this keeps save forward-compatible.
            Object.keys(applicationDoc || {}).forEach((name: string) => {
                if (
                    name.startsWith("__") ||
                    structuralApplicationNames[name] ||
                    copiedApplicationSourceNames[name]
                ) {
                    return;
                }

                const value = applicationDoc?.[name];
                if (value === undefined || typeof value === "function") return;

                project[name] = cloneData(value);
            });

            project.id = appId;
            project._partitionKey = appId;
            project._type = "_Project";
            project._archive = project._archive === true;
            project.IsConstructor = false;
            project.Name = project.Name || runtime?.Name || runtime?.ModuleName || "Application";
            project.ModuleName = project.ModuleName || runtime?.ModuleName || project.Name;

            project.projectUrl = project.projectUrl || "/services/project.ashx";
            project.serviceUrl = project.serviceUrl || "/services/cosmoapps.ashx";
            project.registerMethod = project.registerMethod || "register";
            project.authMethod = project.authMethod || "auth";
            project.selectMethod = project.selectMethod || "select";
            project.byKeyMethod = project.byKeyMethod || "byKey";
            project.upsertMethod = project.upsertMethod || "upsert";
            project.deleteMethos = project.deleteMethos || project.deleteMethod || "delete";
            project.Security = project.Security || { AuthMode: "none", RegMode: "app" };
            project.NavigationType = project.NavigationType || "Horizontal Menu";
            project.DefaultTheme = project.DefaultTheme || "Light";
            project.EnabledThemes = Array.isArray(project.EnabledThemes) && project.EnabledThemes.length
                ? project.EnabledThemes : ["Dark", "Light"];
            project.References = Array.isArray(project.References) ? project.References : [];
            project.AllowedUsers = Array.isArray(project.AllowedUsers) ? project.AllowedUsers : [];
            project.views = Array.isArray(project.views) ? project.views : [];
            project.formColumnsByScreen = Array.isArray(project.formColumnsByScreen)
                ? project.formColumnsByScreen : [];

            project.enums = getRuntimeEnumDocs().map(compactRuntimeEnum);
            project.navigationItems = buildRuntimeNavigationForSave();
            project.types = getRuntimeTypeDocs().map((t: AnyDoc) => compactRuntimeType(t, appId));

            if (!project._owner && (window as any).cosmoDesignerUserEmail) {
                project._owner = String((window as any).cosmoDesignerUserEmail);
            }

            ensureWorkingProjectNames(project);
            return project;
        }

        function runtimeProjectEditorUrl(): string {
            return String((window as any).COSMOAPPS_PROJECT_EDITOR_URL || "").trim()
                || "/Account/cosmoAppsProject.ashx";
        }

        async function saveRuntimeProject(): Promise<AnyDoc> {
            const payload = { type: "upsert", data: buildRuntimeProjectForSave() };
            const response = await fetch(runtimeProjectEditorUrl(), {
                method: "POST",
                credentials: "same-origin",
                cache: "no-store",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload, (key, value) => {
                    if (key.startsWith("__")) return undefined;
                    if (key === "IsConstructor") return false;
                    return value;
                })
            });

            const body = await response.text();
            if (!response.ok) {
                throw new Error(
                    `Сохранение проекта завершилось HTTP ${response.status}` +
                    (body ? `: ${body}` : "")
                );
            }

            let result: AnyDoc = {};
            if (body) {
                try { result = JSON.parse(body); }
                catch { throw new Error("Сервер вернул некорректный JSON: " + body); }
            }

            const errors = Number(result?.errors || 0);
            const skips = Number(result?.skips || 0);

            if (errors > 0) {
                throw new Error(
                    `Сервер сообщил об ошибках сохранения: ${errors}; changes=${Number(result?.changes || 0)}.`
                );
            }
            if (skips > 0) {
                throw new Error(
                    `Часть модели пропущена из-за прав доступа: ${skips}; changes=${Number(result?.changes || 0)}.`
                );
            }

            return result;
        }

        async function saveSelectedOwner(): Promise<void> {
            if (runtime?.ShowLoadPanel) runtime.ShowLoadPanel();

            try {
                const currentUser = String((window as any).cosmoDesignerUserEmail || "").trim();
                const projectForSave = buildRuntimeProjectForSave();

                if (!currentUser) {
                    storePendingDesignerSave(projectForSave);
                    const returnUrl = window.location.pathname + "?resumeSave=1";
                    window.location.href = "/EmailLogin.aspx?returnUrl=" + encodeURIComponent(returnUrl);
                    return;
                }

                const result = await saveRuntimeProject();
                runtime._owner = runtime._owner || currentUser;
                runtime.Name = projectForSave.Name;
                runtime.ModuleName = projectForSave.ModuleName;
                runtime.Description = projectForSave.Description || runtime.Description || null;
                if (applicationDoc) {
                    applicationDoc.Name = projectForSave.Name;
                    applicationDoc.ModuleName = projectForSave.ModuleName;
                    applicationDoc.Description =
                        projectForSave.Description ||
                        applicationDoc.Description ||
                        null;
                }
                clearPendingDesignerSave();

                if (runtime.__designerDraft) {
                    delete runtime.__designerDraft;
                    delete runtime.__designerDraftCreatedAt;
                    const nextUrl = window.location.pathname + "?appId=" + encodeURIComponent(String(runtime.id));
                    window.history.replaceState({}, "", nextUrl);
                }

                DevExpress.ui.notify(
                    `Проект сохранён. Документов: ${Number(result?.changes || 0)}.`,
                    "success",
                    2600
                );
            } catch (error) {
                DevExpress.ui.dialog.alert(
                    error instanceof Error ? error.message : String(error),
                    "Ошибка сохранения"
                );
            } finally {
                if (runtime?.HideLoadPanel) runtime.HideLoadPanel();
            }
        }

        async function reloadMetadata(): Promise<void> {
            if (runtime.ShowLoadPanel) runtime.ShowLoadPanel();

            try {
                runtimeEnums = readRuntimeArray("enums");
                runtimeNavigationItems = readRuntimeArray("navigationItems");
                runtimeObjects = readRuntimeArray("objects");

                const metamodelDocuments = await loadDesignerMetamodel();

                docs = metamodelDocuments
                    .filter(d => !isTrashDoc(d))
                    .map(d => cloneData(d));

                applicationDoc = findApplicationDoc();
                aiInMemoryApplyState = {
                    Applied: false,
                    OperationCount: 0,
                    AppliedAt: null,
                    Message: "",
                    AppliedPlanJson: null
                };
                projectDeclarationBundlePromise = null;
                treeItems = buildTree();

                selectedNode =
                    treeItems.find(x => x.kind === "document" && x.doc === applicationDoc) ||
                    treeItems[0] ||
                    null;

                selectedPropertyRow = null;

                if (tree) {
                    tree.option("items", treeItems);
                    if (selectedNode) tree.option("selectedItemKeys", [selectedNode.id]);
                }

                renderPropertyGrid();
            } finally {
                if (runtime.HideLoadPanel) runtime.HideLoadPanel();
            }
        }


        function isNavigationMenuTreeNode(
            node: DesignerTreeNode | null | undefined
        ): boolean {
            if (
                !node ||
                node.kind !== "document" ||
                !node.doc
            ) {
                return false;
            }

            const schema =
                getSchemaForObject(
                    node.doc,
                    node.collection
                );

            return (
                String(schema?.Name || "") ===
                "Menu"
            );
        }

        function isNavigationGroupTreeNode(
            node: DesignerTreeNode | null | undefined
        ): boolean {
            return !!(
                isNavigationMenuTreeNode(node) &&
                !node?.doc?.Type &&
                !node?.doc?.EntityId &&
                !node?.doc?.TargetType &&
                !node?.doc?.ViewId
            );
        }

        function getNavigationDropDestination(
            node: DesignerTreeNode
        ): {
            parent: AnyDoc;
            collectionName: string;
        } | null {
            if (
                node.kind === "collection" &&
                (
                    String(
                        node.collection?.Name ||
                        ""
                    ) === "NavigationItems" ||
                    String(
                        node.collection?.Name ||
                        ""
                    ) === "Navigation"
                ) &&
                (
                    node.containerDoc ===
                        applicationDoc ||
                    node.ownerDoc ===
                        applicationDoc
                )
            ) {
                return {
                    parent:
                        applicationDoc,
                    collectionName:
                        "NavigationItems"
                };
            }

            if (
                node.kind === "collection" &&
                String(
                    node.collection?.Name ||
                    ""
                ) === "Items" &&
                node.containerDoc
            ) {
                return {
                    parent:
                        node.containerDoc,
                    collectionName:
                        "Items"
                };
            }

            if (
                isNavigationGroupTreeNode(
                    node
                )
            ) {
                return {
                    parent:
                        node.doc,
                    collectionName:
                        "Items"
                };
            }

            return null;
        }

        function moveNavigationObjectManually(
            objectId: string,
            parent: AnyDoc,
            collectionName: string
        ): void {
            const context: GenericModelContext = {
                application:
                    applicationDoc,
                objects:
                    getRuntimeObjectsArray(false),
                enums:
                    getRuntimeEnumsArray(false),
                navigationItems:
                    getRuntimeNavigationItemsArray(false)
            };

            const location =
                findGenericObject(
                    context,
                    objectId
                );

            if (
                !location ||
                !location.array ||
                location.index < 0
            ) {
                throw new Error(
                    "Не найден переносимый пункт навигации."
                );
            }

            if (
                location.object === parent
            ) {
                throw new Error(
                    "Нельзя переместить пункт меню внутрь самого себя."
                );
            }

            if (
                navigationItemContainsId(
                    location.object,
                    String(parent?.id || "")
                )
            ) {
                throw new Error(
                    "Нельзя переместить пункт меню внутрь его потомка."
                );
            }

            validateGenericCollectionExists(
                parent,
                collectionName,
                context
            );

            const moved =
                location.array.splice(
                    location.index,
                    1
                )[0];

            getGenericCollectionArray(
                parent,
                collectionName,
                true,
                context
            ).push(moved);
        }

        function findTreeNodeByDocId(
            nodes: DesignerTreeNode[],
            docId: string
        ): DesignerTreeNode | null {
            for (const node of nodes) {
                if (
                    node.kind === "document" &&
                    String(node.doc?.id || "") ===
                    docId
                ) {
                    return node;
                }

                const found =
                    node.items
                        ? findTreeNodeByDocId(
                            node.items,
                            docId
                        )
                        : null;

                if (found) return found;
            }

            return null;
        }

        function rebuildTreeAfterNavigationMove(
            movedId: string,
            parentId: string,
            collectionName: string
        ): void {
            treeItems = buildTree();

            selectedNode =
                findTreeNodeByDocId(
                    treeItems,
                    movedId
                ) ||
                selectedNode;

            selectedPropertyRow = null;

            if (tree) {
                tree.option(
                    "items",
                    treeItems
                );

                setTimeout(() => {
                    try {
                        if (
                            collectionName ===
                            "NavigationItems"
                        ) {
                            const applicationNode =
                                treeItems.find(
                                    (candidate: DesignerTreeNode) =>
                                        candidate.kind ===
                                            "document" &&
                                        candidate.doc ===
                                            applicationDoc
                                );

                            const navigationNode =
                                applicationNode
                                    ? (
                                        applicationNode.items ||
                                        []
                                    ).find(
                                        (candidate: DesignerTreeNode) =>
                                            candidate.kind ===
                                                "collection" &&
                                            (
                                                String(
                                                    candidate.collection
                                                        ?.Name ||
                                                    ""
                                                ) ===
                                                    "NavigationItems" ||
                                                String(
                                                    candidate.collection
                                                        ?.Name ||
                                                    ""
                                                ) ===
                                                    "Navigation"
                                            )
                                    )
                                    : null;

                            if (navigationNode) {
                                tree.expandItem(
                                    navigationNode.id
                                );
                            }
                        } else {
                            const parentNode =
                                findTreeNodeByDocId(
                                    treeItems,
                                    parentId
                                );

                            if (parentNode) {
                                tree.expandItem(
                                    parentNode.id
                                );

                                const itemsNode =
                                    (parentNode.items || [])
                                        .find(
                                            (candidate: DesignerTreeNode) =>
                                                candidate.kind ===
                                                    "collection" &&
                                                String(
                                                    candidate.collection
                                                        ?.Name ||
                                                    ""
                                                ) ===
                                                    "Items"
                                        );

                                if (itemsNode) {
                                    tree.expandItem(
                                        itemsNode.id
                                    );
                                }
                            }
                        }

                        if (selectedNode?.id) {
                            tree.selectItem(
                                selectedNode.id
                            );
                            tree.scrollToItem(
                                selectedNode.id
                            );
                        }
                    } catch {
                        // ignore render timing
                    }

                    renderPropertyGrid();
                }, 0);
            } else {
                renderPropertyGrid();
            }
        }

        function renderTree($container: JQuery): void {
            let draggedNavigationObjectId: string | null =
                null;
            const $tree = $("<div>")
                .attr("id", `${POPUP_ID}-tree`)
                .appendTo($container);

            tree = $tree.dxTreeView({
                items: treeItems,
                dataStructure: "tree",
                keyExpr: "id",
                displayExpr: "text",
                itemsExpr: "items",
                searchEnabled: true,
                searchMode: "contains",
                selectionMode: "single",
                selectByClick: true,
                expandNodesRecursive: false,
                itemTemplate: (itemData: DesignerTreeNode, itemIndex: number, itemElement: JQuery) => {
                    const $row = $("<div>")
                        .addClass("ca-md-tree-row")
                        .appendTo(itemElement);

                    if (
                        isNavigationMenuTreeNode(
                            itemData
                        )
                    ) {
                        $row
                            .attr("draggable", "true")
                            .attr(
                                "title",
                                "Перетащите пункт в Items нужного раздела"
                            )
                            .on(
                                "dragstart",
                                (event: any) => {
                                    draggedNavigationObjectId =
                                        String(
                                            itemData.doc?.id ||
                                            ""
                                        ) ||
                                        null;

                                    try {
                                        event.originalEvent
                                            ?.dataTransfer
                                            ?.setData(
                                                "text/plain",
                                                draggedNavigationObjectId ||
                                                ""
                                            );
                                    } catch {
                                        // ignore
                                    }
                                }
                            )
                            .on(
                                "dragend",
                                () => {
                                    draggedNavigationObjectId =
                                        null;
                                }
                            );
                    }

                    const navigationDropDestination =
                        getNavigationDropDestination(
                            itemData
                        );

                    if (navigationDropDestination) {
                        $row
                            .on(
                                "dragover",
                                (event: any) => {
                                    if (
                                        !draggedNavigationObjectId
                                    ) {
                                        return;
                                    }

                                    event.preventDefault();
                                    event.originalEvent
                                        ?.preventDefault?.();
                                }
                            )
                            .on(
                                "drop",
                                (event: any) => {
                                    event.preventDefault();
                                    event.originalEvent
                                        ?.preventDefault?.();

                                    const movedId =
                                        draggedNavigationObjectId ||
                                        String(
                                            event.originalEvent
                                                ?.dataTransfer
                                                ?.getData(
                                                    "text/plain"
                                                ) ||
                                            ""
                                        );

                                    draggedNavigationObjectId =
                                        null;

                                    if (!movedId) return;

                                    try {
                                        moveNavigationObjectManually(
                                            movedId,
                                            navigationDropDestination.parent,
                                            navigationDropDestination.collectionName
                                        );

                                        rebuildTreeAfterNavigationMove(
                                            movedId,
                                            String(
                                                navigationDropDestination
                                                    .parent
                                                    ?.id ||
                                                ""
                                            ),
                                            navigationDropDestination
                                                .collectionName
                                        );

                                        DevExpress.ui.notify(
                                            "Пункт меню перемещён. Сохраните проект, чтобы записать изменение.",
                                            "success",
                                            2600
                                        );
                                    } catch (
                                        moveError: any
                                    ) {
                                        DevExpress.ui.notify(
                                            moveError?.message ||
                                            String(moveError),
                                            "error",
                                            3200
                                        );
                                    }
                                }
                            );
                    }

                    $("<span>")
                        .addClass("ca-md-node-icon")
                        .addClass("ca-md-icon-" + getNodeIconKind(itemData))
                        .text(itemData.icon || "·")
                        .appendTo($row);

                    $("<span>")
                        .addClass("ca-md-tree-text")
                        .text(itemData.text)
                        .appendTo($row);

                    const isSelected = selectedNode && selectedNode.id === itemData.id;

                    if (itemData.kind === "collection" && isSelected) {
                        const $addButton = $("<div>")
                            .addClass("ca-md-tree-add")
                            .appendTo($row);

                        $addButton.dxButton({
                            icon: "plus",
                            stylingMode: "text",
                            width: 24,
                            height: 22,
                            hint: `Добавить в ${itemData.collection?.Name || itemData.property?.Name || "collection"}`,
                            onClick: (args: any) => {
                                args.event?.stopPropagation();
                                addItemToSelectedCollection(itemData);
                            }
                        } as any);
                    }
                },
                onItemClick: args => {
                    selectedNode = args.itemData as DesignerTreeNode;
                    selectedPropertyRow = null;
                    renderPropertyGrid();

                    setTimeout(() => {
                        try {
                            tree?.repaint();
                        } catch {
                            // ignore
                        }
                    }, 0);
                },
                onContentReady: args => {
                    if (selectedNode) args.component.selectItem(selectedNode.id);
                }
            }).dxTreeView("instance");
        }

        function openPopup(): void {
            ensureStyle();

            let $host = $(`#${POPUP_ID}`);
            if ($host.length) {
                const oldPopup = $host.dxPopup("instance");
                if (oldPopup) oldPopup.dispose();
                $host.remove();
            }

            const $pageHost = designerPageMode
                ? $(designerPageHostSelector).first()
                : $("body");
            $host = $("<div>")
                .attr("id", POPUP_ID)
                .appendTo($pageHost.length ? $pageHost : $("body"));

            popup = $host.dxPopup({
                showTitle: true,
                title: "",
                showCloseButton: false,
                elementAttr: designerPageMode
                    ? { class: "ca-md-popup ca-md-page-popup" }
                    : { class: "ca-md-popup" },

                container: designerPageMode
                    ? designerPageHostSelector
                    : undefined,
                position: designerPageMode
                    ? { my: "top left", at: "top left", of: designerPageHostSelector }
                    : undefined,
                width: () => designerPageMode
                    ? Math.max(320, $(designerPageHostSelector).innerWidth() || $(window).width())
                    : Math.min($(window).width() - 40, 1650),
                height: () => designerPageMode
                    ? Math.max(320, $(designerPageHostSelector).innerHeight() || $(window).height())
                    : Math.min($(window).height() - 40, 920),
                resizeEnabled: !designerPageMode,
                dragEnabled: !designerPageMode,

                shading: !designerPageMode,
                contentTemplate: contentElement => {
                    const $root = $("<div>")
                        .addClass("ca-md-root dx-widget")
                        .appendTo(contentElement);
                    const $left = $("<div>")
                        .addClass("ca-md-left")
                        .css({
                            width: `${designerLeftWidth}px`,
                            flex: `0 0 ${designerLeftWidth}px`
                        })
                        .appendTo($root);
                    const $leftSplitter = $("<div>")
                        .addClass("ca-md-v-splitter")
                        .attr("title", "Изменить ширину дерева модели")
                        .appendTo($root);
                    const $center = $("<div>")
                        .addClass("ca-md-center")
                        .appendTo($root);
                    const $rightSplitter = $("<div>")
                        .addClass("ca-md-v-splitter")
                        .attr("title", "Изменить ширину панели ИИ")
                        .appendTo($root);
                    const $right = $("<div>")
                        .addClass("ca-md-right")
                        .css({
                            width: `${designerRightWidth}px`,
                            flex: `0 0 ${designerRightWidth}px`
                        })
                        .appendTo($root);

                    attachDesignerVerticalSplitter(
                        $leftSplitter,
                        "left",
                        $root,
                        $left,
                        $right
                    );
                    attachDesignerVerticalSplitter(
                        $rightSplitter,
                        "right",
                        $root,
                        $left,
                        $right
                    );

                    const $leftToolbar = $("<div>").addClass("ca-md-toolbar").appendTo($left);

                    const $leftReloadButton = $("<div>").appendTo($leftToolbar);
                    $leftReloadButton.dxButton({ icon: "refresh", hint: "Перезагрузить метаданные", onClick: reloadMetadata } as any);

                    const $leftSaveButton = $("<div>").appendTo($leftToolbar);
                    $leftSaveButton.dxButton({ icon: "save", hint: "Сохранить проект для runtime", onClick: saveSelectedOwner } as any);

                    const $leftAddButton = $("<div>").appendTo($leftToolbar);
                    $leftAddButton.dxButton({ icon: "plus", hint: "Добавить элемент в выбранную коллекцию", onClick: (_args: any) => addItemToSelectedCollection() } as any);

                    $("<div>").addClass("ca-md-title").text("Модель").appendTo($leftToolbar);

                    const $treeWrap = $("<div>").addClass("ca-md-tree-wrap").appendTo($left);
                    renderTree($treeWrap);

                    const $centerToolbar = $("<div>").addClass("ca-md-toolbar").appendTo($center);
                    const $centerSaveButton = $("<div>").appendTo($centerToolbar);
                    $centerSaveButton.dxButton({ text: "Сохранить", icon: "save", type: "default", stylingMode: "contained", onClick: saveSelectedOwner } as any);

                    const $centerRunButton = $("<div>").appendTo($centerToolbar);
                    $centerRunButton.dxButton({
                        height: 36,
                        type: "success",
                        stylingMode: "contained",
                        hint: "Запустить приложение",
                        onClick: runCurrentApplication,
                        template: (_buttonData: any, buttonContent: any) => {
                            const $content = $(buttonContent).css({
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px"
                            });

                            $("<span>").css({
                                fontSize: "14px",
                                lineHeight: "1",
                                fontWeight: "700"
                            }).text("▶").appendTo($content);

                            $("<span>").text("Run").appendTo($content);
                        }
                    } as any);

                    const $centerReloadButton = $("<div>").appendTo($centerToolbar);
                    $centerReloadButton.dxButton({ text: "Перезагрузить", icon: "refresh", stylingMode: "outlined", onClick: reloadMetadata } as any);

                    const $centerAddButton = $("<div>").appendTo($centerToolbar);
                    $centerAddButton.dxButton({ text: "Добавить", icon: "plus", stylingMode: "outlined", onClick: (_args: any) => addItemToSelectedCollection() } as any);

                    const $detailViewButton = $("<div>").appendTo($centerToolbar);
                    $detailViewButton.dxButton({
                        text: "Представление",
                        icon: "edit",
                        stylingMode: "outlined",
                        onClick: () => {
                            const doc = selectedNode?.doc;

                            if (!doc || !(Array.isArray(doc.Properties) || Array.isArray(doc.Collections) || doc.formLayout)) {
                                DevExpress.ui.notify("Выберите тип / сущность для редактирования представления", "warning", 2400);
                                return;
                            }

                            CosmoApps.DetailViewDesigner.show(doc, {
                                runtime,
                                ownerNode: selectedNode,
                                modelTypes: getModelTypes(),
                                getSchemaByName: getMetaEntityByName,
                                onChanged: () => renderInfo(),
                                onSaved: () => {
                                    renderPropertyGrid();
                                    renderInfo();
                                }
                            });
                        }
                    } as any);

                    const $diagramButton = $("<div>")
                        .appendTo($centerToolbar);
                    $diagramButton.dxButton({
                        text: "Диаграмма",
                        icon: "chart",
                        stylingMode: "outlined",
                        hint:
                            "Открыть выбранную сохранённую диаграмму или создать частичную диаграмму для выбранного типа",
                        onClick: () =>
                            openModelDiagram()
                    } as any);

                    $("<div>").addClass("ca-md-title").text("Свойства").appendTo($centerToolbar);

                    $("<div>").addClass("ca-md-toolbar-spacer").appendTo($centerToolbar);

                    const $propertySearch = $("<div>")
                        .addClass("ca-md-property-search")
                        .appendTo($centerToolbar);

                    ($propertySearch as any).dxTextBox({
                        mode: "search",
                        value: propertySearchText,
                        placeholder: "Поиск свойств...",
                        showClearButton: true,
                        hint: "Поиск по свойствам выбранного объекта",
                        valueChangeEvent: "input",
                        onValueChanged: (args: any) => {
                            propertySearchText = args.value || "";
                            if (grid) {
                                grid.searchByText(propertySearchText);
                            }
                        }
                    } as any);
                    propertySearchBox = ($propertySearch as any).dxTextBox("instance");

                    $("<div>")
                        .addClass("ca-md-grid-wrap")
                        .append(
                            $("<div>")
                                .attr("id", `${POPUP_ID}-property-grid`)
                                .addClass("ca-md-property-grid")
                                .css({ height: "100%" })
                        )
                        .appendTo($center);

                    $("<div>").attr("id", `${POPUP_ID}-info`).addClass("ca-md-info").appendTo($center);

                    $("<div>").addClass("ca-md-ai-header").text("ИИ-ассистент").appendTo($right);

                    const $aiContextToolbar = $("<div>")
                        .addClass("ca-md-ai-context-toolbar")
                        .appendTo($right);

                    const $aiThinkingMode = $("<div>")
                        .addClass("ca-md-ai-context-mode")
                        .appendTo($aiContextToolbar);

                    ($aiThinkingMode as any).dxSelectBox({
                        label: "Режим",
                        labelMode: "floating",
                        dataSource: [
                            {
                                value: "strict",
                                text: "Строгий"
                            },
                            {
                                value: "creative",
                                text: "Творческий"
                            }
                        ],
                        valueExpr: "value",
                        displayExpr: "text",
                        value: aiThinkingMode,
                        hint:
                            "Строгий режим следует явным требованиям. Творческий предлагает более широкую бизнес-концепцию и полезную поддерживающую структуру.",
                        onInitialized: (args: any) => {
                            aiThinkingModeBox =
                                args.component;
                        },
                        onValueChanged: (args: any) => {
                            aiThinkingMode =
                                args.value === "creative"
                                    ? "creative"
                                    : "strict";
                            saveAIThinkingMode(
                                aiThinkingMode
                            );
                            renderAssistant();
                        }
                    } as any);

                    const $briefButton = $("<div>")
                        .addClass("ca-md-ai-project-brief-button")
                        .appendTo($aiContextToolbar);

                    ($briefButton as any).dxButton({
                        text: "Описание проекта",
                        icon: "doc",
                        stylingMode: "outlined",
                        hint: "Описание бизнеса и требований, определяющее контекст проекта",
                        onClick: openAIProjectBriefEditor
                    } as any);

                    $("<div>")
                        .attr("id", `${POPUP_ID}-ai-project-brief-state`)
                        .addClass("ca-md-ai-project-brief-state")
                        .appendTo($right);

                    $("<div>")
                        .attr("id", `${POPUP_ID}-ai-context`)
                        .addClass("ca-md-ai-context")
                        .appendTo($right);

                    $("<div>")
                        .attr("id", `${POPUP_ID}-ai-apply-state`)
                        .addClass("ca-md-ai-apply-state")
                        .appendTo($right);

                    const $aiBody = $("<div>")
                        .attr("id", `${POPUP_ID}-ai-body`)
                        .addClass("ca-md-ai-body")
                        .appendTo($right);

                    const $aiHorizontalSplitter = $("<div>")
                        .addClass(
                            "ca-md-ai-horizontal-splitter"
                        )
                        .attr(
                            "title",
                            "Перетащите, чтобы изменить размер областей ответа ИИ и запроса"
                        )
                        .appendTo($right);

                    const $aiComposer = $("<div>")
                        .addClass("ca-md-ai-composer")
                        .css({
                            height:
                                `${designerAIComposerHeight}px`,
                            flex:
                                `0 0 ${designerAIComposerHeight}px`
                        })
                        .appendTo($right);

                    attachDesignerAIHorizontalSplitter(
                        $aiHorizontalSplitter,
                        $right,
                        $aiBody,
                        $aiComposer
                    );
                    const $aiComposerRow = $("<div>")
                        .addClass("ca-md-ai-composer-row")
                        .appendTo($aiComposer);
                    const $aiPrompt = $("<div>")
                        .addClass("ca-md-ai-prompt")
                        .appendTo($aiComposerRow);

                    const $aiComposerActions = $("<div>")
                        .addClass("ca-md-ai-composer-actions")
                        .appendTo($aiComposerRow);

                    const $aiExpand = $("<div>")
                        .addClass("ca-md-ai-expand")
                        .appendTo($aiComposerActions);
                    const $aiSend = $("<div>")
                        .addClass("ca-md-ai-send")
                        .appendTo($aiComposerActions);

                    ($aiPrompt as any).dxTextArea({
                        height: "100%",
                        minHeight: 0,
                        autoResizeEnabled: false,
                        placeholder: "Спросите о модели, требованиях, бизнес-процессе или попросите внести изменение...",
                        valueChangeEvent: "input",
                        onFocusIn: () => {
                            window.setTimeout(
                                () =>
                                    openDesignerAIPromptEditor(),
                                0
                            );
                        },
                        onInitialized: (args: any) => {
                            aiPromptBox = args.component;
                        },
                        onKeyDown: (args: any) => {
                            const event = args.event;
                            if (event?.key === "Enter" && (event.ctrlKey || event.metaKey)) {
                                event.preventDefault?.();
                                sendDesignerAIRequest();
                            }
                        }
                    } as any);

                    ($aiExpand as any).dxButton({
                        text: "Открыть редактор",
                        icon: "fullscreen",
                        stylingMode: "outlined",
                        hint: "Открыть запрос к ИИ в широком редакторе",
                        onClick: () => {
                            openDesignerAIPromptEditor();
                        }
                    } as any);

                    ($aiSend as any).dxButton({
                        text: "Отправить",
                        icon: "runner",
                        type: "default",
                        stylingMode: "contained",
                        hint: "Отправить запрос (Ctrl+Enter)",
                        onInitialized: (args: any) => {
                            aiSendButton = args.component;
                        },
                        onClick: sendDesignerAIRequest
                    } as any);

                    renderPropertyGrid();
                    renderAssistant();
                },

                toolbarItems: [
                    {
                        toolbar: "top",
                        location: "before",
                        template: (_data: any, _index: any, element: any) => {
                            const $element = $(element);

                            $element.css({
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                                overflow: "hidden"
                            });

                            const $title = $("<div>")
                                .addClass("ca-md-popup-toolbar-title")
                                .appendTo($element);

                            const logoSrc = getApplicationLogoSource();

                            if (logoSrc) {
                                $("<img>")
                                    .addClass("ca-md-popup-toolbar-logo")
                                    .attr("src", logoSrc)
                                    .attr("alt", applicationDoc?.Name || "Application logo")
                                    .on("error", function () {
                                        console.warn("Logo image load error", {
                                            srcStart: logoSrc?.substring(0, 80),
                                            length: logoSrc?.length
                                        });
                                        $(this).hide();
                                    })
                                    .appendTo($title);
                            }

                            $("<span>")
                                .addClass("ca-md-popup-toolbar-title-text")
                                .text("Конструктор моделей CosmoApps")
                                .appendTo($title);
                        }
                    },
                    {
                        toolbar: "top",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            icon: "close",
                            stylingMode: "text",
                            hint: designerPageMode ? "Вернуться на сайт" : "Закрыть",
                            onClick: () => {
                                if (designerPageMode) {
                                    window.location.href = designerBackUrl;
                                } else {
                                    popup?.hide();
                                }
                            }
                        }
                    }
                ],

                onShown: () => {
                    renderPropertyGrid();
                    startInitialDesignerRequest();
                    if (designerAutoSaveOnOpen) {
                        window.setTimeout(() => { saveSelectedOwner(); }, 50);
                    }
                },
                onHidden: () => {
                    if (grid) {
                        grid.dispose();
                        grid = null;
                    }

                    propertySearchBox = null;
                    aiPromptBox = null;
                    aiSendButton = null;
                    aiApplyButton = null;
                    aiThinkingModeBox = null;
                    aiRequestInProgress = false;

                    if (tree) {
                        tree.dispose();
                        tree = null;
                    }

                    popup = null;
                }
            }).dxPopup("instance");

            popup.show();
        }

        await reloadMetadata();
        openPopup();
    }
}
